/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never }
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  Date: { input: any; output: any }
  Long: { input: any; output: any }
  /**
   * Timestamp corresponding to an absolute point in time,
   * in ISO-8601 format.
   */
  Time: { input: any; output: any }
  Timezone: { input: any; output: any }
  UUID: { input: any; output: any }
  Upload: { input: any; output: any }
}

export type AccountInput = {
  kreditID: Scalars['UUID']['input']
  userAccountID: Scalars['UUID']['input']
}

export type ActivateBusinessClientUserInput = {
  id: Scalars['UUID']['input']
}

export type ActivateCampaignCouponInput = {
  coupon: ActivateCouponInput
  /** campaign id */
  id: Scalars['ID']['input']
}

export type ActivateCampaignInput = {
  id: Scalars['ID']['input']
}

export type ActivateCouponInput = {
  /** coupon id */
  id: Scalars['ID']['input']
}

export type ActivePeriod = {
  __typename?: 'ActivePeriod'
  endsAt: Scalars['String']['output']
  startsAt: Scalars['String']['output']
}

export type ActivePeriodInput = {
  endsAt: Scalars['String']['input']
  startsAt: Scalars['String']['input']
}

export type AddBookingTicketsInsuranceInput = {
  /** booking id */
  id: Scalars['ID']['input']
  /** ticket IDs */
  ticketIDs: Array<Scalars['ID']['input']>
}

/** add campaign snack coupon input */
export type AddCampaignSnacksCouponInput = {
  /** campaign id */
  campaignID: Scalars['ID']['input']
  /** coupon code */
  code: Scalars['String']['input']
  /** constraints */
  constraints: SnackConstraintsInput
  /** discount type */
  discountType: DiscountType
  /** endsAt */
  endsAt: Scalars['String']['input']
  /** startsAt */
  startsAt: Scalars['String']['input']
  /** timezone */
  timezone: Scalars['String']['input']
  /** coupon value */
  value: Scalars['Int']['input']
}

/** add coupon input */
export type AddCouponInput = {
  /** campaign id */
  campaignID: Scalars['ID']['input']
  /** coupon promotion channels */
  channels: Array<CouponChannel>
  /** coupon code */
  code: Scalars['String']['input']
  /** constraints */
  constraints: ConstraintsInput
  /** discount type */
  discountType: DiscountType
  /** endsAt */
  endsAt: Scalars['String']['input']
  /** startsAt */
  startsAt: Scalars['String']['input']
  /** timezone */
  timezone: Scalars['String']['input']
  /** coupon value */
  value: Scalars['Int']['input']
}

export type AddFareFamilyFaresInput = {
  fares: Array<FareFamilyFareInput>
  id: Scalars['ID']['input']
}

export type AddLoyaltyCampaignRuleConditionsCitySegmentsConditionsInput = {
  citySegments?: InputMaybe<Array<InputMaybe<ChangeLoyaltyCampaignRuleConditionsCitySegmentInput>>>
}

export type AddLoyaltyCampaignRuleConditionsCitySegmentsInput = {
  id: Scalars['ID']['input']
  rule: AddLoyaltyCampaignRuleConditionsCitySegmentsRuleInput
}

export type AddLoyaltyCampaignRuleConditionsCitySegmentsRuleInput = {
  conditions: AddLoyaltyCampaignRuleConditionsCitySegmentsConditionsInput
  id: Scalars['ID']['input']
}

export type AddLoyaltyCampaignRuleConditionsRouteServicesConditionsInput = {
  routeIDs: Array<Scalars['UUID']['input']>
  routeServiceIDs: Array<Scalars['UUID']['input']>
}

export type AddLoyaltyCampaignRuleConditionsRouteServicesInput = {
  id: Scalars['UUID']['input']
  rule: AddLoyaltyCampaignRuleConditionsRouteServicesRuleInput
}

export type AddLoyaltyCampaignRuleConditionsRouteServicesRuleInput = {
  conditions: AddLoyaltyCampaignRuleConditionsRouteServicesConditionsInput
  id: Scalars['UUID']['input']
}

export type AddLoyaltyCampaignRuleConditionsSalesChannelsConditionsInput = {
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type AddLoyaltyCampaignRuleConditionsSalesChannelsInput = {
  id: Scalars['ID']['input']
  rule: AddLoyaltyCampaignRuleConditionsSalesChannelsRuleInput
}

export type AddLoyaltyCampaignRuleConditionsSalesChannelsRuleInput = {
  conditions: AddLoyaltyCampaignRuleConditionsSalesChannelsConditionsInput
  id: Scalars['ID']['input']
}

export type AddPartnerDocumentInput = {
  category: PartnerDocumentCategoryInput
  filePath: Scalars['String']['input']
}

export type AddPartnerDocumentsInput = {
  documents: Array<AddPartnerDocumentInput>
}

export type AddPartnersPaymentSummaryFilesInput = {
  /** files to be processed */
  files: Array<FileInput>
  /** ID of the summary */
  summaryID: Scalars['UUID']['input']
}

export type AddRouteServicePeaksInput = {
  id: Scalars['ID']['input']
  peaks: Array<RouteServicePeakInput>
}

export type AddRoutingProjectPlanDatasetLocationsInput = {
  id: Scalars['UUID']['input']
  plan: AddRoutingProjectPlanDatasetLocationsPlanInput
}

export type AddRoutingProjectPlanDatasetLocationsLocationResponse = {
  __typename?: 'AddRoutingProjectPlanDatasetLocationsLocationResponse'
  id: Scalars['UUID']['output']
}

export type AddRoutingProjectPlanDatasetLocationsPlanDatasetInput = {
  locations: Array<AddRoutingProjectPlanDatasetLocationsPlanDatasetLocationInput>
}

export type AddRoutingProjectPlanDatasetLocationsPlanDatasetLocationCoordinatesInput = {
  latitude: Scalars['String']['input']
  longitude: Scalars['String']['input']
}

export type AddRoutingProjectPlanDatasetLocationsPlanDatasetLocationInput = {
  coordinates: AddRoutingProjectPlanDatasetLocationsPlanDatasetLocationCoordinatesInput
  dow?: InputMaybe<Array<RoutingProjectLocationDow>>
  label: Scalars['String']['input']
}

export type AddRoutingProjectPlanDatasetLocationsPlanInput = {
  dataset: AddRoutingProjectPlanDatasetLocationsPlanDatasetInput
  id: Scalars['UUID']['input']
}

export type AddRoutingProjectPlanDatasetLocationsResponse = {
  __typename?: 'AddRoutingProjectPlanDatasetLocationsResponse'
  locations: Array<AddRoutingProjectPlanDatasetLocationsLocationResponse>
}

export type AddServiceFeeAddonRuleFeeInput = {
  amount: Scalars['Int']['input']
  currencyCode: Scalars['String']['input']
}

export type AddServiceFeeAddonRuleInput = {
  companyID: Scalars['ID']['input']
  companyLineID: Scalars['ID']['input']
  confirmationModalities: Array<ConfirmationModality>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  segmentIDs: Array<Scalars['ID']['input']>
  ticketFees: Array<AddServiceFeeAddonRuleTicketFeeInput>
}

export type AddServiceFeeAddonRuleTicketFeeInput = {
  fees: Array<AddServiceFeeAddonRuleFeeInput>
  quantity: Scalars['Int']['input']
}

export type AddTripDriverRsvpNoteInput = {
  driverID: Scalars['UUID']['input']
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>
  id: Scalars['UUID']['input']
  message?: InputMaybe<Scalars['String']['input']>
  status: TripDriverRsvpNoteStatus
}

export type AddTripNoteInput = {
  cashFlow?: InputMaybe<CashFlowInput>
  category: TripNoteCategoryInput
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>
  files?: InputMaybe<Array<Scalars['Upload']['input']>>
  id: Scalars['UUID']['input']
  message: Scalars['String']['input']
}

/** address */
export type Address = {
  __typename?: 'Address'
  /** city */
  city: Scalars['String']['output']
  /** country code in ISO_3166-1_alpha-2 format. */
  countryCode: Scalars['String']['output']
  /** line 1 */
  line1: Scalars['String']['output']
  /** line 2 */
  line2?: Maybe<Scalars['String']['output']>
  /** state code in ISO_3166-2:MX format. */
  stateCode: Scalars['String']['output']
  /** zip code */
  zipCode: Scalars['String']['output']
}

export const Amenity = {
  Ac: 'AC',
  Chair: 'CHAIR',
  Eticket: 'ETICKET',
  Excursion: 'EXCURSION',
  Guide: 'GUIDE',
  Light: 'LIGHT',
  Lunchbox: 'LUNCHBOX',
  Plug: 'PLUG',
  Tv: 'TV',
  Wc: 'WC',
  Wifi: 'WIFI'
} as const

export type Amenity = (typeof Amenity)[keyof typeof Amenity]
export type Amounts = {
  __typename?: 'Amounts'
  card: Scalars['Int']['output']
  cash: Scalars['Int']['output']
}

export type AncillariesInput = {
  types?: InputMaybe<Array<AncillaryTypeInput>>
}

export type AncillariesResponse = {
  __typename?: 'AncillariesResponse'
  items: Array<Ancillary>
  total: Scalars['Int']['output']
}

export type Ancillary = {
  __typename?: 'Ancillary'
  company: AncillaryCompany
  conditions?: Maybe<AncillaryConditions>
  id: Scalars['ID']['output']
  isEnabled: Scalars['Boolean']['output']
  label?: Maybe<Array<AncillaryTranslation>>
  name?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Int']['output']>
  /** @deprecated use conditions.salesChannels */
  salesChannels: Array<SalesChannel>
  /** @deprecated use conditions.salesChannels */
  salesChannelsV2: Array<AncillarySalesChannel>
  type: AncillaryType
}

export type AncillaryCitySegment = {
  __typename?: 'AncillaryCitySegment'
  destination: AncillaryPlace
  origin: AncillaryPlace
  routeServices?: Maybe<Array<AncillaryRouteService>>
  segments: Array<AncillarySegment>
}

export type AncillaryCompany = {
  __typename?: 'AncillaryCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type AncillaryConditions = {
  __typename?: 'AncillaryConditions'
  citySegments?: Maybe<Array<AncillaryCitySegment>>
  salesChannels?: Maybe<Array<AncillarySalesChannel>>
  seatsPrice?: Maybe<AncillarySeatsPrice>
}

export type AncillaryConditionsCitySegmentInput = {
  destinationID: Scalars['ID']['input']
  originID: Scalars['ID']['input']
  routeServiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  segmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type AncillaryConditionsInput = {
  citySegments?: InputMaybe<Array<AncillaryConditionsCitySegmentInput>>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  seatsPrice?: InputMaybe<AncillarySeatsPriceInput>
}

export type AncillaryCountry = {
  __typename?: 'AncillaryCountry'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type AncillaryInput = {
  id: Scalars['ID']['input']
}

export type AncillaryPlace = {
  __typename?: 'AncillaryPlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type AncillaryRouteService = {
  __typename?: 'AncillaryRouteService'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type AncillarySalesChannel = {
  __typename?: 'AncillarySalesChannel'
  country: AncillaryCountry
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type AncillarySeatRangePrice = {
  __typename?: 'AncillarySeatRangePrice'
  fromLabel: Scalars['String']['output']
  price: Scalars['Int']['output']
  toLabel: Scalars['String']['output']
}

export type AncillarySeatRangePriceInput = {
  fromLabel: Scalars['String']['input']
  price: Scalars['Int']['input']
  toLabel: Scalars['String']['input']
}

export type AncillarySeatsPrice = {
  __typename?: 'AncillarySeatsPrice'
  doubleDecker?: Maybe<Array<AncillarySeatRangePrice>>
  standard?: Maybe<Array<AncillarySeatRangePrice>>
}

export type AncillarySeatsPriceInput = {
  doubleDecker?: InputMaybe<Array<AncillarySeatRangePriceInput>>
  standard?: InputMaybe<Array<AncillarySeatRangePriceInput>>
}

export type AncillarySegment = {
  __typename?: 'AncillarySegment'
  destination: AncillaryPlace
  id: Scalars['ID']['output']
  origin: AncillaryPlace
}

export const AncillaryStatus = {
  CancellationFailed: 'cancellationFailed',
  Cancelled: 'cancelled',
  Confirmed: 'confirmed',
  CreationFailed: 'creationFailed',
  EditFailed: 'editFailed',
  Expired: 'expired',
  Failed: 'failed',
  Reserved: 'reserved',
  UpdateFailed: 'updateFailed'
} as const

export type AncillaryStatus = (typeof AncillaryStatus)[keyof typeof AncillaryStatus]
export const AncillaryStatusInput = {
  Cancellationfailed: 'CANCELLATIONFAILED',
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  Creationfailed: 'CREATIONFAILED',
  Expired: 'EXPIRED',
  Failed: 'FAILED',
  Reserved: 'RESERVED',
  Updatefailed: 'UPDATEFAILED'
} as const

export type AncillaryStatusInput = (typeof AncillaryStatusInput)[keyof typeof AncillaryStatusInput]
export const AncillaryStatusV2 = {
  Cancellationfailed: 'CANCELLATIONFAILED',
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  Creationfailed: 'CREATIONFAILED',
  Expired: 'EXPIRED',
  Failed: 'FAILED',
  Reserved: 'RESERVED',
  Updatefailed: 'UPDATEFAILED'
} as const

export type AncillaryStatusV2 = (typeof AncillaryStatusV2)[keyof typeof AncillaryStatusV2]
export type AncillaryTranslation = {
  __typename?: 'AncillaryTranslation'
  language: Language
  text: Scalars['String']['output']
}

export type AncillaryTranslationInput = {
  language: Language
  text: Scalars['String']['input']
}

export const AncillaryType = {
  CarryOn: 'CARRY_ON',
  Insurance: 'INSURANCE',
  Luggage: 'LUGGAGE',
  Seat: 'SEAT',
  ServiceFee: 'SERVICE_FEE'
} as const

export type AncillaryType = (typeof AncillaryType)[keyof typeof AncillaryType]
export const AncillaryTypeInput = {
  CarryOn: 'carryOn',
  Insurance: 'insurance',
  Luggage: 'luggage',
  Seat: 'seat',
  ServiceFee: 'serviceFee'
} as const

export type AncillaryTypeInput = (typeof AncillaryTypeInput)[keyof typeof AncillaryTypeInput]
export type ApplyBookingCouponCouponResponse = {
  __typename?: 'ApplyBookingCouponCouponResponse'
  discountType: Scalars['String']['output']
  id: Scalars['ID']['output']
  tickets: Array<ApplyBookingCouponCouponResponseTicket>
  value: Scalars['Int']['output']
}

export type ApplyBookingCouponCouponResponseTicket = {
  __typename?: 'ApplyBookingCouponCouponResponseTicket'
  discount: Scalars['Int']['output']
  id: Scalars['ID']['output']
}

export type ApplyBookingCouponInput = {
  /** coupon code */
  code: Scalars['String']['input']
  /** booking id */
  id: Scalars['ID']['input']
}

export type ApplyBookingCouponResponse = {
  __typename?: 'ApplyBookingCouponResponse'
  coupon: ApplyBookingCouponCouponResponse
  discount: Scalars['Int']['output']
  subtotal: Scalars['Int']['output']
  vat: Scalars['Int']['output']
}

export type ArchiveInventoryInput = {
  id: Scalars['ID']['input']
}

export type ArchiveRouteServiceItineraryScheduleInput = {
  /** route service id */
  id: Scalars['ID']['input']
  /** itinerary schedule ids */
  itineraryScheduleID: Scalars['ID']['input']
}

export type Asset = {
  __typename?: 'Asset'
  name: Scalars['String']['output']
  path: Scalars['String']['output']
}

export type AssignBusinessClientSimsInput = {
  /** path to the csv file with the sims, obtained from the createPresignedUrlForFileUpload mutation */
  filePath: Scalars['String']['input']
  /** business client ID */
  id: Scalars['UUID']['input']
}

export type AssignBusinessCustomerKreditCategoryInput = {
  category: Scalars['Int']['input']
  id: Scalars['UUID']['input']
}

export type AssignBusinessCustomersKreditCategoryInput = {
  category: Scalars['Int']['input']
  ids: Array<Scalars['UUID']['input']>
}

export type AvailableSeats = {
  __typename?: 'AvailableSeats'
  adult: Scalars['Int']['output']
  child: Scalars['Int']['output']
  senior: Scalars['Int']['output']
}

/** booking */
export type Booking = {
  __typename?: 'Booking'
  /** business client */
  businessClient?: Maybe<BookingBusinessClient>
  /** buyer */
  buyer?: Maybe<BookingBuyer>
  /** booking trips check in scores */
  checkInScores: Array<BookingTripCheckInScore>
  /** client */
  client?: Maybe<Client>
  /** time booking was paid */
  confirmedAt?: Maybe<Scalars['Time']['output']>
  /** country */
  country: BookingCountry
  /** coupon */
  coupon?: Maybe<BookingCoupon>
  /** time booking was created */
  createdAt: Scalars['Time']['output']
  /** currency */
  currency: BookingCurrency
  /** ISO 4217 currency code */
  currencyCode: CurrencyCode
  /** departure trips */
  departureTrips: Array<BookingTrip>
  /** emails */
  emails: Array<Email>
  /** booking id */
  id: Scalars['ID']['output']
  /** is home pickup */
  isHomePickup: Scalars['Boolean']['output']
  /** is tax invoiced (is true if all the payments are tax invoiced) */
  isTaxInvoiced: Scalars['Boolean']['output']
  /** is invoiced by user account (only present if isTaxInvoiced is true) */
  isTaxInvoicedByUserAccount?: Maybe<Scalars['Boolean']['output']>
  /** passengers */
  passengers: Array<BookingPassenger>
  /** payments */
  payments: Array<BookingPayment>
  /** refunds */
  refunds: Array<BookingRefund>
  /** return trips */
  returnTrips: Array<BookingTrip>
  /**
   * sales channel
   * @deprecated Use salesChannelV2 instead
   */
  salesChannel?: Maybe<SalesChannel>
  /** sales channel type */
  salesChannelType?: Maybe<SalesChannelType>
  /** sales channel v2 */
  salesChannelV2?: Maybe<BookingSalesChannel>
  /** status */
  status: Scalars['String']['output']
  /** support interactions */
  supportInteractions: Array<SupportInteraction>
  /** tickets */
  tickets: Array<BookingTicket>
  /** vertical */
  vertical: BookingVertical
}

export type BookingAncillary = {
  __typename?: 'BookingAncillary'
  externalID?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  /** @deprecated use type instead */
  label: Scalars['String']['output']
  /** @deprecated not used */
  paid: Scalars['Boolean']['output']
  /** @deprecated use total instead */
  price: Scalars['Int']['output']
  quantity: Scalars['Int']['output']
  status: AncillaryStatus
  /** @deprecated Use total instead */
  subtotal: Scalars['Int']['output']
  total: Scalars['Int']['output']
  type: AncillaryType
  unitPrice: Scalars['Int']['output']
  /** @deprecated total includes VAT */
  vat: Scalars['Int']['output']
}

export type BookingBusinessClient = {
  __typename?: 'BookingBusinessClient'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

/** booking buyer */
export type BookingBuyer = {
  __typename?: 'BookingBuyer'
  /** buyer's email */
  email: Scalars['String']['output']
  /** buyer's first name */
  firstName: Scalars['String']['output']
  /** indicates wether the buyer is also a passenger or not */
  isPassenger: Scalars['Boolean']['output']
  /** buyer's last name */
  lastName: Scalars['String']['output']
  /** buyer's phone number */
  phone: Scalars['String']['output']
}

export type BookingClass = {
  __typename?: 'BookingClass'
  activatedAt?: Maybe<Scalars['Time']['output']>
  company: BookingClassCompany
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  priority: Scalars['Int']['output']
  promo: Scalars['Boolean']['output']
  updatedAt: Scalars['Time']['output']
}

export type BookingClassCompany = {
  __typename?: 'BookingClassCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type BookingCountry = {
  __typename?: 'BookingCountry'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type BookingCoupon = {
  __typename?: 'BookingCoupon'
  /** code */
  code: Scalars['String']['output']
  /** discount type */
  discountType: DiscountType
  /** coupon id */
  id: Scalars['ID']['output']
  /** coupon value */
  value: Scalars['Int']['output']
}

export type BookingCurrency = {
  __typename?: 'BookingCurrency'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export const BookingEmailStatus = {
  Blocked: 'BLOCKED',
  Bounce: 'BOUNCE',
  Deferred: 'DEFERRED',
  Delivered: 'DELIVERED',
  Dropped: 'DROPPED',
  Processed: 'PROCESSED',
  Sent: 'SENT'
} as const

export type BookingEmailStatus = (typeof BookingEmailStatus)[keyof typeof BookingEmailStatus]
export const BookingInvoicedBy = {
  Automatic: 'AUTOMATIC',
  Finance: 'FINANCE',
  User: 'USER'
} as const

export type BookingInvoicedBy = (typeof BookingInvoicedBy)[keyof typeof BookingInvoicedBy]
/** booking passenger */
export type BookingPassenger = {
  __typename?: 'BookingPassenger'
  /** passenger's first name */
  firstName: Scalars['String']['output']
  /** id */
  id: Scalars['ID']['output']
  /** passenger's last name */
  lastName: Scalars['String']['output']
  /** properties */
  properties: Array<BookingPassengerProperty>
  /**
   * passenger type
   * @deprecated Use typeV2 instead
   */
  type?: Maybe<PassengerType>
  /** passenger type */
  typeV2: BookingPassengerType
}

export type BookingPassengerProperty = {
  __typename?: 'BookingPassengerProperty'
  abbreviation: Scalars['String']['output']
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type BookingPassengerType = {
  __typename?: 'BookingPassengerType'
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
}

/** booking payment */
export type BookingPayment = {
  __typename?: 'BookingPayment'
  /** amount */
  amount: Scalars['Int']['output']
  /** auth code */
  authCode?: Maybe<Scalars['String']['output']>
  /** charge id */
  chargeID?: Maybe<Scalars['String']['output']>
  /** id */
  id: Scalars['String']['output']
  /** last 4 */
  last4?: Maybe<Scalars['String']['output']>
  /** payment method */
  method: Scalars['String']['output']
  /** payment list id */
  paymentListID: Scalars['ID']['output']
  /** payment processor */
  processor?: Maybe<Scalars['String']['output']>
  /** reason */
  reason: Scalars['String']['output']
  /** status */
  status: Scalars['String']['output']
  /** tickets */
  tickets: Array<PaymentTicket>
  /** user */
  user?: Maybe<PaymentUser>
}

export type BookingRefund = {
  __typename?: 'BookingRefund'
  amount: Scalars['Int']['output']
  method: Scalars['String']['output']
  paymentID: Scalars['ID']['output']
}

export type BookingSalesChannel = {
  __typename?: 'BookingSalesChannel'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

/** seat */
export type BookingSeat = {
  __typename?: 'BookingSeat'
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
}

/** booking ticket */
export type BookingTicket = {
  __typename?: 'BookingTicket'
  /** ancillaries */
  ancillaries?: Maybe<Array<BookingAncillary>>
  /** cancellation source */
  cancellationSource?: Maybe<CancellationSource>
  /** checked in */
  checkedIn: Scalars['Boolean']['output']
  /** discount */
  discount: Scalars['Int']['output']
  /** ticket id */
  id: Scalars['ID']['output']
  /** passenger */
  passenger?: Maybe<BookingPassenger>
  /** payment */
  payment?: Maybe<TicketPayment>
  /** indicates if a reward was applied to this ticket */
  rewardApplied: Scalars['Boolean']['output']
  /** seat */
  seat?: Maybe<BookingSeat>
  /** service fee */
  serviceFee?: Maybe<ServiceFee>
  /** status */
  status: TicketStatus
  /** subtotal */
  subtotal: Scalars['Int']['output']
  /** trip */
  trip?: Maybe<BookingTrip>
  /** VAT */
  vat: Scalars['Int']['output']
}

export const BookingTicketCancelationReason = {
  Fraud: 'FRAUD',
  NoShow: 'NO_SHOW',
  Operational: 'OPERATIONAL',
  Personal: 'PERSONAL',
  Test: 'TEST',
  TripChange: 'TRIP_CHANGE'
} as const

export type BookingTicketCancelationReason =
  (typeof BookingTicketCancelationReason)[keyof typeof BookingTicketCancelationReason]
/** booking trip */
export type BookingTrip = {
  __typename?: 'BookingTrip'
  /** company line */
  companyLine?: Maybe<BookingTripCompanyLine>
  /** departure at in UTC */
  departureAt: Scalars['Time']['output']
  /** trip id */
  id: Scalars['ID']['output']
  /** is active */
  isActive: Scalars['Boolean']['output']
  /** segment */
  segment: BookingTripSegment
  /** trip's origin timezone */
  timezone: Scalars['String']['output']
}

export type BookingTripCheckInScore = {
  __typename?: 'BookingTripCheckInScore'
  score: Scalars['Float']['output']
  tripID: Scalars['ID']['output']
}

/** booking trip city */
export type BookingTripCity = {
  __typename?: 'BookingTripCity'
  /** id */
  id: Scalars['ID']['output']
  /** city name */
  name: Scalars['String']['output']
  /** timezone */
  timezone: Scalars['String']['output']
}

/** booking trip company line */
export type BookingTripCompanyLine = {
  __typename?: 'BookingTripCompanyLine'
  /** company line name */
  name: Scalars['String']['output']
}

/** booking trip place */
export type BookingTripPlace = {
  __typename?: 'BookingTripPlace'
  /** city */
  city: BookingTripCity
  /** id */
  id: Scalars['ID']['output']
  /** place name */
  name: Scalars['String']['output']
}

export type BookingTripSegment = {
  __typename?: 'BookingTripSegment'
  /** arrival time in UTC */
  arrivalAt: Scalars['Time']['output']
  /** departure time in UTC */
  departureAt: Scalars['Time']['output']
  /** destination place */
  destination?: Maybe<BookingTripPlace>
  /** trip's fare */
  fare?: Maybe<BookingTripSegmentFare>
  /** segment id */
  id: Scalars['ID']['output']
  /** origin place */
  origin?: Maybe<BookingTripPlace>
}

/** booking trip place */
export type BookingTripSegmentFare = {
  __typename?: 'BookingTripSegmentFare'
  /** base price */
  basePrice: Scalars['Int']['output']
  /** id */
  id: Scalars['ID']['output']
}

export const BookingType = {
  OneWay: 'ONE_WAY',
  RoundTrip: 'ROUND_TRIP'
} as const

export type BookingType = (typeof BookingType)[keyof typeof BookingType]
export type BookingV2 = {
  __typename?: 'BookingV2'
  businessClient?: Maybe<BookingV2BusinessClient>
  buyer?: Maybe<BookingV2Buyer>
  client?: Maybe<BookingV2Client>
  confirmedAt?: Maybe<Scalars['Time']['output']>
  country: BookingV2Country
  coupon?: Maybe<BookingV2Coupon>
  createdAt: Scalars['Time']['output']
  currency: BookingV2Currency
  departureTrips: Array<BookingV2Trip>
  emailsSent: Array<BookingV2EmailSent>
  id: Scalars['UUID']['output']
  invoicedBy?: Maybe<BookingInvoicedBy>
  isHomePickup: Scalars['Boolean']['output']
  /** @deprecated Use invoicedBy instead */
  isInvoicedByUserAccount?: Maybe<Scalars['Boolean']['output']>
  isTaxInvoiceable: Scalars['Boolean']['output']
  isTaxInvoiced: Scalars['Boolean']['output']
  passengers: Array<BookingV2Passenger>
  payments: Array<BookingV2Payment>
  refunds: Array<BookingV2Refund>
  returnTrips: Array<BookingV2Trip>
  salesChannel: BookingV2SalesChannel
  status: BookingV2Status
  supportInteractions: Array<BookingV2SupportInteraction>
  tickets: Array<BookingV2Ticket>
  userAccount?: Maybe<BookingV2UserAccount>
  vertical: BookingV2Vertical
}

export type BookingV2BusinessClient = {
  __typename?: 'BookingV2BusinessClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BookingV2Buyer = {
  __typename?: 'BookingV2Buyer'
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  isPassenger: Scalars['Boolean']['output']
  lastName: Scalars['String']['output']
  phone: Scalars['String']['output']
}

export type BookingV2Client = {
  __typename?: 'BookingV2Client'
  os?: Maybe<Scalars['String']['output']>
  source: BookingV2ClientSource
  userAgent?: Maybe<Scalars['String']['output']>
}

export const BookingV2ClientSource = {
  Android: 'ANDROID',
  Ios: 'IOS',
  UrbvanAndroid: 'URBVAN_ANDROID',
  UrbvanIos: 'URBVAN_IOS',
  Web: 'WEB'
} as const

export type BookingV2ClientSource = (typeof BookingV2ClientSource)[keyof typeof BookingV2ClientSource]
export type BookingV2Country = {
  __typename?: 'BookingV2Country'
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
}

export type BookingV2Coupon = {
  __typename?: 'BookingV2Coupon'
  code: Scalars['String']['output']
  discountType: BookingV2CouponDiscountType
  id: Scalars['UUID']['output']
  value: Scalars['Int']['output']
}

export const BookingV2CouponDiscountType = {
  Amount: 'AMOUNT',
  Percentage: 'PERCENTAGE'
} as const

export type BookingV2CouponDiscountType = (typeof BookingV2CouponDiscountType)[keyof typeof BookingV2CouponDiscountType]
export type BookingV2Currency = {
  __typename?: 'BookingV2Currency'
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
}

export type BookingV2EmailSent = {
  __typename?: 'BookingV2EmailSent'
  address: Scalars['String']['output']
  id: Scalars['UUID']['output']
  reason?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
}

export type BookingV2Passenger = {
  __typename?: 'BookingV2Passenger'
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
  properties: Array<BookingV2PassengerProperty>
  type: BookingV2PassengerType
}

export type BookingV2PassengerProperty = {
  __typename?: 'BookingV2PassengerProperty'
  abbreviation: Scalars['String']['output']
  id: Scalars['UUID']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type BookingV2PassengerType = {
  __typename?: 'BookingV2PassengerType'
  id: Scalars['UUID']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type BookingV2Payment = {
  __typename?: 'BookingV2Payment'
  amount: Scalars['Int']['output']
  authCode?: Maybe<Scalars['String']['output']>
  chargeID?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  last4?: Maybe<Scalars['String']['output']>
  method: BookingV2PaymentMethod
  paymentListID?: Maybe<Scalars['UUID']['output']>
  processor?: Maybe<BookingV2PaymentProcessor>
  reason: Scalars['String']['output']
  status: BookingV2PaymentStatus
  tickets: Array<BookingV2PaymentTicket>
  user?: Maybe<BookingV2PaymentUser>
}

export const BookingV2PaymentMethod = {
  AccountMoney: 'ACCOUNT_MONEY',
  Card: 'CARD',
  Cash: 'CASH',
  Coupon: 'COUPON',
  CreditCard: 'CREDIT_CARD',
  DebitCard: 'DEBIT_CARD',
  Kredit: 'KREDIT'
} as const

export type BookingV2PaymentMethod = (typeof BookingV2PaymentMethod)[keyof typeof BookingV2PaymentMethod]
export const BookingV2PaymentProcessor = {
  Clip: 'CLIP',
  Conekta: 'CONEKTA',
  Kredit: 'KREDIT',
  MercadoPago: 'MERCADO_PAGO',
  Stripe: 'STRIPE'
} as const

export type BookingV2PaymentProcessor = (typeof BookingV2PaymentProcessor)[keyof typeof BookingV2PaymentProcessor]
export const BookingV2PaymentStatus = {
  ChargedBack: 'CHARGED_BACK',
  Paid: 'PAID',
  PaymentDeclined: 'PAYMENT_DECLINED',
  PaymentFailed: 'PAYMENT_FAILED',
  Refunded: 'REFUNDED'
} as const

export type BookingV2PaymentStatus = (typeof BookingV2PaymentStatus)[keyof typeof BookingV2PaymentStatus]
export type BookingV2PaymentTicket = {
  __typename?: 'BookingV2PaymentTicket'
  discount: Scalars['Int']['output']
  id: Scalars['UUID']['output']
  subtotal: Scalars['Int']['output']
  vat: Scalars['Int']['output']
}

export type BookingV2PaymentUser = {
  __typename?: 'BookingV2PaymentUser'
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export type BookingV2Refund = {
  __typename?: 'BookingV2Refund'
  amount: Scalars['Int']['output']
  method: BookingV2RefundMethod
  paymentID: Scalars['UUID']['output']
}

export const BookingV2RefundMethod = {
  Card: 'CARD',
  Cash: 'CASH',
  Coupon: 'COUPON',
  CreditCard: 'CREDIT_CARD',
  DebitCard: 'DEBIT_CARD',
  Kredit: 'KREDIT'
} as const

export type BookingV2RefundMethod = (typeof BookingV2RefundMethod)[keyof typeof BookingV2RefundMethod]
export type BookingV2SalesChannel = {
  __typename?: 'BookingV2SalesChannel'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  type: BookingV2SalesChannelType
}

export const BookingV2SalesChannelType = {
  Offline: 'OFFLINE',
  Online: 'ONLINE'
} as const

export type BookingV2SalesChannelType = (typeof BookingV2SalesChannelType)[keyof typeof BookingV2SalesChannelType]
export const BookingV2Status = {
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  Failed: 'FAILED',
  Incomplete: 'INCOMPLETE',
  Paid: 'PAID',
  PartiallyConfirmed: 'PARTIALLY_CONFIRMED',
  Reserved: 'RESERVED'
} as const

export type BookingV2Status = (typeof BookingV2Status)[keyof typeof BookingV2Status]
export type BookingV2SupportInteraction = {
  __typename?: 'BookingV2SupportInteraction'
  callStatus?: Maybe<BookingV2SupportInteractionCallStatus>
  createdAt: Scalars['Time']['output']
  notes?: Maybe<Scalars['String']['output']>
  notificationChannel?: Maybe<BookingV2SupportInteractionNotificationChannel>
  user: BookingV2SupportInteractionUser
}

export const BookingV2SupportInteractionCallStatus = {
  AttendanceConfirmed: 'ATTENDANCE_CONFIRMED',
  BusyNumber: 'BUSY_NUMBER',
  Cancellation: 'CANCELLATION',
  HungUp: 'HUNG_UP',
  NonExistentNumber: 'NON_EXISTENT_NUMBER',
  ServiceChange: 'SERVICE_CHANGE',
  UnavailableNumber: 'UNAVAILABLE_NUMBER',
  Voicemail: 'VOICEMAIL',
  WrongNumber: 'WRONG_NUMBER'
} as const

export type BookingV2SupportInteractionCallStatus =
  (typeof BookingV2SupportInteractionCallStatus)[keyof typeof BookingV2SupportInteractionCallStatus]
export const BookingV2SupportInteractionNotificationChannel = {
  Email: 'EMAIL',
  Phone: 'PHONE',
  SocialMedia: 'SOCIAL_MEDIA',
  Whatsapp: 'WHATSAPP'
} as const

export type BookingV2SupportInteractionNotificationChannel =
  (typeof BookingV2SupportInteractionNotificationChannel)[keyof typeof BookingV2SupportInteractionNotificationChannel]
export type BookingV2SupportInteractionUser = {
  __typename?: 'BookingV2SupportInteractionUser'
  username: Scalars['String']['output']
}

export type BookingV2Ticket = {
  __typename?: 'BookingV2Ticket'
  ancillaries?: Maybe<Array<BookingV2TicketAncillary>>
  cancellationSource?: Maybe<BookingV2TicketCancellationSource>
  discount: Scalars['Int']['output']
  id: Scalars['UUID']['output']
  isCheckedIn: Scalars['Boolean']['output']
  isRewardApplied: Scalars['Boolean']['output']
  passenger?: Maybe<BookingV2Passenger>
  seat?: Maybe<BookingV2TicketSeat>
  serviceFee?: Maybe<BookingV2TicketServiceFee>
  status: BookingV2TicketStatus
  subtotal: Scalars['Int']['output']
  trip?: Maybe<BookingV2Trip>
  vat: Scalars['Int']['output']
}

export type BookingV2TicketAncillary = {
  __typename?: 'BookingV2TicketAncillary'
  externalID?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  quantity: Scalars['Int']['output']
  status: BookingV2TicketAncillaryStatus
  total: Scalars['Int']['output']
  type: BookingV2TicketAncillaryType
  unitPrice: Scalars['Int']['output']
}

export const BookingV2TicketAncillaryStatus = {
  CancellationFailed: 'CANCELLATION_FAILED',
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  CreationFailed: 'CREATION_FAILED',
  Reserved: 'RESERVED',
  UpdateFailed: 'UPDATE_FAILED'
} as const

export type BookingV2TicketAncillaryStatus =
  (typeof BookingV2TicketAncillaryStatus)[keyof typeof BookingV2TicketAncillaryStatus]
export const BookingV2TicketAncillaryType = {
  CarryOn: 'CARRY_ON',
  Insurance: 'INSURANCE',
  Luggage: 'LUGGAGE',
  Seat: 'SEAT',
  ServiceFee: 'SERVICE_FEE'
} as const

export type BookingV2TicketAncillaryType =
  (typeof BookingV2TicketAncillaryType)[keyof typeof BookingV2TicketAncillaryType]
export const BookingV2TicketCancellationSource = {
  Admin: 'ADMIN',
  UserAccount: 'USER_ACCOUNT'
} as const

export type BookingV2TicketCancellationSource =
  (typeof BookingV2TicketCancellationSource)[keyof typeof BookingV2TicketCancellationSource]
export type BookingV2TicketSeat = {
  __typename?: 'BookingV2TicketSeat'
  id: Scalars['UUID']['output']
  label: Scalars['String']['output']
}

export type BookingV2TicketServiceFee = {
  __typename?: 'BookingV2TicketServiceFee'
  id: Scalars['UUID']['output']
  price: Scalars['Int']['output']
}

export const BookingV2TicketStatus = {
  Cancelled: 'CANCELLED',
  Confirmed: 'CONFIRMED',
  Pending: 'PENDING'
} as const

export type BookingV2TicketStatus = (typeof BookingV2TicketStatus)[keyof typeof BookingV2TicketStatus]
export type BookingV2Trip = {
  __typename?: 'BookingV2Trip'
  checkInScore?: Maybe<Scalars['Float']['output']>
  companyLine: BookingV2TripCompanyLine
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  segment: BookingV2TripSegment
}

export type BookingV2TripCompanyLine = {
  __typename?: 'BookingV2TripCompanyLine'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BookingV2TripSegment = {
  __typename?: 'BookingV2TripSegment'
  arrivalAt: Scalars['Time']['output']
  departureAt: Scalars['Time']['output']
  destination: BookingV2TripSegmentPlace
  fare?: Maybe<BookingV2TripSegmentFare>
  id: Scalars['UUID']['output']
  origin: BookingV2TripSegmentPlace
}

export type BookingV2TripSegmentFare = {
  __typename?: 'BookingV2TripSegmentFare'
  basePrice: Scalars['Int']['output']
  id: Scalars['UUID']['output']
}

export type BookingV2TripSegmentPlace = {
  __typename?: 'BookingV2TripSegmentPlace'
  city: BookingV2TripSegmentPlaceCity
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BookingV2TripSegmentPlaceCity = {
  __typename?: 'BookingV2TripSegmentPlaceCity'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  timezone: Scalars['Timezone']['output']
}

export type BookingV2UserAccount = {
  __typename?: 'BookingV2UserAccount'
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<PhoneNumber>
}

export const BookingV2Vertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type BookingV2Vertical = (typeof BookingV2Vertical)[keyof typeof BookingV2Vertical]
export const BookingVertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type BookingVertical = (typeof BookingVertical)[keyof typeof BookingVertical]
/** bookings dashboard data */
export type BookingsDashboardData = {
  __typename?: 'BookingsDashboardData'
  /** cancelled bookings */
  cancelled: BookingsDashboardDataMethodInfo
  /** confirmed bookings */
  confirmed: BookingsDashboardDataMethodInfo
  /** failed bookings */
  failed: BookingsDashboardDataMethodInfo
  /** partially confirmed bookings */
  partiallyConfirmed: BookingsDashboardDataMethodInfo
  /** reserved bookings */
  reserved: BookingsDashboardDataMethodInfo
}

export type BookingsDashboardDataInfo = {
  __typename?: 'BookingsDashboardDataInfo'
  /** total in cents */
  amount: Scalars['Long']['output']
  /** number of bookings */
  count: Scalars['Int']['output']
}

export type BookingsDashboardDataMethodInfo = {
  __typename?: 'BookingsDashboardDataMethodInfo'
  /** bookings made offline */
  offline: BookingsDashboardDataInfo
  /** bookings made online */
  online: BookingsDashboardDataInfo
}

/** bookings dashboard response */
export type BookingsDashboardResponse = {
  __typename?: 'BookingsDashboardResponse'
  /** data for the requested day */
  day: BookingsDashboardData
  /** data for the requested month */
  month: BookingsDashboardData
}

/** paginated bookings response */
export type BookingsResponse = {
  __typename?: 'BookingsResponse'
  /** bookings */
  items: Array<Booking>
  /** total of bookings */
  total: Scalars['Int']['output']
}

export const BookingsV2BuyerEmailStatusInput = {
  Bounce: 'BOUNCE',
  Deferred: 'DEFERRED',
  Delivered: 'DELIVERED',
  Dropped: 'DROPPED',
  Open: 'OPEN',
  Processed: 'PROCESSED',
  Sent: 'SENT'
} as const

export type BookingsV2BuyerEmailStatusInput =
  (typeof BookingsV2BuyerEmailStatusInput)[keyof typeof BookingsV2BuyerEmailStatusInput]
export type BookingsV2Input = {
  buyerEmail?: InputMaybe<Scalars['String']['input']>
  buyerEmailStatus?: InputMaybe<BookingsV2BuyerEmailStatusInput>
  buyerPhone?: InputMaybe<Scalars['String']['input']>
  companyLineID?: InputMaybe<Scalars['UUID']['input']>
  confirmedAtRange?: InputMaybe<BookingsV2TimeRangeInput>
  couponCode?: InputMaybe<Scalars['String']['input']>
  createdAtRange?: InputMaybe<BookingsV2TimeRangeInput>
  departureAtRange?: InputMaybe<BookingsV2TimeRangeInput>
  destinationID?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  originID?: InputMaybe<Scalars['UUID']['input']>
  routeServiceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  salesChannelID?: InputMaybe<Scalars['UUID']['input']>
  shortIDs?: InputMaybe<Array<Scalars['String']['input']>>
  siteID?: InputMaybe<Scalars['UUID']['input']>
  statuses?: InputMaybe<Array<BookingV2Status>>
}

export type BookingsV2Response = {
  __typename?: 'BookingsV2Response'
  items: Array<BookingV2>
  total: Scalars['Int']['output']
}

export type BookingsV2TimeRangeInput = {
  endAt?: InputMaybe<Scalars['Time']['input']>
  startAt?: InputMaybe<Scalars['Time']['input']>
}

export type BusinessClient = {
  __typename?: 'BusinessClient'
  companies: Array<BusinessClientCompany>
  contacts: Array<BusinessClientContact>
  createdAt: Scalars['Time']['output']
  emailDomains: Array<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  kamUser?: Maybe<BusinessClientKamUser>
  kreditDeposits?: Maybe<Array<KreditDeposit>>
  kreditsSettings?: Maybe<KreditsSettings>
  logo?: Maybe<Asset>
  name: Scalars['String']['output']
  numberOfCustomers: Scalars['Int']['output']
  numberOfSites: Scalars['Int']['output']
  processedMobileLineFiles?: Maybe<Array<BusinessClientProcessedMobileLineFile>>
  shareCustomersData: Scalars['Boolean']['output']
  updatedAt: Scalars['Time']['output']
}

export type BusinessClientAutocomplete = {
  __typename?: 'BusinessClientAutocomplete'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  verticals: Array<BusinessClientVertical>
}

export type BusinessClientCompany = {
  __typename?: 'BusinessClientCompany'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  vertical: BusinessClientVertical
}

export type BusinessClientContact = {
  __typename?: 'BusinessClientContact'
  company?: Maybe<BusinessClientCompany>
  email: Scalars['String']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  phone: Scalars['String']['output']
  secondaryEmail?: Maybe<Scalars['String']['output']>
  secondaryPhone?: Maybe<Scalars['String']['output']>
}

export type BusinessClientKamUser = {
  __typename?: 'BusinessClientKamUser'
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
}

export type BusinessClientProcessedMobileLineFile = {
  __typename?: 'BusinessClientProcessedMobileLineFile'
  id: Scalars['UUID']['output']
  processedAmount: Scalars['Int']['output']
  processedAt: Scalars['Time']['output']
  processedBy: BusinessClientKamUser
}

export type BusinessClientSuggestion = {
  __typename?: 'BusinessClientSuggestion'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  verticals: Array<BusinessClientSuggestionVertical>
}

export const BusinessClientSuggestionVertical = {
  City: 'CITY',
  Mobile: 'MOBILE',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type BusinessClientSuggestionVertical =
  (typeof BusinessClientSuggestionVertical)[keyof typeof BusinessClientSuggestionVertical]
export type BusinessClientSuggestionsInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
  verticals?: InputMaybe<Array<BusinessClientSuggestionVertical>>
}

export type BusinessClientSuggestionsResponse = {
  __typename?: 'BusinessClientSuggestionsResponse'
  items: Array<BusinessClientSuggestion>
  total: Scalars['Long']['output']
}

export type BusinessClientUser = {
  __typename?: 'BusinessClientUser'
  businessClient: BusinessClientUserBusinessClient
  businessSite?: Maybe<BusinessClientUserBusinessSite>
  createdAt: Scalars['Time']['output']
  hasAdminRole: Scalars['Boolean']['output']
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  title: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
  userAccount: BusinessClientUserUserAccount
}

export type BusinessClientUserBusinessClient = {
  __typename?: 'BusinessClientUserBusinessClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessClientUserBusinessSite = {
  __typename?: 'BusinessClientUserBusinessSite'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessClientUserUserAccount = {
  __typename?: 'BusinessClientUserUserAccount'
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<BusinessClientUserUserAccountPhoneNumber>
}

export type BusinessClientUserUserAccountPhoneNumber = {
  __typename?: 'BusinessClientUserUserAccountPhoneNumber'
  countryCode: Scalars['String']['output']
  number: Scalars['String']['output']
}

export type BusinessClientUsersInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
}

export type BusinessClientUsersResponse = {
  __typename?: 'BusinessClientUsersResponse'
  items: Array<BusinessClientUser>
  total: Scalars['Int']['output']
}

export const BusinessClientVertical = {
  City: 'CITY',
  Mobile: 'MOBILE',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type BusinessClientVertical = (typeof BusinessClientVertical)[keyof typeof BusinessClientVertical]
export const BusinessClientVerticalInput = {
  City: 'CITY',
  Mobile: 'MOBILE',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type BusinessClientVerticalInput = (typeof BusinessClientVerticalInput)[keyof typeof BusinessClientVerticalInput]
export type BusinessClientsAutocompleteInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
}

export type BusinessClientsAutocompleteResponse = {
  __typename?: 'BusinessClientsAutocompleteResponse'
  items: Array<BusinessClientAutocomplete>
  total: Scalars['Int']['output']
}

export type BusinessClientsInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  vertical?: InputMaybe<BusinessClientVerticalInput>
}

export type BusinessClientsResponse = {
  __typename?: 'BusinessClientsResponse'
  items: Array<BusinessClient>
  total: Scalars['Int']['output']
}

export const BusinessClientsRouteServicesSchedulePriceDow = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const

export type BusinessClientsRouteServicesSchedulePriceDow =
  (typeof BusinessClientsRouteServicesSchedulePriceDow)[keyof typeof BusinessClientsRouteServicesSchedulePriceDow]
export type BusinessCustomer = {
  __typename?: 'BusinessCustomer'
  /** Business client */
  businessClient: BusinessCustomerClient
  /** Business site */
  businessSite?: Maybe<BusinessCustomerSite>
  /** indicates whether this customer is in a domiciliated route */
  hasHomePickupRoute: Scalars['Boolean']['output']
  /** Business customer ID */
  id: Scalars['UUID']['output']
  /** Business customer is enabled */
  isEnabled: Scalars['Boolean']['output']
  /**
   * KreditsSettings is null if the customer does not have a corporate kredits configuration
   * set through the business client. this is not null if the customer has a corporate kredits,
   * and the kreditsSettings.category is null if the customer does not have a category assigned
   */
  kreditsSettings?: Maybe<BusinessCustomerKreditsSettings>
  /** Place */
  place?: Maybe<BusinessCustomerPlace>
  /** QR Code */
  qrCode: Scalars['String']['output']
  /** indicates the routes this customer is in */
  routeIDs?: Maybe<Array<Scalars['UUID']['output']>>
  /** Business customer type */
  type: BusinessCustomerType
  /** User account */
  userAccount: BusinessCustomerUserAccount
}

export type BusinessCustomerCity = {
  __typename?: 'BusinessCustomerCity'
  /** City ID */
  id: Scalars['UUID']['output']
  /** City name */
  name: Scalars['String']['output']
}

export type BusinessCustomerClient = {
  __typename?: 'BusinessCustomerClient'
  /** Business client ID */
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  /** True if the business client has corporate kredits enabled */
  isKreditEnabled: Scalars['Boolean']['output']
  /** Business client name */
  name: Scalars['String']['output']
  /** Business client verticals */
  verticals: Array<BusinessClientVertical>
}

export type BusinessCustomerInput = {
  /** Business customer ID */
  id: Scalars['UUID']['input']
}

export type BusinessCustomerKreditsSettings = {
  __typename?: 'BusinessCustomerKreditsSettings'
  /** amount this customer receives, in cents */
  amount: Scalars['Int']['output']
  /** assigned category. null if not assigned */
  category?: Maybe<Scalars['Int']['output']>
}

export type BusinessCustomerPlace = {
  __typename?: 'BusinessCustomerPlace'
  /** Place address */
  address?: Maybe<BusinessCustomerPlaceAddress>
  /** Place ID */
  id: Scalars['UUID']['output']
  /** Place parent */
  parent: BusinessCustomerCity
}

export type BusinessCustomerPlaceAddress = {
  __typename?: 'BusinessCustomerPlaceAddress'
  /** Address line 1 */
  line1: Scalars['String']['output']
  /** Address zip code */
  zipCode: Scalars['String']['output']
}

export type BusinessCustomerPlaceInput = {
  /** The business customer address */
  address: Scalars['String']['input']
  /** Coordinates for the place. If not provided, the coordinates will be fetched from the address */
  location?: InputMaybe<LocationInput>
  /** The ID of the city where this place is located */
  parentID: Scalars['UUID']['input']
  /** The business customer zip code */
  zipCode: Scalars['String']['input']
}

export type BusinessCustomerSite = {
  __typename?: 'BusinessCustomerSite'
  /** Business site ID */
  id: Scalars['UUID']['output']
  /** Business site name */
  name: Scalars['String']['output']
}

export type BusinessCustomerSuggestion = {
  __typename?: 'BusinessCustomerSuggestion'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessCustomerSuggestionsInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type BusinessCustomerSuggestionsResponse = {
  __typename?: 'BusinessCustomerSuggestionsResponse'
  items: Array<BusinessCustomerSuggestion>
  total: Scalars['Long']['output']
}

export const BusinessCustomerType = {
  Associate: 'ASSOCIATE'
} as const

export type BusinessCustomerType = (typeof BusinessCustomerType)[keyof typeof BusinessCustomerType]
export const BusinessCustomerTypeInput = {
  Associate: 'ASSOCIATE'
} as const

export type BusinessCustomerTypeInput = (typeof BusinessCustomerTypeInput)[keyof typeof BusinessCustomerTypeInput]
export type BusinessCustomerUserAccount = {
  __typename?: 'BusinessCustomerUserAccount'
  /** User account email */
  email?: Maybe<Scalars['String']['output']>
  /** User account first name */
  firstName?: Maybe<Scalars['String']['output']>
  /** User account ID */
  id: Scalars['UUID']['output']
  /** User account last name */
  lastName?: Maybe<Scalars['String']['output']>
  /**
   * User account name
   * @deprecated use FirstName and LastName
   */
  name: Scalars['String']['output']
  /**
   * User account phone
   * @deprecated use phoneNumber
   */
  phone?: Maybe<Scalars['String']['output']>
  /** User account phone number */
  phoneNumber?: Maybe<PhoneNumber>
}

export type BusinessCustomersInput = {
  /** Business client id */
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  /** Business customer id, may be a UUID or the first 8 characters of a UUID */
  businessCustomerID?: InputMaybe<Scalars['String']['input']>
  /** Business Site ID, may be a UUID or the first 8 characters of a UUID */
  businessSiteID?: InputMaybe<Scalars['String']['input']>
  /** Corporate Kredits Category, use 0 to filter customers without a category */
  category?: InputMaybe<Scalars['Int']['input']>
  /** Business Customer Email */
  email?: InputMaybe<Scalars['String']['input']>
  /** businessCustomerIDs is a list of business customer uuids */
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  /** IsEnabled */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** Business Customer Phone Number */
  phoneNumber?: InputMaybe<BusinessCustomersPhoneNumberInput>
  /** User account id, may be a UUID or the first 8 characters of a UUID */
  userAccountID?: InputMaybe<Scalars['String']['input']>
}

export type BusinessCustomersPhoneNumberInput = {
  /** country code is ignored at the moment. may be implemented in the future */
  countryCode?: InputMaybe<Scalars['String']['input']>
  number: Scalars['String']['input']
}

export type BusinessCustomersResponse = {
  __typename?: 'BusinessCustomersResponse'
  /** Current page */
  items: Array<BusinessCustomer>
  /** Total number of items */
  total: Scalars['Int']['output']
}

export type BusinessPartner = {
  __typename?: 'BusinessPartner'
  bankDetails?: Maybe<BusinessPartnerBankDetails>
  /** @deprecated Use `bankDetails` instead */
  bankName: Scalars['String']['output']
  /** @deprecated Use `taxInfo` instead */
  businessName?: Maybe<Scalars['String']['output']>
  city?: Maybe<BusinessPartnerCity>
  /** @deprecated Use `city` instead */
  cityName?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `bankDetails` instead */
  clabe: Scalars['String']['output']
  /** @deprecated Use `taxInfo` instead */
  companyName?: Maybe<Scalars['String']['output']>
  contacts: Array<BusinessPartnerContact>
  createdAt: Scalars['Time']['output']
  /** @deprecated Use `taxInfo` instead */
  curp?: Maybe<Scalars['String']['output']>
  documents: Array<BusinessPartnerDocument>
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  kamUser?: Maybe<BusinessPartnerKamUser>
  name: Scalars['String']['output']
  numberOfVehicles: Scalars['Int']['output']
  operationalStateCodes?: Maybe<Array<Scalars['String']['output']>>
  /** @deprecated Use `taxInfo` instead */
  personType?: Maybe<BusinessPartnerTaxPersonType>
  /** @deprecated Use `taxInfo` instead */
  rfc: Scalars['String']['output']
  stateCode?: Maybe<Scalars['String']['output']>
  /** @deprecated Use `operationalStateCodes` instead */
  stateCodes?: Maybe<Array<Scalars['String']['output']>>
  taxInfo?: Maybe<BusinessPartnerTaxInformation>
  type: BusinessPartnerType
  updatedAt: Scalars['Time']['output']
  verticals: Array<BusinessPartnerVertical>
}

export type BusinessPartnerAutocomplete = {
  __typename?: 'BusinessPartnerAutocomplete'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  verticals: Array<BusinessPartnerVertical>
}

export type BusinessPartnerBankDetails = {
  __typename?: 'BusinessPartnerBankDetails'
  bankCoverLink?: Maybe<Scalars['String']['output']>
  bankName: Scalars['String']['output']
  clabe: Scalars['String']['output']
  paymentEmail: Scalars['String']['output']
  paymentType: BusinessPartnerBankPaymentType
}

export const BusinessPartnerBankPaymentType = {
  InterbankTransfer: 'INTERBANK_TRANSFER',
  Spei: 'SPEI',
  TransferWithinBank: 'TRANSFER_WITHIN_BANK'
} as const

export type BusinessPartnerBankPaymentType =
  (typeof BusinessPartnerBankPaymentType)[keyof typeof BusinessPartnerBankPaymentType]
export type BusinessPartnerCity = {
  __typename?: 'BusinessPartnerCity'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  stateCode: Scalars['String']['output']
}

export type BusinessPartnerContact = {
  __typename?: 'BusinessPartnerContact'
  email: Scalars['String']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  phone: Scalars['String']['output']
  secondaryEmail?: Maybe<Scalars['String']['output']>
  secondaryPhone?: Maybe<Scalars['String']['output']>
}

export type BusinessPartnerDocument = {
  __typename?: 'BusinessPartnerDocument'
  category: BusinessPartnerDocumentCategory
  filename: Scalars['String']['output']
  id: Scalars['UUID']['output']
  url: Scalars['String']['output']
}

export const BusinessPartnerDocumentCategory = {
  AccountStatementCover: 'ACCOUNT_STATEMENT_COVER',
  ComplianceOpinion: 'COMPLIANCE_OPINION',
  ConstitutiveAct: 'CONSTITUTIVE_ACT',
  Curp: 'CURP',
  OfficialId: 'OFFICIAL_ID',
  PowerOfAttorney: 'POWER_OF_ATTORNEY',
  ProofOfAddress: 'PROOF_OF_ADDRESS',
  Repse: 'REPSE',
  Rfc: 'RFC'
} as const

export type BusinessPartnerDocumentCategory =
  (typeof BusinessPartnerDocumentCategory)[keyof typeof BusinessPartnerDocumentCategory]
export type BusinessPartnerKamUser = {
  __typename?: 'BusinessPartnerKamUser'
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
}

export type BusinessPartnerTaxInformation = {
  __typename?: 'BusinessPartnerTaxInformation'
  businessName?: Maybe<Scalars['String']['output']>
  companyName?: Maybe<Scalars['String']['output']>
  curp?: Maybe<Scalars['String']['output']>
  personType: BusinessPartnerTaxPersonType
  proofOfTaxSituation?: Maybe<Scalars['String']['output']>
  repseID?: Maybe<Scalars['String']['output']>
  repseLink?: Maybe<Scalars['String']['output']>
  rfc: Scalars['String']['output']
  taxRegime?: Maybe<Scalars['String']['output']>
}

export const BusinessPartnerTaxPersonType = {
  Individual: 'INDIVIDUAL',
  LegalEntity: 'LEGAL_ENTITY'
} as const

export type BusinessPartnerTaxPersonType =
  (typeof BusinessPartnerTaxPersonType)[keyof typeof BusinessPartnerTaxPersonType]
export const BusinessPartnerType = {
  Fleet: 'FLEET',
  Host: 'HOST'
} as const

export type BusinessPartnerType = (typeof BusinessPartnerType)[keyof typeof BusinessPartnerType]
export const BusinessPartnerVertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type BusinessPartnerVertical = (typeof BusinessPartnerVertical)[keyof typeof BusinessPartnerVertical]
export type BusinessPartnersAutocompleteInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>
}

export type BusinessPartnersAutocompleteResponse = {
  __typename?: 'BusinessPartnersAutocompleteResponse'
  items: Array<BusinessPartnerAutocomplete>
  total: Scalars['Int']['output']
}

export type BusinessPartnersInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  kamUserId?: InputMaybe<Scalars['UUID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  paymentEmail?: InputMaybe<Scalars['String']['input']>
  rfc?: InputMaybe<Scalars['String']['input']>
  stateCodes?: InputMaybe<Array<Scalars['String']['input']>>
  taxPersonType?: InputMaybe<BusinessPartnerTaxPersonType>
}

export type BusinessPartnersResponse = {
  __typename?: 'BusinessPartnersResponse'
  items: Array<BusinessPartner>
  total: Scalars['Int']['output']
}

export type BusinessSite = {
  __typename?: 'BusinessSite'
  city?: Maybe<BusinessSiteCity>
  client: BusinessSiteClient
  contacts: Array<BusinessSiteContact>
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  kreditsSettings?: Maybe<Array<KreditCategory>>
  name: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
}

export type BusinessSiteAutocomplete = {
  __typename?: 'BusinessSiteAutocomplete'
  clientID: Scalars['UUID']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessSiteCity = {
  __typename?: 'BusinessSiteCity'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessSiteClient = {
  __typename?: 'BusinessSiteClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessSiteContact = {
  __typename?: 'BusinessSiteContact'
  email: Scalars['String']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  phone: Scalars['String']['output']
  secondaryEmail?: Maybe<Scalars['String']['output']>
  secondaryPhone?: Maybe<Scalars['String']['output']>
}

export type BusinessSiteSuggestion = {
  __typename?: 'BusinessSiteSuggestion'
  businessClient: BusinessSiteSuggestionBusinessClient
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessSiteSuggestionBusinessClient = {
  __typename?: 'BusinessSiteSuggestionBusinessClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type BusinessSiteSuggestionsInput = {
  businessClientIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type BusinessSiteSuggestionsResponse = {
  __typename?: 'BusinessSiteSuggestionsResponse'
  items: Array<BusinessSiteSuggestion>
  total: Scalars['Long']['output']
}

export type BusinessSitesAutocompleteInput = {
  clientID?: InputMaybe<Scalars['UUID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
}

export type BusinessSitesAutocompleteResponse = {
  __typename?: 'BusinessSitesAutocompleteResponse'
  items: Array<BusinessSiteAutocomplete>
  total: Scalars['Int']['output']
}

export type BusinessSitesInput = {
  clientID?: InputMaybe<Scalars['UUID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
}

export type BusinessSitesResponse = {
  __typename?: 'BusinessSitesResponse'
  items: Array<BusinessSite>
  total: Scalars['Int']['output']
}

export type Buyer = {
  __typename?: 'Buyer'
  email?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
}

export type Campaign = {
  __typename?: 'Campaign'
  area?: Maybe<CampaignArea>
  company: CampaignCompany
  coupons: Array<Coupon>
  description: Scalars['String']['output']
  endsAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  startsAt: Scalars['String']['output']
  subCampaigns: Array<SubCampaign>
  template?: Maybe<CampaignTemplate>
  timezone: Scalars['String']['output']
  type: CampaignType
}

export const CampaignArea = {
  CustomerSupport: 'CUSTOMER_SUPPORT',
  Marketing: 'MARKETING',
  Mobile: 'MOBILE',
  Partners: 'PARTNERS',
  Sales: 'SALES',
  Snacks: 'SNACKS',
  Travel: 'TRAVEL'
} as const

export type CampaignArea = (typeof CampaignArea)[keyof typeof CampaignArea]
export type CampaignAutocomplete = {
  __typename?: 'CampaignAutocomplete'
  /** campaign id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

export type CampaignCompany = {
  __typename?: 'CampaignCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CampaignCouponSupportInteractionInput = {
  callStatus?: InputMaybe<Scalars['String']['input']>
  note?: InputMaybe<Scalars['String']['input']>
  notificationChannel?: InputMaybe<Scalars['String']['input']>
}

export type CampaignPlace = {
  __typename?: 'CampaignPlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CampaignQueryInput = {
  id: Scalars['ID']['input']
}

export type CampaignSegment = {
  __typename?: 'CampaignSegment'
  destination: CampaignPlace
  id: Scalars['ID']['output']
  origin: CampaignPlace
}

export type CampaignTemplate = {
  __typename?: 'CampaignTemplate'
  confirmationModalities: CouponConfirmationModalities
  expirationTime: Duration
  prefix?: Maybe<Scalars['String']['output']>
  /** @deprecated Use salesChannelsV2 instead */
  salesChannels: Array<SalesChannel>
  salesChannelsV2: Array<CampaignTemplateSalesChannel>
  value: Scalars['Int']['output']
}

export type CampaignTemplateSalesChannel = {
  __typename?: 'CampaignTemplateSalesChannel'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const CampaignType = {
  GeneralCoupon: 'GENERAL_COUPON',
  Incidence: 'INCIDENCE',
  UniqueCouponForDatabase: 'UNIQUE_COUPON_FOR_DATABASE',
  CustomerSupport: 'customer_support',
  Marketing: 'marketing',
  Snacks: 'snacks'
} as const

export type CampaignType = (typeof CampaignType)[keyof typeof CampaignType]
export type CampaignsAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  types?: InputMaybe<Array<CampaignType>>
}

export type CampaignsInput = {
  areas?: InputMaybe<Array<CampaignArea>>
  companyID?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  types?: InputMaybe<Array<CampaignType>>
}

export type CancelBookingTicketsInput = {
  /** comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** booking ID */
  id: Scalars['UUID']['input']
  /** payments, only required if cannot refund automatically because it was paid with cash or clip. */
  payments?: InputMaybe<Array<PaymentRefundInputV2>>
  /** cancelation reason */
  reason: BookingTicketCancelationReason
  /** refund destination. */
  refundDestination?: InputMaybe<RefundDestinationInput>
  /** ticket IDs */
  ticketIDs: Array<Scalars['UUID']['input']>
}

export type CancelBookingTicketsInsuranceInput = {
  /** booking id */
  id: Scalars['ID']['input']
  /** ticket IDs */
  ticketIDs: Array<Scalars['ID']['input']>
}

export type CancelBookingTripChangeProposalInput = {
  id: Scalars['ID']['input']
  reason?: InputMaybe<Scalars['String']['input']>
  tripChangeProposalID: Scalars['ID']['input']
}

export type CancelBusinessClientKreditDepositInput = {
  /** business client id */
  id: Scalars['UUID']['input']
  /** reason for cancellation */
  reason?: InputMaybe<Scalars['String']['input']>
  /** transaction id to cancel */
  transactionID: Scalars['UUID']['input']
}

export type CancelOrderInput = {
  id: Scalars['ID']['input']
}

export type CancelSaleItemsInput = {
  id: Scalars['ID']['input']
  lineItems: Array<CancelSaleItemsLineItemInput>
}

export type CancelSaleItemsLineItemInput = {
  id: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
}

export const CancellationCategory = {
  BusinessClient: 'BUSINESS_CLIENT',
  Driver: 'DRIVER',
  ExternalConditions: 'EXTERNAL_CONDITIONS',
  Other: 'OTHER',
  Partner: 'PARTNER',
  Planning: 'PLANNING',
  Vehicle: 'VEHICLE'
} as const

export type CancellationCategory = (typeof CancellationCategory)[keyof typeof CancellationCategory]
export const CancellationReason = {
  Accident: 'accident',
  Maintenance: 'maintenance',
  MechanicalFailure: 'mechanicalFailure',
  Other: 'other',
  Planning: 'planning',
  RoadBlock: 'roadBlock'
} as const

export type CancellationReason = (typeof CancellationReason)[keyof typeof CancellationReason]
export const CancellationSource = {
  Admin: 'ADMIN',
  UserAccount: 'USER_ACCOUNT'
} as const

export type CancellationSource = (typeof CancellationSource)[keyof typeof CancellationSource]
export const CancellationSubcategory = {
  Absence: 'ABSENCE',
  Accident: 'ACCIDENT',
  Disability: 'DISABILITY',
  MechanicalFailure: 'MECHANICAL_FAILURE',
  Other: 'OTHER',
  Protest: 'PROTEST',
  Roadblock: 'ROADBLOCK',
  ScheduledMaintenance: 'SCHEDULED_MAINTENANCE',
  Security: 'SECURITY',
  Traffic: 'TRAFFIC',
  UnitStoppage: 'UNIT_STOPPAGE',
  Weather: 'WEATHER'
} as const

export type CancellationSubcategory = (typeof CancellationSubcategory)[keyof typeof CancellationSubcategory]
export type Cart = {
  __typename?: 'Cart'
  companies: Array<CartCompany>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  status: Scalars['String']['output']
}

export type CartActivity = {
  __typename?: 'CartActivity'
  amount: Scalars['Int']['output']
  borrowedAt: Scalars['Time']['output']
  conciliationStatus?: Maybe<CartActivityConciliationStatus>
  id: Scalars['ID']['output']
  returnedAt?: Maybe<Scalars['Time']['output']>
  sales: Array<CartActivitySale>
  user: CartActivityUser
}

export const CartActivityConciliationStatus = {
  Completed: 'completed',
  Conflicting: 'conflicting'
} as const

export type CartActivityConciliationStatus =
  (typeof CartActivityConciliationStatus)[keyof typeof CartActivityConciliationStatus]
export type CartActivityResponse = {
  __typename?: 'CartActivityResponse'
  items: Array<CartActivity>
  total: Scalars['Int']['output']
}

export type CartActivitySale = {
  __typename?: 'CartActivitySale'
  amount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  status: SaleStatus
}

export type CartActivityUser = {
  __typename?: 'CartActivityUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type CartCompany = {
  __typename?: 'CartCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CartInput = {
  name: Scalars['String']['input']
}

export type CartQueryInput = {
  id: Scalars['ID']['input']
}

export const CartStatus = {
  Available: 'AVAILABLE',
  Occupied: 'OCCUPIED'
} as const

export type CartStatus = (typeof CartStatus)[keyof typeof CartStatus]
export type CartsQueryInput = {
  name?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<CartStatus>
}

export type CartsResponse = {
  __typename?: 'CartsResponse'
  items: Array<Cart>
  total: Scalars['Int']['output']
}

export type CashFlow = {
  __typename?: 'CashFlow'
  amount: Scalars['Int']['output']
  type: Scalars['String']['output']
}

export type CashFlowInput = {
  payments?: InputMaybe<Array<CashFlowPaymentInput>>
  type: CashFlowTypeInput
}

export type CashFlowPaymentInput = {
  amount: Scalars['Int']['input']
  last4?: InputMaybe<Scalars['String']['input']>
  method: PaymentIncidencePaymentMethodInput
}

export const CashFlowTypeInput = {
  Expense: 'EXPENSE',
  Income: 'INCOME'
} as const

export type CashFlowTypeInput = (typeof CashFlowTypeInput)[keyof typeof CashFlowTypeInput]
/** vehicle template cell component */
export const CellComponent = {
  Door: 'door',
  Driver: 'driver',
  Empty: 'empty',
  Seat: 'seat',
  Stair: 'stair',
  Wc: 'wc'
} as const

export type CellComponent = (typeof CellComponent)[keyof typeof CellComponent]
/** vehicle template cell component properties */
export const CellComponentProperty = {
  Handicap: 'handicap',
  Men: 'men',
  Plug: 'plug',
  Tv: 'tv',
  Women: 'women'
} as const

export type CellComponentProperty = (typeof CellComponentProperty)[keyof typeof CellComponentProperty]
export type Change = {
  __typename?: 'Change'
  bookings: Array<ChangeBooking>
  difference: Array<ChangeDifference>
  executeAt?: Maybe<Scalars['Time']['output']>
  id: Scalars['ID']['output']
  movedBookings: Array<ChangeBooking>
  status?: Maybe<ChangeStatus>
  statusChanges: Array<StatusChange>
  trips: Array<ChangeTrip>
  type: ChangeType
  user: ChangeUser
}

export type ChangeAncillaryInput = {
  conditions?: InputMaybe<AncillaryConditionsInput>
  id: Scalars['ID']['input']
  label?: InputMaybe<Array<AncillaryTranslationInput>>
  name?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
}

export type ChangeBooking = {
  __typename?: 'ChangeBooking'
  id: Scalars['ID']['output']
}

/** change passengers names input */
export type ChangeBookingPassengersNamesInput = {
  /** booking id */
  bookingID: Scalars['ID']['input']
  /** ticket id */
  passengers: Array<ChangeBookingPassengersNamesPassengerInput>
}

export type ChangeBookingPassengersNamesPassengerInput = {
  /** first name */
  firstName: Scalars['String']['input']
  /** passenger id */
  id: Scalars['ID']['input']
  /** last name */
  lastName: Scalars['String']['input']
}

export type ChangeBookingTicketsAncillariesInput = {
  id: Scalars['ID']['input']
  tickets: Array<ChangeBookingTicketsAncillariesTicketInput>
}

export type ChangeBookingTicketsAncillariesTicketAncillaryInput = {
  id: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
}

export type ChangeBookingTicketsAncillariesTicketInput = {
  ancillaries: Array<ChangeBookingTicketsAncillariesTicketAncillaryInput>
  id: Scalars['ID']['input']
}

export type ChangeBusinessClientContactInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  email: Scalars['String']['input']
  id: Scalars['UUID']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  secondaryEmail?: InputMaybe<Scalars['String']['input']>
  secondaryPhone?: InputMaybe<Scalars['String']['input']>
}

export type ChangeBusinessClientContactsInput = {
  contacts: Array<ChangeBusinessClientContactInput>
}

export type ChangeBusinessClientCustomerKreditsAmountInput = {
  /** Kredit Amount, in cents */
  amount: Scalars['Int']['input']
  /** Customer ID */
  customerID: Scalars['UUID']['input']
  /** Business Client ID */
  id: Scalars['UUID']['input']
}

export type ChangeBusinessClientCustomersKreditsAmountInput = {
  /** Kredit Amount, in cents */
  amount: Scalars['Int']['input']
  /** Customer IDs */
  customerIDs: Array<Scalars['UUID']['input']>
  /** Business Client ID */
  id: Scalars['UUID']['input']
}

export type ChangeBusinessClientInput = {
  companyIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>
  kamUserID?: InputMaybe<Scalars['UUID']['input']>
  logoPath?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  /** shareCustomersData defines if the customers' personal data will be displayed or not */
  shareCustomersData?: InputMaybe<Scalars['Boolean']['input']>
}

export type ChangeBusinessClientKreditSettingsInput = {
  /** Kredit Categories */
  categories: Array<KreditCategoryInput>
  /** Business Client ID */
  id: Scalars['UUID']['input']
  /** Site IDS for which the Kredits settings are being set */
  siteIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type ChangeBusinessClientSiteKreditSettingsInput = {
  /** Kredit Categories */
  categories: Array<KreditCategoryInput>
  /** Business Client ID */
  id: Scalars['UUID']['input']
  /** Site id for which the Kredits settings are being set */
  siteID: Scalars['UUID']['input']
}

export type ChangeBusinessClientUserBusinessClientInput = {
  businessClientID: Scalars['UUID']['input']
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  id: Scalars['UUID']['input']
}

export type ChangeBusinessClientUserInput = {
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  hasAdminRole?: InputMaybe<Scalars['Boolean']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  userAccountID: Scalars['UUID']['input']
}

export type ChangeBusinessCustomerBusinessClientInput = {
  businessClientID: Scalars['UUID']['input']
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  id: Scalars['UUID']['input']
}

export type ChangeBusinessCustomerBusinessSiteInput = {
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  id: Scalars['UUID']['input']
}

export type ChangeBusinessSiteContactInput = {
  email: Scalars['String']['input']
  id: Scalars['UUID']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  secondaryEmail?: InputMaybe<Scalars['String']['input']>
  secondaryPhone?: InputMaybe<Scalars['String']['input']>
}

export type ChangeBusinessSiteContactsInput = {
  contacts: Array<ChangeBusinessSiteContactInput>
}

export type ChangeBusinessSiteInput = {
  cityID?: InputMaybe<Scalars['UUID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ChangeCartInput = {
  cart: CartInput
  id: Scalars['ID']['input']
}

export const ChangeCategory = {
  Executed: 'executed',
  Scheduled: 'scheduled'
} as const

export type ChangeCategory = (typeof ChangeCategory)[keyof typeof ChangeCategory]
export type ChangeComboItemInput = {
  id: Scalars['ID']['input']
  item: ComboItemInput
}

export type ChangeCompanyInsuranceSettingsInput = {
  /** company id */
  companyID: Scalars['ID']['input']
  /** insurance settings */
  insuranceSettings: InsuranceSettingsInput
}

export type ChangeCurrencyExchangeRateInput = {
  exchangeRate: Scalars['Float']['input']
  id: Scalars['ID']['input']
}

export type ChangeDifference = {
  __typename?: 'ChangeDifference'
  itinerary?: Maybe<ItineraryDifference>
  routeService: ChangeRouteService
  segments?: Maybe<SegmentsDifference>
  vehicle?: Maybe<VehicleDifference>
}

export type ChangeDriverDocumentsDocumentInput = {
  category: DriverDocumentCategoryInput
  filePath: Scalars['String']['input']
}

export type ChangeDriverDocumentsInput = {
  documents: Array<ChangeDriverDocumentsDocumentInput>
  driverID: Scalars['UUID']['input']
}

/** change fare rule */
export type ChangeFareRuleInput = {
  /** activation at ranges */
  activationAtRanges?: InputMaybe<Array<FareRuleDateRangeInput>>
  /** city segments */
  citySegments?: InputMaybe<Array<FareRulecitySegmentInput>>
  /** departure at ranges */
  departureAtRanges?: InputMaybe<Array<FareRuleDateRangeInput>>
  /** description */
  description?: InputMaybe<Scalars['String']['input']>
  /** exceptions */
  exceptions?: InputMaybe<FareRuleExceptionsInput>
  /** fare rule id */
  id: Scalars['ID']['input']
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
  /** price */
  price?: InputMaybe<Scalars['Int']['input']>
}

export type ChangeInventoryInput = {
  id: Scalars['ID']['input']
  inventory: InventoryInput
}

/** change inventory rule cabin settings */
export type ChangeInventoryRuleCabinStrategiesInput = {
  /** cabin strategies */
  cabinStrategies: Array<ChangeInventoryRuleCabinStrategyInput>
  /** inventory rule id */
  id: Scalars['ID']['input']
}

/** change inventory rule cabin strategy */
export type ChangeInventoryRuleCabinStrategyInput = {
  /** activation ranges */
  activationRanges?: InputMaybe<Array<InventoryRuleDaysToDepartureRangeInput>>
  /** cabin settings */
  cabinSettings: Array<InventoryRuleCabinSettingInput>
  /** id */
  id: Scalars['ID']['input']
}

/** change inventory rule */
export type ChangeInventoryRuleInput = {
  /** activation at ranges */
  activationAtRanges?: InputMaybe<Array<InventoryRuleDateRangeInput>>
  /** city segments */
  citySegments?: InputMaybe<Array<InventoryRulecitySegmentInput>>
  /** departure at ranges */
  departureAtRanges?: InputMaybe<Array<InventoryRuleDateRangeInput>>
  /** description */
  description?: InputMaybe<Scalars['String']['input']>
  /** exceptions */
  exceptions?: InputMaybe<InventoryRuleExceptionsInput>
  /** inventory rule id */
  id: Scalars['ID']['input']
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
}

/** change item input */
export type ChangeItemInput = {
  /** item id */
  id: Scalars['ID']['input']
  /** item */
  item: ItemInput
}

export type ChangeItemKolorsMobilePlanInput = {
  id: Scalars['ID']['input']
  item: ItemKolorsMobilePlanInput
}

export type ChangeLoyaltyCampaignInput = {
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  timeFrame?: InputMaybe<ChangeLoyaltyCampaignTimeFrameInput>
}

export type ChangeLoyaltyCampaignRuleConditionsCitySegmentInput = {
  destinationID: Scalars['ID']['input']
  originID: Scalars['ID']['input']
  segmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type ChangeLoyaltyCampaignRuleConditionsInput = {
  citySegments?: InputMaybe<Array<InputMaybe<ChangeLoyaltyCampaignRuleConditionsCitySegmentInput>>>
  routeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  routeServiceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  totalBookingsValue?: InputMaybe<Scalars['Int']['input']>
}

export type ChangeLoyaltyCampaignRuleDetailsInput = {
  description?: InputMaybe<Scalars['String']['input']>
  details?: InputMaybe<Scalars['String']['input']>
  howToGet?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  validAt?: InputMaybe<Scalars['String']['input']>
}

export type ChangeLoyaltyCampaignRuleInput = {
  id: Scalars['ID']['input']
  rule: ChangeLoyaltyCampaignRuleRuleInput
}

export type ChangeLoyaltyCampaignRuleRuleInput = {
  conditions?: InputMaybe<ChangeLoyaltyCampaignRuleConditionsInput>
  details?: InputMaybe<ChangeLoyaltyCampaignRuleDetailsInput>
  id: Scalars['ID']['input']
}

export type ChangeLoyaltyCampaignTimeFrameInput = {
  endAt?: InputMaybe<Scalars['Time']['input']>
  startAt?: InputMaybe<Scalars['Time']['input']>
}

export type ChangeOperationalCostSettingsCostsInput = {
  /** costPerDriver in cents */
  costPerDriver: Scalars['Int']['input']
  /** distanceCost in cents */
  costPerKm: Scalars['Int']['input']
  /** durationCost in cents */
  durationCost: Scalars['Int']['input']
  /** fixedCost in cents */
  fixedCost: Scalars['Int']['input']
}

export type ChangeOperationalCostSettingsFactorsDurationFactorInput = {
  end: Scalars['Int']['input']
  start: Scalars['Int']['input']
  /** duration factor in percentage (input multiplied by 100) */
  value: Scalars['Int']['input']
}

export type ChangeOperationalCostSettingsFactorsInput = {
  /** airConditioning factor in percentage (input multiplied by 100) */
  airConditioning?: Scalars['Int']['input']
  /** baseDistance in meters */
  baseDistance: Scalars['Int']['input']
  duration?: InputMaybe<Array<ChangeOperationalCostSettingsFactorsDurationFactorInput>>
  /** perKm factor in percentage (input multiplied by 100) */
  perKm: Scalars['Int']['input']
  /** redZone factor in percentage (input multiplied by 100) */
  redZone: Scalars['Int']['input']
}

export type ChangeOperationalCostSettingsInput = {
  costs: ChangeOperationalCostSettingsCostsInput
  factors: ChangeOperationalCostSettingsFactorsInput
  id: Scalars['UUID']['input']
}

export type ChangeOrderInput = {
  destinationID?: InputMaybe<Scalars['ID']['input']>
  id: Scalars['ID']['input']
  lineItems?: InputMaybe<Array<OrderLineItemInput>>
  purchaseID?: InputMaybe<Scalars['ID']['input']>
  supplier?: InputMaybe<Scalars['String']['input']>
}

export type ChangePartnerBankDetailsInput = {
  bankCoverLink?: InputMaybe<Scalars['String']['input']>
  bankName: Scalars['String']['input']
  clabe: Scalars['String']['input']
  paymentEmail: Scalars['String']['input']
  paymentType: PartnerBankPaymentTypeInput
}

export type ChangePartnerContactInput = {
  email: Scalars['String']['input']
  id: Scalars['UUID']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  secondaryEmail?: InputMaybe<Scalars['String']['input']>
  secondaryPhone?: InputMaybe<Scalars['String']['input']>
}

export type ChangePartnerContactsInput = {
  contacts: Array<ChangePartnerContactInput>
}

export type ChangePartnerDetailsInput = {
  cityID?: InputMaybe<Scalars['UUID']['input']>
  name: Scalars['String']['input']
  operationalStateCodes: Array<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  type: PartnerTypeInput
  verticals: Array<PartnerVerticalInput>
}

export type ChangePartnerKamUserInput = {
  kamUserID: Scalars['UUID']['input']
}

export type ChangePartnerTaxInformationInput = {
  businessName?: InputMaybe<Scalars['String']['input']>
  companyName?: InputMaybe<Scalars['String']['input']>
  curp?: InputMaybe<Scalars['String']['input']>
  personType: PartnerTaxInformationPersonTypeInput
  proofOfTaxSituation?: InputMaybe<Scalars['String']['input']>
  repseID?: InputMaybe<Scalars['String']['input']>
  repseLink?: InputMaybe<Scalars['String']['input']>
  rfc: Scalars['String']['input']
  taxRegime?: InputMaybe<Scalars['String']['input']>
}

export type ChangePassengerPropertyDateRangeInput = {
  endAt: Scalars['Time']['input']
  startAt: Scalars['Time']['input']
}

export type ChangePassengerPropertyInput = {
  abbreviation?: InputMaybe<Array<ChangePassengerPropertyTranslationInput>>
  departureDateRanges?: InputMaybe<Array<ChangePassengerPropertyDateRangeInput>>
  description?: InputMaybe<Array<ChangePassengerPropertyTranslationInput>>
  id: Scalars['ID']['input']
  label?: InputMaybe<Array<ChangePassengerPropertyTranslationInput>>
  required?: InputMaybe<Scalars['Boolean']['input']>
  searchDateRanges?: InputMaybe<Array<ChangePassengerPropertyDateRangeInput>>
  settings?: InputMaybe<Array<ChangePassengerPropertySettingInput>>
}

export type ChangePassengerPropertySettingInput = {
  discount: Scalars['Int']['input']
  passengerTypeIDs: Array<Scalars['ID']['input']>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type ChangePassengerPropertyTranslationInput = {
  language: Language
  text: Scalars['String']['input']
}

export type ChangePassengerTypeInput = {
  abbreviation?: InputMaybe<Array<ChangePassengerTypeTranslationInput>>
  description?: InputMaybe<Array<ChangePassengerTypeTranslationInput>>
  discount?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
  label?: InputMaybe<Array<ChangePassengerTypeTranslationInput>>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type ChangePassengerTypeTranslationInput = {
  language: Language
  plural?: Scalars['Boolean']['input']
  text: Scalars['String']['input']
}

export type ChangePlace = {
  __typename?: 'ChangePlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  timezone: Scalars['String']['output']
}

export type ChangePlaceV2AddressInput = {
  cityName?: InputMaybe<Scalars['String']['input']>
  countryCode?: InputMaybe<Scalars['String']['input']>
  line1?: InputMaybe<Scalars['String']['input']>
  line2?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type ChangePlaceV2CoordinatesInput = {
  latitude: Scalars['String']['input']
  longitude: Scalars['String']['input']
}

export type ChangePlaceV2Input = {
  address?: InputMaybe<ChangePlaceV2AddressInput>
  amenities?: InputMaybe<Array<PlaceV2AmenityInput>>
  area?: InputMaybe<Scalars['String']['input']>
  coordinates?: InputMaybe<ChangePlaceV2CoordinatesInput>
  directions?: InputMaybe<Scalars['String']['input']>
  geofenceRadius?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  param?: InputMaybe<Scalars['String']['input']>
  photoPath?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  type?: InputMaybe<PlaceV2TypeInput>
}

export type ChangeRouteService = {
  __typename?: 'ChangeRouteService'
  code: Scalars['String']['output']
  id: Scalars['String']['output']
}

export type ChangeRouteServiceBusinessClientInput = {
  businessSiteIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  id: Scalars['ID']['input']
}

export type ChangeRouteServiceItinerariesScheduleInput = {
  /** route service id */
  id: Scalars['ID']['input']
  /** itineraries schedule */
  itinerariesSchedule: Array<ChangeRouteServiceItineraryScheduleInput>
}

export type ChangeRouteServiceItineraryScheduleInput = {
  /** days of week */
  dow: Array<Weekday>
  /** end at */
  endAt?: InputMaybe<Scalars['Date']['input']>
  /** itinerary schedule id */
  id: Scalars['ID']['input']
  /** itinerary */
  itinerary: Array<ChangeRouteServiceItineraryScheduleStopInput>
  /** notes */
  notes?: Array<Scalars['String']['input']>
  /** route id */
  routeID: Scalars['ID']['input']
  /** start at */
  startAt: Scalars['Date']['input']
}

export type ChangeRouteServiceItineraryScheduleStopInput = {
  arrival?: InputMaybe<ChangeRouteServiceItineraryScheduleStopTimeInput>
  departure?: InputMaybe<ChangeRouteServiceItineraryScheduleStopTimeInput>
  placeID: Scalars['ID']['input']
}

export type ChangeRouteServiceItineraryScheduleStopTimeInput = {
  day: Scalars['Int']['input']
  time: Scalars['String']['input']
}

export type ChangeRouteServiceVehicleScheduleFrequencyInput = {
  unit: RouteServiceScheduleFrequencyUnit
  value: Scalars['Int']['input']
}

export type ChangeRouteServiceVehicleScheduleInput = {
  /** days of week */
  dow?: InputMaybe<Array<Weekday>>
  /** driver id */
  driverID?: InputMaybe<Scalars['ID']['input']>
  /** end at */
  endAt?: InputMaybe<Scalars['Date']['input']>
  /** frequency */
  frequency?: InputMaybe<ChangeRouteServiceVehicleScheduleFrequencyInput>
  /** vehicle schedule id */
  id: Scalars['ID']['input']
  /** start at */
  startAt: Scalars['Date']['input']
  /** vehicle id */
  vehicleID: Scalars['ID']['input']
}

export type ChangeRouteServiceVehiclesScheduleInput = {
  /** route service id */
  id: Scalars['ID']['input']
  /** vehicles schedule */
  vehiclesSchedule: Array<ChangeRouteServiceVehicleScheduleInput>
}

export type ChangeRoutingProjectInput = {
  id: Scalars['UUID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ChangeRoutingProjectPlanConstraintsInput = {
  id: Scalars['UUID']['input']
  plan: ChangeRoutingProjectPlanConstraintsPlanInput
}

export type ChangeRoutingProjectPlanConstraintsPlanConstraintsInput = {
  destinationID?: InputMaybe<Scalars['UUID']['input']>
  endTime?: InputMaybe<Scalars['String']['input']>
  maxDistance?: InputMaybe<Scalars['Int']['input']>
  maxDuration?: InputMaybe<Scalars['Int']['input']>
  maxStops?: InputMaybe<Scalars['Int']['input']>
  originID?: InputMaybe<Scalars['UUID']['input']>
  startTime?: InputMaybe<Scalars['String']['input']>
  stopDuration?: InputMaybe<Scalars['Int']['input']>
  vehicles?: InputMaybe<Array<InputMaybe<ChangeRoutingProjectPlanConstraintsPlanConstraintsVehicleInput>>>
}

export type ChangeRoutingProjectPlanConstraintsPlanConstraintsVehicleInput = {
  capacity: Scalars['Int']['input']
  number: Scalars['Int']['input']
}

export type ChangeRoutingProjectPlanConstraintsPlanInput = {
  constraints: ChangeRoutingProjectPlanConstraintsPlanConstraintsInput
  id: Scalars['UUID']['input']
}

export type ChangeRoutingProjectPlanDatasetLocationsInput = {
  id: Scalars['UUID']['input']
  plan: ChangeRoutingProjectPlanDatasetLocationsPlanInput
}

export type ChangeRoutingProjectPlanDatasetLocationsPlanDatasetInput = {
  locations: Array<ChangeRoutingProjectPlanDatasetLocationsPlanDatasetLocationInput>
}

export type ChangeRoutingProjectPlanDatasetLocationsPlanDatasetLocationCoordinatesInput = {
  latitude: Scalars['String']['input']
  longitude: Scalars['String']['input']
}

export type ChangeRoutingProjectPlanDatasetLocationsPlanDatasetLocationInput = {
  coordinates: ChangeRoutingProjectPlanDatasetLocationsPlanDatasetLocationCoordinatesInput
  dow?: InputMaybe<Array<RoutingProjectLocationDow>>
  id: Scalars['UUID']['input']
  label: Scalars['String']['input']
}

export type ChangeRoutingProjectPlanDatasetLocationsPlanInput = {
  dataset: ChangeRoutingProjectPlanDatasetLocationsPlanDatasetInput
  id: Scalars['UUID']['input']
}

export type ChangeRoutingProjectPlanOptimizationRouteStopsInput = {
  id: Scalars['UUID']['input']
  plan: ChangeRoutingProjectPlanOptimizationRouteStopsPlanInput
}

export type ChangeRoutingProjectPlanOptimizationRouteStopsPlanInput = {
  id: Scalars['UUID']['input']
  optimization: ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationInput
}

export type ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationInput = {
  route: ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationRouteInput
}

export type ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationRouteInput = {
  distance: Scalars['Int']['input']
  duration: Scalars['Int']['input']
  id: Scalars['UUID']['input']
  polyline: Scalars['String']['input']
  stops: Array<ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationRouteStopInput>
}

export type ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationRouteStopInput = {
  arrival?: InputMaybe<ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationRouteStopTimeInput>
  departure?: InputMaybe<ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationRouteStopTimeInput>
  locationID: Scalars['UUID']['input']
}

export type ChangeRoutingProjectPlanOptimizationRouteStopsPlanOptimizationRouteStopTimeInput = {
  day: Scalars['Int']['input']
  time: Scalars['String']['input']
}

export type ChangeSegment = {
  __typename?: 'ChangeSegment'
  destination: ChangePlace
  id: Scalars['ID']['output']
  origin: ChangePlace
}

export type ChangeServiceFeeAddonRuleFeeInput = {
  amount: Scalars['Int']['input']
  currencyCode: Scalars['String']['input']
}

export type ChangeServiceFeeAddonRuleInput = {
  companyID: Scalars['ID']['input']
  confirmationModalities?: InputMaybe<Array<ConfirmationModality>>
  id: Scalars['ID']['input']
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  segmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  ticketFees?: InputMaybe<Array<ChangeServiceFeeAddonRuleTicketFeeInput>>
}

export type ChangeServiceFeeAddonRuleTicketFeeInput = {
  fees: Array<ChangeServiceFeeAddonRuleFeeInput>
  quantity: Scalars['Int']['input']
}

export const ChangeStatus = {
  Cancelled: 'cancelled',
  Completed: 'completed',
  Executed: 'executed',
  Failed: 'failed',
  Scheduled: 'scheduled',
  Started: 'started'
} as const

export type ChangeStatus = (typeof ChangeStatus)[keyof typeof ChangeStatus]
export type ChangeStop = {
  __typename?: 'ChangeStop'
  arrivalAt?: Maybe<Scalars['Time']['output']>
  departureAt?: Maybe<Scalars['Time']['output']>
  origin: ChangePlace
}

export type ChangeTDriverDetailsInput = {
  partnerID?: InputMaybe<Scalars['UUID']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
}

export type ChangeTRouteInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type ChangeTTripDriverInput = {
  comments?: InputMaybe<Scalars['String']['input']>
  driverID?: InputMaybe<Scalars['UUID']['input']>
  reason?: InputMaybe<ChangeTripDriverReason>
}

export type ChangeTVehicleCardsInput = {
  fuelCards?: InputMaybe<Array<Scalars['String']['input']>>
  tagCards?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ChangeTVehicleDetailsInput = {
  cityName?: InputMaybe<Scalars['String']['input']>
  companyIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  externalID?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  stateCode?: InputMaybe<Scalars['String']['input']>
  vin: Scalars['String']['input']
}

export type ChangeTVehicleDocumentsDocumentInput = {
  category: VehicleDocumentCategoryInput
  filePath: Scalars['String']['input']
}

export type ChangeTVehicleDocumentsInput = {
  documents: Array<ChangeTVehicleDocumentsDocumentInput>
}

export type ChangeTVehicleDriversInput = {
  driverIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type ChangeTVehicleFeaturesInput = {
  amenities?: InputMaybe<Array<Scalars['String']['input']>>
  brandCoverage?: InputMaybe<Scalars['String']['input']>
  make?: InputMaybe<Scalars['String']['input']>
  model?: InputMaybe<Scalars['String']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

export type ChangeTVehicleInsurancePolicyInput = {
  expirationDate: Scalars['Date']['input']
  filePath?: InputMaybe<Scalars['String']['input']>
}

export type ChangeTVehicleLicensePlatesInput = {
  licensePlates: Array<ChangeTVehicleLicensePlatesLicensePlateInput>
}

export type ChangeTVehicleLicensePlatesLicensePlateInput = {
  number: Scalars['String']['input']
  stateCode?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
}

export type ChangeTVehicleOdometerReadingInput = {
  odometerReading: Scalars['Int']['input']
}

export type ChangeTVehicleRegistrationDetailsInput = {
  category: VehicleRegistrationCategoryInput
  expirationDate?: InputMaybe<Scalars['Date']['input']>
  filePath?: InputMaybe<Scalars['String']['input']>
  isPermanent?: Scalars['Boolean']['input']
  stateCode?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<VehicleRegistrationTypeInput>
}

export type ChangeTrip = {
  __typename?: 'ChangeTrip'
  departureAt: Scalars['Time']['output']
  id: Scalars['ID']['output']
}

export type ChangeTripConfirmationModalitiesConfirmationModalityExceptionsInput = {
  placeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type ChangeTripConfirmationModalitiesConfirmationModalityInput = {
  exceptions: ChangeTripConfirmationModalitiesConfirmationModalityExceptionsInput
  name: Scalars['String']['input']
  salesChannelIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type ChangeTripConfirmationModalitiesInput = {
  confirmationModalities: Array<ChangeTripConfirmationModalitiesConfirmationModalityInput>
  id: Scalars['UUID']['input']
}

export const ChangeTripDriverReason = {
  BusinessClient: 'BUSINESS_CLIENT',
  Partner: 'PARTNER'
} as const

export type ChangeTripDriverReason = (typeof ChangeTripDriverReason)[keyof typeof ChangeTripDriverReason]
/** change trip itinerary departure time input */
export type ChangeTripItineraryDepartureTimeInput = {
  /** departure date */
  departureDate: Scalars['String']['input']
  /** trip ID */
  id: Scalars['ID']['input']
  /** itinerary */
  itinerary: Array<ChangeTripItineraryDepartureTimeItineraryInput>
}

/** change trip itinerary departure time itinerary input */
export type ChangeTripItineraryDepartureTimeItineraryInput = {
  /** arrival time */
  arrival?: InputMaybe<ChangeTripItineraryDepartureTimeItineraryTimeInput>
  /** departure time */
  departure?: InputMaybe<ChangeTripItineraryDepartureTimeItineraryTimeInput>
  /** place ID */
  placeID: Scalars['ID']['input']
}

/** change trip itinerary departure time itinerary time input */
export type ChangeTripItineraryDepartureTimeItineraryTimeInput = {
  /** an integer representing how many days after departure the stop takes place. ex. 0 = same day, 1 = next day */
  day: Scalars['Int']['input']
  /** time in hh:mm format, in the timezone of the place */
  time: Scalars['String']['input']
}

/** change trip route input */
export type ChangeTripRouteInput = {
  /** departure date */
  departureDate: Scalars['Date']['input']
  /** trip ID */
  id: Scalars['UUID']['input']
  /** itinerary */
  itinerary: Array<ChangeTripRouteItineraryStopInput>
  /** place replacements */
  placeReplacements: Array<ChangeTripRoutePlaceReplacementInput>
  /** route ID */
  routeID: Scalars['UUID']['input']
}

/** change trip route itinerary stop input */
export type ChangeTripRouteItineraryStopInput = {
  /** arrival time */
  arrival?: InputMaybe<ChangeTripRouteItineraryStopTimeInput>
  /** departure time */
  departure?: InputMaybe<ChangeTripRouteItineraryStopTimeInput>
  /** place ID */
  placeID: Scalars['UUID']['input']
}

/** change trip route itinerary stop time input */
export type ChangeTripRouteItineraryStopTimeInput = {
  /** an integer representing how many days after departure the stop takes place. ex. 0 = same day, 1 = next day */
  day: Scalars['Int']['input']
  /** time in hh:mm format, in the timezone of the place */
  time: Scalars['String']['input']
}

export type ChangeTripRoutePlaceReplacementInput = {
  newPlaceID: Scalars['UUID']['input']
  oldPlaceID: Scalars['UUID']['input']
}

/** change crew users assigned to a trip input */
export type ChangeTripUsersInput = {
  id: Scalars['ID']['input']
  userIDs: Array<Scalars['ID']['input']>
}

/** change trip vehicle input */
export type ChangeTripVehicleInput = {
  /** comments for the change */
  comments?: InputMaybe<Scalars['String']['input']>
  /** trip ID */
  id: Scalars['ID']['input']
  /** reason for the change */
  reason: ChangeTripVehicleReason
  /** vehicle ID */
  vehicleID: Scalars['ID']['input']
}

export const ChangeTripVehicleReason = {
  BackupFixed: 'BACKUP_FIXED',
  BackupFlexible: 'BACKUP_FLEXIBLE',
  BusinessClient: 'BUSINESS_CLIENT',
  Partner: 'PARTNER',
  Uber: 'UBER'
} as const

export type ChangeTripVehicleReason = (typeof ChangeTripVehicleReason)[keyof typeof ChangeTripVehicleReason]
/** change trips vehicle input */
export type ChangeTripsVehicleInput = {
  /** comments for the change */
  comments?: InputMaybe<Scalars['String']['input']>
  /** reason for the change */
  reason: ChangeTripVehicleReason
  /** trips ID */
  tripIDs: Array<Scalars['ID']['input']>
  /** vehicle ID */
  vehicleID: Scalars['ID']['input']
}

export const ChangeType = {
  ChangeRouteServiceItinerary: 'ChangeRouteServiceItinerary',
  ChangeRouteServicesRoute: 'ChangeRouteServicesRoute',
  RouteServiceActivePeriodChanged: 'RouteServiceActivePeriodChanged',
  RouteServiceDeactivated: 'RouteServiceDeactivated',
  RouteServiceItineraryChanged: 'RouteServiceItineraryChanged',
  RouteServiceRouteChanged: 'RouteServiceRouteChanged',
  RouteServiceVehicleChanged: 'RouteServiceVehicleChanged',
  TripCancelled: 'TripCancelled',
  TripDeactivated: 'TripDeactivated',
  TripItineraryChanged: 'TripItineraryChanged',
  TripRouteChanged: 'TripRouteChanged',
  TripVehicleChanged: 'TripVehicleChanged'
} as const

export type ChangeType = (typeof ChangeType)[keyof typeof ChangeType]
export type ChangeUser = {
  __typename?: 'ChangeUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type ChangeUserAccountDetailsInput = {
  /** User Account Email */
  email?: InputMaybe<Scalars['String']['input']>
  /** User Account First Name */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** User Account Gender */
  gender?: InputMaybe<UserAccountGenderInput>
  /** User Account ID */
  id: Scalars['UUID']['input']
  /** User Account Last Name */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** User Account Phone Number */
  phoneNumber?: InputMaybe<PhoneNumberInput>
}

export type ChangeUserPasswordInput = {
  password: Scalars['String']['input']
}

export type ChangeVehicle = {
  __typename?: 'ChangeVehicle'
  capacity: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  partner: Partner
}

export type ChangesResponse = {
  __typename?: 'ChangesResponse'
  items: Array<Change>
  total: Scalars['Int']['output']
}

export type CitySuggestion = {
  __typename?: 'CitySuggestion'
  countryCode?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  stateCode?: Maybe<Scalars['String']['output']>
}

export type CitySuggestionsInput = {
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  pattern?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  vertical?: InputMaybe<Scalars['String']['input']>
}

export type CitySuggestionsResponse = {
  __typename?: 'CitySuggestionsResponse'
  items: Array<CitySuggestion>
  total: Scalars['Long']['output']
}

export const Class = {
  E: 'E',
  L: 'L',
  P: 'P'
} as const

export type Class = (typeof Class)[keyof typeof Class]
export type Client = {
  __typename?: 'Client'
  os?: Maybe<Scalars['String']['output']>
  source: Source
  userAgent?: Maybe<Scalars['String']['output']>
}

export type ComboComponent = {
  __typename?: 'ComboComponent'
  eligibleItems: Array<Item>
  quantity: Scalars['Int']['output']
}

export type ComboItem = {
  __typename?: 'ComboItem'
  category: Scalars['String']['output']
  components: Array<ComboComponent>
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  minSellingPrice?: Maybe<Scalars['Int']['output']>
  name: Scalars['String']['output']
  photoPath?: Maybe<Scalars['String']['output']>
  sellingPrice: Scalars['Int']['output']
  subcategory: Scalars['String']['output']
}

/** combo item autocomplete */
export type ComboItemAutocomplete = {
  __typename?: 'ComboItemAutocomplete'
  /** category */
  category: Scalars['String']['output']
  /** item ID */
  id: Scalars['ID']['output']
  /** isActive */
  isActive: Scalars['Boolean']['output']
  /** name */
  name: Scalars['String']['output']
  /** subcategory */
  subcategory: Scalars['String']['output']
}

export type ComboItemInput = {
  category?: InputMaybe<Scalars['String']['input']>
  components?: InputMaybe<Array<ItemComboComponentInput>>
  minSellingPrice?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  photoPath?: InputMaybe<Scalars['String']['input']>
  sellingPrice?: InputMaybe<Scalars['Int']['input']>
  subcategory?: InputMaybe<Scalars['String']['input']>
}

export type ComboItemQueryInput = {
  id: Scalars['ID']['input']
}

export type ComboItemsAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type ComboItemsQueryInput = {
  category?: InputMaybe<Scalars['String']['input']>
  companyID?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  subcategory?: InputMaybe<Scalars['String']['input']>
}

export type ComboItemsResponse = {
  __typename?: 'ComboItemsResponse'
  items: Array<ComboItem>
  total: Scalars['Int']['output']
}

export type CompaniesAutocompleteInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type CompaniesV2Autocomplete = {
  __typename?: 'CompaniesV2Autocomplete'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  vertical: CompanyV2Vertical
}

export type CompaniesV2AutocompleteInput = {
  verticals?: InputMaybe<Array<CompanyV2VerticalInput>>
}

export type CompaniesV2AutocompleteResponse = {
  __typename?: 'CompaniesV2AutocompleteResponse'
  items: Array<CompaniesV2Autocomplete>
  total: Scalars['Int']['output']
}

export type CompaniesV2Input = {
  vertical?: InputMaybe<CompanyV2VerticalInput>
}

export type CompaniesV2Response = {
  __typename?: 'CompaniesV2Response'
  items: Array<CompanyV2>
  total: Scalars['Int']['output']
}

/** company */
export type Company = {
  __typename?: 'Company'
  /** address */
  address?: Maybe<Address>
  /** comments */
  comments?: Maybe<Scalars['String']['output']>
  /** domains */
  domains: Array<Scalars['String']['output']>
  /** company id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** phone */
  phone: Scalars['String']['output']
  /** company role */
  policyRole?: Maybe<CompanyCompanyRole>
}

/** company autocomplete */
export type CompanyAutocomplete = {
  __typename?: 'CompanyAutocomplete'
  /** company ID */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** company role */
export type CompanyCompanyRole = {
  __typename?: 'CompanyCompanyRole'
  /** role id */
  id: Scalars['ID']['output']
  /** role name */
  name: Scalars['String']['output']
}

export type CompanyInsuranceSalesChannel = {
  __typename?: 'CompanyInsuranceSalesChannel'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CompanyInsuranceSettings = {
  __typename?: 'CompanyInsuranceSettings'
  active?: Maybe<Scalars['Boolean']['output']>
  price?: Maybe<Scalars['Int']['output']>
  /** @deprecated Use salesChannelsV2 instead */
  salesChannels?: Maybe<Array<Maybe<SalesChannel>>>
  salesChannelsV2?: Maybe<Array<CompanyInsuranceSalesChannel>>
}

export type CompanyInsuranceSettingsInput = {
  companyID: Scalars['ID']['input']
}

/** company line */
export type CompanyLine = {
  __typename?: 'CompanyLine'
  /** amenities */
  amenities: Array<Amenity>
  /** class */
  class: Class
  /** company line id */
  id: Scalars['ID']['output']
  /** path for the company line's logo */
  logoPath?: Maybe<Scalars['String']['output']>
  /** name */
  name: Scalars['String']['output']
  /** refund rules */
  refundRules: Scalars['String']['output']
  /** type */
  type: CompanyLineType
}

/** company line autocomplete */
export type CompanyLineAutocomplete = {
  __typename?: 'CompanyLineAutocomplete'
  /** company line ID */
  id: Scalars['ID']['output']
  /** company line name */
  name: Scalars['String']['output']
}

export const CompanyLineType = {
  Bus: 'BUS',
  Van: 'VAN'
} as const

export type CompanyLineType = (typeof CompanyLineType)[keyof typeof CompanyLineType]
export type CompanyLinesAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** company role */
export type CompanyRole = {
  __typename?: 'CompanyRole'
  /** companies that have this role assigned */
  companies: Array<RoleCompany>
  /** conditions */
  conditions: Array<Scalars['String']['output']>
  /** company role id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** permissions */
  permissions: Array<RolePermission>
}

export type CompanySuggestion = {
  __typename?: 'CompanySuggestion'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  vertical: Scalars['String']['output']
}

export type CompanySuggestionsInput = {
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  pattern?: InputMaybe<Scalars['String']['input']>
  verticals?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CompanySuggestionsResponse = {
  __typename?: 'CompanySuggestionsResponse'
  items: Array<CompanySuggestion>
  total: Scalars['Long']['output']
}

export type CompanyV2 = {
  __typename?: 'CompanyV2'
  address: CompanyV2Address
  comments?: Maybe<Scalars['String']['output']>
  companyLines?: Maybe<Array<CompanyV2CompanyLine>>
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  insuranceSettings?: Maybe<CompanyV2InsuranceSettings>
  name: Scalars['String']['output']
  numberOfClients: Scalars['Int']['output']
  phone?: Maybe<Scalars['String']['output']>
  policy?: Maybe<CompanyV2Policy>
  updatedAt: Scalars['Time']['output']
  vertical: CompanyV2Vertical
}

export type CompanyV2Address = {
  __typename?: 'CompanyV2Address'
  cityName: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  line1: Scalars['String']['output']
  line2?: Maybe<Scalars['String']['output']>
  stateCode: Scalars['String']['output']
  zipCode: Scalars['String']['output']
}

export type CompanyV2CompanyLine = {
  __typename?: 'CompanyV2CompanyLine'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type CompanyV2InsuranceSettings = {
  __typename?: 'CompanyV2InsuranceSettings'
  isActive?: Maybe<Scalars['Boolean']['output']>
  price?: Maybe<Scalars['Int']['output']>
  salesChannels: Array<CompanyV2SalesChannel>
}

export type CompanyV2Policy = {
  __typename?: 'CompanyV2Policy'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type CompanyV2SalesChannel = {
  __typename?: 'CompanyV2SalesChannel'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export const CompanyV2Vertical = {
  City: 'CITY',
  Mobile: 'MOBILE',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type CompanyV2Vertical = (typeof CompanyV2Vertical)[keyof typeof CompanyV2Vertical]
export const CompanyV2VerticalInput = {
  City: 'CITY',
  Mobile: 'MOBILE',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type CompanyV2VerticalInput = (typeof CompanyV2VerticalInput)[keyof typeof CompanyV2VerticalInput]
export type ConfirmBookingTripChangeProposalInput = {
  id: Scalars['ID']['input']
  tripChangeProposalID: Scalars['ID']['input']
}

export type ConfirmationModalities = {
  __typename?: 'ConfirmationModalities'
  facebook: Scalars['Boolean']['output']
  paid: Scalars['Boolean']['output']
  reserved: Scalars['Boolean']['output']
}

export const ConfirmationModality = {
  Paid: 'PAID',
  Reserved: 'RESERVED'
} as const

export type ConfirmationModality = (typeof ConfirmationModality)[keyof typeof ConfirmationModality]
export type ConfirmationMoldalitiesInput = {
  paid?: InputMaybe<Scalars['Boolean']['input']>
  reserved?: InputMaybe<Scalars['Boolean']['input']>
}

export type ConstraintSegment = {
  __typename?: 'ConstraintSegment'
  destination: ConstraintSegmentPlace
  id: Scalars['ID']['output']
  origin: ConstraintSegmentPlace
}

export type ConstraintSegmentPlace = {
  __typename?: 'ConstraintSegmentPlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type Constraints = {
  __typename?: 'Constraints'
  bookingTypes: Array<BookingType>
  citySegments?: Maybe<Array<CouponConstraintCitySegment>>
  confirmationModalities: CouponConfirmationModalities
  departureDateRanges: Array<DepartureDateRange>
  limit?: Maybe<Scalars['Int']['output']>
  minSale?: Maybe<Scalars['Int']['output']>
  minTicketsCount?: Maybe<Scalars['Int']['output']>
  onlyRegisteredUsers: Scalars['Boolean']['output']
  onlyRoundTrips: Scalars['Boolean']['output']
  passengerTypes?: Maybe<Array<CouponConstraintsPassengerType>>
  salesChannels?: Maybe<Array<SalesChannel>>
  salesChannelsV2?: Maybe<Array<CouponConstraintsSalesChannel>>
  /** @deprecated Use citySegments instead */
  segments: Array<ConstraintSegment>
  userLimit: Scalars['Int']['output']
}

export type ConstraintsInput = {
  bookingTypes?: InputMaybe<Array<BookingType>>
  citySegments?: InputMaybe<Array<CouponConstraintsCitySegmentInput>>
  confirmationModalities?: InputMaybe<ConfirmationMoldalitiesInput>
  departureDateRanges?: InputMaybe<Array<DepartureDateRangeInput>>
  limit?: InputMaybe<Scalars['Int']['input']>
  minSale?: InputMaybe<Scalars['Int']['input']>
  minTicketsCount?: InputMaybe<Scalars['Int']['input']>
  onlyRegisteredUsers?: InputMaybe<Scalars['Boolean']['input']>
  onlyRoundTrips?: InputMaybe<Scalars['Boolean']['input']>
  passengerTypes?: InputMaybe<Array<CouponConstraintsPassengerTypeInput>>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  userLimit: Scalars['Int']['input']
}

export const CostType = {
  Fixed: 'FIXED',
  PerKm: 'PER_KM'
} as const

export type CostType = (typeof CostType)[keyof typeof CostType]
export type CountriesInput = {
  ok?: InputMaybe<Scalars['Boolean']['input']>
}

export type CountriesOutput = {
  __typename?: 'CountriesOutput'
  items: Array<Country>
  total: Scalars['Int']['output']
}

export type Country = {
  __typename?: 'Country'
  code: Scalars['String']['output']
  createdAt: Scalars['Time']['output']
  currencyID: Scalars['ID']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
}

export type CountryInput = {
  id: Scalars['ID']['input']
}

export type Coupon = {
  __typename?: 'Coupon'
  campaign: CouponCampaign
  channels: Array<CouponChannel>
  code: Scalars['String']['output']
  constraints: Constraints
  discountType: DiscountType
  endsAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  startsAt: Scalars['String']['output']
  supportInteractions: Array<CouponSupportInteraction>
  timezone: Scalars['String']['output']
  usedCount: Scalars['Int']['output']
  value: Scalars['Int']['output']
}

export type CouponCampaign = {
  __typename?: 'CouponCampaign'
  area: CampaignArea
  company: CouponCampaignCompany
  endsAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  startsAt: Scalars['String']['output']
  timezone: Scalars['String']['output']
  type: CampaignType
}

export type CouponCampaignCompany = {
  __typename?: 'CouponCampaignCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const CouponChannel = {
  Sem: 'SEM',
  Facebook: 'facebook'
} as const

export type CouponChannel = (typeof CouponChannel)[keyof typeof CouponChannel]
export type CouponConfirmationModalities = {
  __typename?: 'CouponConfirmationModalities'
  paid: Scalars['Boolean']['output']
  reserved: Scalars['Boolean']['output']
}

export type CouponConstraintCitySegment = {
  __typename?: 'CouponConstraintCitySegment'
  destination: CampaignPlace
  origin: CampaignPlace
  segments: Array<CampaignSegment>
}

export type CouponConstraintsCitySegmentInput = {
  destinationID: Scalars['ID']['input']
  originID: Scalars['ID']['input']
  segmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type CouponConstraintsPassengerType = {
  __typename?: 'CouponConstraintsPassengerType'
  countryCode: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CouponConstraintsPassengerTypeInput = {
  id: Scalars['ID']['input']
}

export type CouponConstraintsSalesChannel = {
  __typename?: 'CouponConstraintsSalesChannel'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

/** coupon query input */
export type CouponInput = {
  id: Scalars['ID']['input']
}

export const CouponStatus = {
  Created: 'CREATED',
  Expired: 'EXPIRED',
  Redeemed: 'REDEEMED',
  Sent: 'SENT'
} as const

export type CouponStatus = (typeof CouponStatus)[keyof typeof CouponStatus]
export type CouponSupportInteraction = {
  __typename?: 'CouponSupportInteraction'
  callStatus?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Time']['output']
  notes?: Maybe<Scalars['String']['output']>
  notificationChannel?: Maybe<Scalars['String']['output']>
}

export type CouponUser = {
  __typename?: 'CouponUser'
  email?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
}

/** coupons query input */
export type CouponsInput = {
  campaignID?: InputMaybe<Scalars['ID']['input']>
  campaignTypes?: InputMaybe<Array<CampaignType>>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type CouponsResponse = {
  __typename?: 'CouponsResponse'
  items: Array<Coupon>
  total: Scalars['Int']['output']
}

export type CouponsWithPaginationInput = {
  campaignAreas?: InputMaybe<Array<CampaignArea>>
  campaignID?: InputMaybe<Scalars['ID']['input']>
  campaignTypes?: InputMaybe<Array<CampaignType>>
  code?: InputMaybe<Scalars['String']['input']>
}

export type CreateAncillaryInput = {
  companyID: Scalars['ID']['input']
  conditions?: InputMaybe<AncillaryConditionsInput>
  label?: InputMaybe<Array<AncillaryTranslationInput>>
  name?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  type: AncillaryTypeInput
}

export type CreateBookingTripChangeProposalInput = {
  id: Scalars['ID']['input']
  keepPrice: Scalars['Boolean']['input']
  newTrip: CreateBookingTripChangeProposalTripInput
  oldTrip: CreateBookingTripChangeProposalTripInput
  seatIDs: Array<Scalars['ID']['input']>
}

export type CreateBookingTripChangeProposalResponse = {
  __typename?: 'CreateBookingTripChangeProposalResponse'
  coupon?: Maybe<CreateBookingTripChangeProposalResponseCoupon>
  id: Scalars['ID']['output']
  reward?: Maybe<CreateBookingTripChangeProposalResponseReward>
  tickets: Array<CreateBookingTripChangeProposalResponseTicket>
  trips: Array<CreateBookingTripChangeProposalResponseTrip>
}

export type CreateBookingTripChangeProposalResponseAncillary = {
  __typename?: 'CreateBookingTripChangeProposalResponseAncillary'
  id: Scalars['ID']['output']
  /** @deprecated use total instead */
  price: Scalars['Int']['output']
  quantity: Scalars['Int']['output']
  status: AncillaryStatus
  /** @deprecated Use total instead */
  subtotal: Scalars['Int']['output']
  total: Scalars['Int']['output']
  type: AncillaryType
  unitPrice: Scalars['Int']['output']
  /** @deprecated total includes VAT */
  vat: Scalars['Int']['output']
}

export type CreateBookingTripChangeProposalResponseCity = {
  __typename?: 'CreateBookingTripChangeProposalResponseCity'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  timezone: Scalars['String']['output']
}

export type CreateBookingTripChangeProposalResponseCoupon = {
  __typename?: 'CreateBookingTripChangeProposalResponseCoupon'
  code: Scalars['String']['output']
  discountType: Scalars['String']['output']
  id: Scalars['ID']['output']
  ticketIDs: Array<Scalars['ID']['output']>
  value: Scalars['Int']['output']
}

export type CreateBookingTripChangeProposalResponsePassenger = {
  __typename?: 'CreateBookingTripChangeProposalResponsePassenger'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
}

export type CreateBookingTripChangeProposalResponsePlace = {
  __typename?: 'CreateBookingTripChangeProposalResponsePlace'
  city: CreateBookingTripChangeProposalResponseCity
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type CreateBookingTripChangeProposalResponseReward = {
  __typename?: 'CreateBookingTripChangeProposalResponseReward'
  discount: Scalars['Int']['output']
  ticketID: Scalars['ID']['output']
}

export type CreateBookingTripChangeProposalResponseSeat = {
  __typename?: 'CreateBookingTripChangeProposalResponseSeat'
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
}

export type CreateBookingTripChangeProposalResponseTicket = {
  __typename?: 'CreateBookingTripChangeProposalResponseTicket'
  ancillaries: Array<CreateBookingTripChangeProposalResponseAncillary>
  discount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  passenger: CreateBookingTripChangeProposalResponsePassenger
  seat: CreateBookingTripChangeProposalResponseSeat
  /** service fee */
  serviceFee?: Maybe<CreateBookingTripChangeProposalResponseTicketServiceFee>
  subtotal: Scalars['Int']['output']
  tripID: Scalars['ID']['output']
  vat: Scalars['Int']['output']
}

export type CreateBookingTripChangeProposalResponseTicketServiceFee = {
  __typename?: 'CreateBookingTripChangeProposalResponseTicketServiceFee'
  id: Scalars['ID']['output']
  price: Scalars['Int']['output']
}

export type CreateBookingTripChangeProposalResponseTrip = {
  __typename?: 'CreateBookingTripChangeProposalResponseTrip'
  id: Scalars['ID']['output']
  segment: CreateBookingTripChangeProposalResponseTripSegment
}

export type CreateBookingTripChangeProposalResponseTripSegment = {
  __typename?: 'CreateBookingTripChangeProposalResponseTripSegment'
  arrivalAt: Scalars['Time']['output']
  departureAt: Scalars['Time']['output']
  destination: CreateBookingTripChangeProposalResponsePlace
  id: Scalars['ID']['output']
  origin: CreateBookingTripChangeProposalResponsePlace
}

export type CreateBookingTripChangeProposalTripInput = {
  id: Scalars['ID']['input']
  segmentID: Scalars['ID']['input']
}

export type CreateBusinessClientContactInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  secondaryEmail?: InputMaybe<Scalars['String']['input']>
  secondaryPhone?: InputMaybe<Scalars['String']['input']>
}

export type CreateBusinessClientContactsInput = {
  contacts: Array<CreateBusinessClientContactInput>
}

export type CreateBusinessClientInput = {
  companyIDs: Array<Scalars['UUID']['input']>
  contacts: Array<CreateBusinessClientContactInput>
  emailDomains?: InputMaybe<Array<Scalars['String']['input']>>
  kamUserID?: InputMaybe<Scalars['UUID']['input']>
  logoPath?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  /** shareCustomersData defines if the customers' personal data will be displayed or not */
  shareCustomersData?: Scalars['Boolean']['input']
}

export type CreateBusinessClientResponse = {
  __typename?: 'CreateBusinessClientResponse'
  id: Scalars['UUID']['output']
}

export type CreateBusinessClientUserInput = {
  businessClientID: Scalars['UUID']['input']
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  email: Scalars['String']['input']
  firstName: Scalars['String']['input']
  hasAdminRole?: Scalars['Boolean']['input']
  lastName: Scalars['String']['input']
  phoneNumber: PhoneNumberInput
  title: Scalars['String']['input']
}

export type CreateBusinessClientsRouteServicesSchedulePriceInput = {
  priceSchedule: CreateBusinessClientsRouteServicesSchedulePricePriceScheduleInput
  routeServiceIDs: Array<Scalars['UUID']['input']>
}

export type CreateBusinessClientsRouteServicesSchedulePricePriceScheduleInput = {
  dow: Array<BusinessClientsRouteServicesSchedulePriceDow>
  endAt?: InputMaybe<Scalars['Date']['input']>
  price: Scalars['Int']['input']
  startAt: Scalars['Date']['input']
}

export type CreateBusinessCustomerInput = {
  /** The business client ID */
  businessClientID: Scalars['UUID']['input']
  /** The business site ID */
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  /** The business customer email */
  email?: InputMaybe<Scalars['String']['input']>
  /** The business customer first name */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** kredit category */
  kreditCategory?: InputMaybe<Scalars['Int']['input']>
  /** The business customer last name */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** The business customer phone number */
  phoneNumber?: InputMaybe<PhoneNumberInput>
  /** If place is present, a place will be created and assigned to the business customer */
  place?: InputMaybe<BusinessCustomerPlaceInput>
  /** The business customer type. Default is ASSOCIATE */
  type?: BusinessCustomerTypeInput
}

export type CreateBusinessCustomersFromCsvInput = {
  /** The business client ID */
  businessClientID: Scalars['UUID']['input']
  /** The business site ID */
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  /** The path of the CSV file */
  path: Scalars['String']['input']
  /** The business customer type. Default is ASSOCIATE */
  type?: BusinessCustomerTypeInput
}

export type CreateBusinessSiteContactInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  secondaryEmail?: InputMaybe<Scalars['String']['input']>
  secondaryPhone?: InputMaybe<Scalars['String']['input']>
}

export type CreateBusinessSiteContactsInput = {
  contacts: Array<CreateBusinessSiteContactInput>
}

export type CreateBusinessSiteInput = {
  cityID?: InputMaybe<Scalars['UUID']['input']>
  clientID: Scalars['UUID']['input']
  contacts: Array<CreateBusinessSiteContactInput>
  name: Scalars['String']['input']
}

export type CreateBusinessSiteResponse = {
  __typename?: 'CreateBusinessSiteResponse'
  id: Scalars['UUID']['output']
}

export type CreateCampaignInput = {
  area: CampaignArea
  companyID: Scalars['ID']['input']
  description: Scalars['String']['input']
  endsAt: Scalars['String']['input']
  name: Scalars['String']['input']
  startsAt: Scalars['String']['input']
  timezone: Scalars['String']['input']
  type: CampaignType
}

export type CreateCampaignSubcampaignInput = {
  authorizer?: InputMaybe<Scalars['String']['input']>
  filePath?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
  trip?: InputMaybe<CreateCampaignSubcampaignTripInput>
}

export type CreateCampaignSubcampaignResponse = {
  __typename?: 'CreateCampaignSubcampaignResponse'
  id: Scalars['ID']['output']
}

export type CreateCampaignSubcampaignTripInput = {
  id: Scalars['ID']['input']
  legSegmentIDs: Array<Scalars['ID']['input']>
}

export type CreateCartInput = {
  companyIDs: Array<Scalars['ID']['input']>
  name: Scalars['String']['input']
}

export type CreateCompanyV2AddressInput = {
  cityName: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  line1: Scalars['String']['input']
  line2?: InputMaybe<Scalars['String']['input']>
  stateCode: Scalars['String']['input']
  zipCode: Scalars['String']['input']
}

export type CreateCompanyV2Input = {
  address: CreateCompanyV2AddressInput
  comments?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  policyID?: InputMaybe<Scalars['UUID']['input']>
  vertical: CompanyV2VerticalInput
}

export type CreateCountryInput = {
  code: Scalars['String']['input']
  currencyID: Scalars['ID']['input']
  name: Scalars['String']['input']
}

export type CreateCurrencyInput = {
  code: Scalars['String']['input']
  exchangeRate: Scalars['Float']['input']
  name: Scalars['String']['input']
  symbol: Scalars['String']['input']
}

export type CreateDriverInput = {
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  gender?: InputMaybe<UserAccountGenderInput>
  lastName?: InputMaybe<Scalars['String']['input']>
  partnerID: Scalars['UUID']['input']
  phoneNumber?: InputMaybe<PhoneNumberInput>
  stateCode?: InputMaybe<Scalars['String']['input']>
}

export type CreateDriverResponse = {
  __typename?: 'CreateDriverResponse'
  id: Scalars['UUID']['output']
}

/** create fare rule */
export type CreateFareRuleInput = {
  /** activation at ranges */
  activationAtRanges: Array<FareRuleDateRangeInput>
  /** city segments */
  citySegments: Array<FareRulecitySegmentInput>
  /** company id */
  companyID: Scalars['ID']['input']
  /** departure at ranges */
  departureAtRanges: Array<FareRuleDateRangeInput>
  /** description */
  description: Scalars['String']['input']
  /** exceptions */
  exceptions: FareRuleExceptionsInput
  /** name */
  name: Scalars['String']['input']
  /** price */
  price: Scalars['Int']['input']
}

export type CreateInventoryInput = {
  address?: InputMaybe<InventoryAddressInput>
  companyID?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  type: InventoryType
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** create inventory rule cabin settings */
export type CreateInventoryRuleCabinStrategiesInput = {
  /** cabin strategies */
  cabinStrategies: Array<InventoryRuleCabinStrategyInput>
  /** inventory rule id */
  id: Scalars['ID']['input']
}

/** create inventory rule */
export type CreateInventoryRuleInput = {
  /** activation at ranges */
  activationAtRanges: Array<InventoryRuleDateRangeInput>
  /** cabin strategies */
  cabinStrategies?: InputMaybe<Array<InventoryRuleCabinStrategyInput>>
  /** city segments */
  citySegments: Array<InventoryRulecitySegmentInput>
  /** company id */
  companyID: Scalars['ID']['input']
  /** departure at ranges */
  departureAtRanges: Array<InventoryRuleDateRangeInput>
  /** description */
  description: Scalars['String']['input']
  /** exceptions */
  exceptions: InventoryRuleExceptionsInput
  /** name */
  name: Scalars['String']['input']
}

export type CreateLoyaltyCampaignInput = {
  companyID: Scalars['ID']['input']
  companyLineIDs: Array<Scalars['ID']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  timeFrame: CreateLoyaltyCampaignTimeFrameInput
}

export type CreateLoyaltyCampaignRuleConditionsCitySegmentInput = {
  destinationID: Scalars['ID']['input']
  originID: Scalars['ID']['input']
  segmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type CreateLoyaltyCampaignRuleConditionsInput = {
  citySegments?: InputMaybe<Array<InputMaybe<CreateLoyaltyCampaignRuleConditionsCitySegmentInput>>>
  routeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  routeServiceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  totalBookingsValue?: InputMaybe<Scalars['Int']['input']>
}

export type CreateLoyaltyCampaignRuleEffectsInput = {
  rewardID: Scalars['ID']['input']
}

export type CreateLoyaltyCampaignRuleInput = {
  conditions: CreateLoyaltyCampaignRuleConditionsInput
  description?: InputMaybe<Scalars['String']['input']>
  details: Scalars['String']['input']
  effects: CreateLoyaltyCampaignRuleEffectsInput
  howToGet: Scalars['String']['input']
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  validAt: Scalars['String']['input']
}

export type CreateLoyaltyCampaignTimeFrameInput = {
  endAt: Scalars['Time']['input']
  startAt: Scalars['Time']['input']
}

export type CreateLoyaltyRewardInput = {
  companyID: Scalars['ID']['input']
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  type?: LoyaltyRewardType
}

export type CreateOperationalCostInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  stateCode: Scalars['String']['input']
  vehicleCapacity: Scalars['Int']['input']
  vehicleType: OperationalCostVehicleType
}

export type CreateOperationalCostResponse = {
  __typename?: 'CreateOperationalCostResponse'
  id: Scalars['UUID']['output']
  isNew: Scalars['Boolean']['output']
}

export type CreateOrderInput = {
  destinationID: Scalars['ID']['input']
  lineItems: Array<OrderLineItemInput>
  originID?: InputMaybe<Scalars['ID']['input']>
  purchaseID?: InputMaybe<Scalars['ID']['input']>
  supplier?: InputMaybe<Scalars['String']['input']>
  type: OrderType
}

export type CreatePartnerContactInput = {
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  phone: Scalars['String']['input']
  secondaryEmail?: InputMaybe<Scalars['String']['input']>
  secondaryPhone?: InputMaybe<Scalars['String']['input']>
}

export type CreatePartnerContactsInput = {
  contacts: Array<CreatePartnerContactInput>
}

export type CreatePartnerInput = {
  cityID?: InputMaybe<Scalars['UUID']['input']>
  name: Scalars['String']['input']
  operationalStateCodes: Array<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  type: PartnerTypeInput
  verticals: Array<PartnerVerticalInput>
}

export type CreatePartnerResponse = {
  __typename?: 'CreatePartnerResponse'
  id: Scalars['UUID']['output']
}

export const CreatePartnersPaymentSummaryCategoryInput = {
  Breakdown: 'BREAKDOWN',
  Calendar: 'CALENDAR',
  Miscellaneous: 'MISCELLANEOUS',
  Payment: 'PAYMENT',
  Tag: 'TAG',
  Uber: 'UBER'
} as const

export type CreatePartnersPaymentSummaryCategoryInput =
  (typeof CreatePartnersPaymentSummaryCategoryInput)[keyof typeof CreatePartnersPaymentSummaryCategoryInput]
export type CreatePartnersPaymentSummaryInput = {
  /** files to be processed */
  files?: InputMaybe<Array<FileInput>>
  /** name of the summary. e.g. '1QENE2021' */
  name: Scalars['String']['input']
}

export type CreatePartnersPaymentSummaryResponse = {
  __typename?: 'CreatePartnersPaymentSummaryResponse'
  /** ID of the created summary */
  id: Scalars['UUID']['output']
}

export type CreatePassengerPropertyDateRangeInput = {
  endAt: Scalars['Time']['input']
  startAt: Scalars['Time']['input']
}

export type CreatePassengerPropertyInput = {
  abbreviation: Array<CreatePassengerPropertyTranslationInput>
  countryCode: Scalars['String']['input']
  departureDateRanges?: InputMaybe<Array<CreatePassengerPropertyDateRangeInput>>
  description?: InputMaybe<Array<CreatePassengerPropertyTranslationInput>>
  label: Array<CreatePassengerPropertyTranslationInput>
  name: Scalars['String']['input']
  required: Scalars['Boolean']['input']
  searchDateRanges?: InputMaybe<Array<CreatePassengerPropertyDateRangeInput>>
  settings?: InputMaybe<Array<CreatePassengerPropertySettingInput>>
}

export type CreatePassengerPropertySettingInput = {
  discount: Scalars['Int']['input']
  passengerTypeIDs: Array<Scalars['ID']['input']>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type CreatePassengerPropertyTranslationInput = {
  language: Language
  text: Scalars['String']['input']
}

export type CreatePassengerTypeInput = {
  abbreviation?: InputMaybe<Array<CreatePassengerTypeTranslationInput>>
  countryCode: Scalars['String']['input']
  description?: InputMaybe<Array<CreatePassengerTypeTranslationInput>>
  discount: Scalars['Int']['input']
  label: Array<CreatePassengerTypeTranslationInput>
  name: Scalars['String']['input']
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type CreatePassengerTypeTranslationInput = {
  language: Language
  plural?: Scalars['Boolean']['input']
  text: Scalars['String']['input']
}

export type CreatePlaceForBusinessCustomerInput = {
  businessClientID: Scalars['UUID']['input']
  businessCustomerID: Scalars['UUID']['input']
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  name: Scalars['String']['input']
  place: BusinessCustomerPlaceInput
}

export type CreatePlaceV2AddressInput = {
  cityName: Scalars['String']['input']
  countryCode: Scalars['String']['input']
  line1: Scalars['String']['input']
  line2?: InputMaybe<Scalars['String']['input']>
  stateCode: Scalars['String']['input']
  zipCode: Scalars['String']['input']
}

export type CreatePlaceV2CoordinatesInput = {
  latitude: Scalars['String']['input']
  longitude: Scalars['String']['input']
}

export type CreatePlaceV2Input = {
  address?: InputMaybe<CreatePlaceV2AddressInput>
  amenities?: InputMaybe<Array<PlaceV2AmenityInput>>
  area?: InputMaybe<Scalars['String']['input']>
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  code: Scalars['String']['input']
  companyID?: InputMaybe<Scalars['UUID']['input']>
  coordinates: CreatePlaceV2CoordinatesInput
  directions?: InputMaybe<Scalars['String']['input']>
  geofenceRadius?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  param: Scalars['String']['input']
  parentID: Scalars['UUID']['input']
  photoPath?: InputMaybe<Scalars['String']['input']>
  tags: Array<Scalars['String']['input']>
  type: PlaceV2TypeInput
}

export type CreatePresignedUrlForFileUploadInput = {
  /** file name */
  name: Scalars['String']['input']
}

export type CreatePresignedUrlForFileUploadOutput = {
  __typename?: 'CreatePresignedUrlForFileUploadOutput'
  /** file path */
  path: Scalars['String']['output']
  /** signed url */
  url: Scalars['String']['output']
}

/** create route input */
export type CreateRouteInput = {
  /** company id */
  companyID: Scalars['ID']['input']
  /** company lines that use this route */
  companyLineIDs: Array<Scalars['String']['input']>
  /** places this route has stops in */
  placeIDs: Array<Scalars['String']['input']>
}

export type CreateRouteResponse = {
  __typename?: 'CreateRouteResponse'
  id: Scalars['ID']['output']
}

export type CreateRouteServiceBusinessClientInput = {
  businessSiteIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  id: Scalars['ID']['input']
}

export type CreateRouteServiceDriverOverrideInput = {
  /** adiitional comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** date */
  date: Scalars['Date']['input']
  /** driver id */
  driverID: Scalars['UUID']['input']
  /** route service id */
  id: Scalars['UUID']['input']
  /** reason for the change */
  reason: CreateRouteServiceDriverOverrideReasonInput
}

export const CreateRouteServiceDriverOverrideReasonCategory = {
  BusinessClient: 'BUSINESS_CLIENT',
  Driver: 'DRIVER',
  Other: 'OTHER',
  Partner: 'PARTNER'
} as const

export type CreateRouteServiceDriverOverrideReasonCategory =
  (typeof CreateRouteServiceDriverOverrideReasonCategory)[keyof typeof CreateRouteServiceDriverOverrideReasonCategory]
export type CreateRouteServiceDriverOverrideReasonInput = {
  /** reason category */
  category: CreateRouteServiceDriverOverrideReasonCategory
  /** reason subcategory */
  subcategory?: InputMaybe<CreateRouteServiceDriverOverrideReasonSubcategory>
}

export const CreateRouteServiceDriverOverrideReasonSubcategory = {
  Absence: 'ABSENCE',
  Disability: 'DISABILITY',
  Other: 'OTHER',
  Replacement: 'REPLACEMENT'
} as const

export type CreateRouteServiceDriverOverrideReasonSubcategory =
  (typeof CreateRouteServiceDriverOverrideReasonSubcategory)[keyof typeof CreateRouteServiceDriverOverrideReasonSubcategory]
export type CreateRouteServiceItinerariesScheduleInput = {
  /** route service id */
  id: Scalars['ID']['input']
  /** itineraries schedule */
  itinerariesSchedule: Array<CreateRouteServiceItineraryScheduleInput>
}

export type CreateRouteServiceItineraryOverrideInput = {
  /** date */
  date: Scalars['Date']['input']
  /** route service id */
  id: Scalars['UUID']['input']
  /** itinerary */
  itinerary?: InputMaybe<Array<CreateRouteServiceItineraryOverrideStopInput>>
}

export type CreateRouteServiceItineraryOverrideStopInput = {
  /** arrival */
  arrival?: InputMaybe<CreateRouteServiceItineraryOverrideStopTimeInput>
  /** departure */
  departure?: InputMaybe<CreateRouteServiceItineraryOverrideStopTimeInput>
  /** place id */
  placeID: Scalars['UUID']['input']
}

export type CreateRouteServiceItineraryOverrideStopTimeInput = {
  /** day */
  day: Scalars['Int']['input']
  /** time */
  time: Scalars['String']['input']
}

export type CreateRouteServiceItineraryScheduleInput = {
  dow: Array<Weekday>
  endAt?: InputMaybe<Scalars['Date']['input']>
  itinerary: Array<CreateRouteServiceItineraryScheduleStopInput>
  notes?: Array<Scalars['String']['input']>
  oldRouteID?: InputMaybe<Scalars['ID']['input']>
  placeReplacements?: Array<CreateRouteServiceItinerarySchedulePlaceReplacementInput>
  routeID: Scalars['ID']['input']
  startAt: Scalars['Date']['input']
}

export type CreateRouteServiceItinerarySchedulePlaceReplacementInput = {
  newPlaceID: Scalars['ID']['input']
  oldPlaceID: Scalars['ID']['input']
}

export type CreateRouteServiceItineraryScheduleStopInput = {
  arrival?: InputMaybe<CreateRouteServiceItineraryScheduleStopTimeInput>
  departure?: InputMaybe<CreateRouteServiceItineraryScheduleStopTimeInput>
  placeID: Scalars['ID']['input']
}

export type CreateRouteServiceItineraryScheduleStopTimeInput = {
  day: Scalars['Int']['input']
  time: Scalars['String']['input']
}

export type CreateRouteServicePastVehicleOverrideInput = {
  /** additional comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** date */
  date: Scalars['Date']['input']
  /** route service id */
  id: Scalars['UUID']['input']
  /** reason for the change */
  reason: CreateRouteServiceVehicleOverrideReasonInput
  /** vehicle id */
  vehicleID: Scalars['UUID']['input']
}

export type CreateRouteServiceRouteOverrideInput = {
  /** date */
  date: Scalars['Date']['input']
  /** route service id */
  id: Scalars['UUID']['input']
  /** itinerary */
  itinerary?: InputMaybe<Array<CreateRouteServiceRouteOverrideStopInput>>
  /** old route id */
  oldRouteID: Scalars['UUID']['input']
  /** place replacements */
  placeReplacements?: InputMaybe<Array<CreateRouteServiceRouteOverridePlaceReplacementInput>>
  /** route id */
  routeID: Scalars['UUID']['input']
}

export type CreateRouteServiceRouteOverridePlaceReplacementInput = {
  /** new place id */
  newPlaceID: Scalars['UUID']['input']
  /** old place id */
  oldPlaceID: Scalars['UUID']['input']
}

export type CreateRouteServiceRouteOverrideStopInput = {
  /** arrival */
  arrival?: InputMaybe<CreateRouteServiceRouteOverrideStopTimeInput>
  /** departure */
  departure?: InputMaybe<CreateRouteServiceRouteOverrideStopTimeInput>
  /** place id */
  placeID: Scalars['UUID']['input']
}

export type CreateRouteServiceRouteOverrideStopTimeInput = {
  /** day */
  day: Scalars['Int']['input']
  /** time */
  time: Scalars['String']['input']
}

export type CreateRouteServiceSingleTripInput = {
  companyLineID: Scalars['ID']['input']
  date: Scalars['Date']['input']
  itinerary: Array<CreateRouteServiceSingleTripStopInput>
  reason?: InputMaybe<RouteServiceSingleTripReason>
  routeID: Scalars['ID']['input']
  vehicleID: Scalars['ID']['input']
}

export type CreateRouteServiceSingleTripStopInput = {
  arrival?: InputMaybe<CreateRouteServiceSingleTripStopTimeInput>
  departure?: InputMaybe<CreateRouteServiceSingleTripStopTimeInput>
  placeID: Scalars['ID']['input']
}

export type CreateRouteServiceSingleTripStopTimeInput = {
  day: Scalars['Int']['input']
  time: Scalars['String']['input']
}

export type CreateRouteServiceVehicleOverrideInput = {
  /** additional comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** date */
  date: Scalars['Date']['input']
  /** route service id */
  id: Scalars['UUID']['input']
  /** reason for the change */
  reason: CreateRouteServiceVehicleOverrideReasonInput
  /** vehicle id */
  vehicleID: Scalars['UUID']['input']
}

export const CreateRouteServiceVehicleOverrideReasonCategory = {
  BusinessClient: 'BUSINESS_CLIENT',
  Other: 'OTHER',
  Partner: 'PARTNER',
  Planning: 'PLANNING',
  Vehicle: 'VEHICLE'
} as const

export type CreateRouteServiceVehicleOverrideReasonCategory =
  (typeof CreateRouteServiceVehicleOverrideReasonCategory)[keyof typeof CreateRouteServiceVehicleOverrideReasonCategory]
export type CreateRouteServiceVehicleOverrideReasonInput = {
  /** reason category */
  category: CreateRouteServiceVehicleOverrideReasonCategory
  /** reason subcategory */
  subcategory?: InputMaybe<CreateRouteServiceVehicleOverrideReasonSubcategory>
}

export const CreateRouteServiceVehicleOverrideReasonSubcategory = {
  Accident: 'ACCIDENT',
  MechanicalFailure: 'MECHANICAL_FAILURE',
  Other: 'OTHER',
  ScheduledMaintenance: 'SCHEDULED_MAINTENANCE'
} as const

export type CreateRouteServiceVehicleOverrideReasonSubcategory =
  (typeof CreateRouteServiceVehicleOverrideReasonSubcategory)[keyof typeof CreateRouteServiceVehicleOverrideReasonSubcategory]
export type CreateRouteServiceVehicleScheduleFrequencyInput = {
  unit: RouteServiceScheduleFrequencyUnit
  value: Scalars['Int']['input']
}

export type CreateRouteServiceVehicleScheduleInput = {
  dow?: InputMaybe<Array<Weekday>>
  driverID?: InputMaybe<Scalars['ID']['input']>
  endAt?: InputMaybe<Scalars['Date']['input']>
  frequency?: InputMaybe<CreateRouteServiceVehicleScheduleFrequencyInput>
  startAt: Scalars['Date']['input']
  vehicleID: Scalars['ID']['input']
}

export type CreateRouteServiceVehiclesScheduleInput = {
  /** adiitional comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** route service id */
  id: Scalars['ID']['input']
  /** reason for the change */
  reason?: InputMaybe<CreateRouteServiceVehiclesScheduleReason>
  /** vehicles schedule */
  vehiclesSchedule: Array<CreateRouteServiceVehicleScheduleInput>
}

export const CreateRouteServiceVehiclesScheduleReason = {
  BackupFixed: 'BACKUP_FIXED',
  BackupFlexible: 'BACKUP_FLEXIBLE',
  BusinessClient: 'BUSINESS_CLIENT',
  Partner: 'PARTNER',
  Uber: 'UBER'
} as const

export type CreateRouteServiceVehiclesScheduleReason =
  (typeof CreateRouteServiceVehiclesScheduleReason)[keyof typeof CreateRouteServiceVehiclesScheduleReason]
export type CreateRoutingProjectDatasetDatasetInput = {
  name: Scalars['String']['input']
  url: Scalars['String']['input']
}

export type CreateRoutingProjectDatasetInput = {
  dataset: CreateRoutingProjectDatasetDatasetInput
  id: Scalars['UUID']['input']
}

export type CreateRoutingProjectDatasetResponse = {
  __typename?: 'CreateRoutingProjectDatasetResponse'
  id: Scalars['UUID']['output']
}

export type CreateRoutingProjectInput = {
  name: Scalars['String']['input']
  tags?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CreateRoutingProjectPlanInput = {
  id: Scalars['UUID']['input']
  plan: CreateRoutingProjectPlanPlanInput
}

export type CreateRoutingProjectPlanOptimizationInput = {
  id: Scalars['UUID']['input']
  plan: CreateRoutingProjectPlanOptimizationPlanInput
}

export type CreateRoutingProjectPlanOptimizationPlanInput = {
  id: Scalars['UUID']['input']
}

export type CreateRoutingProjectPlanPlanDatasetInput = {
  id?: InputMaybe<Scalars['UUID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  url?: InputMaybe<Scalars['String']['input']>
}

export type CreateRoutingProjectPlanPlanInput = {
  dataset: CreateRoutingProjectPlanPlanDatasetInput
  name: Scalars['String']['input']
}

export type CreateRoutingProjectPlanResponse = {
  __typename?: 'CreateRoutingProjectPlanResponse'
  id: Scalars['UUID']['output']
}

export type CreateRoutingProjectResponse = {
  __typename?: 'CreateRoutingProjectResponse'
  id: Scalars['UUID']['output']
}

export type CreateSalesChannelInput = {
  countryID: Scalars['ID']['input']
  name: Scalars['String']['input']
  type: SalesChannelType
}

export type CreateTRouteInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  companyID: Scalars['UUID']['input']
  companyLineIDs: Array<Scalars['UUID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  polyline: CreateTRoutePolylineInput
  stopIDs: Array<Scalars['UUID']['input']>
}

export type CreateTRoutePolylineInput = {
  distance: Scalars['Int']['input']
  encoded: Scalars['String']['input']
}

export type CreateTRouteResponse = {
  __typename?: 'CreateTRouteResponse'
  id: Scalars['UUID']['output']
}

export type CreateTVehicleCardsInput = {
  fuelCards?: InputMaybe<Array<Scalars['String']['input']>>
  tagCards?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CreateTVehicleInput = {
  cards: CreateTVehicleCardsInput
  cityName?: InputMaybe<Scalars['String']['input']>
  companyIDs: Array<Scalars['UUID']['input']>
  driverIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  externalID?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  partnerID: Scalars['UUID']['input']
  stateCode?: InputMaybe<Scalars['String']['input']>
  templateID: Scalars['UUID']['input']
  vin: Scalars['String']['input']
}

export type CreateTVehicleResponse = {
  __typename?: 'CreateTVehicleResponse'
  id: Scalars['UUID']['output']
}

export type CurrenciesInput = {
  ok?: InputMaybe<Scalars['Boolean']['input']>
}

export type CurrenciesOutput = {
  __typename?: 'CurrenciesOutput'
  items: Array<Currency>
  total: Scalars['Int']['output']
}

export type Currency = {
  __typename?: 'Currency'
  code: Scalars['String']['output']
  createdAt: Scalars['Time']['output']
  exchangeRate: Scalars['Float']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  symbol: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
}

export const CurrencyCode = {
  Mxn: 'MXN',
  Usd: 'USD'
} as const

export type CurrencyCode = (typeof CurrencyCode)[keyof typeof CurrencyCode]
export type CurrencyInput = {
  id: Scalars['ID']['input']
}

export type DatabaseSubCampaign = {
  __typename?: 'DatabaseSubCampaign'
  campaign: SubCampaignCampaign
  coupons: Array<Coupon>
  endsAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  startsAt: Scalars['String']['output']
}

export type DatabaseSubcampaign = {
  __typename?: 'DatabaseSubcampaign'
  campaignID: Scalars['ID']['output']
  campaignType: Scalars['String']['output']
  endsAt: Scalars['Time']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  startsAt: Scalars['Time']['output']
  status: SubcampaignStatus
}

export type DatabaseSubcampaignCoupon = {
  __typename?: 'DatabaseSubcampaignCoupon'
  emails: Array<Email>
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  status: CouponStatus
  supportInteractions: Array<SubcampaignSupportInteraction>
  user: CouponUser
}

export type DatabaseSubcampaignCouponsInput = {
  email?: InputMaybe<Scalars['String']['input']>
  emailStatus?: InputMaybe<SubcampaignCouponEmailStatus>
  phone?: InputMaybe<Scalars['String']['input']>
  subcampaignID: Scalars['ID']['input']
  userName?: InputMaybe<Scalars['String']['input']>
}

export type DatabaseSubcampaignCouponsResponse = {
  __typename?: 'DatabaseSubcampaignCouponsResponse'
  coupons: Array<DatabaseSubcampaignCoupon>
  total: Scalars['Int']['output']
}

export type DatabaseSubcampaignInput = {
  id: Scalars['ID']['input']
}

export type DatabaseSubcampaignsInput = {
  campaignID?: InputMaybe<Scalars['ID']['input']>
}

export type DatabaseSubcampaignsResponse = {
  __typename?: 'DatabaseSubcampaignsResponse'
  items: Array<DatabaseSubCampaign>
  total: Scalars['Int']['output']
}

export type DateRange = {
  end?: InputMaybe<Scalars['Time']['input']>
  start?: InputMaybe<Scalars['Time']['input']>
}

export type DateRangeInput = {
  endAt?: InputMaybe<Scalars['Date']['input']>
  startAt?: InputMaybe<Scalars['Date']['input']>
}

/** days of week */
export const DayOfWeek = {
  Friday: 'friday',
  Monday: 'monday',
  Saturday: 'saturday',
  Sunday: 'sunday',
  Thursday: 'thursday',
  Tuesday: 'tuesday',
  Wednesday: 'wednesday'
} as const

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek]
export type DeactivateBusinessClientUserInput = {
  id: Scalars['UUID']['input']
}

export type DeactivateCampaignCouponInput = {
  coupon: DeactivateCouponInput
  /** campaign id */
  id: Scalars['ID']['input']
  subcampaignID?: InputMaybe<Scalars['ID']['input']>
}

export type DeactivateCampaignInput = {
  id: Scalars['ID']['input']
}

export type DeactivateCouponInput = {
  /** coupon id */
  id: Scalars['ID']['input']
}

export type DeactivatePartnerInput = {
  comments?: InputMaybe<Scalars['String']['input']>
  reason: DeactivatePartnerReasonInput
}

export const DeactivatePartnerReasonInput = {
  Other: 'OTHER',
  Partner: 'PARTNER'
} as const

export type DeactivatePartnerReasonInput =
  (typeof DeactivatePartnerReasonInput)[keyof typeof DeactivatePartnerReasonInput]
export type DeactivateVehicleInput = {
  reason: DeactivateVehicleReasonInput
}

export const DeactivateVehicleReasonInput = {
  Operational: 'OPERATIONAL'
} as const

export type DeactivateVehicleReasonInput =
  (typeof DeactivateVehicleReasonInput)[keyof typeof DeactivateVehicleReasonInput]
export const DeactivationReason = {
  Accident: 'accident',
  Maintenance: 'maintenance',
  MechanicalFailure: 'mechanicalFailure',
  Other: 'other',
  Planning: 'planning',
  RoadBlock: 'roadBlock'
} as const

export type DeactivationReason = (typeof DeactivationReason)[keyof typeof DeactivationReason]
/** default origin place for a site. */
export type DefaultOrigin = {
  __typename?: 'DefaultOrigin'
  /** place id */
  id: Scalars['ID']['output']
  /** place name */
  name: Scalars['String']['output']
}

export type DeleteBusinessClientContactsInput = {
  contactIDs: Array<Scalars['UUID']['input']>
}

export type DeleteBusinessSiteContactsInput = {
  contactIDs: Array<Scalars['UUID']['input']>
}

/** delete inventory rule cabin settings */
export type DeleteInventoryRuleCabinStrategiesInput = {
  /** cabin strategies id */
  cabinStrategyIDs: Array<Scalars['ID']['input']>
  /** inventory rule id */
  id: Scalars['ID']['input']
}

export type DeletePartnerContactsInput = {
  contactIDs: Array<Scalars['UUID']['input']>
}

export type DeleteRouteServiceVehiclesScheduleInput = {
  /** route service id */
  id: Scalars['ID']['input']
  /** vehicle schedule ids */
  vehiclesScheduleIDs: Array<Scalars['ID']['input']>
}

export type DeleteTVehicleDocumentsInput = {
  categories: Array<VehicleDocumentCategoryInput>
}

/** demand */
export const Demand = {
  /** local no stops */
  D: 'D',
  /** not local no stops */
  I: 'I',
  /** local with stops */
  L: 'L',
  /** N/A */
  N: 'N',
  /** not local with stops */
  T: 'T'
} as const

export type Demand = (typeof Demand)[keyof typeof Demand]
export type DepartureDateRange = {
  __typename?: 'DepartureDateRange'
  from: Scalars['String']['output']
  to: Scalars['String']['output']
}

export type DepartureDateRangeInput = {
  from: Scalars['String']['input']
  to: Scalars['String']['input']
}

export type DepositKreditCorporateFundsInput = {
  account: AccountInput
  amount: Scalars['Int']['input']
}

export type DepositKreditsBonusFundsInput = {
  accounts: Array<AccountInput>
  amount: Scalars['Int']['input']
}

export type DepositKreditsCorporateFundsInput = {
  accounts: Array<AccountInput>
  amount: Scalars['Int']['input']
}

export type DisableAncillaryInput = {
  id: Scalars['ID']['input']
}

export type DisableBusinessCustomerInput = {
  id: Scalars['UUID']['input']
}

export type DisableDriverInput = {
  id: Scalars['UUID']['input']
}

/** disable fare rule */
export type DisableFareRuleInput = {
  /** id */
  id: Scalars['ID']['input']
}

/** disable inventory rule */
export type DisableInventoryRuleInput = {
  /** inventory rule id */
  id: Scalars['ID']['input']
}

export type DisablePassengerPropertyInput = {
  id: Scalars['ID']['input']
}

export type DisablePassengerTypeInput = {
  id: Scalars['ID']['input']
}

export type DisableServiceFeeAddonRuleInput = {
  companyID: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export const DiscountType = {
  Amount: 'amount',
  Percentage: 'percentage'
} as const

export type DiscountType = (typeof DiscountType)[keyof typeof DiscountType]
/** document category */
export const DocumentCategory = {
  Bills: 'bills',
  Inspections: 'inspections',
  Insurance: 'insurance',
  Legal: 'legal'
} as const

export type DocumentCategory = (typeof DocumentCategory)[keyof typeof DocumentCategory]
export const Domain = {
  Kolors: 'kolors',
  Miautobus: 'miautobus'
} as const

export type Domain = (typeof Domain)[keyof typeof Domain]
export type DrawerBooking = {
  __typename?: 'DrawerBooking'
  buyer?: Maybe<BookingBuyer>
  coupon?: Maybe<DrawerBookingCoupon>
  id: Scalars['ID']['output']
  isCancelled: Scalars['Boolean']['output']
  payments: Array<DrawerBookingPayment>
  tickets: Array<Maybe<DrawerBookingTicket>>
}

export type DrawerBookingCoupon = {
  __typename?: 'DrawerBookingCoupon'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type DrawerBookingPayment = {
  __typename?: 'DrawerBookingPayment'
  amount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  last4?: Maybe<Scalars['String']['output']>
  method: Scalars['String']['output']
  status: Scalars['String']['output']
  tickets: Array<PaymentTicket>
}

export type DrawerBookingTicket = {
  __typename?: 'DrawerBookingTicket'
  id: Scalars['ID']['output']
  passengerType: DrawerBookingTicketPassengerType
  status: DrawerBookingTicketStatus
}

export const DrawerBookingTicketPassengerType = {
  Adult: 'adult',
  Child: 'child',
  Senior: 'senior',
  Student: 'student',
  Teacher: 'teacher'
} as const

export type DrawerBookingTicketPassengerType =
  (typeof DrawerBookingTicketPassengerType)[keyof typeof DrawerBookingTicketPassengerType]
export const DrawerBookingTicketStatus = {
  Cancelled: 'cancelled',
  Confirmed: 'confirmed',
  Reserved: 'reserved'
} as const

export type DrawerBookingTicketStatus = (typeof DrawerBookingTicketStatus)[keyof typeof DrawerBookingTicketStatus]
export type DrawerCompany = {
  __typename?: 'DrawerCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type DrawerData = {
  __typename?: 'DrawerData'
  actualAmount?: Maybe<Scalars['Int']['output']>
  company: DrawerCompany
  drawerBookings: Array<DrawerBooking>
  drawerKreditSales: Array<DrawerSale>
  drawerMobileSales: Array<DrawerSale>
  drawerSales: Array<DrawerSale>
  endTime?: Maybe<Scalars['Time']['output']>
  expectedAmount: ExpectedAmount
  receiptData: ReceiptData
  site: DrawerSite
  startTime?: Maybe<Scalars['Time']['output']>
  status: DrawerStatus
  user: DrawerUser
}

export type DrawerSale = {
  __typename?: 'DrawerSale'
  id: Scalars['ID']['output']
  payment: DrawerSalePayment
}

export type DrawerSalePayment = {
  __typename?: 'DrawerSalePayment'
  amount: Scalars['Int']['output']
  last4?: Maybe<Scalars['String']['output']>
  method: Scalars['String']['output']
}

export type DrawerSite = {
  __typename?: 'DrawerSite'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const DrawerStatus = {
  Closed: 'closed',
  Open: 'open'
} as const

export type DrawerStatus = (typeof DrawerStatus)[keyof typeof DrawerStatus]
export type DrawerUser = {
  __typename?: 'DrawerUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type DrawersResponse = {
  __typename?: 'DrawersResponse'
  items: Array<DrawerData>
  total: Scalars['Int']['output']
}

export type DriverDevice = {
  __typename?: 'DriverDevice'
  androidID?: Maybe<Scalars['String']['output']>
  app?: Maybe<DriverDeviceApp>
  brand: Scalars['String']['output']
  gpsEnabled: Scalars['Boolean']['output']
  id: Scalars['UUID']['output']
  idfa?: Maybe<Scalars['String']['output']>
  model: Scalars['String']['output']
  os: Scalars['String']['output']
  osVersion: Scalars['String']['output']
}

export type DriverDeviceApp = {
  __typename?: 'DriverDeviceApp'
  androidPermissions?: Maybe<DriverDeviceAppAndroidPermissions>
  appID: Scalars['String']['output']
  oneSignalID?: Maybe<Scalars['String']['output']>
  version: Scalars['String']['output']
}

export type DriverDeviceAppAndroidPermissions = {
  __typename?: 'DriverDeviceAppAndroidPermissions'
  accessBackgroundLocation: Scalars['Boolean']['output']
  accessCoarseLocation: Scalars['Boolean']['output']
  accessFineLocation: Scalars['Boolean']['output']
  accessNetworkState: Scalars['Boolean']['output']
  camera: Scalars['Boolean']['output']
  foregroundService: Scalars['Boolean']['output']
  internet: Scalars['Boolean']['output']
  locationHardware: Scalars['Boolean']['output']
  readExternalStorage: Scalars['Boolean']['output']
  vibrate: Scalars['Boolean']['output']
  wakeLock: Scalars['Boolean']['output']
  writeExternalStorage: Scalars['Boolean']['output']
}

export const DriverDocumentCategoryInput = {
  Application: 'APPLICATION',
  BirthCertificate: 'BIRTH_CERTIFICATE',
  Curp: 'CURP',
  Id: 'ID',
  Licence: 'LICENCE',
  Photo: 'PHOTO',
  ProofOfAddress: 'PROOF_OF_ADDRESS',
  ProofOfLastStudy: 'PROOF_OF_LAST_STUDY'
} as const

export type DriverDocumentCategoryInput = (typeof DriverDocumentCategoryInput)[keyof typeof DriverDocumentCategoryInput]
export type DriverSuggestion = {
  __typename?: 'DriverSuggestion'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type DriverSuggestionsInput = {
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  partnerID?: InputMaybe<Scalars['UUID']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type DriverSuggestionsResponse = {
  __typename?: 'DriverSuggestionsResponse'
  items: Array<DriverSuggestion>
  total: Scalars['Long']['output']
}

export type Duration = {
  __typename?: 'Duration'
  unit: DurationUnit
  value: Scalars['Int']['output']
}

export type DurationInput = {
  unit: DurationUnit
  value: Scalars['Int']['input']
}

export const DurationUnit = {
  Days: 'DAYS',
  Hours: 'HOURS'
} as const

export type DurationUnit = (typeof DurationUnit)[keyof typeof DurationUnit]
export type Email = {
  __typename?: 'Email'
  address: Scalars['String']['output']
  id: Scalars['ID']['output']
  reason?: Maybe<Scalars['String']['output']>
  status: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
}

export type EnableAncillaryInput = {
  id: Scalars['ID']['input']
}

export type EnableBusinessCustomerInput = {
  id: Scalars['UUID']['input']
}

export type EnableDriverInput = {
  id: Scalars['UUID']['input']
}

/** enable fare rule */
export type EnableFareRuleInput = {
  /** id */
  id: Scalars['ID']['input']
}

/** enable inventory rule */
export type EnableInventoryRuleInput = {
  /** inventory rule id */
  id: Scalars['ID']['input']
}

export type EnablePassengerPropertyInput = {
  id: Scalars['ID']['input']
}

export type EnablePassengerTypeInput = {
  id: Scalars['ID']['input']
}

export type EnableServiceFeeAddonRuleInput = {
  companyID: Scalars['ID']['input']
  id: Scalars['ID']['input']
}

export type ExpectedAmount = {
  __typename?: 'ExpectedAmount'
  bookings: Scalars['Int']['output']
  kreditSales: Scalars['Int']['output']
  mobileSales: Scalars['Int']['output']
  sales: Scalars['Int']['output']
}

export type ExpectedAmountByMethod = {
  __typename?: 'ExpectedAmountByMethod'
  bookings: Amounts
  kreditSales: Amounts
  mobileSales: Amounts
  sales: Amounts
}

export type FareFamiliesResponse = {
  __typename?: 'FareFamiliesResponse'
  /** fare families */
  items: Array<FareFamily>
  /** total number of fare families */
  total: Scalars['Int']['output']
}

export type FareFamily = {
  __typename?: 'FareFamily'
  company: FareFamilyCompany
  familyName: Scalars['String']['output']
  fares: Array<FareFamilyFare>
  id: Scalars['ID']['output']
  segment: FareFamilySegment
}

export type FareFamilyCompany = {
  __typename?: 'FareFamilyCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type FareFamilyFare = {
  __typename?: 'FareFamilyFare'
  basePrice: Scalars['Int']['output']
  bookingClass: FareFamilyFareBookingClass
  createdAt: Scalars['Time']['output']
  demand: Demand
  /**
   * DOW is an integer representing a day of the week
   *
   * 0 -> N/A
   *
   * 1 -> Monday
   *
   * 2 -> Tuesday
   *
   * 3 -> Wednesday
   *
   * 4 -> Thursday
   *
   * 5 -> Friday
   *
   * 6 -> Saturday
   *
   * 7 -> Sunday
   */
  dow: Scalars['Int']['output']
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  /**
   * SalesChannel is an integer representing a sales channel
   *
   * 0 -> N/A
   *
   * 1 -> Offline
   *
   * 2 -> Online
   */
  salesChannel: Scalars['Int']['output']
  seasonType: SeasonType
  serviceType: ServiceType
  timeWindow: Scalars['Int']['output']
  type: FareType
  updatedAt: Scalars['Time']['output']
}

export type FareFamilyFareBookingClass = {
  __typename?: 'FareFamilyFareBookingClass'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type FareFamilyFareInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>
  bookingClassID: Scalars['ID']['input']
  demand: Demand
  /**
   * DOW is an integer representing a day of the week
   *
   * 0 -> N/A
   *
   * 1 -> Monday
   *
   * 2 -> Tuesday
   *
   * 3 -> Wednesday
   *
   * 4 -> Thursday
   *
   * 5 -> Friday
   *
   * 6 -> Saturday
   *
   * 7 -> Sunday
   */
  dow: Scalars['Int']['input']
  isActive: Scalars['Boolean']['input']
  /**
   * SalesChannel is an integer representing a sales channel
   *
   * 0 -> N/A
   *
   * 1 -> Offline
   *
   * 2 -> Online
   */
  salesChannel: Scalars['Int']['input']
  seasonType: SeasonType
  serviceType: ServiceType
  timeWindow: Scalars['Int']['input']
  /** deprecated in favor of basePrice */
  total?: InputMaybe<Scalars['Int']['input']>
  type: FareType
}

export type FareFamilySegment = {
  __typename?: 'FareFamilySegment'
  destination: FareFamilySegmentPlace
  id: Scalars['ID']['output']
  origin: FareFamilySegmentPlace
}

export type FareFamilySegmentPlace = {
  __typename?: 'FareFamilySegmentPlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

/** fare rule */
export type FareRule = {
  __typename?: 'FareRule'
  /** activation at ranges */
  activationAtRanges?: Maybe<Array<FareRuleDateRange>>
  /** city segments */
  citySegments: Array<FareRuleCitySegment>
  /** company id */
  companyID: Scalars['String']['output']
  /** departure at ranges */
  departureAtRanges: Array<FareRuleDateRange>
  /** description */
  description: Scalars['String']['output']
  /** enabled */
  enabled: Scalars['Boolean']['output']
  /** exceptions */
  exceptions: FareRuleExceptions
  /** id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** price */
  price: Scalars['Int']['output']
  /** status */
  status: FareRuleStatus
  /** trips affected */
  tripsAffected: Scalars['Int']['output']
}

/** fare rule city segment */
export type FareRuleCitySegment = {
  __typename?: 'FareRuleCitySegment'
  /** all route services */
  allRouteServices: Scalars['Boolean']['output']
  /** all segments */
  allSegments: Scalars['Boolean']['output']
  /** destination */
  destination: FareRulePlace
  /** origin */
  origin: FareRulePlace
  /** route services */
  routeServices: Array<FareRuleRouteService>
  /** segments */
  segments: Array<FareRuleSegment>
}

/** fare rule date range */
export type FareRuleDateRange = {
  __typename?: 'FareRuleDateRange'
  /** start end */
  endAt: Scalars['Time']['output']
  /** start at */
  startAt: Scalars['Time']['output']
}

/** date range */
export type FareRuleDateRangeInput = {
  /** end at */
  endAt: Scalars['Time']['input']
  /** start at */
  startAt: Scalars['Time']['input']
}

/** fare rule exceptions */
export type FareRuleExceptions = {
  __typename?: 'FareRuleExceptions'
  /** days of week */
  dow?: Maybe<Array<Scalars['Int']['output']>>
}

/** exceptions */
export type FareRuleExceptionsInput = {
  /** day of week */
  dow?: InputMaybe<Array<Scalars['Int']['input']>>
}

/** fare rule query */
export type FareRuleInput = {
  /** id */
  id: Scalars['ID']['input']
}

/** itinerary stop */
export type FareRuleItineraryStop = {
  __typename?: 'FareRuleItineraryStop'
  /** day */
  day: Scalars['Int']['output']
  /** departure time in hh:mm format, in the timezone of the place */
  departureTime: Scalars['String']['output']
  /** place id */
  placeID: Scalars['ID']['output']
}

/** fare rule place */
export type FareRulePlace = {
  __typename?: 'FareRulePlace'
  /** code */
  code: Scalars['String']['output']
  /** id */
  id: Scalars['ID']['output']
  /** day of week */
  name: Scalars['String']['output']
}

/** fare rule route service */
export type FareRuleRouteService = {
  __typename?: 'FareRuleRouteService'
  /** code */
  code: Scalars['String']['output']
  /** id */
  id: Scalars['ID']['output']
}

/** fare rule segment */
export type FareRuleSegment = {
  __typename?: 'FareRuleSegment'
  /** destination */
  destination: FareRulePlace
  /** id */
  id: Scalars['ID']['output']
  /** origin */
  origin: FareRulePlace
}

/** fare rule status */
export const FareRuleStatus = {
  /** activated, in an activation range */
  Activated: 'activated',
  /** created, base status */
  Created: 'created',
  /** deactivated, in an activation range but disabled */
  Deactivated: 'deactivated',
  /** disabled, after last activation range */
  Expired: 'expired',
  /** scheduled, previous to an activation range */
  Scheduled: 'scheduled'
} as const

export type FareRuleStatus = (typeof FareRuleStatus)[keyof typeof FareRuleStatus]
/** city segment */
export type FareRulecitySegmentInput = {
  /** destination id */
  destinationID: Scalars['ID']['input']
  /** origin id */
  originID: Scalars['ID']['input']
  /** route services id */
  routeServiceIDs: Array<Scalars['ID']['input']>
  /** segments id */
  segmentIDs: Array<Scalars['ID']['input']>
}

/** fare rules query */
export type FareRulesInput = {
  /** destination city id */
  destinationCityID?: InputMaybe<Scalars['String']['input']>
  /** destination id */
  destinationID?: InputMaybe<Scalars['String']['input']>
  /** days of week */
  dow?: InputMaybe<Array<Scalars['Int']['input']>>
  /** origin city id */
  originCityID?: InputMaybe<Scalars['String']['input']>
  /** origin id */
  originID?: InputMaybe<Scalars['String']['input']>
  /** route service id */
  routeServiceID?: InputMaybe<Scalars['String']['input']>
  /** status */
  status?: InputMaybe<Scalars['String']['input']>
}

export type FareRulesResponse = {
  __typename?: 'FareRulesResponse'
  items: Array<FareRule>
  total: Scalars['Int']['output']
}

/** fare type */
export const FareType = {
  /** normal, available for all booking classes */
  M: 'M',
  /** promo, available if booking class allows it */
  P: 'P'
} as const

export type FareType = (typeof FareType)[keyof typeof FareType]
export type FileInput = {
  /** category of the file */
  category: CreatePartnersPaymentSummaryCategoryInput
  /** path to the file, as returned by the createPresignedUrlForFileUpload mutation */
  filePath: Scalars['String']['input']
}

export type ForceChangeUserAccountPasswordInput = {
  /** User Account ID */
  id: Scalars['UUID']['input']
  /** User Account Password */
  password: Scalars['String']['input']
}

export type Frequency = {
  __typename?: 'Frequency'
  unit: FrequencyUnit
  value: Scalars['Int']['output']
}

export type FrequencyInput = {
  unit: FrequencyUnitInput
  value: Scalars['Int']['input']
}

export const FrequencyUnit = {
  Day: 'DAY',
  Month: 'MONTH'
} as const

export type FrequencyUnit = (typeof FrequencyUnit)[keyof typeof FrequencyUnit]
export const FrequencyUnitInput = {
  Day: 'DAY',
  Month: 'MONTH'
} as const

export type FrequencyUnitInput = (typeof FrequencyUnitInput)[keyof typeof FrequencyUnitInput]
export type IncidenceSubCampaign = {
  __typename?: 'IncidenceSubCampaign'
  authorizer: Scalars['String']['output']
  campaign: SubCampaignCampaign
  coupons: Array<Coupon>
  endsAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  reason: Scalars['String']['output']
  startsAt: Scalars['String']['output']
  trip: SubCampaignTrip
}

export type IncidenceSubcampaign = {
  __typename?: 'IncidenceSubcampaign'
  campaignID: Scalars['ID']['output']
  campaignType: Scalars['String']['output']
  coupons: Array<IncidenceSubcampaignCoupon>
  endsAt: Scalars['Time']['output']
  id: Scalars['ID']['output']
  startsAt: Scalars['Time']['output']
  status: SubcampaignStatus
  trip: SubcampaignTrip
}

export type IncidenceSubcampaignCoupon = {
  __typename?: 'IncidenceSubcampaignCoupon'
  emails: Array<Email>
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  originalBooking: SubcampaignBooking
  redeemedBooking?: Maybe<SubcampaignBooking>
  status: CouponStatus
  supportInteractions: Array<SubcampaignSupportInteraction>
}

export type IncidenceSubcampaignInput = {
  id: Scalars['ID']['input']
}

export type IncidenceSubcampaignsInput = {
  campaignID?: InputMaybe<Scalars['ID']['input']>
  tripDestinationID?: InputMaybe<Scalars['ID']['input']>
  tripOriginID?: InputMaybe<Scalars['ID']['input']>
}

export type IncidenceSubcampaignsResponse = {
  __typename?: 'IncidenceSubcampaignsResponse'
  items: Array<IncidenceSubCampaign>
  total: Scalars['Int']['output']
}

export type Insurance = {
  __typename?: 'Insurance'
  bookingID: Scalars['ID']['output']
  certificateID?: Maybe<Scalars['String']['output']>
  confirmedAt?: Maybe<Scalars['Time']['output']>
  externalID?: Maybe<Scalars['String']['output']>
  hasConflict?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  insuranceCoverage?: Maybe<InsuranceCoverage>
  /** @deprecated Use statusV2 instead */
  status: AncillaryStatus
  statusV2: AncillaryStatusV2
  ticket: InsuranceTicket
}

export type InsuranceCoverage = {
  __typename?: 'InsuranceCoverage'
  arrivalAt: Scalars['Time']['output']
  departureAt: Scalars['Time']['output']
  passenger?: Maybe<InsurancePassenger>
}

export type InsurancePassenger = {
  __typename?: 'InsurancePassenger'
  email?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
}

/** insurance settings */
export type InsuranceSettingsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type InsuranceTicket = {
  __typename?: 'InsuranceTicket'
  passenger: InsurancePassenger
  trip: TicketInsuranceTrip
}

export type InteractionUser = {
  __typename?: 'InteractionUser'
  username: Scalars['String']['output']
}

export type InventoriesAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  types?: InputMaybe<Array<InventoryAutocompleteType>>
}

export type InventoriesQueryInput = {
  name?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<InventoryType>
}

export type InventoriesResponse = {
  __typename?: 'InventoriesResponse'
  items: Array<Inventory>
  total: Scalars['Int']['output']
}

export type Inventory = {
  __typename?: 'Inventory'
  address?: Maybe<InventoryAddress>
  company: InventoryCompany
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: InventoryType
  users: Array<InventoryUser>
}

export type InventoryAddress = {
  __typename?: 'InventoryAddress'
  city?: Maybe<InventoryCity>
  line1?: Maybe<Scalars['String']['output']>
  line2?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type InventoryAddressInput = {
  cityID?: InputMaybe<Scalars['ID']['input']>
  line1?: InputMaybe<Scalars['String']['input']>
  line2?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

/** inventory autocomplete */
export type InventoryAutocomplete = {
  __typename?: 'InventoryAutocomplete'
  /** inventory ID */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** type */
  type: InventoryType
}

export const InventoryAutocompleteType = {
  Base: 'base',
  Cart: 'cart',
  Warehouse: 'warehouse'
} as const

export type InventoryAutocompleteType = (typeof InventoryAutocompleteType)[keyof typeof InventoryAutocompleteType]
export type InventoryCity = {
  __typename?: 'InventoryCity'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type InventoryCompany = {
  __typename?: 'InventoryCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type InventoryInput = {
  address?: InputMaybe<InventoryAddressInput>
  name?: InputMaybe<Scalars['String']['input']>
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** item */
export type InventoryItemResponse = {
  __typename?: 'InventoryItemResponse'
  /** brand */
  brand: Scalars['String']['output']
  /** category */
  category: Scalars['String']['output']
  /** container */
  container: Scalars['String']['output']
  /** item id */
  id: Scalars['ID']['output']
  /** indicates whether the item is active or not */
  isActive: Scalars['Boolean']['output']
  /** lost quantity */
  lostQuantity: Scalars['Int']['output']
  /** minimum selling price */
  minSellingPrice?: Maybe<Scalars['Int']['output']>
  /** name */
  name: Scalars['String']['output']
  /** needs refrigeration */
  needsRefrigeration: Scalars['Boolean']['output']
  /** net content */
  netContent: Scalars['Int']['output']
  /** photo path */
  photoPath: Scalars['String']['output']
  /** selling price */
  sellingPrice: Scalars['Int']['output']
  /** sold quantity */
  soldQuantity: Scalars['Int']['output']
  /** stock quantity */
  stockQuantity: Scalars['Int']['output']
  /** subcategory */
  subcategory?: Maybe<Scalars['String']['output']>
  /** measurement units */
  units: Scalars['String']['output']
}

export type InventoryItemsQueryInput = {
  category?: InputMaybe<Scalars['String']['input']>
  companyID?: InputMaybe<Scalars['ID']['input']>
  inStock?: InputMaybe<Scalars['Boolean']['input']>
  inventoryID: Scalars['ID']['input']
  itemID?: InputMaybe<Scalars['ID']['input']>
  subcategory?: InputMaybe<Scalars['String']['input']>
}

/** inventory item */
export type InventoryItemsResponse = {
  __typename?: 'InventoryItemsResponse'
  /** items */
  items: Array<InventoryItemResponse>
  /** total of inventory items */
  total: Scalars['Int']['output']
}

export type InventoryQueryInput = {
  id: Scalars['ID']['input']
}

/** inventory rule */
export type InventoryRule = {
  __typename?: 'InventoryRule'
  /** activation at ranges */
  activationAtRanges?: Maybe<Array<InventoryRuleDateRange>>
  /** cabin strategies */
  cabinStrategies: Array<InventoryRuleCabinStrategy>
  /** city segments */
  citySegments: Array<InventoryRuleCitySegment>
  /** company id */
  companyID: Scalars['String']['output']
  /** departure at ranges */
  departureAtRanges: Array<InventoryRuleDateRange>
  /** description */
  description: Scalars['String']['output']
  /** enabled */
  enabled: Scalars['Boolean']['output']
  /** exceptions */
  exceptions: InventoryRuleExceptions
  /** id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** status */
  status: InventoryRuleStatus
  /** trips affected */
  tripsAffected: Scalars['Int']['output']
}

/** inventory rule booking class */
export type InventoryRuleBookingClass = {
  __typename?: 'InventoryRuleBookingClass'
  /** id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** priority */
  priority: Scalars['Int']['output']
}

/** inventory rule cabin setting */
export type InventoryRuleCabinSetting = {
  __typename?: 'InventoryRuleCabinSetting'
  bookingClass: InventoryRuleBookingClass
  /** is active */
  isActive: Scalars['Boolean']['output']
  /** max load factor */
  maxLoadFactor: Scalars['Int']['output']
  /** promo */
  promo: Scalars['Boolean']['output']
}

/** cabin setting */
export type InventoryRuleCabinSettingInput = {
  /** booking class id */
  bookingClassID: Scalars['ID']['input']
  /** is active */
  isActive: Scalars['Boolean']['input']
  /** max load factor */
  maxLoadFactor: Scalars['Int']['input']
  /** promo */
  promo?: InputMaybe<Scalars['Boolean']['input']>
}

/** inventory rule cabin strategy */
export type InventoryRuleCabinStrategy = {
  __typename?: 'InventoryRuleCabinStrategy'
  /** activation ranges */
  activationRanges: Array<InventoryRuleDaysToDepartureRange>
  /** cabin settings */
  cabinSettings: Array<InventoryRuleCabinSetting>
  /** id */
  id: Scalars['ID']['output']
  /** is default */
  isDefault: Scalars['Boolean']['output']
  /** name */
  name: Scalars['String']['output']
  /** version */
  version: Scalars['Int']['output']
}

/** inventory rule cabin strategy */
export type InventoryRuleCabinStrategyInput = {
  /** activation ranges */
  activationRanges?: InputMaybe<Array<InventoryRuleDaysToDepartureRangeInput>>
  /** cabin settings */
  cabinSettings: Array<InventoryRuleCabinSettingInput>
}

/** inventory rule city segment */
export type InventoryRuleCitySegment = {
  __typename?: 'InventoryRuleCitySegment'
  /** all route services */
  allRouteServices: Scalars['Boolean']['output']
  /** all segments */
  allSegments: Scalars['Boolean']['output']
  /** destination */
  destination: InventoryRulePlace
  /** origin */
  origin: InventoryRulePlace
  /** route services */
  routeServices: Array<InventoryRuleRouteService>
  /** segments */
  segments: Array<InventoryRuleSegment>
}

/** inventory rule date range */
export type InventoryRuleDateRange = {
  __typename?: 'InventoryRuleDateRange'
  /** start end */
  endAt: Scalars['Time']['output']
  /** start at */
  startAt: Scalars['Time']['output']
}

/** date range */
export type InventoryRuleDateRangeInput = {
  /** end at */
  endAt: Scalars['Time']['input']
  /** start at */
  startAt: Scalars['Time']['input']
}

/** days to departure range */
export type InventoryRuleDaysToDepartureRange = {
  __typename?: 'InventoryRuleDaysToDepartureRange'
  /** end */
  end: Scalars['Int']['output']
  /** start */
  start: Scalars['Int']['output']
}

/** days to departure range */
export type InventoryRuleDaysToDepartureRangeInput = {
  /** end */
  end: Scalars['Int']['input']
  /** start */
  start: Scalars['Int']['input']
}

/** inventory rule exceptions */
export type InventoryRuleExceptions = {
  __typename?: 'InventoryRuleExceptions'
  /** days of week */
  dow: Array<Scalars['Int']['output']>
  /** route services */
  routeServices: Array<InventoryRuleRouteService>
}

/** exceptions */
export type InventoryRuleExceptionsInput = {
  /** day of week */
  dow?: InputMaybe<Array<Scalars['Int']['input']>>
  /** route services id */
  routeServiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** inventory rule query */
export type InventoryRuleInput = {
  /** id */
  id: Scalars['ID']['input']
}

/** itinerary stop */
export type InventoryRuleItineraryStop = {
  __typename?: 'InventoryRuleItineraryStop'
  /** day */
  day: Scalars['Int']['output']
  /** departure time in hh:mm format, in the timezone of the place */
  departureTime: Scalars['String']['output']
  /** place id */
  placeID: Scalars['ID']['output']
}

/** inventory rule place */
export type InventoryRulePlace = {
  __typename?: 'InventoryRulePlace'
  /** code */
  code: Scalars['String']['output']
  /** id */
  id: Scalars['ID']['output']
  /** day of week */
  name: Scalars['String']['output']
}

/** inventory rule route service */
export type InventoryRuleRouteService = {
  __typename?: 'InventoryRuleRouteService'
  /** code */
  code: Scalars['String']['output']
  /** id */
  id: Scalars['ID']['output']
}

/** inventory rule segment */
export type InventoryRuleSegment = {
  __typename?: 'InventoryRuleSegment'
  /** destination */
  destination: InventoryRulePlace
  /** id */
  id: Scalars['ID']['output']
  /** origin */
  origin: InventoryRulePlace
}

/** inventory rule status */
export const InventoryRuleStatus = {
  /** activated, in an activation range */
  Activated: 'activated',
  /** created, base status */
  Created: 'created',
  /** deactivated, in an activation range but disabled */
  Deactivated: 'deactivated',
  /** expired, after last activation range */
  Expired: 'expired',
  /** scheduled, previous to an activation range */
  Scheduled: 'scheduled'
} as const

export type InventoryRuleStatus = (typeof InventoryRuleStatus)[keyof typeof InventoryRuleStatus]
/** city segment */
export type InventoryRulecitySegmentInput = {
  /** destination id */
  destinationID: Scalars['ID']['input']
  /** origin id */
  originID: Scalars['ID']['input']
  /** route services id */
  routeServiceIDs: Array<Scalars['ID']['input']>
  /** segments id */
  segmentIDs: Array<Scalars['ID']['input']>
}

/** inventory rules query */
export type InventoryRulesInput = {
  /** destination city id */
  destinationCityID?: InputMaybe<Scalars['String']['input']>
  /** destination id */
  destinationID?: InputMaybe<Scalars['String']['input']>
  /** days of week */
  dow?: InputMaybe<Array<Scalars['Int']['input']>>
  /** origin city id */
  originCityID?: InputMaybe<Scalars['String']['input']>
  /** origin id */
  originID?: InputMaybe<Scalars['String']['input']>
  /** route service id */
  routeServiceID?: InputMaybe<Scalars['String']['input']>
  /** status */
  status?: InputMaybe<InventoryRuleStatus>
}

/** inventory rules response */
export type InventoryRulesResponse = {
  __typename?: 'InventoryRulesResponse'
  items: Array<InventoryRule>
  total: Scalars['Int']['output']
}

export const InventoryType = {
  Base: 'base',
  Cart: 'cart',
  Warehouse: 'warehouse'
} as const

export type InventoryType = (typeof InventoryType)[keyof typeof InventoryType]
export type InventoryUser = {
  __typename?: 'InventoryUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type InventoryWaste = {
  __typename?: 'InventoryWaste'
  amount: Scalars['Int']['output']
  createdAt: Scalars['Time']['output']
  id: Scalars['ID']['output']
  inventory: InventoryWasteInventory
  items: Array<InventoryWasteItem>
  reason: ItemWasteReason
  status: InventoryWasteStatus
  user: InventoryWasteUser
}

export type InventoryWasteInventory = {
  __typename?: 'InventoryWasteInventory'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type InventoryWasteItem = {
  __typename?: 'InventoryWasteItem'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  price: Scalars['Int']['output']
  quantity: Scalars['Int']['output']
  subtotal: Scalars['Int']['output']
}

export const InventoryWasteStatus = {
  Cancelled: 'cancelled',
  Created: 'created'
} as const

export type InventoryWasteStatus = (typeof InventoryWasteStatus)[keyof typeof InventoryWasteStatus]
export type InventoryWasteUser = {
  __typename?: 'InventoryWasteUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
}

export type InventoryWastesQueryInput = {
  creationDateRange?: InputMaybe<DateRangeInput>
  id?: InputMaybe<Scalars['ID']['input']>
  inventoryID?: InputMaybe<Scalars['ID']['input']>
  itemID?: InputMaybe<Scalars['ID']['input']>
}

export type InventoryWastesResponse = {
  __typename?: 'InventoryWastesResponse'
  items: Array<InventoryWaste>
  total: Scalars['Int']['output']
}

/** item */
export type Item = {
  __typename?: 'Item'
  /** brand */
  brand: Scalars['String']['output']
  /** category */
  category: Scalars['String']['output']
  /** container */
  container: Scalars['String']['output']
  /** item id */
  id: Scalars['ID']['output']
  /** indicates whether the item is active or not */
  isActive: Scalars['Boolean']['output']
  /** minimum selling price */
  minSellingPrice?: Maybe<Scalars['Int']['output']>
  /** name */
  name: Scalars['String']['output']
  /** needs refrigeration */
  needsRefrigeration: Scalars['Boolean']['output']
  /** net content */
  netContent: Scalars['Int']['output']
  /** photo path */
  photoPath?: Maybe<Scalars['String']['output']>
  /** selling price */
  sellingPrice: Scalars['Int']['output']
  /** subcategory */
  subcategory?: Maybe<Scalars['String']['output']>
  /** template name */
  templateName?: Maybe<TemplateName>
  /** measurement units */
  units: Scalars['String']['output']
}

/** item autocomplete */
export type ItemAutocomplete = {
  __typename?: 'ItemAutocomplete'
  /** brand */
  brand: Scalars['String']['output']
  /** category */
  category: Scalars['String']['output']
  /** container */
  container: Scalars['String']['output']
  /** item ID */
  id: Scalars['ID']['output']
  /** isActive */
  isActive: Scalars['Boolean']['output']
  /** name */
  name: Scalars['String']['output']
  /** netContent */
  netContent: Scalars['Int']['output']
  /** subcategory */
  subcategory?: Maybe<Scalars['String']['output']>
  /** measurement units */
  units: Scalars['String']['output']
}

export type ItemComboComponentInput = {
  eligibleItemIDs: Array<Scalars['ID']['input']>
  quantity: Scalars['Int']['input']
}

export type ItemInput = {
  /** brand */
  brand?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  container?: InputMaybe<Scalars['String']['input']>
  /** the item's minimum selling price in cents */
  minSellingPrice?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  needsRefrigeration?: InputMaybe<Scalars['Boolean']['input']>
  /** net content in milliliters or milligrams */
  netContent?: InputMaybe<Scalars['Int']['input']>
  photoPath?: InputMaybe<Scalars['String']['input']>
  /** the item's selling price in cents */
  sellingPrice?: InputMaybe<Scalars['Int']['input']>
  subcategory?: InputMaybe<Scalars['String']['input']>
  /** measurement units */
  units?: InputMaybe<Scalars['String']['input']>
}

export type ItemKolorsMobilePlanInput = {
  name?: InputMaybe<Scalars['String']['input']>
  photoPath?: InputMaybe<Scalars['String']['input']>
  planID?: InputMaybe<Scalars['ID']['input']>
  sellingPrice?: InputMaybe<Scalars['Int']['input']>
}

export type ItemQueryInput = {
  id: Scalars['ID']['input']
}

export const ItemRemovalReason = {
  Accident: 'accident',
  AdministrativeError: 'administrativeError',
  Expired: 'expired',
  OperativeWaste: 'operativeWaste',
  Return: 'return'
} as const

export type ItemRemovalReason = (typeof ItemRemovalReason)[keyof typeof ItemRemovalReason]
export const ItemWasteReason = {
  Accident: 'accident',
  AdministrativeError: 'administrativeError',
  Expired: 'expired',
  OperativeWaste: 'operativeWaste',
  Return: 'return'
} as const

export type ItemWasteReason = (typeof ItemWasteReason)[keyof typeof ItemWasteReason]
export type ItemsAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  includeSims?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type ItemsQueryInput = {
  category?: InputMaybe<Scalars['String']['input']>
  companyID?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  subcategory?: InputMaybe<Scalars['String']['input']>
}

export type ItemsResponse = {
  __typename?: 'ItemsResponse'
  items: Array<Item>
  total: Scalars['Int']['output']
}

export type ItineraryDifference = {
  __typename?: 'ItineraryDifference'
  new: Array<ChangeStop>
  old: Array<ChangeStop>
}

export type ItineraryScheduleNote = {
  __typename?: 'ItineraryScheduleNote'
  createdAt: Scalars['Time']['output']
  text: Scalars['String']['output']
  user: RouteServiceUser
}

export type KolorsMobilePlanItem = {
  __typename?: 'KolorsMobilePlanItem'
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  photoPath: Scalars['String']['output']
  planID: Scalars['ID']['output']
  sellingPrice: Scalars['Int']['output']
  templateName: TemplateName
}

export type KolorsMobilePlanItemInput = {
  id: Scalars['ID']['input']
}

export type KolorsMobilePlanItemsInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
}

export type KolorsMobilePlanItemsResponse = {
  __typename?: 'KolorsMobilePlanItemsResponse'
  items: Array<KolorsMobilePlanItem>
  total: Scalars['Int']['output']
}

/**
 * The Kredit type represents a user kolors credits container,
 * including its balance.
 */
export type Kredit = {
  __typename?: 'Kredit'
  accounts: Array<KreditAccount>
  /** The balance of the Kolors Credits container, represented in cents. */
  balance: Scalars['Int']['output']
  businessClient?: Maybe<KreditBusinessClient>
  businessCustomer?: Maybe<KreditBusinessCustomer>
  businessSite?: Maybe<KreditBusinessSite>
  /** The timestamp of when the Kolors Credits container was created. */
  createdAt: Scalars['Time']['output']
  /** The unique ID of the Kolors Credits container. */
  id: Scalars['ID']['output']
  /** The timestamp of when the Kolors Credits container was last updated. */
  updatedAt: Scalars['Time']['output']
  /** The user related to this Kolors Credits container. */
  user: KreditUser
}

export type KreditAccount = {
  __typename?: 'KreditAccount'
  balance: Scalars['Int']['output']
  type: KreditAccountType
}

export const KreditAccountType = {
  Bonus: 'BONUS',
  Corporate: 'CORPORATE',
  Mobile: 'MOBILE',
  Refund: 'REFUND',
  TopUp: 'TOP_UP'
} as const

export type KreditAccountType = (typeof KreditAccountType)[keyof typeof KreditAccountType]
export type KreditBusinessClient = {
  __typename?: 'KreditBusinessClient'
  id: Scalars['UUID']['output']
  isKreditEnabled: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export type KreditBusinessCustomer = {
  __typename?: 'KreditBusinessCustomer'
  category?: Maybe<Scalars['Int']['output']>
  id: Scalars['UUID']['output']
}

export type KreditBusinessSite = {
  __typename?: 'KreditBusinessSite'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type KreditCategory = {
  __typename?: 'KreditCategory'
  amount: Scalars['Int']['output']
  frequency: Frequency
  name: Scalars['Int']['output']
}

export type KreditCategoryInput = {
  /** Kredit Dispersion Amount, in cents. */
  amount: Scalars['Int']['input']
  /** Kredit Dispersion Frequency. At the moment, only monthly frequency is supported. */
  frequency: FrequencyInput
  /** Kredit Category Name. Using an integer for now, so we have an unlimited number of categories that can be mapped */
  name: Scalars['Int']['input']
}

export type KreditDeposit = {
  __typename?: 'KreditDeposit'
  /** amount in cents */
  amount: Scalars['Int']['output']
  /** created at */
  createdAt: Scalars['Time']['output']
  /** transaction id */
  id: Scalars['UUID']['output']
  /** user that processed the deposit */
  user: BusinessClientKamUser
}

/** Input for querying a specific kredit by ID. */
export type KreditInput = {
  /** The ID of the kredit to query. */
  id: Scalars['ID']['input']
}

export type KreditSettingsBusinessSite = {
  __typename?: 'KreditSettingsBusinessSite'
  categories: Array<KreditCategory>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

/** The KreditTransaction type represents a single transaction made on a Kredit. */
export type KreditTransaction = {
  __typename?: 'KreditTransaction'
  accounts: Array<KreditAccountType>
  /** The amount of the transaction, represented in cents. */
  amount: Scalars['Int']['output']
  /**
   * The potential booking ID associated with the transaction.
   * @deprecated Use transactionSource instead.
   */
  bookingID?: Maybe<Scalars['ID']['output']>
  /** The timestamp of when the transaction was created. */
  createdAt: Scalars['Time']['output']
  /** The unique ID of the transaction. */
  id: Scalars['ID']['output']
  /**
   * The potential payment ID associated with the transaction.
   * @deprecated Use transactionSource instead.
   */
  paymentID?: Maybe<Scalars['ID']['output']>
  /** The source details of the transacion */
  source: TransactionSource
  /** The type of transaction made (deposit, withdrawal, transfer, etc.). */
  type: KreditTransactionType
}

export const KreditTransactionType = {
  Deposit: 'DEPOSIT',
  Refund: 'REFUND',
  Unknown: 'UNKNOWN',
  Withdrawal: 'WITHDRAWAL'
} as const

export type KreditTransactionType = (typeof KreditTransactionType)[keyof typeof KreditTransactionType]
export type KreditTransactionsInput = {
  kreditID: Scalars['ID']['input']
}

export type KreditTransactionsResponse = {
  __typename?: 'KreditTransactionsResponse'
  items: Array<KreditTransaction>
  total: Scalars['Int']['output']
}

/** The KreditUser type represents a single user in the system. */
export type KreditUser = {
  __typename?: 'KreditUser'
  /** The email of the user. */
  email: Scalars['String']['output']
  /** The first name of the user. */
  firstName: Scalars['String']['output']
  /** The unique ID of the user. */
  id: Scalars['ID']['output']
  /** The last name of the user. */
  lastName: Scalars['String']['output']
  /**
   * The phone number of the user.
   * @deprecated Use phoneNumber instead.
   */
  phone: Scalars['String']['output']
  /** The phone number of the user. */
  phoneNumber: KreditUserPhoneNumber
  /**
   * The full name of the user.
   * @deprecated Use firstName and lastName instead.
   */
  userFullName: Scalars['String']['output']
}

export type KreditUserPhoneNumber = {
  __typename?: 'KreditUserPhoneNumber'
  countryCode: Scalars['String']['output']
  number: Scalars['String']['output']
}

/** Input for querying kredits by associated user details. */
export type KreditsInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  category?: InputMaybe<Scalars['Int']['input']>
  /** The email of the user to find associated kredits. */
  email?: InputMaybe<Scalars['String']['input']>
  /** The phone number of the user to find associated kredits. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** The full name of the user to find associated kredits. */
  userFullName?: InputMaybe<Scalars['String']['input']>
}

/**
 * The response from querying for a list of kredits. Includes the list of kredits
 * and the total count of kredits.
 */
export type KreditsResponse = {
  __typename?: 'KreditsResponse'
  /** The specific kredits that match the query. */
  items: Array<Kredit>
  /** The total number of kredits that match the query. */
  total: Scalars['Int']['output']
}

export type KreditsSettings = {
  __typename?: 'KreditsSettings'
  businessSites?: Maybe<Array<KreditSettingsBusinessSite>>
  categories: Array<KreditCategory>
}

/** language */
export const Language = {
  En: 'EN',
  Es: 'ES'
} as const

export type Language = (typeof Language)[keyof typeof Language]
export type Limit = {
  __typename?: 'Limit'
  /** limit key */
  key: Scalars['String']['output']
  /** limit type */
  type: LimitType
  /** limit value */
  value?: Maybe<Scalars['Int']['output']>
}

/** limit type */
export const LimitType = {
  Passenger: 'passenger'
} as const

export type LimitType = (typeof LimitType)[keyof typeof LimitType]
export type LineItemComboComponent = {
  __typename?: 'LineItemComboComponent'
  item: Item
  quantity: Scalars['Int']['output']
}

/** geolocation */
export type Location = {
  __typename?: 'Location'
  /** latitude */
  latitude: Scalars['String']['output']
  /** longitude */
  longitude: Scalars['String']['output']
}

export type LocationCitiesInput = {
  salesChannelID: Scalars['UUID']['input']
  vertical?: PlaceVertical
}

export type LocationCitiesResponse = {
  __typename?: 'LocationCitiesResponse'
  locationCities: Array<LocationCity>
}

export type LocationCity = {
  __typename?: 'LocationCity'
  id: Scalars['UUID']['output']
  isDestination: Scalars['Boolean']['output']
  isOrigin: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  param: Scalars['String']['output']
  places: Array<LocationPlace>
}

export type LocationCityInput = {
  id?: InputMaybe<Scalars['UUID']['input']>
  param?: InputMaybe<Scalars['String']['input']>
  salesChannelID: Scalars['UUID']['input']
  vertical?: PlaceVertical
}

export type LocationInput = {
  /** The latitude of the location */
  latitude: Scalars['String']['input']
  /** The longitude of the location */
  longitude: Scalars['String']['input']
}

export type LocationPlace = {
  __typename?: 'LocationPlace'
  address: LocationPlaceAddress
  amenities: Array<LocationPlaceAmenity>
  directions: Scalars['String']['output']
  id: Scalars['UUID']['output']
  isDestination: Scalars['Boolean']['output']
  isOrigin: Scalars['Boolean']['output']
  location: LocationPlaceLocation
  name: Scalars['String']['output']
  param: Scalars['String']['output']
  type: LocationPlaceType
}

export type LocationPlaceAddress = {
  __typename?: 'LocationPlaceAddress'
  city: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  line1: Scalars['String']['output']
  line2?: Maybe<Scalars['String']['output']>
  stateCode: Scalars['String']['output']
  zipCode: Scalars['String']['output']
}

export const LocationPlaceAmenity = {
  KolorsMobile: 'KOLORS_MOBILE',
  KolorsTicket: 'KOLORS_TICKET'
} as const

export type LocationPlaceAmenity = (typeof LocationPlaceAmenity)[keyof typeof LocationPlaceAmenity]
export type LocationPlaceLocation = {
  __typename?: 'LocationPlaceLocation'
  latitude: Scalars['String']['output']
  longitude: Scalars['String']['output']
}

export const LocationPlaceType = {
  Attraction: 'ATTRACTION',
  ConvenienceStore: 'CONVENIENCE_STORE',
  Hotel: 'HOTEL',
  Mall: 'MALL',
  Office: 'OFFICE',
  ParkingLot: 'PARKING_LOT',
  PointOfInterest: 'POINT_OF_INTEREST',
  ResidentialArea: 'RESIDENTIAL_AREA',
  Restaurant: 'RESTAURANT',
  School: 'SCHOOL',
  Sidewalk: 'SIDEWALK',
  Station: 'STATION',
  Supermarket: 'SUPERMARKET',
  Venue: 'VENUE'
} as const

export type LocationPlaceType = (typeof LocationPlaceType)[keyof typeof LocationPlaceType]
export type LoyaltyCampaign = {
  __typename?: 'LoyaltyCampaign'
  company: LoyaltyCampaignCompany
  companyLines: Array<LoyaltyCampaignCompanyLine>
  description?: Maybe<Scalars['String']['output']>
  endAt: Scalars['Time']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  rules: Array<LoyaltyCampaignRule>
  startAt: Scalars['Time']['output']
  status: Scalars['String']['output']
}

export type LoyaltyCampaignCompany = {
  __typename?: 'LoyaltyCampaignCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type LoyaltyCampaignCompanyLine = {
  __typename?: 'LoyaltyCampaignCompanyLine'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type LoyaltyCampaignConditions = {
  __typename?: 'LoyaltyCampaignConditions'
  citySegments?: Maybe<Array<Maybe<LoyaltyCampaignRuleConditionsCitySegment>>>
  routeServices?: Maybe<Array<LoyaltyCampaignRuleConditionsRouteService>>
  /** @deprecated use salesChannelsV2 */
  salesChannels: Array<Scalars['String']['output']>
  salesChannelsV2: Array<LoyaltyCampaignConditionsSalesChannel>
  totalBookingsValue?: Maybe<Scalars['Int']['output']>
}

export type LoyaltyCampaignConditionsSalesChannel = {
  __typename?: 'LoyaltyCampaignConditionsSalesChannel'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type LoyaltyCampaignEffect = {
  __typename?: 'LoyaltyCampaignEffect'
  reward?: Maybe<LoyaltyCampaignReward>
}

export type LoyaltyCampaignInput = {
  id: Scalars['ID']['input']
}

export type LoyaltyCampaignPlace = {
  __typename?: 'LoyaltyCampaignPlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type LoyaltyCampaignReward = {
  __typename?: 'LoyaltyCampaignReward'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type LoyaltyCampaignRule = {
  __typename?: 'LoyaltyCampaignRule'
  conditions?: Maybe<LoyaltyCampaignConditions>
  description?: Maybe<Scalars['String']['output']>
  details: Scalars['String']['output']
  effects: Array<LoyaltyCampaignEffect>
  howToGet: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  validAt: Scalars['String']['output']
}

export type LoyaltyCampaignRuleConditionsCitySegment = {
  __typename?: 'LoyaltyCampaignRuleConditionsCitySegment'
  destination: LoyaltyCampaignPlace
  /** @deprecated use destination */
  destinationID: Scalars['ID']['output']
  origin: LoyaltyCampaignPlace
  /** @deprecated use origin */
  originID: Scalars['ID']['output']
  /** @deprecated use segments */
  segmentIDs: Array<Scalars['ID']['output']>
  segments: Array<LoyaltyCampaignSegment>
}

export type LoyaltyCampaignRuleConditionsRouteService = {
  __typename?: 'LoyaltyCampaignRuleConditionsRouteService'
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
}

export type LoyaltyCampaignRuleInput = {
  id: Scalars['ID']['input']
  ruleID: Scalars['ID']['input']
}

export type LoyaltyCampaignSegment = {
  __typename?: 'LoyaltyCampaignSegment'
  destination: LoyaltyCampaignPlace
  id: Scalars['ID']['output']
  origin: LoyaltyCampaignPlace
}

export type LoyaltyCampaignsInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
}

export type LoyaltyCampaignsResponse = {
  __typename?: 'LoyaltyCampaignsResponse'
  items: Array<LoyaltyCampaign>
  total: Scalars['Int']['output']
}

export type LoyaltyReward = {
  __typename?: 'LoyaltyReward'
  company: LoyaltyRewardCompany
  /** @deprecated use company.id instead */
  companyID: Scalars['ID']['output']
  description?: Maybe<Scalars['String']['output']>
  earnedCount: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  redeemedCount: Scalars['Int']['output']
  type: LoyaltyRewardType
}

export type LoyaltyRewardAutocomplete = {
  __typename?: 'LoyaltyRewardAutocomplete'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type LoyaltyRewardCompany = {
  __typename?: 'LoyaltyRewardCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const LoyaltyRewardType = {
  KolorsGoRewardMvp: 'KolorsGoRewardMVP',
  KolorsRewardMvp: 'KolorsRewardMVP'
} as const

export type LoyaltyRewardType = (typeof LoyaltyRewardType)[keyof typeof LoyaltyRewardType]
export type LoyaltyRewardsAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type LoyaltyRewardsInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
}

export type LoyaltyRewardsResponse = {
  __typename?: 'LoyaltyRewardsResponse'
  items: Array<LoyaltyReward>
  total: Scalars['Int']['output']
}

export type MarkVehicleOutOfServiceInput = {
  id: Scalars['UUID']['input']
}

export type Mutation = {
  __typename?: 'Mutation'
  /** activate a booking class */
  activateBookingClass: Scalars['Boolean']['output']
  activateBusinessClient: Scalars['Boolean']['output']
  activateBusinessClientUser: Scalars['Boolean']['output']
  activateBusinessSite: Scalars['Boolean']['output']
  /** activate campaign */
  activateCampaign: Scalars['Boolean']['output']
  /** activate campaign coupon */
  activateCampaignCoupon: Scalars['Boolean']['output']
  /** activate an item */
  activateItem?: Maybe<ToggleItemResponse>
  activatePartner: Scalars['Boolean']['output']
  /** activate a season event */
  activateSeasonEvent: Scalars['Boolean']['output']
  /** activate a route service */
  activateService?: Maybe<ToggleServiceResponse>
  /** activate a site */
  activateSite: ToggleSiteResponse
  /** activate correlated trips for sale */
  activateTripSale: Scalars['Boolean']['output']
  /** activate a user */
  activateUser?: Maybe<ToggleUserResponse>
  activateVehicle: Scalars['Boolean']['output']
  /** add booking tickets insurance */
  addBookingTicketsInsurance: Scalars['Boolean']['output']
  addCampaignCouponSupportInteraction: Scalars['Boolean']['output']
  /** add campaign snack coupon */
  addCampaignSnacksCoupon: Scalars['Boolean']['output']
  /** add coupon */
  addCoupon: Scalars['Boolean']['output']
  /** add fare family fares */
  addFareFamilyFares: AddFareFamilyFaresResponse
  addLoyaltyCampaignRuleConditionsCitySegments: Scalars['Boolean']['output']
  addLoyaltyCampaignRuleConditionsRouteServices: Scalars['Boolean']['output']
  addLoyaltyCampaignRuleConditionsSalesChannels: Scalars['Boolean']['output']
  addPartnerDocuments: Scalars['Boolean']['output']
  addPartnersPaymentSummaryFiles: Scalars['Boolean']['output']
  addRouteServicePeaks: Scalars['Boolean']['output']
  addRoutingProjectPlanDatasetLocations: AddRoutingProjectPlanDatasetLocationsResponse
  /** add segment company line spec */
  addSegmentCompanyLineSpec: Scalars['Boolean']['output']
  addServiceFeeAddonRule: Scalars['Boolean']['output']
  addTripDriverRSVPNote: Scalars['Boolean']['output']
  addTripNote: Scalars['Boolean']['output']
  /** apply booking coupon */
  applyBookingCoupon: ApplyBookingCouponResponse
  /** archive inventory */
  archiveInventory: Scalars['Boolean']['output']
  archiveRouteServiceItinerarySchedule: Scalars['Boolean']['output']
  /** archive a vehicle template */
  archiveVehicleTemplate: Scalars['Boolean']['output']
  /** Assign sims to business client */
  assignBusinessClientSims: Scalars['Boolean']['output']
  assignBusinessCustomerKreditCategory: Scalars['Boolean']['output']
  assignBusinessCustomersKreditCategory: Scalars['Boolean']['output']
  /** cancel booking tickets */
  cancelBookingTickets: Scalars['Boolean']['output']
  /** cancel booking tickets insurance */
  cancelBookingTicketsInsurance: Scalars['Boolean']['output']
  /** cancel booking trip change */
  cancelBookingTripChange: Scalars['Boolean']['output']
  /** cancel booking trip change proposal */
  cancelBookingTripChangeProposal: Scalars['Boolean']['output']
  /** cancel business client kredit deposit */
  cancelBusinessClientKreditDeposit: Scalars['Boolean']['output']
  /** cancel a scheduled change */
  cancelChange: Scalars['Boolean']['output']
  /** cancel an order */
  cancelOrder: Scalars['Boolean']['output']
  /** cancel sale items */
  cancelSaleItems: Scalars['Boolean']['output']
  /**
   * cancel tickets
   * @deprecated Use cancelBookingTickets instead
   */
  cancelTickets: Scalars['Boolean']['output']
  /** cancel trip */
  cancelTrip: Scalars['Boolean']['output']
  /** cancel multiple trips */
  cancelTrips: Scalars['Boolean']['output']
  changeAncillary: Scalars['Boolean']['output']
  /** change booking passengers names */
  changeBookingPassengersNames: Scalars['Boolean']['output']
  /** change a bookings's payment details */
  changeBookingPayment: Scalars['Boolean']['output']
  /** change booking tickets ancillaries */
  changeBookingTicketsAncillaries: Scalars['Boolean']['output']
  /** change booking tripChange ticket seat */
  changeBookingTripChangeTicketSeat: Scalars['Boolean']['output']
  changeBusinessClient: Scalars['Boolean']['output']
  changeBusinessClientContacts: Scalars['Boolean']['output']
  /** Change the amount of Kredits for a Business Client's Customer. This overrides the amount set via the client or site settings. */
  changeBusinessClientCustomerKreditsAmount: Scalars['Boolean']['output']
  /** Change the amount of Kredits for a Business Client's Customers. This overrides the amount set via the client or site settings. */
  changeBusinessClientCustomersKreditsAmount: Scalars['Boolean']['output']
  /** Change Kredit Settings for a Business Client. All settings are overwritten. */
  changeBusinessClientKreditSettings: Scalars['Boolean']['output']
  /** Change Kredit Settings for a Site of a Business Client. This will overwrite the settings for the site. */
  changeBusinessClientSiteKreditSettings: Scalars['Boolean']['output']
  changeBusinessClientUser: Scalars['Boolean']['output']
  changeBusinessClientUserBusinessClient: Scalars['Boolean']['output']
  changeBusinessCustomerBusinessClient: Scalars['Boolean']['output']
  changeBusinessCustomerBusinessSite: Scalars['Boolean']['output']
  changeBusinessSite: Scalars['Boolean']['output']
  changeBusinessSiteContacts: Scalars['Boolean']['output']
  /** change a booking's buyer */
  changeBuyer: Scalars['Boolean']['output']
  /** change a cart */
  changeCart: Scalars['Boolean']['output']
  /** change a combo item */
  changeComboItem: Scalars['Boolean']['output']
  /** change company insurance settings */
  changeCompanyInsuranceSettings: Scalars['Boolean']['output']
  changeCurrencyExchangeRate: Scalars['Boolean']['output']
  changeDriverDocuments: Scalars['Boolean']['output']
  /** change fare family fares */
  changeFareFamilyFares: Scalars['Boolean']['output']
  /** change fare rule */
  changeFareRule: Scalars['Boolean']['output']
  /** change an inventory */
  changeInventory: Scalars['Boolean']['output']
  /** change inventory rule */
  changeInventoryRule: Scalars['Boolean']['output']
  /** change inventory rule cabin strategies */
  changeInventoryRuleCabinStrategies: Scalars['Boolean']['output']
  /** change an item */
  changeItem: Scalars['Boolean']['output']
  /** change a kolors mobile plan item */
  changeItemKolorsMobilePlan: Scalars['Boolean']['output']
  changeLoyaltyCampaign: Scalars['Boolean']['output']
  changeLoyaltyCampaignRule: Scalars['Boolean']['output']
  changeOperationalCostSettings: Scalars['Boolean']['output']
  /** change an order */
  changeOrder: Scalars['Boolean']['output']
  changePartnerBankDetails: Scalars['Boolean']['output']
  changePartnerContacts: Scalars['Boolean']['output']
  changePartnerDetails: Scalars['Boolean']['output']
  changePartnerKAMUser: Scalars['Boolean']['output']
  changePartnerTaxInformation: Scalars['Boolean']['output']
  changePassengerProperty: Scalars['Boolean']['output']
  changePassengerType: Scalars['Boolean']['output']
  changePlaceV2: Scalars['Boolean']['output']
  changeRouteServiceItinerariesSchedule: Scalars['Boolean']['output']
  changeRouteServiceVehiclesSchedule: Scalars['Boolean']['output']
  changeRoutingProject: Scalars['Boolean']['output']
  changeRoutingProjectPlanConstraints: Scalars['Boolean']['output']
  changeRoutingProjectPlanDatasetLocations: Scalars['Boolean']['output']
  changeRoutingProjectPlanOptimizationRouteStops: Scalars['Boolean']['output']
  changeServiceFeeAddonRule: Scalars['Boolean']['output']
  /** change a site. only the properties to change should be included. */
  changeSite: Scalars['Boolean']['output']
  changeTDriverDetails: Scalars['Boolean']['output']
  changeTRoute: Scalars['Boolean']['output']
  changeTTripDriver: Scalars['Boolean']['output']
  changeTVehicleCards: Scalars['Boolean']['output']
  changeTVehicleDetails: Scalars['Boolean']['output']
  changeTVehicleDocuments: Scalars['Boolean']['output']
  changeTVehicleDrivers: Scalars['Boolean']['output']
  changeTVehicleFeatures: Scalars['Boolean']['output']
  changeTVehicleInsurancePolicy: Scalars['Boolean']['output']
  changeTVehicleLicensePlates: Scalars['Boolean']['output']
  changeTVehicleOdometerReading: Scalars['Boolean']['output']
  changeTVehicleRegistrationDetails: Scalars['Boolean']['output']
  /** change a ticket's passenger details */
  changeTicketsPassenger: Scalars['Boolean']['output']
  /** deselect a seat and select another */
  changeTripBookingSeat: Scalars['Boolean']['output']
  changeTripConfirmationModalities: Scalars['Boolean']['output']
  /**
   * change trip itinerary departure time
   * @deprecated Use createRouteServiceItinerariesSchedule instead
   */
  changeTripItineraryDepartureTime: Scalars['Boolean']['output']
  /**
   * change trip route
   * @deprecated Use createRouteServiceItinerariesSchedule instead
   */
  changeTripRoute: Scalars['Boolean']['output']
  /** changes the crew users assigned to a trip */
  changeTripUsers: Scalars['Boolean']['output']
  /**
   * change trip vehicle
   * @deprecated Use createRouteServiceVehiclesSchedule instead
   */
  changeTripVehicle: Scalars['Boolean']['output']
  /**
   * change trips vehicle
   * @deprecated Not used anymore
   */
  changeTripsVehicle: Scalars['Boolean']['output']
  /** Change User Account Details */
  changeUserAccountDetails: Scalars['Boolean']['output']
  changeUserPassword: Scalars['Boolean']['output']
  /** confirm booking payment on site */
  confirmBookingPaymentOnSite: Scalars['Boolean']['output']
  /** confirm booking trip change proposal */
  confirmBookingTripChangeProposal: Scalars['Boolean']['output']
  /** confirm booking tripChanges */
  confirmBookingTripChanges: ConfirmBookingTripChangesResponse
  createAncillary: Scalars['Boolean']['output']
  /** create a booking class */
  createBookingClass: Scalars['Boolean']['output']
  /** create booking trip change proposal */
  createBookingTripChangeProposal: CreateBookingTripChangeProposalResponse
  createBusinessClient: CreateBusinessClientResponse
  createBusinessClientContacts: Scalars['Boolean']['output']
  createBusinessClientUser: Scalars['Boolean']['output']
  createBusinessClientsRouteServicesSchedulePrice: Scalars['Boolean']['output']
  createBusinessCustomer: Scalars['Boolean']['output']
  createBusinessCustomersFromCSV: Scalars['Boolean']['output']
  createBusinessSite: CreateBusinessSiteResponse
  createBusinessSiteContacts: Scalars['Boolean']['output']
  /** create campaign */
  createCampaign: Scalars['Boolean']['output']
  /** create campaign subcampaign */
  createCampaignSubcampaign?: Maybe<CreateCampaignSubcampaignResponse>
  /** create cart */
  createCart: Scalars['Boolean']['output']
  /** create a city */
  createCity: Scalars['Boolean']['output']
  /**
   * create a company
   * @deprecated Use createCompanyV2 instead
   */
  createCompany: Scalars['Boolean']['output']
  /** create a company line */
  createCompanyLine: Scalars['Boolean']['output']
  createCompanyV2: Scalars['Boolean']['output']
  createCountry: Scalars['Boolean']['output']
  createCurrency: Scalars['Boolean']['output']
  createDriver: CreateDriverResponse
  /** create fare families */
  createFareFamilies: Scalars['Boolean']['output']
  /** create fare rule */
  createFareRule: Scalars['Boolean']['output']
  /** create inventory */
  createInventory: Scalars['Boolean']['output']
  /** create inventory rule */
  createInventoryRule: Scalars['Boolean']['output']
  /** create inventory rule cabin strategies */
  createInventoryRuleCabinStrategies: Scalars['Boolean']['output']
  createLoyaltyCampaign: Scalars['Boolean']['output']
  createLoyaltyCampaignRule: Scalars['Boolean']['output']
  createLoyaltyReward: Scalars['Boolean']['output']
  createOperationalCost: CreateOperationalCostResponse
  /** create order */
  createOrder: Scalars['Boolean']['output']
  createPartner: CreatePartnerResponse
  createPartnerContacts: Scalars['Boolean']['output']
  createPartnersPaymentSummary: CreatePartnersPaymentSummaryResponse
  createPassengerProperty: Scalars['Boolean']['output']
  createPassengerType: Scalars['Boolean']['output']
  /**
   * create a place
   * @deprecated Use createPlaceV2 instead
   */
  createPlace: Scalars['Boolean']['output']
  createPlaceForBusinessCustomer: Scalars['Boolean']['output']
  createPlaceV2: Scalars['Boolean']['output']
  /** create policy company role */
  createPolicyCompanyRole: Scalars['Boolean']['output']
  /** create policy permission */
  createPolicyPermission: Scalars['Boolean']['output']
  /** create policy private role */
  createPolicyPrivateRole: Scalars['Boolean']['output']
  /** create policy role */
  createPolicyRole: Scalars['Boolean']['output']
  createPresignedUrlForFileUpload: CreatePresignedUrlForFileUploadOutput
  /**
   * create a route
   * @deprecated Use createTRoute instead
   */
  createRoute?: Maybe<CreateRouteResponse>
  createRouteServiceDriverOverride: Scalars['Boolean']['output']
  createRouteServiceItinerariesSchedule: Scalars['Boolean']['output']
  createRouteServiceItineraryOverride: Scalars['Boolean']['output']
  createRouteServicePastVehicleOverride: Scalars['Boolean']['output']
  createRouteServiceRouteOverride: Scalars['Boolean']['output']
  createRouteServiceSingleTrip: Scalars['Boolean']['output']
  createRouteServiceVehicleOverride: Scalars['Boolean']['output']
  createRouteServiceVehiclesSchedule: Scalars['Boolean']['output']
  createRoutingProject: CreateRoutingProjectResponse
  createRoutingProjectDataset: CreateRoutingProjectDatasetResponse
  createRoutingProjectPlan: CreateRoutingProjectPlanResponse
  createRoutingProjectPlanOptimization: Scalars['Boolean']['output']
  createSalesChannel: Scalars['Boolean']['output']
  /** create a season event */
  createSeasonEvent: Scalars['Boolean']['output']
  /** create a route service */
  createService: Scalars['Boolean']['output']
  /** create a site */
  createSite: Scalars['Boolean']['output']
  createTRoute: CreateTRouteResponse
  createTVehicle: CreateTVehicleResponse
  /** create a user */
  createUser: Scalars['Boolean']['output']
  /** create vehicle template */
  createVehicleTemplate: Scalars['Boolean']['output']
  /** deactivate a booking class */
  deactivateBookingClass: Scalars['Boolean']['output']
  deactivateBusinessClient: Scalars['Boolean']['output']
  deactivateBusinessClientUser: Scalars['Boolean']['output']
  deactivateBusinessSite: Scalars['Boolean']['output']
  /** deactivate campaign */
  deactivateCampaign: Scalars['Boolean']['output']
  /** deactivate campaign coupon */
  deactivateCampaignCoupon: Scalars['Boolean']['output']
  /** deactivate an item */
  deactivateItem?: Maybe<ToggleItemResponse>
  deactivatePartner: Scalars['Boolean']['output']
  /** deactivate a season event */
  deactivateSeasonEvent: Scalars['Boolean']['output']
  /** deactivate a route service */
  deactivateService?: Maybe<ToggleServiceResponse>
  /** deactivate a site */
  deactivateSite: ToggleSiteResponse
  /** deactivate correlated trips for sale */
  deactivateTripSale: Scalars['Boolean']['output']
  /** deactivate a user */
  deactivateUser?: Maybe<ToggleUserResponse>
  deactivateVehicle: Scalars['Boolean']['output']
  deleteBusinessClientContacts: Scalars['Boolean']['output']
  deleteBusinessSiteContacts: Scalars['Boolean']['output']
  /** delete inventory rule cabin strategies */
  deleteInventoryRuleCabinStrategies: Scalars['Boolean']['output']
  deletePartnerContacts: Scalars['Boolean']['output']
  deleteRouteServiceVehiclesSchedule: Scalars['Boolean']['output']
  deleteTVehicleDocuments: Scalars['Boolean']['output']
  depositKreditCorporateFunds: Scalars['Boolean']['output']
  depositKreditsBonusFunds: Scalars['Boolean']['output']
  depositKreditsCorporateFunds: Scalars['Boolean']['output']
  disableAncillary: Scalars['Boolean']['output']
  disableBusinessCustomer: Scalars['Boolean']['output']
  disableDriver: Scalars['Boolean']['output']
  /** disable fare rule */
  disableFareRule: Scalars['Boolean']['output']
  /** disable inventory rule */
  disableInventoryRule: Scalars['Boolean']['output']
  disablePassengerProperty: Scalars['Boolean']['output']
  disablePassengerType: Scalars['Boolean']['output']
  disableServiceFeeAddonRule: Scalars['Boolean']['output']
  enableAncillary: Scalars['Boolean']['output']
  enableBusinessCustomer: Scalars['Boolean']['output']
  enableDriver: Scalars['Boolean']['output']
  /** enable fare rule */
  enableFareRule: Scalars['Boolean']['output']
  /** enable inventory rule */
  enableInventoryRule: Scalars['Boolean']['output']
  enablePassengerProperty: Scalars['Boolean']['output']
  enablePassengerType: Scalars['Boolean']['output']
  enableServiceFeeAddonRule: Scalars['Boolean']['output']
  /** Force Change User Account Password */
  forceChangeUserAccountPassword: Scalars['Boolean']['output']
  /** login */
  login: LoginResponse
  /** logout */
  logout: Scalars['Boolean']['output']
  markVehicleOutOfService: Scalars['Boolean']['output']
  /** Process business client kredits dispersion */
  processBusinessClientKreditsDispersion: Scalars['Boolean']['output']
  /** receive an order */
  receiveOrder: Scalars['Boolean']['output']
  /** refresh session */
  refreshSession: LoginResponse
  registerBookingSupportInteraction: Scalars['Boolean']['output']
  /** register booking tax invoiced */
  registerBookingTaxInvoiced: Scalars['Boolean']['output']
  /** register inventory waste */
  registerInventoryWaste: Scalars['Boolean']['output']
  /** register item */
  registerItem: Scalars['Boolean']['output']
  /** register item combo */
  registerItemCombo: Scalars['Boolean']['output']
  /** register item kolors mobile plan */
  registerItemKolorsMobilePlan: Scalars['Boolean']['output']
  registerTripOdometerDistance: Scalars['Boolean']['output']
  /**
   * register vehicle
   * @deprecated Use createTVehicle instead
   */
  registerVehicle: Scalars['Boolean']['output']
  /** reject an order */
  rejectOrder: Scalars['Boolean']['output']
  removePartnerDocuments: Scalars['Boolean']['output']
  removeRoutingProjectPlanDatasetLocations: Scalars['Boolean']['output']
  replacePlaceForBusinessCustomer: Scalars['Boolean']['output']
  /** request business client kredit deposit */
  requestBusinessClientKreditDeposit: Scalars['Boolean']['output']
  requestCampaignSubcampaignCouponsDelivery: Scalars['Boolean']['output']
  /** Request Reset User Account Password */
  requestResetUserAccountPassword: Scalars['Boolean']['output']
  resetUserPassword: Scalars['Boolean']['output']
  /** return a cart */
  returnCart: Scalars['Boolean']['output']
  scheduleRouteServiceTrips: Scalars['Boolean']['output']
  sendEmailCoupon: Scalars['Boolean']['output']
  /** @deprecated Use sendEmailCoupon instead */
  sendEmailIncidenceCoupon: Scalars['Boolean']['output']
  /** send emails to all partners with data for the given summary */
  sendPartnersPaymentSummaryEmails: Scalars['Boolean']['output']
  sendSMSCoupon: Scalars['Boolean']['output']
  /** @deprecated Use sendSMSCoupon instead */
  sendSMSIncidenceCoupon: Scalars['Boolean']['output']
  /** send tickets */
  sendTickets: Scalars['Boolean']['output']
  /** set campaign template */
  setCampaignTemplate: Scalars['Boolean']['output']
  /** ship an order */
  shipOrder: Scalars['Boolean']['output']
  /** start booking trip change */
  startBookingTripChange: StartBookingTripChangeResponse
  /** start booking trip change */
  startMoveBookingTripChange: StartMoveBookingTripChangeResponse
  submitB2BContactForm: Scalars['Boolean']['output']
  unassignBusinessCustomerKreditCategory: Scalars['Boolean']['output']
  unassignBusinessCustomersKreditCategory: Scalars['Boolean']['output']
  /** update campaign */
  updateCampaign: Scalars['Boolean']['output']
  /** update campaign snack coupon */
  updateCampaignSnacksCoupon: Scalars['Boolean']['output']
  /** update a city */
  updateCity: Scalars['Boolean']['output']
  /** update a company */
  updateCompany: Scalars['Boolean']['output']
  /** update a company line */
  updateCompanyLine: Scalars['Boolean']['output']
  /** update coupon */
  updateCoupon: Scalars['Boolean']['output']
  /**
   * update a place
   * @deprecated Use changePlaceV2 instead
   */
  updatePlace: Scalars['Boolean']['output']
  /** update policy company role */
  updatePolicyCompanyRole: Scalars['Boolean']['output']
  /** update policy private role */
  updatePolicyPrivateRole: Scalars['Boolean']['output']
  /** update season event */
  updateSeasonEvent: Scalars['Boolean']['output']
  /** update a segment */
  updateSegment: Scalars['Boolean']['output']
  /** update service */
  updateService: Scalars['Boolean']['output']
  /**
   * update a user
   * @deprecated Use updateUserV2 instead
   */
  updateUser: Scalars['Boolean']['output']
  updateUserV2: Scalars['Boolean']['output']
  /**
   * update a vehicle
   * @deprecated Not used anymore
   */
  updateVehicle: Scalars['Boolean']['output']
  /** update a vehicle template */
  updateVehicleTemplate: Scalars['Boolean']['output']
  uploadOperationalCostSettings: Scalars['Boolean']['output']
  upsertPartnerCosts: Scalars['Boolean']['output']
  validateBusinessCustomersCSV: Scalars['Boolean']['output']
  validateCouponsCSV: Scalars['Boolean']['output']
  verifyMfaCode: VerifyMfaCodeResponse
  /** verify trips inventory rule */
  verifyTripsInventoryRule: Scalars['Boolean']['output']
}

export type MutationActivateBookingClassArgs = {
  input: ActivateBookingClassInput
}

export type MutationActivateBusinessClientArgs = {
  id: Scalars['UUID']['input']
}

export type MutationActivateBusinessClientUserArgs = {
  input: ActivateBusinessClientUserInput
}

export type MutationActivateBusinessSiteArgs = {
  id: Scalars['UUID']['input']
}

export type MutationActivateCampaignArgs = {
  input: ActivateCampaignInput
}

export type MutationActivateCampaignCouponArgs = {
  input: ActivateCampaignCouponInput
}

export type MutationActivateItemArgs = {
  input: ActivateItemInput
}

export type MutationActivatePartnerArgs = {
  id: Scalars['UUID']['input']
}

export type MutationActivateSeasonEventArgs = {
  input: ActivateSeasonEventInput
}

export type MutationActivateServiceArgs = {
  input: ActivateServiceInput
}

export type MutationActivateSiteArgs = {
  input: ActivateSiteInput
}

export type MutationActivateTripSaleArgs = {
  input: ActivateTripSaleInput
}

export type MutationActivateUserArgs = {
  input: ActivateUserInput
}

export type MutationActivateVehicleArgs = {
  id: Scalars['UUID']['input']
}

export type MutationAddBookingTicketsInsuranceArgs = {
  input: AddBookingTicketsInsuranceInput
}

export type MutationAddCampaignCouponSupportInteractionArgs = {
  input: AddCampaignCouponSupportInteractionInput
}

export type MutationAddCampaignSnacksCouponArgs = {
  input: AddCampaignSnacksCouponInput
}

export type MutationAddCouponArgs = {
  input: AddCouponInput
}

export type MutationAddFareFamilyFaresArgs = {
  input: AddFareFamilyFaresInput
}

export type MutationAddLoyaltyCampaignRuleConditionsCitySegmentsArgs = {
  input: AddLoyaltyCampaignRuleConditionsCitySegmentsInput
}

export type MutationAddLoyaltyCampaignRuleConditionsRouteServicesArgs = {
  input: AddLoyaltyCampaignRuleConditionsRouteServicesInput
}

export type MutationAddLoyaltyCampaignRuleConditionsSalesChannelsArgs = {
  input: AddLoyaltyCampaignRuleConditionsSalesChannelsInput
}

export type MutationAddPartnerDocumentsArgs = {
  id: Scalars['UUID']['input']
  input: AddPartnerDocumentsInput
}

export type MutationAddPartnersPaymentSummaryFilesArgs = {
  input: AddPartnersPaymentSummaryFilesInput
}

export type MutationAddRouteServicePeaksArgs = {
  input: AddRouteServicePeaksInput
}

export type MutationAddRoutingProjectPlanDatasetLocationsArgs = {
  input: AddRoutingProjectPlanDatasetLocationsInput
}

export type MutationAddSegmentCompanyLineSpecArgs = {
  input: AddSegmentCompanyLineSpecInput
}

export type MutationAddServiceFeeAddonRuleArgs = {
  input: AddServiceFeeAddonRuleInput
}

export type MutationAddTripDriverRsvpNoteArgs = {
  input: AddTripDriverRsvpNoteInput
}

export type MutationAddTripNoteArgs = {
  input: AddTripNoteInput
}

export type MutationApplyBookingCouponArgs = {
  input: ApplyBookingCouponInput
}

export type MutationArchiveInventoryArgs = {
  input: ArchiveInventoryInput
}

export type MutationArchiveRouteServiceItineraryScheduleArgs = {
  input: ArchiveRouteServiceItineraryScheduleInput
}

export type MutationArchiveVehicleTemplateArgs = {
  input: ArchiveVehicleTemplateInput
}

export type MutationAssignBusinessClientSimsArgs = {
  input: AssignBusinessClientSimsInput
}

export type MutationAssignBusinessCustomerKreditCategoryArgs = {
  input: AssignBusinessCustomerKreditCategoryInput
}

export type MutationAssignBusinessCustomersKreditCategoryArgs = {
  input: AssignBusinessCustomersKreditCategoryInput
}

export type MutationCancelBookingTicketsArgs = {
  input: CancelBookingTicketsInput
}

export type MutationCancelBookingTicketsInsuranceArgs = {
  input: CancelBookingTicketsInsuranceInput
}

export type MutationCancelBookingTripChangeArgs = {
  input: CancelBookingTripChangeInput
}

export type MutationCancelBookingTripChangeProposalArgs = {
  input: CancelBookingTripChangeProposalInput
}

export type MutationCancelBusinessClientKreditDepositArgs = {
  input: CancelBusinessClientKreditDepositInput
}

export type MutationCancelChangeArgs = {
  input: CancelChangeInput
}

export type MutationCancelOrderArgs = {
  input: CancelOrderInput
}

export type MutationCancelSaleItemsArgs = {
  input: CancelSaleItemsInput
}

export type MutationCancelTicketsArgs = {
  input: CancelTicketsInput
}

export type MutationCancelTripArgs = {
  input: CancelTripInput
}

export type MutationCancelTripsArgs = {
  input: CancelTripsInput
}

export type MutationChangeAncillaryArgs = {
  input: ChangeAncillaryInput
}

export type MutationChangeBookingPassengersNamesArgs = {
  input: ChangeBookingPassengersNamesInput
}

export type MutationChangeBookingPaymentArgs = {
  input: ChangeBookingPaymentInput
}

export type MutationChangeBookingTicketsAncillariesArgs = {
  input: ChangeBookingTicketsAncillariesInput
}

export type MutationChangeBookingTripChangeTicketSeatArgs = {
  input: ChangeBookingTripChangeTicketSeatInput
}

export type MutationChangeBusinessClientArgs = {
  id: Scalars['UUID']['input']
  input: ChangeBusinessClientInput
}

export type MutationChangeBusinessClientContactsArgs = {
  id: Scalars['UUID']['input']
  input: ChangeBusinessClientContactsInput
}

export type MutationChangeBusinessClientCustomerKreditsAmountArgs = {
  input: ChangeBusinessClientCustomerKreditsAmountInput
}

export type MutationChangeBusinessClientCustomersKreditsAmountArgs = {
  input: ChangeBusinessClientCustomersKreditsAmountInput
}

export type MutationChangeBusinessClientKreditSettingsArgs = {
  input: ChangeBusinessClientKreditSettingsInput
}

export type MutationChangeBusinessClientSiteKreditSettingsArgs = {
  input: ChangeBusinessClientSiteKreditSettingsInput
}

export type MutationChangeBusinessClientUserArgs = {
  input: ChangeBusinessClientUserInput
}

export type MutationChangeBusinessClientUserBusinessClientArgs = {
  input: ChangeBusinessClientUserBusinessClientInput
}

export type MutationChangeBusinessCustomerBusinessClientArgs = {
  input: ChangeBusinessCustomerBusinessClientInput
}

export type MutationChangeBusinessCustomerBusinessSiteArgs = {
  input: ChangeBusinessCustomerBusinessSiteInput
}

export type MutationChangeBusinessSiteArgs = {
  id: Scalars['UUID']['input']
  input: ChangeBusinessSiteInput
}

export type MutationChangeBusinessSiteContactsArgs = {
  id: Scalars['UUID']['input']
  input: ChangeBusinessSiteContactsInput
}

export type MutationChangeBuyerArgs = {
  input: ChangeBuyerInput
}

export type MutationChangeCartArgs = {
  input: ChangeCartInput
}

export type MutationChangeComboItemArgs = {
  input: ChangeComboItemInput
}

export type MutationChangeCompanyInsuranceSettingsArgs = {
  input: ChangeCompanyInsuranceSettingsInput
}

export type MutationChangeCurrencyExchangeRateArgs = {
  input: ChangeCurrencyExchangeRateInput
}

export type MutationChangeDriverDocumentsArgs = {
  input: ChangeDriverDocumentsInput
}

export type MutationChangeFareFamilyFaresArgs = {
  input: ChangeFareFamilyFaresInput
}

export type MutationChangeFareRuleArgs = {
  input: ChangeFareRuleInput
}

export type MutationChangeInventoryArgs = {
  input: ChangeInventoryInput
}

export type MutationChangeInventoryRuleArgs = {
  input: ChangeInventoryRuleInput
}

export type MutationChangeInventoryRuleCabinStrategiesArgs = {
  input: ChangeInventoryRuleCabinStrategiesInput
}

export type MutationChangeItemArgs = {
  input: ChangeItemInput
}

export type MutationChangeItemKolorsMobilePlanArgs = {
  input: ChangeItemKolorsMobilePlanInput
}

export type MutationChangeLoyaltyCampaignArgs = {
  input: ChangeLoyaltyCampaignInput
}

export type MutationChangeLoyaltyCampaignRuleArgs = {
  input: ChangeLoyaltyCampaignRuleInput
}

export type MutationChangeOperationalCostSettingsArgs = {
  input: ChangeOperationalCostSettingsInput
}

export type MutationChangeOrderArgs = {
  input: ChangeOrderInput
}

export type MutationChangePartnerBankDetailsArgs = {
  id: Scalars['UUID']['input']
  input: ChangePartnerBankDetailsInput
}

export type MutationChangePartnerContactsArgs = {
  id: Scalars['UUID']['input']
  input: ChangePartnerContactsInput
}

export type MutationChangePartnerDetailsArgs = {
  id: Scalars['UUID']['input']
  input: ChangePartnerDetailsInput
}

export type MutationChangePartnerKamUserArgs = {
  id: Scalars['UUID']['input']
  input: ChangePartnerKamUserInput
}

export type MutationChangePartnerTaxInformationArgs = {
  id: Scalars['UUID']['input']
  input: ChangePartnerTaxInformationInput
}

export type MutationChangePassengerPropertyArgs = {
  input: ChangePassengerPropertyInput
}

export type MutationChangePassengerTypeArgs = {
  input: ChangePassengerTypeInput
}

export type MutationChangePlaceV2Args = {
  id: Scalars['UUID']['input']
  input: ChangePlaceV2Input
}

export type MutationChangeRouteServiceItinerariesScheduleArgs = {
  input: ChangeRouteServiceItinerariesScheduleInput
}

export type MutationChangeRouteServiceVehiclesScheduleArgs = {
  input: ChangeRouteServiceVehiclesScheduleInput
}

export type MutationChangeRoutingProjectArgs = {
  input: ChangeRoutingProjectInput
}

export type MutationChangeRoutingProjectPlanConstraintsArgs = {
  input: ChangeRoutingProjectPlanConstraintsInput
}

export type MutationChangeRoutingProjectPlanDatasetLocationsArgs = {
  input: ChangeRoutingProjectPlanDatasetLocationsInput
}

export type MutationChangeRoutingProjectPlanOptimizationRouteStopsArgs = {
  input: ChangeRoutingProjectPlanOptimizationRouteStopsInput
}

export type MutationChangeServiceFeeAddonRuleArgs = {
  input: ChangeServiceFeeAddonRuleInput
}

export type MutationChangeSiteArgs = {
  input: ChangeSiteInput
}

export type MutationChangeTDriverDetailsArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTDriverDetailsInput
}

export type MutationChangeTRouteArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTRouteInput
}

export type MutationChangeTTripDriverArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTTripDriverInput
}

export type MutationChangeTVehicleCardsArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleCardsInput
}

export type MutationChangeTVehicleDetailsArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleDetailsInput
}

export type MutationChangeTVehicleDocumentsArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleDocumentsInput
}

export type MutationChangeTVehicleDriversArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleDriversInput
}

export type MutationChangeTVehicleFeaturesArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleFeaturesInput
}

export type MutationChangeTVehicleInsurancePolicyArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleInsurancePolicyInput
}

export type MutationChangeTVehicleLicensePlatesArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleLicensePlatesInput
}

export type MutationChangeTVehicleOdometerReadingArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleOdometerReadingInput
}

export type MutationChangeTVehicleRegistrationDetailsArgs = {
  id: Scalars['UUID']['input']
  input: ChangeTVehicleRegistrationDetailsInput
}

export type MutationChangeTicketsPassengerArgs = {
  input: ChangeTicketsPassengerInput
}

export type MutationChangeTripBookingSeatArgs = {
  input: ChangeTripBookingSeatInput
}

export type MutationChangeTripConfirmationModalitiesArgs = {
  input: ChangeTripConfirmationModalitiesInput
}

export type MutationChangeTripItineraryDepartureTimeArgs = {
  input: ChangeTripItineraryDepartureTimeInput
}

export type MutationChangeTripRouteArgs = {
  input: ChangeTripRouteInput
}

export type MutationChangeTripUsersArgs = {
  input: ChangeTripUsersInput
}

export type MutationChangeTripVehicleArgs = {
  input: ChangeTripVehicleInput
}

export type MutationChangeTripsVehicleArgs = {
  input: ChangeTripsVehicleInput
}

export type MutationChangeUserAccountDetailsArgs = {
  input: ChangeUserAccountDetailsInput
}

export type MutationChangeUserPasswordArgs = {
  input: ChangeUserPasswordInput
}

export type MutationConfirmBookingPaymentOnSiteArgs = {
  input: ConfirmBookingPaymentOnSiteInput
}

export type MutationConfirmBookingTripChangeProposalArgs = {
  input: ConfirmBookingTripChangeProposalInput
}

export type MutationConfirmBookingTripChangesArgs = {
  input: ConfirmBookingTripChangesInput
}

export type MutationCreateAncillaryArgs = {
  input: CreateAncillaryInput
}

export type MutationCreateBookingClassArgs = {
  input: CreateBookingClassInput
}

export type MutationCreateBookingTripChangeProposalArgs = {
  input: CreateBookingTripChangeProposalInput
}

export type MutationCreateBusinessClientArgs = {
  input: CreateBusinessClientInput
}

export type MutationCreateBusinessClientContactsArgs = {
  id: Scalars['UUID']['input']
  input: CreateBusinessClientContactsInput
}

export type MutationCreateBusinessClientUserArgs = {
  input: CreateBusinessClientUserInput
}

export type MutationCreateBusinessClientsRouteServicesSchedulePriceArgs = {
  input: CreateBusinessClientsRouteServicesSchedulePriceInput
}

export type MutationCreateBusinessCustomerArgs = {
  input: CreateBusinessCustomerInput
}

export type MutationCreateBusinessCustomersFromCsvArgs = {
  input: CreateBusinessCustomersFromCsvInput
}

export type MutationCreateBusinessSiteArgs = {
  input: CreateBusinessSiteInput
}

export type MutationCreateBusinessSiteContactsArgs = {
  id: Scalars['UUID']['input']
  input: CreateBusinessSiteContactsInput
}

export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput
}

export type MutationCreateCampaignSubcampaignArgs = {
  input: CreateCampaignSubcampaignInput
}

export type MutationCreateCartArgs = {
  input: CreateCartInput
}

export type MutationCreateCityArgs = {
  input: CreateCityInput
}

export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput
}

export type MutationCreateCompanyLineArgs = {
  input: CreateCompanyLineInput
}

export type MutationCreateCompanyV2Args = {
  input: CreateCompanyV2Input
}

export type MutationCreateCountryArgs = {
  input: CreateCountryInput
}

export type MutationCreateCurrencyArgs = {
  input: CreateCurrencyInput
}

export type MutationCreateDriverArgs = {
  input: CreateDriverInput
}

export type MutationCreateFareFamiliesArgs = {
  input: CreateFareFamiliesInput
}

export type MutationCreateFareRuleArgs = {
  input: CreateFareRuleInput
}

export type MutationCreateInventoryArgs = {
  input: CreateInventoryInput
}

export type MutationCreateInventoryRuleArgs = {
  input: CreateInventoryRuleInput
}

export type MutationCreateInventoryRuleCabinStrategiesArgs = {
  input: CreateInventoryRuleCabinStrategiesInput
}

export type MutationCreateLoyaltyCampaignArgs = {
  input: CreateLoyaltyCampaignInput
}

export type MutationCreateLoyaltyCampaignRuleArgs = {
  input: CreateLoyaltyCampaignRuleInput
}

export type MutationCreateLoyaltyRewardArgs = {
  input: CreateLoyaltyRewardInput
}

export type MutationCreateOperationalCostArgs = {
  input: CreateOperationalCostInput
}

export type MutationCreateOrderArgs = {
  input: CreateOrderInput
}

export type MutationCreatePartnerArgs = {
  input: CreatePartnerInput
}

export type MutationCreatePartnerContactsArgs = {
  id: Scalars['UUID']['input']
  input: CreatePartnerContactsInput
}

export type MutationCreatePartnersPaymentSummaryArgs = {
  input: CreatePartnersPaymentSummaryInput
}

export type MutationCreatePassengerPropertyArgs = {
  input: CreatePassengerPropertyInput
}

export type MutationCreatePassengerTypeArgs = {
  input: CreatePassengerTypeInput
}

export type MutationCreatePlaceArgs = {
  input: CreatePlaceInput
}

export type MutationCreatePlaceForBusinessCustomerArgs = {
  input: CreatePlaceForBusinessCustomerInput
}

export type MutationCreatePlaceV2Args = {
  input: CreatePlaceV2Input
}

export type MutationCreatePolicyCompanyRoleArgs = {
  input: CreatePolicyCompanyRoleInput
}

export type MutationCreatePolicyPermissionArgs = {
  input: CreatePolicyPermissionInput
}

export type MutationCreatePolicyPrivateRoleArgs = {
  input: CreatePolicyPrivateRoleInput
}

export type MutationCreatePolicyRoleArgs = {
  input: CreatePolicyRoleInput
}

export type MutationCreatePresignedUrlForFileUploadArgs = {
  input: CreatePresignedUrlForFileUploadInput
}

export type MutationCreateRouteArgs = {
  input: CreateRouteInput
}

export type MutationCreateRouteServiceDriverOverrideArgs = {
  input: CreateRouteServiceDriverOverrideInput
}

export type MutationCreateRouteServiceItinerariesScheduleArgs = {
  input: CreateRouteServiceItinerariesScheduleInput
}

export type MutationCreateRouteServiceItineraryOverrideArgs = {
  input: CreateRouteServiceItineraryOverrideInput
}

export type MutationCreateRouteServicePastVehicleOverrideArgs = {
  input: CreateRouteServicePastVehicleOverrideInput
}

export type MutationCreateRouteServiceRouteOverrideArgs = {
  input: CreateRouteServiceRouteOverrideInput
}

export type MutationCreateRouteServiceSingleTripArgs = {
  input: CreateRouteServiceSingleTripInput
}

export type MutationCreateRouteServiceVehicleOverrideArgs = {
  input: CreateRouteServiceVehicleOverrideInput
}

export type MutationCreateRouteServiceVehiclesScheduleArgs = {
  input: CreateRouteServiceVehiclesScheduleInput
}

export type MutationCreateRoutingProjectArgs = {
  input: CreateRoutingProjectInput
}

export type MutationCreateRoutingProjectDatasetArgs = {
  input: CreateRoutingProjectDatasetInput
}

export type MutationCreateRoutingProjectPlanArgs = {
  input: CreateRoutingProjectPlanInput
}

export type MutationCreateRoutingProjectPlanOptimizationArgs = {
  input: CreateRoutingProjectPlanOptimizationInput
}

export type MutationCreateSalesChannelArgs = {
  input: CreateSalesChannelInput
}

export type MutationCreateSeasonEventArgs = {
  input: CreateSeasonEventInput
}

export type MutationCreateServiceArgs = {
  input: CreateServiceInput
}

export type MutationCreateSiteArgs = {
  input: CreateSiteInput
}

export type MutationCreateTRouteArgs = {
  input: CreateTRouteInput
}

export type MutationCreateTVehicleArgs = {
  input: CreateTVehicleInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationCreateVehicleTemplateArgs = {
  input: CreateVehicleTemplateInput
}

export type MutationDeactivateBookingClassArgs = {
  input: DeactivateBookingClassInput
}

export type MutationDeactivateBusinessClientArgs = {
  id: Scalars['UUID']['input']
}

export type MutationDeactivateBusinessClientUserArgs = {
  input: DeactivateBusinessClientUserInput
}

export type MutationDeactivateBusinessSiteArgs = {
  id: Scalars['UUID']['input']
}

export type MutationDeactivateCampaignArgs = {
  input: DeactivateCampaignInput
}

export type MutationDeactivateCampaignCouponArgs = {
  input: DeactivateCampaignCouponInput
}

export type MutationDeactivateItemArgs = {
  input: DeactivateItemInput
}

export type MutationDeactivatePartnerArgs = {
  id: Scalars['UUID']['input']
  input: DeactivatePartnerInput
}

export type MutationDeactivateSeasonEventArgs = {
  input: DeactivateSeasonEventInput
}

export type MutationDeactivateServiceArgs = {
  input: DeactivateServiceInput
}

export type MutationDeactivateSiteArgs = {
  input: DeactivateSiteInput
}

export type MutationDeactivateTripSaleArgs = {
  input: DeactivateTripSaleInput
}

export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput
}

export type MutationDeactivateVehicleArgs = {
  id: Scalars['UUID']['input']
  input: DeactivateVehicleInput
}

export type MutationDeleteBusinessClientContactsArgs = {
  id: Scalars['UUID']['input']
  input: DeleteBusinessClientContactsInput
}

export type MutationDeleteBusinessSiteContactsArgs = {
  id: Scalars['UUID']['input']
  input: DeleteBusinessSiteContactsInput
}

export type MutationDeleteInventoryRuleCabinStrategiesArgs = {
  input: DeleteInventoryRuleCabinStrategiesInput
}

export type MutationDeletePartnerContactsArgs = {
  id: Scalars['UUID']['input']
  input: DeletePartnerContactsInput
}

export type MutationDeleteRouteServiceVehiclesScheduleArgs = {
  input: DeleteRouteServiceVehiclesScheduleInput
}

export type MutationDeleteTVehicleDocumentsArgs = {
  id: Scalars['UUID']['input']
  input: DeleteTVehicleDocumentsInput
}

export type MutationDepositKreditCorporateFundsArgs = {
  input: DepositKreditCorporateFundsInput
}

export type MutationDepositKreditsBonusFundsArgs = {
  input: DepositKreditsBonusFundsInput
}

export type MutationDepositKreditsCorporateFundsArgs = {
  input: DepositKreditsCorporateFundsInput
}

export type MutationDisableAncillaryArgs = {
  input: DisableAncillaryInput
}

export type MutationDisableBusinessCustomerArgs = {
  input: DisableBusinessCustomerInput
}

export type MutationDisableDriverArgs = {
  input: DisableDriverInput
}

export type MutationDisableFareRuleArgs = {
  input: DisableFareRuleInput
}

export type MutationDisableInventoryRuleArgs = {
  input: DisableInventoryRuleInput
}

export type MutationDisablePassengerPropertyArgs = {
  input: DisablePassengerPropertyInput
}

export type MutationDisablePassengerTypeArgs = {
  input: DisablePassengerTypeInput
}

export type MutationDisableServiceFeeAddonRuleArgs = {
  input: DisableServiceFeeAddonRuleInput
}

export type MutationEnableAncillaryArgs = {
  input: EnableAncillaryInput
}

export type MutationEnableBusinessCustomerArgs = {
  input: EnableBusinessCustomerInput
}

export type MutationEnableDriverArgs = {
  input: EnableDriverInput
}

export type MutationEnableFareRuleArgs = {
  input: EnableFareRuleInput
}

export type MutationEnableInventoryRuleArgs = {
  input: EnableInventoryRuleInput
}

export type MutationEnablePassengerPropertyArgs = {
  input: EnablePassengerPropertyInput
}

export type MutationEnablePassengerTypeArgs = {
  input: EnablePassengerTypeInput
}

export type MutationEnableServiceFeeAddonRuleArgs = {
  input: EnableServiceFeeAddonRuleInput
}

export type MutationForceChangeUserAccountPasswordArgs = {
  input: ForceChangeUserAccountPasswordInput
}

export type MutationLoginArgs = {
  input: LoginInput
}

export type MutationMarkVehicleOutOfServiceArgs = {
  input: MarkVehicleOutOfServiceInput
}

export type MutationProcessBusinessClientKreditsDispersionArgs = {
  input: ProcessBusinessClientKreditsDispersionInput
}

export type MutationReceiveOrderArgs = {
  input: ReceiveOrderInput
}

export type MutationRefreshSessionArgs = {
  input: RefreshSessionInput
}

export type MutationRegisterBookingSupportInteractionArgs = {
  input: RegisterBookingSupportInteractionInput
}

export type MutationRegisterBookingTaxInvoicedArgs = {
  input: RegisterBookingTaxInvoicedInput
}

export type MutationRegisterInventoryWasteArgs = {
  input: RegisterInventoryWasteInput
}

export type MutationRegisterItemArgs = {
  input: RegisterItemInput
}

export type MutationRegisterItemComboArgs = {
  input: RegisterItemComboInput
}

export type MutationRegisterItemKolorsMobilePlanArgs = {
  input: RegisterItemKolorsMobilePlanInput
}

export type MutationRegisterTripOdometerDistanceArgs = {
  input: RegisterTripOdometerDistanceInput
}

export type MutationRegisterVehicleArgs = {
  input: RegisterVehicleInput
}

export type MutationRejectOrderArgs = {
  input: RejectOrderInput
}

export type MutationRemovePartnerDocumentsArgs = {
  id: Scalars['UUID']['input']
  input: RemovePartnerDocumentsInput
}

export type MutationRemoveRoutingProjectPlanDatasetLocationsArgs = {
  input: RemoveRoutingProjectPlanDatasetLocationsInput
}

export type MutationReplacePlaceForBusinessCustomerArgs = {
  input: ReplacePlaceForBusinessCustomerInput
}

export type MutationRequestBusinessClientKreditDepositArgs = {
  input: RequestBusinessClientKreditDepositInput
}

export type MutationRequestCampaignSubcampaignCouponsDeliveryArgs = {
  input: RequestCampaignSubcampaignCouponsDeliveryInput
}

export type MutationRequestResetUserAccountPasswordArgs = {
  input: RequestResetUserAccountPasswordInput
}

export type MutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput
}

export type MutationReturnCartArgs = {
  input: ReturnCartInput
}

export type MutationScheduleRouteServiceTripsArgs = {
  input: ScheduleRouteServiceTripsInput
}

export type MutationSendEmailCouponArgs = {
  input: SendEmailCouponInput
}

export type MutationSendEmailIncidenceCouponArgs = {
  input: SendEmailIncidenceCouponInput
}

export type MutationSendPartnersPaymentSummaryEmailsArgs = {
  input: SendPartnersPaymentSummaryEmailsInput
}

export type MutationSendSmsCouponArgs = {
  input: SendSmsCouponInput
}

export type MutationSendSmsIncidenceCouponArgs = {
  input: SendSmsIncidenceCouponInput
}

export type MutationSendTicketsArgs = {
  input: SendTicketsInput
}

export type MutationSetCampaignTemplateArgs = {
  input: SetCampaignTemplateInput
}

export type MutationShipOrderArgs = {
  input: ShipOrderInput
}

export type MutationStartBookingTripChangeArgs = {
  input: StartBookingTripChangeInput
}

export type MutationStartMoveBookingTripChangeArgs = {
  input: StartMoveBookingTripChangeInput
}

export type MutationSubmitB2BContactFormArgs = {
  input: SubmitB2BContactFormInput
}

export type MutationUnassignBusinessCustomerKreditCategoryArgs = {
  input: UnassignBusinessCustomerKreditCategoryInput
}

export type MutationUnassignBusinessCustomersKreditCategoryArgs = {
  input: UnassignBusinessCustomersKreditCategoryInput
}

export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput
}

export type MutationUpdateCampaignSnacksCouponArgs = {
  input: UpdateSnacksCouponInput
}

export type MutationUpdateCityArgs = {
  input: UpdateCityInput
}

export type MutationUpdateCompanyArgs = {
  input: UpdateCompanyInput
}

export type MutationUpdateCompanyLineArgs = {
  input: UpdateCompanyLineInput
}

export type MutationUpdateCouponArgs = {
  input: UpdateCouponInput
}

export type MutationUpdatePlaceArgs = {
  input: UpdatePlaceInput
}

export type MutationUpdatePolicyCompanyRoleArgs = {
  input: UpdatePolicyCompanyRoleInput
}

export type MutationUpdatePolicyPrivateRoleArgs = {
  input: UpdatePolicyPrivateRoleInput
}

export type MutationUpdateSeasonEventArgs = {
  input: UpdateSeasonEventInput
}

export type MutationUpdateSegmentArgs = {
  input: UpdateSegmentInput
}

export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
}

export type MutationUpdateUserV2Args = {
  input: UpdateUserInput
}

export type MutationUpdateVehicleArgs = {
  input: UpdateVehicleInput
}

export type MutationUpdateVehicleTemplateArgs = {
  input: UpdateVehicleTemplateInput
}

export type MutationUploadOperationalCostSettingsArgs = {
  input: UploadOperationalCostSettingsInput
}

export type MutationUpsertPartnerCostsArgs = {
  input: UpsertPartnerCostsInput
}

export type MutationValidateBusinessCustomersCsvArgs = {
  input: ValidateBusinessCustomersCsvInput
}

export type MutationValidateCouponsCsvArgs = {
  input: ValidateCouponsCsvInput
}

export type MutationVerifyMfaCodeArgs = {
  input: VerifyMfaCodeInput
}

export type MutationVerifyTripsInventoryRuleArgs = {
  input: VerifyTripsInventoryRuleInput
}

/** note attached file */
export type NoteFile = {
  __typename?: 'NoteFile'
  /** filename */
  fileName: Scalars['String']['output']
  /** path to file */
  path: Scalars['String']['output']
}

export type OperationalCost = {
  __typename?: 'OperationalCost'
  businessClient?: Maybe<OperationalCostBusinessClient>
  businessSite?: Maybe<OperationalCostBusinessSite>
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  settings: OperationalCostSettings
  stateCode: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
  vehicleCapacity: Scalars['Int']['output']
  vehicleType: OperationalCostVehicleType
}

export type OperationalCostBusinessClient = {
  __typename?: 'OperationalCostBusinessClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type OperationalCostBusinessSite = {
  __typename?: 'OperationalCostBusinessSite'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type OperationalCostSettings = {
  __typename?: 'OperationalCostSettings'
  costs: OperationalCostSettingsCosts
  factors: OperationalCostSettingsFactors
}

export type OperationalCostSettingsCosts = {
  __typename?: 'OperationalCostSettingsCosts'
  costPerDriver: Scalars['Int']['output']
  costPerKm: Scalars['Int']['output']
  durationCost: Scalars['Int']['output']
  fixedCost: Scalars['Int']['output']
}

export type OperationalCostSettingsFactors = {
  __typename?: 'OperationalCostSettingsFactors'
  airConditioning: Scalars['Int']['output']
  baseDistance: Scalars['Int']['output']
  duration: Array<OperationalCostSettingsFactorsDuration>
  perKm: Scalars['Int']['output']
  redZone: Scalars['Int']['output']
}

export type OperationalCostSettingsFactorsDuration = {
  __typename?: 'OperationalCostSettingsFactorsDuration'
  end: Scalars['Int']['output']
  start: Scalars['Int']['output']
  value: Scalars['Int']['output']
}

export const OperationalCostVehicleType = {
  Bus: 'BUS',
  Sedan: 'SEDAN',
  Suv: 'SUV',
  Van: 'VAN'
} as const

export type OperationalCostVehicleType = (typeof OperationalCostVehicleType)[keyof typeof OperationalCostVehicleType]
export type OperationalCostsInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  vehicleCapacity?: InputMaybe<Scalars['Int']['input']>
  vehicleType?: InputMaybe<OperationalCostVehicleType>
}

export type OperationalCostsResponse = {
  __typename?: 'OperationalCostsResponse'
  items: Array<OperationalCost>
  total: Scalars['Int']['output']
}

export type Order = {
  __typename?: 'Order'
  cancelledBy?: Maybe<OrderUser>
  changedBy?: Maybe<OrderUser>
  companies: Array<OrderCompany>
  conciliationStatus?: Maybe<OrderConciliationStatus>
  createdAt: Scalars['Time']['output']
  createdBy: OrderUser
  destination: OrderInventory
  id: Scalars['ID']['output']
  lineItems: Array<OrderLineItem>
  origin?: Maybe<OrderInventory>
  purchaseID?: Maybe<Scalars['String']['output']>
  receivedAt?: Maybe<Scalars['Time']['output']>
  receivedBy?: Maybe<OrderUser>
  receiverApp?: Maybe<OrderReceiverApp>
  rejectedAt?: Maybe<Scalars['Time']['output']>
  status: OrderStatus
  supplier?: Maybe<Scalars['String']['output']>
  type: OrderType
}

export type OrderCompany = {
  __typename?: 'OrderCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const OrderConciliationStatus = {
  Completed: 'completed',
  Conflicting: 'conflicting'
} as const

export type OrderConciliationStatus = (typeof OrderConciliationStatus)[keyof typeof OrderConciliationStatus]
export type OrderInventory = {
  __typename?: 'OrderInventory'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: InventoryType
}

export type OrderLineItem = {
  __typename?: 'OrderLineItem'
  container: Scalars['String']['output']
  cost: Scalars['Int']['output']
  itemID: Scalars['ID']['output']
  name: Scalars['String']['output']
  netContent: Scalars['Int']['output']
  ordered: Scalars['Int']['output']
  received?: Maybe<Scalars['Int']['output']>
  units: Scalars['String']['output']
}

export type OrderLineItemInput = {
  cost?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
}

export type OrderQueryInput = {
  id: Scalars['ID']['input']
}

export const OrderReceiverApp = {
  Admin: 'admin',
  Pos: 'pos'
} as const

export type OrderReceiverApp = (typeof OrderReceiverApp)[keyof typeof OrderReceiverApp]
export const OrderStatus = {
  Cancelled: 'cancelled',
  Completed: 'completed',
  Created: 'created',
  Pending: 'pending',
  Received: 'received',
  Rejected: 'rejected'
} as const

export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus]
export const OrderType = {
  Purchase: 'purchase',
  Shipment: 'shipment'
} as const

export type OrderType = (typeof OrderType)[keyof typeof OrderType]
export type OrderUser = {
  __typename?: 'OrderUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type OrdersQueryInput = {
  conciliationStatus?: InputMaybe<OrderConciliationStatus>
  creationDateRange?: InputMaybe<DateRangeInput>
  destinationID?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  inventoryID?: InputMaybe<Scalars['ID']['input']>
  itemID?: InputMaybe<Scalars['ID']['input']>
  originID?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<OrderStatus>
  type?: InputMaybe<OrderType>
}

export type OrdersResponse = {
  __typename?: 'OrdersResponse'
  items: Array<Order>
  total: Scalars['Int']['output']
}

/** Pagination controls for requests that return multiple items. */
export type Pagination = {
  /** desired page, first page is 0 */
  page: Scalars['Int']['input']
  /** amount of results per page */
  size: Scalars['Int']['input']
}

export type PaginationV2 = {
  page: Scalars['Int']['input']
  size: Scalars['Int']['input']
}

export type Partner = {
  __typename?: 'Partner'
  externalID: Scalars['String']['output']
  name: Scalars['String']['output']
}

export const PartnerBankPaymentTypeInput = {
  InterbankTransfer: 'INTERBANK_TRANSFER',
  Spei: 'SPEI',
  TransferWithinBank: 'TRANSFER_WITHIN_BANK'
} as const

export type PartnerBankPaymentTypeInput = (typeof PartnerBankPaymentTypeInput)[keyof typeof PartnerBankPaymentTypeInput]
export const PartnerCostScheduleDow = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const

export type PartnerCostScheduleDow = (typeof PartnerCostScheduleDow)[keyof typeof PartnerCostScheduleDow]
export const PartnerDocumentCategoryInput = {
  AccountStatementCover: 'ACCOUNT_STATEMENT_COVER',
  ComplianceOpinion: 'COMPLIANCE_OPINION',
  ConstitutiveAct: 'CONSTITUTIVE_ACT',
  Curp: 'CURP',
  OfficialId: 'OFFICIAL_ID',
  PowerOfAttorney: 'POWER_OF_ATTORNEY',
  ProofOfAddress: 'PROOF_OF_ADDRESS',
  Repse: 'REPSE',
  Rfc: 'RFC'
} as const

export type PartnerDocumentCategoryInput =
  (typeof PartnerDocumentCategoryInput)[keyof typeof PartnerDocumentCategoryInput]
export type PartnerInput = {
  externalID?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type PartnerSuggestion = {
  __typename?: 'PartnerSuggestion'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type PartnerSuggestionsInput = {
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type PartnerSuggestionsResponse = {
  __typename?: 'PartnerSuggestionsResponse'
  items: Array<PartnerSuggestion>
  total: Scalars['Long']['output']
}

export const PartnerTaxInformationPersonTypeInput = {
  Individual: 'INDIVIDUAL',
  LegalEntity: 'LEGAL_ENTITY'
} as const

export type PartnerTaxInformationPersonTypeInput =
  (typeof PartnerTaxInformationPersonTypeInput)[keyof typeof PartnerTaxInformationPersonTypeInput]
export const PartnerTypeInput = {
  Fleet: 'FLEET',
  Host: 'HOST'
} as const

export type PartnerTypeInput = (typeof PartnerTypeInput)[keyof typeof PartnerTypeInput]
export const PartnerVerticalInput = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type PartnerVerticalInput = (typeof PartnerVerticalInput)[keyof typeof PartnerVerticalInput]
export type PartnersPaymentSummariesInput = {
  /** this is a placeholder field to allow the input to be non-empty */
  id?: InputMaybe<Scalars['UUID']['input']>
}

export type PartnersPaymentSummariesResponse = {
  __typename?: 'PartnersPaymentSummariesResponse'
  items: Array<PartnersPaymentSummary>
  total: Scalars['Int']['output']
}

export type PartnersPaymentSummary = {
  __typename?: 'PartnersPaymentSummary'
  /** emails */
  emails: Array<SummaryEmail>
  /** the summary end date, in dd/mm/yyyy format. this is parsed from the summary name */
  endDate: Scalars['String']['output']
  /** the summary files */
  files: Array<PartnersPaymentSummaryFile>
  /** the summary id */
  id: Scalars['UUID']['output']
  /** name of the summary. e.g. '1QENE2021' */
  name: Scalars['String']['output']
  /** the summary start date, in dd/mm/yyyy format. this is parsed from the summary name */
  startDate: Scalars['String']['output']
  /** the summary status */
  status: PartnersPaymentSummaryStatus
  /** timeline */
  timeline: Array<PartnersPaymentSummaryTimelineEvent>
}

export type PartnersPaymentSummaryFile = {
  __typename?: 'PartnersPaymentSummaryFile'
  /** file category */
  category: PartnersPaymentSummaryFileCategory
  /** errors file path. only available when the file processing resulted in errors */
  errorsFilePath?: Maybe<Scalars['String']['output']>
  /** file id */
  id: Scalars['UUID']['output']
  /** file path */
  path: Scalars['String']['output']
}

export const PartnersPaymentSummaryFileCategory = {
  Breakdown: 'BREAKDOWN',
  Calendar: 'CALENDAR',
  Miscellaneous: 'MISCELLANEOUS',
  Payment: 'PAYMENT',
  Tag: 'TAG',
  Uber: 'UBER'
} as const

export type PartnersPaymentSummaryFileCategory =
  (typeof PartnersPaymentSummaryFileCategory)[keyof typeof PartnersPaymentSummaryFileCategory]
export type PartnersPaymentSummaryInput = {
  /** the summary id */
  id: Scalars['UUID']['input']
}

export const PartnersPaymentSummaryStatus = {
  /** the summary is created but not all files are uploaded */
  Draft: 'DRAFT',
  /** at least one file processing resulted in errors */
  Errors: 'ERRORS',
  /** all files are uploaded and the summary is ready to be sent */
  Ready: 'READY',
  /** the summary is sent */
  Sent: 'SENT'
} as const

export type PartnersPaymentSummaryStatus =
  (typeof PartnersPaymentSummaryStatus)[keyof typeof PartnersPaymentSummaryStatus]
export type PartnersPaymentSummaryTimelineEvent = {
  __typename?: 'PartnersPaymentSummaryTimelineEvent'
  action?: Maybe<PartnersPaymentSummaryTimelineEventAction>
  correlationID: Scalars['UUID']['output']
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  type: Scalars['String']['output']
  user: TimelineEventUser
}

export type PartnersPaymentSummaryTimelineEventAction = PartnersPaymentSummaryTimelineEventActionFilesUploaded

export type PartnersPaymentSummaryTimelineEventActionFilesUploaded = {
  __typename?: 'PartnersPaymentSummaryTimelineEventActionFilesUploaded'
  files: Array<PartnersPaymentSummaryFile>
}

export type PassengerPropertiesAutocompleteInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  salesChannelsIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type PassengerPropertiesAutocompleteOutput = {
  __typename?: 'PassengerPropertiesAutocompleteOutput'
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type PassengerPropertiesInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type PassengerPropertiesOutput = {
  __typename?: 'PassengerPropertiesOutput'
  items: Array<PassengerProperty>
  total: Scalars['Int']['output']
}

export type PassengerProperty = {
  __typename?: 'PassengerProperty'
  abbreviation: Array<PassengerPropertyTranslation>
  countryCode: Scalars['String']['output']
  createdAt: Scalars['Time']['output']
  departureDateRanges: Array<PassengerPropertyDateRange>
  description: Array<PassengerPropertyTranslation>
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  label: Array<PassengerPropertyTranslation>
  name: Scalars['String']['output']
  required: Scalars['Boolean']['output']
  searchDateRanges: Array<PassengerPropertyDateRange>
  settings: Array<PassengerPropertySetting>
  updatedAt: Scalars['Time']['output']
}

export type PassengerPropertyDateRange = {
  __typename?: 'PassengerPropertyDateRange'
  endAt: Scalars['Time']['output']
  startAt: Scalars['Time']['output']
}

export type PassengerPropertyInput = {
  id: Scalars['ID']['input']
}

export type PassengerPropertyPassengerType = {
  __typename?: 'PassengerPropertyPassengerType'
  id: Scalars['ID']['output']
  label: Array<PassengerPropertyTranslation>
  name: Scalars['String']['output']
}

export type PassengerPropertySetting = {
  __typename?: 'PassengerPropertySetting'
  discount: Scalars['Int']['output']
  passengerTypes: Array<Maybe<PassengerPropertyPassengerType>>
  /** @deprecated use salesChannelsV2 instead */
  salesChannels: Array<SalesChannel>
  salesChannelsV2: Array<PassengerPropertySettingSalesChannel>
}

export type PassengerPropertySettingSalesChannel = {
  __typename?: 'PassengerPropertySettingSalesChannel'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type PassengerPropertyTranslation = {
  __typename?: 'PassengerPropertyTranslation'
  language: Language
  text: Scalars['String']['output']
}

/** passenger types */
export const PassengerType = {
  Adult: 'adult',
  Child: 'child',
  Senior: 'senior',
  Student: 'student',
  Teacher: 'teacher'
} as const

export type PassengerType = (typeof PassengerType)[keyof typeof PassengerType]
export type PassengerTypeInput = {
  id: Scalars['ID']['input']
}

export type PassengerTypeSalesChannel = {
  __typename?: 'PassengerTypeSalesChannel'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const PassengerTypeSalesChannelAdmin = {
  KolorsMx: 'KOLORS_MX',
  KolorsUs: 'KOLORS_US',
  Pos: 'POS',
  All: 'all',
  Offline: 'offline',
  Online: 'online'
} as const

export type PassengerTypeSalesChannelAdmin =
  (typeof PassengerTypeSalesChannelAdmin)[keyof typeof PassengerTypeSalesChannelAdmin]
export type PassengerTypeV2 = {
  __typename?: 'PassengerTypeV2'
  abbreviation: Array<PassengerTypeV2Translation>
  countryCode: Scalars['String']['output']
  createdAt: Scalars['Time']['output']
  description: Array<PassengerTypeV2Translation>
  discount: Scalars['Int']['output']
  enabled: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  label: Array<PassengerTypeV2Translation>
  name: Scalars['String']['output']
  /** @deprecated use salesChannelsV2 */
  salesChannels: Array<PassengerTypeSalesChannelAdmin>
  salesChannelsV2: Array<PassengerTypeSalesChannel>
  updatedAt: Scalars['Time']['output']
}

export type PassengerTypeV2Translation = {
  __typename?: 'PassengerTypeV2Translation'
  language: Language
  plural: Scalars['Boolean']['output']
  text: Scalars['String']['output']
}

export type PassengerTypesAutocompleteInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
  salesChannelsIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type PassengerTypesAutocompleteOutput = {
  __typename?: 'PassengerTypesAutocompleteOutput'
  countryCode: Scalars['String']['output']
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type PassengerTypesInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>
  enabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type PassengerTypesOutput = {
  __typename?: 'PassengerTypesOutput'
  items: Array<PassengerTypeV2>
  total: Scalars['Int']['output']
}

export const PaymentIncidencePaymentMethodInput = {
  Card: 'CARD',
  Cash: 'CASH'
} as const

export type PaymentIncidencePaymentMethodInput =
  (typeof PaymentIncidencePaymentMethodInput)[keyof typeof PaymentIncidencePaymentMethodInput]
/** payment methods */
export const PaymentMethod = {
  Card: 'card',
  Cash: 'cash'
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]
/** payment processors */
export const PaymentProcessor = {
  Clip: 'clip',
  Conekta: 'conekta'
} as const

export type PaymentProcessor = (typeof PaymentProcessor)[keyof typeof PaymentProcessor]
export type PaymentRefundInput = {
  /** amount to refund in cents */
  amount: Scalars['Int']['input']
  /** payment id */
  paymentID: Scalars['ID']['input']
}

export type PaymentRefundInputV2 = {
  /** amount to refund in cents */
  amount: Scalars['Int']['input']
  /** payment ID */
  paymentID: Scalars['UUID']['input']
}

/** payment status */
export const PaymentStatus = {
  Paid: 'paid',
  Pending: 'pending'
} as const

export type PaymentStatus = (typeof PaymentStatus)[keyof typeof PaymentStatus]
/** payment ticket */
export type PaymentTicket = {
  __typename?: 'PaymentTicket'
  /** discount */
  discount: Scalars['Int']['output']
  /** id */
  id: Scalars['String']['output']
  /** subtotal in cents */
  subtotal: Scalars['Int']['output']
  /** vat in cents */
  vat: Scalars['Int']['output']
}

export type PaymentUser = {
  __typename?: 'PaymentUser'
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

/** permission */
export type Permission = {
  __typename?: 'Permission'
  /** actions */
  actions: Array<Scalars['String']['output']>
  /** permission id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

export type PermissionInput = {
  action?: Scalars['String']['input']
  aggregateName: Scalars['String']['input']
  strict?: Scalars['Boolean']['input']
}

/**
 * phone number is divided into countryCode and number, excluding the plus sign.
 * e.g. +52 55 1234 5678 => countryCode: "52", number: "5512345678"
 */
export type PhoneNumber = {
  __typename?: 'PhoneNumber'
  countryCode: Scalars['String']['output']
  number: Scalars['String']['output']
}

/**
 * phone number is divided into countryCode and number, excluding the plus sign.
 * e.g. +52 55 1234 5678 => countryCode: "52", number: "5512345678"
 */
export type PhoneNumberInput = {
  countryCode: Scalars['String']['input']
  number: Scalars['String']['input']
}

/** place */
export type Place = {
  __typename?: 'Place'
  /** address */
  address?: Maybe<Address>
  /** amenities */
  amenities: Array<PlaceAmenity>
  /** area */
  area?: Maybe<Scalars['String']['output']>
  /** city name, only present if place is not a city */
  cityName?: Maybe<Scalars['String']['output']>
  /** code */
  code: Scalars['String']['output']
  /** countryCode */
  countryCode?: Maybe<Scalars['String']['output']>
  /** directions */
  directions?: Maybe<Scalars['String']['output']>
  /** place id */
  id: Scalars['ID']['output']
  /** geolocation */
  location: Location
  /** name */
  name: Scalars['String']['output']
  /** unique human readable identifier for the place */
  param: Scalars['String']['output']
  /** parent, only present if place is not a city */
  parent?: Maybe<Place>
  /** child places. only present if place is a city. */
  places: Array<Place>
  /** state code in ISO_3166-2:MX format. */
  stateCode?: Maybe<Scalars['String']['output']>
  /** tags */
  tags: Array<Scalars['String']['output']>
  /** timezone */
  timezone: Scalars['String']['output']
  /** place type */
  type: PlaceType
}

export type PlaceAddressV2 = {
  __typename?: 'PlaceAddressV2'
  city: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  line1: Scalars['String']['output']
  line2?: Maybe<Scalars['String']['output']>
  stateCode: Scalars['String']['output']
  zipCode: Scalars['String']['output']
}

export const PlaceAmenity = {
  KolorsMobile: 'KOLORS_MOBILE',
  KolorsTicket: 'KOLORS_TICKET'
} as const

export type PlaceAmenity = (typeof PlaceAmenity)[keyof typeof PlaceAmenity]
export type PlaceByParamV2Input = {
  param: Scalars['String']['input']
  salesChannelID: Scalars['UUID']['input']
  vertical?: PlaceVertical
}

export type PlaceGeoLocationInput = {
  latitude: Scalars['String']['input']
  longitude: Scalars['String']['input']
}

export type PlaceLocationV2 = {
  __typename?: 'PlaceLocationV2'
  latitude: Scalars['String']['output']
  longitude: Scalars['String']['output']
}

export type PlaceSuggestion = {
  __typename?: 'PlaceSuggestion'
  id: Scalars['UUID']['output']
  location?: Maybe<PlaceSuggestionLocation>
  name: Scalars['String']['output']
  stateCode?: Maybe<Scalars['String']['output']>
}

export type PlaceSuggestionLocation = {
  __typename?: 'PlaceSuggestionLocation'
  latitude: Scalars['String']['output']
  longitude: Scalars['String']['output']
}

export type PlaceSuggestionV2 = {
  __typename?: 'PlaceSuggestionV2'
  address?: Maybe<PlaceAddressV2>
  cityName: Scalars['String']['output']
  code: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  id: Scalars['UUID']['output']
  location?: Maybe<PlaceLocationV2>
  name: Scalars['String']['output']
  param: Scalars['String']['output']
  places: Array<PlaceSuggestionV2>
  searchScore: Scalars['Float']['output']
  stateCode: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type PlaceSuggestionsInput = {
  limit: Scalars['Int']['input']
  originId?: InputMaybe<Scalars['UUID']['input']>
  pattern: Scalars['String']['input']
  salesChannelID: Scalars['UUID']['input']
  vertical?: PlaceVertical
}

export type PlaceSuggestionsResponse = {
  __typename?: 'PlaceSuggestionsResponse'
  places: Array<PlaceSuggestionV2>
}

/** place types */
export const PlaceType = {
  Attraction: 'attraction',
  City: 'city',
  ConvenienceStore: 'convenience_store',
  Hotel: 'hotel',
  Mall: 'mall',
  Office: 'office',
  ParkingLot: 'parking_lot',
  PointOfInterest: 'point_of_interest',
  ResidentialArea: 'residential_area',
  Restaurant: 'restaurant',
  School: 'school',
  Sidewalk: 'sidewalk',
  Station: 'station',
  Supermarket: 'supermarket',
  Venue: 'venue'
} as const

export type PlaceType = (typeof PlaceType)[keyof typeof PlaceType]
export type PlaceV2 = {
  __typename?: 'PlaceV2'
  address?: Maybe<PlaceAddressV2>
  cityName?: Maybe<Scalars['String']['output']>
  code: Scalars['String']['output']
  countryCode?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  location?: Maybe<PlaceLocationV2>
  name: Scalars['String']['output']
  param: Scalars['String']['output']
  parent?: Maybe<PlaceV2>
  places: Array<PlaceV2>
  stateCode?: Maybe<Scalars['String']['output']>
  tags: Array<Scalars['String']['output']>
  timezone: Scalars['String']['output']
  type: Scalars['String']['output']
}

export const PlaceV2AmenityInput = {
  KolorsMobile: 'KOLORS_MOBILE',
  KolorsTicket: 'KOLORS_TICKET'
} as const

export type PlaceV2AmenityInput = (typeof PlaceV2AmenityInput)[keyof typeof PlaceV2AmenityInput]
export type PlaceV2Input = {
  id: Scalars['UUID']['input']
  salesChannelID: Scalars['UUID']['input']
  vertical?: PlaceVertical
}

export const PlaceV2TypeInput = {
  Attraction: 'ATTRACTION',
  ConvenienceStore: 'CONVENIENCE_STORE',
  Hotel: 'HOTEL',
  Mall: 'MALL',
  Office: 'OFFICE',
  ParkingLot: 'PARKING_LOT',
  PointOfInterest: 'POINT_OF_INTEREST',
  ResidentialArea: 'RESIDENTIAL_AREA',
  Restaurant: 'RESTAURANT',
  School: 'SCHOOL',
  Sidewalk: 'SIDEWALK',
  Station: 'STATION',
  Supermarket: 'SUPERMARKET',
  Venue: 'VENUE'
} as const

export type PlaceV2TypeInput = (typeof PlaceV2TypeInput)[keyof typeof PlaceV2TypeInput]
export const PlaceVertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type PlaceVertical = (typeof PlaceVertical)[keyof typeof PlaceVertical]
export type PlacesByGeoLocation = {
  __typename?: 'PlacesByGeoLocation'
  destination: PlacesByGeoLocationPlace
  origin: PlacesByGeoLocationPlace
}

export type PlacesByGeoLocationInput = {
  destination: PlaceGeoLocationInput
  distance?: Scalars['Int']['input']
  origin: PlaceGeoLocationInput
  salesChannelID: Scalars['UUID']['input']
  vertical?: PlaceVertical
}

export type PlacesByGeoLocationPlace = {
  __typename?: 'PlacesByGeoLocationPlace'
  id: Scalars['UUID']['output']
  location: PlaceLocationV2
  name: Scalars['String']['output']
  param: Scalars['String']['output']
}

export type PlacesByGeoLocationResponse = {
  __typename?: 'PlacesByGeoLocationResponse'
  places: Array<PlacesByGeoLocation>
}

/** policy types */
export const PolicyType = {
  CompanyRole: 'companyRole',
  Permission: 'permission',
  PrivateRole: 'privateRole',
  Role: 'role'
} as const

export type PolicyType = (typeof PolicyType)[keyof typeof PolicyType]
export type ProcessBusinessClientKreditsDispersionInput = {
  id: Scalars['UUID']['input']
}

/** Application-level queries. */
export type Query = {
  __typename?: 'Query'
  ancillaries: AncillariesResponse
  ancillary: Ancillary
  bookingClasses: Array<BookingClass>
  /** get bookings */
  bookings: BookingsResponse
  bookingsDashboard: BookingsDashboardResponse
  bookingsV2: BookingsV2Response
  businessClient: BusinessClient
  businessClientSuggestions: BusinessClientSuggestionsResponse
  businessClientUser: BusinessClientUser
  businessClientUsers: BusinessClientUsersResponse
  businessClients: BusinessClientsResponse
  businessClientsAutocomplete: BusinessClientsAutocompleteResponse
  businessCustomer: BusinessCustomer
  businessCustomerSuggestions: BusinessCustomerSuggestionsResponse
  businessCustomers: BusinessCustomersResponse
  businessPartner: BusinessPartner
  businessPartners: BusinessPartnersResponse
  businessPartnersAutocomplete: BusinessPartnersAutocompleteResponse
  businessSite: BusinessSite
  businessSiteSuggestions: BusinessSiteSuggestionsResponse
  businessSites: BusinessSitesResponse
  businessSitesAutocomplete: BusinessSitesAutocompleteResponse
  campaign?: Maybe<Campaign>
  campaigns: Array<Campaign>
  campaignsAutocomplete: Array<CampaignAutocomplete>
  cart?: Maybe<Cart>
  cartActivity: CartActivityResponse
  carts: CartsResponse
  /** get cashiers */
  cashiers: Array<User>
  changes: ChangesResponse
  /**
   * get cities. default limit is 10.
   * @deprecated Use tcities instead
   */
  cities: Array<Place>
  /**
   * get city
   * @deprecated Use tcity instead
   */
  city?: Maybe<Place>
  citySuggestions: CitySuggestionsResponse
  comboItem?: Maybe<ComboItem>
  comboItems: ComboItemsResponse
  comboItemsAutocomplete: Array<ComboItemAutocomplete>
  /**
   * get companies. default limit is 10.
   * @deprecated Use companiesV2 instead
   */
  companies: Array<Company>
  /** @deprecated Use companiesV2Autocomplete instead */
  companiesAutocomplete: Array<CompanyAutocomplete>
  companiesV2: CompaniesV2Response
  companiesV2Autocomplete: CompaniesV2AutocompleteResponse
  /**
   * get company
   * @deprecated Use companyV2 instead
   */
  company?: Maybe<Company>
  companyInsuranceSettings: CompanyInsuranceSettings
  /** get company line */
  companyLine?: Maybe<CompanyLine>
  /** get company lines. default limit is 10. */
  companyLines: Array<CompanyLine>
  companyLinesAutocomplete: Array<CompanyLineAutocomplete>
  /** get company roles */
  companyRoles: CompanyRolesResponse
  companySuggestions: CompanySuggestionsResponse
  companyV2: CompanyV2
  countries: CountriesOutput
  country: Country
  coupon?: Maybe<Coupon>
  couponsWithPagination: CouponsResponse
  currencies: CurrenciesOutput
  currency: Currency
  databaseSubcampaign?: Maybe<DatabaseSubcampaign>
  databaseSubcampaignCoupons?: Maybe<DatabaseSubcampaignCouponsResponse>
  databaseSubcampaigns: DatabaseSubcampaignsResponse
  drawers: DrawersResponse
  driverSuggestions: DriverSuggestionsResponse
  /** get drivers */
  drivers: Array<User>
  /** @deprecated Use fareFamiliesWithPagination instead */
  fareFamilies: Array<FareFamily>
  fareFamiliesWithPagination: FareFamiliesResponse
  fareRule?: Maybe<FareRule>
  fareRules: FareRulesResponse
  incidenceSubcampaign?: Maybe<IncidenceSubcampaign>
  incidenceSubcampaigns: IncidenceSubcampaignsResponse
  inventories: InventoriesResponse
  inventoriesAutocomplete: Array<InventoryAutocomplete>
  inventory?: Maybe<Inventory>
  inventoryItems: InventoryItemsResponse
  inventoryRule?: Maybe<InventoryRule>
  inventoryRules: InventoryRulesResponse
  inventoryWastes: InventoryWastesResponse
  item?: Maybe<Item>
  items: ItemsResponse
  itemsAutocomplete: Array<ItemAutocomplete>
  kolorsMobilePlanItem?: Maybe<KolorsMobilePlanItem>
  kolorsMobilePlanItems: KolorsMobilePlanItemsResponse
  /** Fetch a specific Kolors Credits container using its ID. */
  kredit: Kredit
  kreditTransactions: KreditTransactionsResponse
  /** Fetch a list of Kolors Credits containers, possibly filtered by User characteristics. */
  kredits: KreditsResponse
  locationCities: LocationCitiesResponse
  locationCity: LocationCity
  loyaltyCampaign: LoyaltyCampaign
  loyaltyCampaignRule: LoyaltyCampaignRule
  loyaltyCampaigns: LoyaltyCampaignsResponse
  loyaltyRewards: LoyaltyRewardsResponse
  loyaltyRewardsAutocomplete: Array<LoyaltyRewardAutocomplete>
  noop?: Maybe<Scalars['Boolean']['output']>
  ok: Scalars['Boolean']['output']
  operationalCost: OperationalCost
  operationalCosts: OperationalCostsResponse
  order?: Maybe<Order>
  orders: OrdersResponse
  partnerSuggestions: PartnerSuggestionsResponse
  /** @deprecated Use businessPartnersAutocomplete instead */
  partnersAutocomplete: Array<Partner>
  partnersPaymentSummaries: PartnersPaymentSummariesResponse
  partnersPaymentSummary: PartnersPaymentSummary
  passengerProperties: PassengerPropertiesOutput
  passengerPropertiesAutocomplete: Array<PassengerPropertiesAutocompleteOutput>
  passengerProperty: PassengerProperty
  passengerType: PassengerTypeV2
  passengerTypes: PassengerTypesOutput
  passengerTypesAutocomplete: Array<PassengerTypesAutocompleteOutput>
  /** get permissions */
  permissions: Array<Permission>
  /**
   * get place
   * @deprecated Use tplace instead
   */
  place?: Maybe<Place>
  placeByParamV2: PlaceV2
  placeSuggestions: PlaceSuggestionsResponse
  placeV2: PlaceV2
  /**
   * get places. default limit is 10.
   * @deprecated Use tplaces instead
   */
  places: Array<Place>
  placesByGeoLocation: PlacesByGeoLocationResponse
  /** get role */
  role?: Maybe<Role>
  /** get roles */
  roles: RolesResponse
  /**
   * get route
   * @deprecated Use troute instead
   */
  route?: Maybe<Route>
  routeServiceSuggestions: RouteServiceSuggestionsResponse
  routeSuggestions: RouteSuggestionsResponse
  routeVehicles: Array<Vehicle>
  /**
   * get routes. default limit is 10.
   * @deprecated Use troutes instead
   */
  routes: Array<Route>
  /** @deprecated Use troutes instead */
  routesWithPagination: RoutesResponse
  routingProject: RoutingProjectResponse
  routingProjectPlan: RoutingProjectPlanResponse
  routingProjects: RoutingProjectsResponse
  routingProjectsTags: RoutingProjectsTagsResponse
  sales: SalesResponse
  salesChannel: SalesChannelV2
  salesChannels: SalesChannelsOutput
  seasonEvent?: Maybe<SeasonEvent>
  seasonEvents: Array<SeasonEvent>
  seatsTemplate: SeatsTemplateResponse
  /** get segment */
  segment?: Maybe<Segment>
  segmentSuggestions: SegmentSuggestionsResponse
  /** get segments. default limit is 10. */
  segments: Array<Segment>
  /** get segments between cities */
  segmentsBetweenCities: Array<Segment>
  segmentsWithPagination: SegmentsResponse
  service?: Maybe<Service>
  serviceFeeAddonRule: ServiceFeeAddonRule
  serviceFeeAddonRules: ServiceFeeAddonRulesOutput
  /**
   * get route services. default limit is 10.
   * @deprecated use servicesWithPagination
   */
  services: Array<Service>
  servicesWithPagination: ServicesResponse
  /** get site */
  site?: Maybe<Site>
  /** get sites */
  sites?: Maybe<SitesResponse>
  sitesAutocomplete: Array<SiteAutocomplete>
  sitesDashboard: SitesDashboard
  subcampaign?: Maybe<Subcampaign>
  suppliersAutocomplete: Array<SupplierAutocomplete>
  tcities: TCitiesResponse
  tcitiesAutocomplete: TCitiesAutocompleteResponse
  tcity: TCity
  tdriver: TDriver
  tdrivers: TDriversResponse
  tdriversAutocomplete: TDriversAutocompleteResponse
  ticketsInsurance: TicketInsuranceResponse
  tplace: TPlace
  tplaceSuggestions: TPlaceSuggestionsResponse
  tplaces: TPlacesResponse
  tplacesAutocomplete: TPlacesAutocompleteResponse
  /** get trip */
  trip?: Maybe<Trip>
  tripBookings: TripBookings
  tripSegments: Array<TripSegment>
  tripTracking: TripTrackingResponse
  tripV2: TripV2
  /** get trips */
  trips: TripsResponse
  tripsDriverConflict: TripsDriverConflictResponse
  tripsV2: TripsV2Response
  tripsVehicleConflict: TripsVehicleConflictResponse
  troute: TRoute
  troutes: TRoutesResponse
  troutesAutocomplete: TRoutesAutocompleteResponse
  tvehicle: TVehicle
  tvehicles: TVehiclesResponse
  tvehiclesAutocomplete: TVehiclesAutocompleteResponse
  /** get user */
  user?: Maybe<User>
  userSuggestions: UserSuggestionsResponse
  /** get users */
  users: UsersResponse
  usersAutocomplete: Array<UserAutocomplete>
  /**
   * get vehicle
   * @deprecated Use tvehicle instead
   */
  vehicle?: Maybe<Vehicle>
  vehicleSuggestions: VehicleSuggestionsResponse
  /** get vehicle template */
  vehicleTemplate?: Maybe<VehicleTemplate>
  vehicleTemplateSuggestions: VehicleTemplateSuggestionsResponse
  /** get vehicle templates */
  vehicleTemplates: Array<VehicleTemplate>
  /** @deprecated Use tvehiclesAutocomplete instead */
  vehicleTemplatesAutocomplete: Array<VehicleTemplateAutocomplete>
  /**
   * get vehicles
   * @deprecated Use tvehicles instead
   */
  vehicles: Array<Vehicle>
  /** Fetch a specific Wallet using its ID. */
  wallet: Wallet
  /** Fetch a list of Wallets, possibly filtered by User characteristics. */
  wallets: WalletsResponse
}

/** Application-level queries. */
export type QueryAncillariesArgs = {
  input?: InputMaybe<AncillariesInput>
  pagination: Pagination
}

/** Application-level queries. */
export type QueryAncillaryArgs = {
  input?: InputMaybe<AncillaryInput>
}

/** Application-level queries. */
export type QueryBookingClassesArgs = {
  input?: InputMaybe<BookingClassesInput>
}

/** Application-level queries. */
export type QueryBookingsArgs = {
  input?: InputMaybe<BookingsQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryBookingsDashboardArgs = {
  input?: InputMaybe<BookingsDashboardInput>
}

/** Application-level queries. */
export type QueryBookingsV2Args = {
  input: BookingsV2Input
  pagination?: PaginationV2
  sorting?: SortingV2
}

/** Application-level queries. */
export type QueryBusinessClientArgs = {
  id: Scalars['UUID']['input']
}

/** Application-level queries. */
export type QueryBusinessClientSuggestionsArgs = {
  input: BusinessClientSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessClientUserArgs = {
  id: Scalars['UUID']['input']
}

/** Application-level queries. */
export type QueryBusinessClientUsersArgs = {
  input?: InputMaybe<BusinessClientUsersInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessClientsArgs = {
  input?: InputMaybe<BusinessClientsInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessClientsAutocompleteArgs = {
  input?: InputMaybe<BusinessClientsAutocompleteInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessCustomerArgs = {
  input: BusinessCustomerInput
}

/** Application-level queries. */
export type QueryBusinessCustomerSuggestionsArgs = {
  input: BusinessCustomerSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessCustomersArgs = {
  input: BusinessCustomersInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryBusinessPartnerArgs = {
  id: Scalars['UUID']['input']
}

/** Application-level queries. */
export type QueryBusinessPartnersArgs = {
  input?: InputMaybe<BusinessPartnersInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessPartnersAutocompleteArgs = {
  input?: InputMaybe<BusinessPartnersAutocompleteInput>
}

/** Application-level queries. */
export type QueryBusinessSiteArgs = {
  id: Scalars['UUID']['input']
}

/** Application-level queries. */
export type QueryBusinessSiteSuggestionsArgs = {
  input: BusinessSiteSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessSitesArgs = {
  input?: InputMaybe<BusinessSitesInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryBusinessSitesAutocompleteArgs = {
  input?: InputMaybe<BusinessSitesAutocompleteInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryCampaignArgs = {
  input: CampaignQueryInput
}

/** Application-level queries. */
export type QueryCampaignsArgs = {
  input?: InputMaybe<CampaignsInput>
}

/** Application-level queries. */
export type QueryCampaignsAutocompleteArgs = {
  input?: InputMaybe<CampaignsAutocompleteInput>
}

/** Application-level queries. */
export type QueryCartArgs = {
  input: CartQueryInput
}

/** Application-level queries. */
export type QueryCartActivityArgs = {
  input?: InputMaybe<CartActivityInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryCartsArgs = {
  input?: InputMaybe<CartsQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryCashiersArgs = {
  input?: InputMaybe<CashiersQueryInput>
}

/** Application-level queries. */
export type QueryChangesArgs = {
  input?: InputMaybe<ChangesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryCitiesArgs = {
  input?: InputMaybe<PlacesQueryInput>
}

/** Application-level queries. */
export type QueryCityArgs = {
  input: PlaceQueryInput
}

/** Application-level queries. */
export type QueryCitySuggestionsArgs = {
  input: CitySuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryComboItemArgs = {
  input: ComboItemQueryInput
}

/** Application-level queries. */
export type QueryComboItemsArgs = {
  input?: InputMaybe<ComboItemsQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryComboItemsAutocompleteArgs = {
  input?: InputMaybe<ComboItemsAutocompleteInput>
}

/** Application-level queries. */
export type QueryCompaniesArgs = {
  input?: InputMaybe<CompaniesQueryInput>
}

/** Application-level queries. */
export type QueryCompaniesAutocompleteArgs = {
  input?: InputMaybe<CompaniesAutocompleteInput>
}

/** Application-level queries. */
export type QueryCompaniesV2Args = {
  input?: InputMaybe<CompaniesV2Input>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryCompaniesV2AutocompleteArgs = {
  input?: InputMaybe<CompaniesV2AutocompleteInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryCompanyArgs = {
  input: CompanyQueryInput
}

/** Application-level queries. */
export type QueryCompanyInsuranceSettingsArgs = {
  input: CompanyInsuranceSettingsInput
}

/** Application-level queries. */
export type QueryCompanyLineArgs = {
  input?: InputMaybe<CompanyLineQueryInput>
}

/** Application-level queries. */
export type QueryCompanyLinesArgs = {
  input?: InputMaybe<CompanyLinesQueryInput>
}

/** Application-level queries. */
export type QueryCompanyLinesAutocompleteArgs = {
  input?: InputMaybe<CompanyLinesAutocompleteInput>
}

/** Application-level queries. */
export type QueryCompanyRolesArgs = {
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryCompanySuggestionsArgs = {
  input: CompanySuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryCompanyV2Args = {
  id: Scalars['UUID']['input']
}

/** Application-level queries. */
export type QueryCountriesArgs = {
  input?: InputMaybe<CountriesInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryCountryArgs = {
  input: CountryInput
}

/** Application-level queries. */
export type QueryCouponArgs = {
  input: CouponInput
}

/** Application-level queries. */
export type QueryCouponsWithPaginationArgs = {
  input?: InputMaybe<CouponsWithPaginationInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryCurrenciesArgs = {
  input?: InputMaybe<CurrenciesInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryCurrencyArgs = {
  input: CurrencyInput
}

/** Application-level queries. */
export type QueryDatabaseSubcampaignArgs = {
  input: DatabaseSubcampaignInput
}

/** Application-level queries. */
export type QueryDatabaseSubcampaignCouponsArgs = {
  input: DatabaseSubcampaignCouponsInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryDatabaseSubcampaignsArgs = {
  input?: InputMaybe<DatabaseSubcampaignsInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryDrawersArgs = {
  input?: InputMaybe<DrawersInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryDriverSuggestionsArgs = {
  input: DriverSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryDriversArgs = {
  input: DriversInput
}

/** Application-level queries. */
export type QueryFareFamiliesArgs = {
  input?: InputMaybe<FareFamiliesInput>
}

/** Application-level queries. */
export type QueryFareFamiliesWithPaginationArgs = {
  input?: InputMaybe<FareFamiliesInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryFareRuleArgs = {
  input: FareRuleInput
}

/** Application-level queries. */
export type QueryFareRulesArgs = {
  input?: InputMaybe<FareRulesInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryIncidenceSubcampaignArgs = {
  input: IncidenceSubcampaignInput
}

/** Application-level queries. */
export type QueryIncidenceSubcampaignsArgs = {
  input?: InputMaybe<IncidenceSubcampaignsInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryInventoriesArgs = {
  input?: InputMaybe<InventoriesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryInventoriesAutocompleteArgs = {
  input?: InputMaybe<InventoriesAutocompleteInput>
}

/** Application-level queries. */
export type QueryInventoryArgs = {
  input: InventoryQueryInput
}

/** Application-level queries. */
export type QueryInventoryItemsArgs = {
  input: InventoryItemsQueryInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryInventoryRuleArgs = {
  input: InventoryRuleInput
}

/** Application-level queries. */
export type QueryInventoryRulesArgs = {
  input: InventoryRulesInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryInventoryWastesArgs = {
  input?: InputMaybe<InventoryWastesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryItemArgs = {
  input: ItemQueryInput
}

/** Application-level queries. */
export type QueryItemsArgs = {
  input?: InputMaybe<ItemsQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryItemsAutocompleteArgs = {
  input?: InputMaybe<ItemsAutocompleteInput>
}

/** Application-level queries. */
export type QueryKolorsMobilePlanItemArgs = {
  input?: InputMaybe<KolorsMobilePlanItemInput>
}

/** Application-level queries. */
export type QueryKolorsMobilePlanItemsArgs = {
  input?: InputMaybe<KolorsMobilePlanItemsInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryKreditArgs = {
  input: KreditInput
}

/** Application-level queries. */
export type QueryKreditTransactionsArgs = {
  input: KreditTransactionsInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryKreditsArgs = {
  input: KreditsInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryLocationCitiesArgs = {
  input: LocationCitiesInput
}

/** Application-level queries. */
export type QueryLocationCityArgs = {
  input: LocationCityInput
}

/** Application-level queries. */
export type QueryLoyaltyCampaignArgs = {
  input: LoyaltyCampaignInput
}

/** Application-level queries. */
export type QueryLoyaltyCampaignRuleArgs = {
  input: LoyaltyCampaignRuleInput
}

/** Application-level queries. */
export type QueryLoyaltyCampaignsArgs = {
  input?: InputMaybe<LoyaltyCampaignsInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryLoyaltyRewardsArgs = {
  input: LoyaltyRewardsInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryLoyaltyRewardsAutocompleteArgs = {
  input?: InputMaybe<LoyaltyRewardsAutocompleteInput>
}

/** Application-level queries. */
export type QueryOperationalCostArgs = {
  id: Scalars['UUID']['input']
}

/** Application-level queries. */
export type QueryOperationalCostsArgs = {
  input?: InputMaybe<OperationalCostsInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryOrderArgs = {
  input: OrderQueryInput
}

/** Application-level queries. */
export type QueryOrdersArgs = {
  input?: InputMaybe<OrdersQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryPartnerSuggestionsArgs = {
  input: PartnerSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryPartnersPaymentSummariesArgs = {
  input?: InputMaybe<PartnersPaymentSummariesInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryPartnersPaymentSummaryArgs = {
  input: PartnersPaymentSummaryInput
}

/** Application-level queries. */
export type QueryPassengerPropertiesArgs = {
  input?: InputMaybe<PassengerPropertiesInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryPassengerPropertiesAutocompleteArgs = {
  input?: InputMaybe<PassengerPropertiesAutocompleteInput>
}

/** Application-level queries. */
export type QueryPassengerPropertyArgs = {
  input: PassengerPropertyInput
}

/** Application-level queries. */
export type QueryPassengerTypeArgs = {
  input: PassengerTypeInput
}

/** Application-level queries. */
export type QueryPassengerTypesArgs = {
  input?: InputMaybe<PassengerTypesInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryPassengerTypesAutocompleteArgs = {
  input?: InputMaybe<PassengerTypesAutocompleteInput>
}

/** Application-level queries. */
export type QueryPermissionsArgs = {
  input?: InputMaybe<PermissionsQueryInput>
}

/** Application-level queries. */
export type QueryPlaceArgs = {
  input: PlaceQueryInput
}

/** Application-level queries. */
export type QueryPlaceByParamV2Args = {
  input: PlaceByParamV2Input
}

/** Application-level queries. */
export type QueryPlaceSuggestionsArgs = {
  input: PlaceSuggestionsInput
}

/** Application-level queries. */
export type QueryPlaceV2Args = {
  input: PlaceV2Input
}

/** Application-level queries. */
export type QueryPlacesArgs = {
  input?: InputMaybe<PlacesQueryInput>
}

/** Application-level queries. */
export type QueryPlacesByGeoLocationArgs = {
  input: PlacesByGeoLocationInput
}

/** Application-level queries. */
export type QueryRoleArgs = {
  input: RoleQueryInput
}

/** Application-level queries. */
export type QueryRolesArgs = {
  input?: InputMaybe<RolesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryRouteArgs = {
  input?: InputMaybe<RouteQueryInput>
}

/** Application-level queries. */
export type QueryRouteServiceSuggestionsArgs = {
  input: RouteServiceSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryRouteSuggestionsArgs = {
  input: RouteSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryRouteVehiclesArgs = {
  input: RouteVehiclesQueryInput
}

/** Application-level queries. */
export type QueryRoutesArgs = {
  input?: InputMaybe<RoutesQueryInput>
}

/** Application-level queries. */
export type QueryRoutesWithPaginationArgs = {
  input?: InputMaybe<RoutesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryRoutingProjectArgs = {
  input: RoutingProjectInput
}

/** Application-level queries. */
export type QueryRoutingProjectPlanArgs = {
  input: RoutingProjectPlanInput
}

/** Application-level queries. */
export type QueryRoutingProjectsArgs = {
  input: RoutingProjectsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QuerySalesArgs = {
  input?: InputMaybe<SalesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QuerySalesChannelArgs = {
  input: SalesChannelInput
}

/** Application-level queries. */
export type QuerySalesChannelsArgs = {
  input?: InputMaybe<SalesChannelsInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QuerySeasonEventArgs = {
  input: SeasonEventInput
}

/** Application-level queries. */
export type QuerySeatsTemplateArgs = {
  input: SeatsTemplateInput
}

/** Application-level queries. */
export type QuerySegmentArgs = {
  input?: InputMaybe<SegmentQueryInput>
}

/** Application-level queries. */
export type QuerySegmentSuggestionsArgs = {
  input: SegmentSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QuerySegmentsArgs = {
  input?: InputMaybe<SegmentsQueryInput>
}

/** Application-level queries. */
export type QuerySegmentsBetweenCitiesArgs = {
  input: SegmentsBetweenCitiesInput
}

/** Application-level queries. */
export type QuerySegmentsWithPaginationArgs = {
  input?: InputMaybe<SegmentsQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryServiceArgs = {
  input: ServiceQueryInput
}

/** Application-level queries. */
export type QueryServiceFeeAddonRuleArgs = {
  id: Scalars['ID']['input']
}

/** Application-level queries. */
export type QueryServiceFeeAddonRulesArgs = {
  input: ServiceFeeAddonRulesInput
  pagination: Pagination
}

/** Application-level queries. */
export type QueryServicesArgs = {
  input?: InputMaybe<ServicesQueryInput>
}

/** Application-level queries. */
export type QueryServicesWithPaginationArgs = {
  input?: InputMaybe<ServicesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QuerySiteArgs = {
  input: SiteQueryInput
}

/** Application-level queries. */
export type QuerySitesArgs = {
  input?: InputMaybe<SitesQueryInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QuerySitesAutocompleteArgs = {
  input?: InputMaybe<SitesAutocompleteInput>
}

/** Application-level queries. */
export type QuerySitesDashboardArgs = {
  input?: InputMaybe<SitesDashboardInput>
}

/** Application-level queries. */
export type QuerySubcampaignArgs = {
  input: SubcampaignInput
}

/** Application-level queries. */
export type QuerySuppliersAutocompleteArgs = {
  input?: InputMaybe<SuppliersAutocompleteInput>
}

/** Application-level queries. */
export type QueryTcitiesArgs = {
  input?: InputMaybe<TCitiesInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryTcitiesAutocompleteArgs = {
  input?: InputMaybe<TCitiesAutocompleteInput>
}

/** Application-level queries. */
export type QueryTcityArgs = {
  input: TCityInput
}

/** Application-level queries. */
export type QueryTdriverArgs = {
  input: TDriverInput
}

/** Application-level queries. */
export type QueryTdriversArgs = {
  input?: InputMaybe<TDriversInput>
  pagination?: InputMaybe<TPagination>
  sorting?: InputMaybe<TSorting>
}

/** Application-level queries. */
export type QueryTdriversAutocompleteArgs = {
  input?: InputMaybe<TDriversAutocompleteInput>
}

/** Application-level queries. */
export type QueryTicketsInsuranceArgs = {
  input?: InputMaybe<TicketsInsuranceInput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryTplaceArgs = {
  input: TPlaceInput
}

/** Application-level queries. */
export type QueryTplaceSuggestionsArgs = {
  input: TPlaceSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryTplacesArgs = {
  input?: InputMaybe<TPlacesInput>
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryTplacesAutocompleteArgs = {
  input?: InputMaybe<TPlacesAutocompleteInput>
}

/** Application-level queries. */
export type QueryTripArgs = {
  input: TripQueryInput
}

/** Application-level queries. */
export type QueryTripBookingsArgs = {
  input: TripBookingsQueryInput
}

/** Application-level queries. */
export type QueryTripSegmentsArgs = {
  input: TripSegmentsQueryInput
}

/** Application-level queries. */
export type QueryTripTrackingArgs = {
  input: TripTrackingQueryInput
}

/** Application-level queries. */
export type QueryTripV2Args = {
  input: TripV2Input
}

/** Application-level queries. */
export type QueryTripsArgs = {
  input: TripsQueryInput
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryTripsDriverConflictArgs = {
  input: TripsDriverConflictInput
}

/** Application-level queries. */
export type QueryTripsV2Args = {
  input: TripsV2Input
  pagination?: PaginationV2
  sorting?: SortingV2
}

/** Application-level queries. */
export type QueryTripsVehicleConflictArgs = {
  input: TripsVehicleConflictInput
}

/** Application-level queries. */
export type QueryTrouteArgs = {
  input: TRouteInput
}

/** Application-level queries. */
export type QueryTroutesArgs = {
  input?: InputMaybe<TRoutesInput>
  pagination?: InputMaybe<TPagination>
  sorting?: InputMaybe<TSorting>
}

/** Application-level queries. */
export type QueryTroutesAutocompleteArgs = {
  input?: InputMaybe<TRoutesAutocompleteInput>
}

/** Application-level queries. */
export type QueryTvehicleArgs = {
  input: TVehicleInput
}

/** Application-level queries. */
export type QueryTvehiclesArgs = {
  input?: InputMaybe<TVehiclesInput>
  pagination?: InputMaybe<TPagination>
  sorting?: InputMaybe<TSorting>
}

/** Application-level queries. */
export type QueryTvehiclesAutocompleteArgs = {
  input?: InputMaybe<TVehiclesAutocompleteInput>
}

/** Application-level queries. */
export type QueryUserArgs = {
  input: UserQueryInput
}

/** Application-level queries. */
export type QueryUserSuggestionsArgs = {
  input: UserSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryUsersArgs = {
  input?: InputMaybe<UsersQueryInmput>
  pagination?: InputMaybe<Pagination>
}

/** Application-level queries. */
export type QueryUsersAutocompleteArgs = {
  input?: InputMaybe<UsersAutocompleteInput>
}

/** Application-level queries. */
export type QueryVehicleArgs = {
  input: VehicleQueryInput
}

/** Application-level queries. */
export type QueryVehicleSuggestionsArgs = {
  input: VehicleSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryVehicleTemplateArgs = {
  input: TemplateQueryInput
}

/** Application-level queries. */
export type QueryVehicleTemplateSuggestionsArgs = {
  input: VehicleTemplateSuggestionsInput
  pagination?: InputMaybe<PaginationV2>
  sorting?: InputMaybe<SortingV2>
}

/** Application-level queries. */
export type QueryVehicleTemplatesArgs = {
  input?: InputMaybe<TemplatesQueryInput>
}

/** Application-level queries. */
export type QueryVehicleTemplatesAutocompleteArgs = {
  input?: InputMaybe<VehicleTemplatesAutocompleteInput>
}

/** Application-level queries. */
export type QueryVehiclesArgs = {
  input?: InputMaybe<VehiclesQueryInput>
}

/** Application-level queries. */
export type QueryWalletArgs = {
  input: WalletInput
}

/** Application-level queries. */
export type QueryWalletsArgs = {
  input: WalletsInput
  pagination?: InputMaybe<Pagination>
}

export type ReceiptData = {
  __typename?: 'ReceiptData'
  actualAmount?: Maybe<Amounts>
  expectedAmount: ExpectedAmountByMethod
  ticketsByStatus?: Maybe<TicketsByStatus>
}

export type ReceiveOrderInput = {
  id: Scalars['ID']['input']
  receivedItems: Array<ReceivedItemInput>
}

export type ReceivedItemInput = {
  id: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
}

export const RefundDestinationInput = {
  Card: 'CARD',
  Kredit: 'KREDIT'
} as const

export type RefundDestinationInput = (typeof RefundDestinationInput)[keyof typeof RefundDestinationInput]
export type RegisterBookingSupportInteractionInput = {
  callStatus?: InputMaybe<CallStatus>
  id: Scalars['ID']['input']
  notes?: InputMaybe<Scalars['String']['input']>
  notificationChannel?: InputMaybe<NotificationChannel>
}

export type RegisterBookingTaxInvoicedInput = {
  bookingID: Scalars['UUID']['input']
  taxFolio: Scalars['String']['input']
}

export type RegisterInventoryWasteInput = {
  id: Scalars['ID']['input']
  items: Array<RegisterWasteItemInput>
  purchaseID?: InputMaybe<Scalars['String']['input']>
  reason: ItemWasteReason
  supplier?: InputMaybe<Scalars['String']['input']>
}

export type RegisterItemComboInput = {
  category: Scalars['String']['input']
  components: Array<ItemComboComponentInput>
  minSellingPrice?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  photoPath?: InputMaybe<Scalars['String']['input']>
  sellingPrice: Scalars['Int']['input']
  subcategory: Scalars['String']['input']
}

export type RegisterItemInput = {
  /** brand */
  brand: Scalars['String']['input']
  category: Scalars['String']['input']
  container: Scalars['String']['input']
  /** the item's minimum selling price in cents */
  minSellingPrice?: InputMaybe<Scalars['Int']['input']>
  name: Scalars['String']['input']
  needsRefrigeration?: InputMaybe<Scalars['Boolean']['input']>
  /** net content in milliliters or milligrams */
  netContent: Scalars['Int']['input']
  photoPath?: InputMaybe<Scalars['String']['input']>
  /** the item's selling price in cents */
  sellingPrice: Scalars['Int']['input']
  subcategory?: InputMaybe<Scalars['String']['input']>
  /** template name */
  templateName?: InputMaybe<TemplateName>
  /** measurement units */
  units: Scalars['String']['input']
}

export type RegisterItemKolorsMobilePlanInput = {
  name: Scalars['String']['input']
  photoPath?: InputMaybe<Scalars['String']['input']>
  planID: Scalars['ID']['input']
  sellingPrice: Scalars['Int']['input']
  templateName: TemplateName
}

export type RegisterTripOdometerDistanceInput = {
  distance: Scalars['Int']['input']
  filePaths?: InputMaybe<Array<Scalars['String']['input']>>
  id: Scalars['UUID']['input']
  message?: InputMaybe<Scalars['String']['input']>
}

export type RegisterWasteItemInput = {
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
  quantity: Scalars['Int']['input']
  unitPrice?: InputMaybe<Scalars['Int']['input']>
}

export type RejectOrderInput = {
  id: Scalars['ID']['input']
}

export type RemoveInventoryItemsInput = {
  id: Scalars['ID']['input']
  items: Array<RemoveItemsInput>
  purchaseID?: InputMaybe<Scalars['String']['input']>
  reason: ItemRemovalReason
  supplier?: InputMaybe<Scalars['String']['input']>
}

export type RemoveItemsInput = {
  id: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
  unitPrice: Scalars['Int']['input']
}

export type RemovePartnerDocumentsInput = {
  documentIDs: Array<Scalars['UUID']['input']>
}

export type RemoveRoutingProjectPlanDatasetLocationsInput = {
  id: Scalars['UUID']['input']
  plan: RemoveRoutingProjectPlanDatasetLocationsPlanInput
}

export type RemoveRoutingProjectPlanDatasetLocationsPlanDatasetInput = {
  locationIDs: Array<Scalars['UUID']['input']>
}

export type RemoveRoutingProjectPlanDatasetLocationsPlanInput = {
  dataset: RemoveRoutingProjectPlanDatasetLocationsPlanDatasetInput
  id: Scalars['UUID']['input']
}

export type ReplacePlaceForBusinessCustomerInput = {
  businessClientID: Scalars['UUID']['input']
  businessCustomerID: Scalars['UUID']['input']
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  currentPlaceID: Scalars['UUID']['input']
  name: Scalars['String']['input']
  place: BusinessCustomerPlaceInput
}

export type RequestBusinessClientKreditDepositInput = {
  /** business client id */
  ID: Scalars['UUID']['input']
  /** amount of kredits to deposit */
  amount: Scalars['Int']['input']
  /** receipt file path */
  receiptPath?: InputMaybe<Scalars['String']['input']>
}

export type RequestCampaignSubcampaignCouponsDeliveryInput = {
  id: Scalars['ID']['input']
  subcampaignID: Scalars['ID']['input']
}

export type RequestResetUserAccountPasswordInput = {
  /** User Account Email */
  email: Scalars['String']['input']
}

export type ResetUserPasswordInput = {
  id: Scalars['UUID']['input']
  password: Scalars['String']['input']
}

export type ReturnCartInput = {
  id: Scalars['ID']['input']
}

/** role */
export type Role = {
  __typename?: 'Role'
  /** role id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** role's permissions */
  permissions: Array<RolePermission>
  /** users that have this role assigned */
  users: Array<RoleUser>
}

/** role company */
export type RoleCompany = {
  __typename?: 'RoleCompany'
  /** company id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** role permission */
export type RolePermission = {
  __typename?: 'RolePermission'
  /** permission id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** role user */
export type RoleUser = {
  __typename?: 'RoleUser'
  /** email */
  email: Scalars['String']['output']
  /** user id */
  id: Scalars['ID']['output']
}

/** route */
export type Route = {
  __typename?: 'Route'
  /** company */
  company: RouteCompany
  /** company lines */
  companyLines: Array<RouteCompanyLine>
  /** route id */
  id: Scalars['ID']['output']
  /** indicates wether the route is active or not */
  isActive: Scalars['Boolean']['output']
  /** segments */
  segments: Array<RouteSegment>
  /** route services */
  services: Array<RouteRouteService>
  /** stops */
  stops: Array<RouteStop>
}

/** company */
export type RouteCompany = {
  __typename?: 'RouteCompany'
  /** company id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** company line */
export type RouteCompanyLine = {
  __typename?: 'RouteCompanyLine'
  /** company line id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** route service */
export type RouteRouteService = {
  __typename?: 'RouteRouteService'
  /** code */
  code?: Maybe<Scalars['String']['output']>
  /** route service id */
  id: Scalars['ID']['output']
  /** indicates wether the route service is active or not */
  isActive: Scalars['Boolean']['output']
}

/** segment */
export type RouteSegment = {
  __typename?: 'RouteSegment'
  /** company line specs */
  companyLineSpecs: Array<RouteSegmentCompanyLineSpec>
  /** destination place */
  destination: RouteSegmentPlace
  /** segment id */
  id: Scalars['ID']['output']
  /** origin place */
  origin: RouteSegmentPlace
}

/** company line spec */
export type RouteSegmentCompanyLineSpec = {
  __typename?: 'RouteSegmentCompanyLineSpec'
  /** distance in meters */
  distance: Scalars['Int']['output']
  /** duration in minutes */
  duration: Scalars['Int']['output']
  /** company line id */
  id: Scalars['ID']['output']
}

/** place */
export type RouteSegmentPlace = {
  __typename?: 'RouteSegmentPlace'
  /** place id */
  id: Scalars['ID']['output']
  /** timezone */
  timezone: Scalars['String']['output']
}

export type RouteServiceBusinessClient = {
  __typename?: 'RouteServiceBusinessClient'
  businessSites?: Maybe<Array<RouteServiceBusinessSite>>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type RouteServiceBusinessSite = {
  __typename?: 'RouteServiceBusinessSite'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

/** company */
export type RouteServiceCompany = {
  __typename?: 'RouteServiceCompany'
  /** company id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** vertical */
  vertical: RouteServiceCompanyVertical
}

/** company line */
export type RouteServiceCompanyLine = {
  __typename?: 'RouteServiceCompanyLine'
  /** company */
  company: RouteServiceCompany
  /**
   * company id
   * @deprecated use company.id instead
   */
  companyID: Scalars['ID']['output']
  /** company line id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

export const RouteServiceCompanyVertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type RouteServiceCompanyVertical = (typeof RouteServiceCompanyVertical)[keyof typeof RouteServiceCompanyVertical]
export type RouteServiceConfirmationModalitiesInput = {
  facebook: Scalars['Boolean']['input']
  paid: Scalars['Boolean']['input']
  reserved: Scalars['Boolean']['input']
}

export type RouteServiceConfirmationModalitiesV2ExceptionInput = {
  placeIDs: Array<Scalars['ID']['input']>
}

export type RouteServiceConfirmationModalitiesV2Input = {
  exceptions: RouteServiceConfirmationModalitiesV2ExceptionInput
  name: Scalars['String']['input']
  salesChannelIDs: Array<Scalars['ID']['input']>
}

/** confirmation modalities v2 */
export type RouteServiceConfirmationModalityV2 = {
  __typename?: 'RouteServiceConfirmationModalityV2'
  exceptions: RouteServiceConfirmationModalityV2Exceptions
  name: Scalars['String']['output']
  salesChannels: Array<RouteServiceSalesChannelV2>
}

/** confirmation modality exception */
export type RouteServiceConfirmationModalityV2Exceptions = {
  __typename?: 'RouteServiceConfirmationModalityV2Exceptions'
  places?: Maybe<Array<RouteServiceConfirmationModalityV2Place>>
}

/** confirmation modality exception places */
export type RouteServiceConfirmationModalityV2Place = {
  __typename?: 'RouteServiceConfirmationModalityV2Place'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type RouteServiceItinerarySchedule = {
  __typename?: 'RouteServiceItinerarySchedule'
  dow: Array<Weekday>
  endAt?: Maybe<Scalars['Date']['output']>
  id: Scalars['ID']['output']
  itinerary: Array<RouteServiceItineraryStop>
  notes: Array<ItineraryScheduleNote>
  route: RouteServiceRoute
  startAt: Scalars['Date']['output']
  status: RouteServiceItineraryScheduleStatus
}

export const RouteServiceItineraryScheduleStatus = {
  Disabled: 'DISABLED',
  Enabled: 'ENABLED',
  Expired: 'EXPIRED'
} as const

export type RouteServiceItineraryScheduleStatus =
  (typeof RouteServiceItineraryScheduleStatus)[keyof typeof RouteServiceItineraryScheduleStatus]
/** itinerary stop */
export type RouteServiceItineraryStop = {
  __typename?: 'RouteServiceItineraryStop'
  /** arrival time */
  arrival?: Maybe<RouteServiceItineraryTime>
  /** departure time */
  departure?: Maybe<RouteServiceItineraryTime>
  /** place id */
  placeID: Scalars['ID']['output']
  /** timezone */
  timezone: Scalars['String']['output']
}

/** itinerary time */
export type RouteServiceItineraryTime = {
  __typename?: 'RouteServiceItineraryTime'
  /** an integer representing how many days after departure the stop takes place. ex. 0 = same day, 1 = next day */
  day: Scalars['Int']['output']
  /** time in hh:mm format, in the timezone of the place */
  time: Scalars['String']['output']
}

export type RouteServicePeak = {
  __typename?: 'RouteServicePeak'
  endAt: Scalars['Date']['output']
  id: Scalars['ID']['output']
  startAt: Scalars['Date']['output']
}

export type RouteServicePeakInput = {
  endAt: Scalars['Date']['input']
  startAt: Scalars['Date']['input']
}

/** route */
export type RouteServiceRoute = {
  __typename?: 'RouteServiceRoute'
  /** route id */
  id: Scalars['ID']['output']
  /** segments */
  segments: Array<RouteServiceRouteSegment>
  /** stops */
  stops: Array<RouteServiceRouteStop>
}

/** segment */
export type RouteServiceRouteSegment = {
  __typename?: 'RouteServiceRouteSegment'
  /** company line specs */
  companyLineSpecs: Array<RouteServiceRouteSegmentCompanyLineSpec>
  /** destination place */
  destination: RouteServiceRouteSegmentPlace
  /** segment id */
  id: Scalars['ID']['output']
  /** origin place */
  origin: RouteServiceRouteSegmentPlace
}

/** company line spec */
export type RouteServiceRouteSegmentCompanyLineSpec = {
  __typename?: 'RouteServiceRouteSegmentCompanyLineSpec'
  /** distance in meters */
  distance: Scalars['Int']['output']
  /** duration in minutes */
  duration: Scalars['Int']['output']
  /** company line id */
  id: Scalars['ID']['output']
}

/** place */
export type RouteServiceRouteSegmentPlace = {
  __typename?: 'RouteServiceRouteSegmentPlace'
  /** place code */
  code: Scalars['String']['output']
  /** place id */
  id: Scalars['ID']['output']
  /** place name */
  name: Scalars['String']['output']
  /** timezone */
  timezone: Scalars['String']['output']
}

/** route stop */
export type RouteServiceRouteStop = {
  __typename?: 'RouteServiceRouteStop'
  /** place code */
  code: Scalars['String']['output']
  /** place id */
  id: Scalars['ID']['output']
  /** place name */
  name: Scalars['String']['output']
  /** timezone */
  timezone: Scalars['String']['output']
}

export type RouteServiceSalesChannelV2 = {
  __typename?: 'RouteServiceSalesChannelV2'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type RouteServiceScheduleFrequency = {
  __typename?: 'RouteServiceScheduleFrequency'
  unit: RouteServiceScheduleFrequencyUnit
  value: Scalars['Int']['output']
}

export const RouteServiceScheduleFrequencyUnit = {
  Day: 'DAY',
  Week: 'WEEK'
} as const

export type RouteServiceScheduleFrequencyUnit =
  (typeof RouteServiceScheduleFrequencyUnit)[keyof typeof RouteServiceScheduleFrequencyUnit]
export const RouteServiceSingleTripReason = {
  Maintenance: 'MAINTENANCE',
  Operation: 'OPERATION'
} as const

export type RouteServiceSingleTripReason =
  (typeof RouteServiceSingleTripReason)[keyof typeof RouteServiceSingleTripReason]
export type RouteServiceSuggestion = {
  __typename?: 'RouteServiceSuggestion'
  code: Scalars['String']['output']
  departureTime?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
}

export type RouteServiceSuggestionsInput = {
  code?: InputMaybe<Scalars['String']['input']>
  companyID?: InputMaybe<Scalars['UUID']['input']>
  companyLineIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  endAt?: InputMaybe<DateRange>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  includeWithNoEndDate?: InputMaybe<Scalars['Boolean']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  normalizedCode?: InputMaybe<Scalars['String']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
  routeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  startAt?: InputMaybe<DateRange>
  verticals?: InputMaybe<Array<Scalars['String']['input']>>
}

export type RouteServiceSuggestionsResponse = {
  __typename?: 'RouteServiceSuggestionsResponse'
  items: Array<RouteServiceSuggestion>
  total: Scalars['Long']['output']
}

/** Crew User */
export type RouteServiceUser = {
  __typename?: 'RouteServiceUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

/** vehicle */
export type RouteServiceVehicle = {
  __typename?: 'RouteServiceVehicle'
  /** externalID */
  externalID?: Maybe<Scalars['String']['output']>
  /** vehicle id */
  id?: Maybe<Scalars['ID']['output']>
  /** name */
  name?: Maybe<Scalars['String']['output']>
  /** template */
  template: RouteServiceVehicleTemplate
}

export type RouteServiceVehicleSchedule = {
  __typename?: 'RouteServiceVehicleSchedule'
  dow?: Maybe<Array<Weekday>>
  driver?: Maybe<RouteServiceVehicleScheduleDriver>
  endAt?: Maybe<Scalars['Date']['output']>
  frequency?: Maybe<RouteServiceScheduleFrequency>
  id: Scalars['ID']['output']
  startAt: Scalars['Date']['output']
  vehicle: RouteServiceVehicle
}

export type RouteServiceVehicleScheduleDriver = {
  __typename?: 'RouteServiceVehicleScheduleDriver'
  id: Scalars['ID']['output']
  userAccount: RouteServiceVehicleScheduleDriverUserAccount
}

export type RouteServiceVehicleScheduleDriverUserAccount = {
  __typename?: 'RouteServiceVehicleScheduleDriverUserAccount'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  /** @deprecated use firstName and lastName instead */
  name?: Maybe<Scalars['String']['output']>
}

export type RouteServiceVehicleTemplate = {
  __typename?: 'RouteServiceVehicleTemplate'
  /** capacity */
  capacity: Scalars['Int']['output']
  /** template id */
  id: Scalars['ID']['output']
}

/** route stop */
export type RouteStop = {
  __typename?: 'RouteStop'
  /** place code */
  code: Scalars['String']['output']
  /** place id */
  id: Scalars['ID']['output']
  /** place name */
  name: Scalars['String']['output']
  /** timezone */
  timezone: Scalars['String']['output']
}

export type RouteStopAddress = {
  __typename?: 'RouteStopAddress'
  city: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  line1: Scalars['String']['output']
  line2?: Maybe<Scalars['String']['output']>
  stateCode: Scalars['String']['output']
  zipCode: Scalars['String']['output']
}

export type RouteStopCoordinates = {
  __typename?: 'RouteStopCoordinates'
  latitude: Scalars['String']['output']
  longitude: Scalars['String']['output']
}

export type RouteSuggestion = {
  __typename?: 'RouteSuggestion'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type RouteSuggestionsInput = {
  businessClientIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  businessSiteIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  companyLineIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  pattern?: InputMaybe<Scalars['String']['input']>
  verticals?: InputMaybe<Array<Scalars['String']['input']>>
}

export type RouteSuggestionsResponse = {
  __typename?: 'RouteSuggestionsResponse'
  items: Array<RouteSuggestion>
  total: Scalars['Long']['output']
}

export type RouteVehiclesQueryInput = {
  routeID: Scalars['ID']['input']
}

export type RoutesResponse = {
  __typename?: 'RoutesResponse'
  /** routes */
  items: Array<Route>
  /** total number of routes */
  total: Scalars['Int']['output']
}

export type RoutingProject = {
  __typename?: 'RoutingProject'
  createdAt: Scalars['Time']['output']
  datasets: Array<RoutingProjectDataset>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  plans: Array<RoutingProjectPlan>
  tags?: Maybe<Array<Scalars['String']['output']>>
  updatedAt: Scalars['Time']['output']
}

export const RoutingProjectDow = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const

export type RoutingProjectDow = (typeof RoutingProjectDow)[keyof typeof RoutingProjectDow]
export type RoutingProjectDataset = {
  __typename?: 'RoutingProjectDataset'
  id: Scalars['UUID']['output']
  locations: Array<RoutingProjectDatasetLocation>
  name: Scalars['String']['output']
}

export type RoutingProjectDatasetLocation = {
  __typename?: 'RoutingProjectDatasetLocation'
  coordinates: RoutingProjectDatasetLocationCoordinates
  dow: Array<RoutingProjectDow>
  id: Scalars['UUID']['output']
  label: Scalars['String']['output']
}

export type RoutingProjectDatasetLocationCoordinates = {
  __typename?: 'RoutingProjectDatasetLocationCoordinates'
  latitude: Scalars['String']['output']
  longitude: Scalars['String']['output']
}

export type RoutingProjectInput = {
  id: Scalars['UUID']['input']
}

export const RoutingProjectLocationDow = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const

export type RoutingProjectLocationDow = (typeof RoutingProjectLocationDow)[keyof typeof RoutingProjectLocationDow]
export type RoutingProjectPlan = {
  __typename?: 'RoutingProjectPlan'
  constraints?: Maybe<RoutingProjectPlanConstraints>
  dataset: RoutingProjectDataset
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  optimization?: Maybe<RoutingProjectPlanOptimization>
  status: RoutingProjectPlanStatus
}

export type RoutingProjectPlanConstraints = {
  __typename?: 'RoutingProjectPlanConstraints'
  destination?: Maybe<RoutingProjectPlanConstraintsLocation>
  endTime?: Maybe<Scalars['String']['output']>
  maxDistance?: Maybe<Scalars['Int']['output']>
  maxDuration?: Maybe<Scalars['Int']['output']>
  maxStops?: Maybe<Scalars['Int']['output']>
  origin?: Maybe<RoutingProjectPlanConstraintsLocation>
  startTime?: Maybe<Scalars['String']['output']>
  stopDuration?: Maybe<Scalars['Int']['output']>
  vehicles?: Maybe<Array<RoutingProjectPlanConstraintsVehicle>>
}

export type RoutingProjectPlanConstraintsLocation = {
  __typename?: 'RoutingProjectPlanConstraintsLocation'
  id: Scalars['UUID']['output']
  label: Scalars['String']['output']
}

export type RoutingProjectPlanConstraintsVehicle = {
  __typename?: 'RoutingProjectPlanConstraintsVehicle'
  capacity: Scalars['Int']['output']
  number: Scalars['Int']['output']
}

export type RoutingProjectPlanInput = {
  id: Scalars['UUID']['input']
  planID: Scalars['UUID']['input']
}

export type RoutingProjectPlanOptimization = {
  __typename?: 'RoutingProjectPlanOptimization'
  routes: Array<RoutingProjectPlanOptimizationRoute>
  skippedLocations: Array<RoutingProjectPlanOptimizationSkippedLocation>
}

export type RoutingProjectPlanOptimizationRoute = {
  __typename?: 'RoutingProjectPlanOptimizationRoute'
  distance: Scalars['Int']['output']
  duration: Scalars['Int']['output']
  id: Scalars['UUID']['output']
  polyline: Scalars['String']['output']
  stops: Array<RoutingProjectPlanOptimizationRouteStop>
  vehicleCapacity: Scalars['Int']['output']
}

export type RoutingProjectPlanOptimizationRouteStop = {
  __typename?: 'RoutingProjectPlanOptimizationRouteStop'
  arrival?: Maybe<RoutingProjectPlanOptimizationRouteStopTime>
  departure?: Maybe<RoutingProjectPlanOptimizationRouteStopTime>
  location: RoutingProjectDatasetLocation
}

export type RoutingProjectPlanOptimizationRouteStopTime = {
  __typename?: 'RoutingProjectPlanOptimizationRouteStopTime'
  day: Scalars['Int']['output']
  time: Scalars['String']['output']
}

export type RoutingProjectPlanOptimizationSkippedLocation = {
  __typename?: 'RoutingProjectPlanOptimizationSkippedLocation'
  location: RoutingProjectDatasetLocation
  reasons: Array<RoutingProjectPlanOptimizationSkippedLocationReason>
}

export const RoutingProjectPlanOptimizationSkippedLocationReason = {
  CannotBePerformedWithinVehicleDistanceLimit: 'CANNOT_BE_PERFORMED_WITHIN_VEHICLE_DISTANCE_LIMIT',
  CannotBePerformedWithinVehicleDurationLimit: 'CANNOT_BE_PERFORMED_WITHIN_VEHICLE_DURATION_LIMIT',
  DemandExceedsVehicleCapacity: 'DEMAND_EXCEEDS_VEHICLE_CAPACITY'
} as const

export type RoutingProjectPlanOptimizationSkippedLocationReason =
  (typeof RoutingProjectPlanOptimizationSkippedLocationReason)[keyof typeof RoutingProjectPlanOptimizationSkippedLocationReason]
export type RoutingProjectPlanResponse = {
  __typename?: 'RoutingProjectPlanResponse'
  plan: RoutingProjectPlan
}

export const RoutingProjectPlanStatus = {
  Simulation: 'SIMULATION'
} as const

export type RoutingProjectPlanStatus = (typeof RoutingProjectPlanStatus)[keyof typeof RoutingProjectPlanStatus]
export type RoutingProjectResponse = {
  __typename?: 'RoutingProjectResponse'
  routingProject: RoutingProject
}

export type RoutingProjectsInput = {
  name?: InputMaybe<Scalars['String']['input']>
}

export type RoutingProjectsResponse = {
  __typename?: 'RoutingProjectsResponse'
  items: Array<RoutingProject>
  total: Scalars['Int']['output']
}

export type RoutingProjectsTagsResponse = {
  __typename?: 'RoutingProjectsTagsResponse'
  tags: Array<Scalars['String']['output']>
  total: Scalars['Int']['output']
}

export type ShaAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaAncillariesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaAncillariesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaAutocompleteProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBookingsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessClientUsersHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessClientUsersProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessClientsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessClientsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessCustomersHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessCustomersProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessSitesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaBusinessSitesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaCompaniesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaCompaniesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaCountriesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaCountriesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaCurrenciesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaCurrenciesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaDriversHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaDriversProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaFormsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaInventoryRulesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaKreditsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaKreditsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaLoyaltyCampaignsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaLoyaltyRewardsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaLoyaltyRewardsProjectorInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaMobilePlansHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaOperationalCostsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaOperationalCostsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPartnerCostsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPartnersHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPartnersPaymentSummariesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPartnersPaymentSummariesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPartnersProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPassengerPropertiesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPassengerTypesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPassengersProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPlacesAutocompleteProjectorSnitchInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPlacesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaPlacesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaRoutesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaRoutesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaRoutingProjectsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaRoutingProjectsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaSalesChannelsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaSalesChannelsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaSeasonEventsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaSessionsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaSubcampaignsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaSubcampaignsProjectorInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaTripSegmentsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaTripsHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaTripsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaVehiclesHandlerAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaVehiclesProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type ShaWalletsProjectorAdminInput = {
  value?: InputMaybe<Scalars['String']['input']>
}

export type Sale = {
  __typename?: 'Sale'
  buyer?: Maybe<SaleBuyer>
  cart: SaleCart
  coupon?: Maybe<SaleCoupon>
  createdAt: Scalars['Time']['output']
  id: Scalars['ID']['output']
  lineItems: Array<SaleLineItem>
  payment: SalePayment
  seller: SaleUser
  status: Scalars['String']['output']
  trip?: Maybe<SaleTrip>
}

export type SaleBuyer = {
  __typename?: 'SaleBuyer'
  email?: Maybe<Scalars['String']['output']>
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  seat?: Maybe<SaleSeat>
}

export type SaleCart = {
  __typename?: 'SaleCart'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const SaleChannel = {
  Pos: 'POS',
  Online: 'online'
} as const

export type SaleChannel = (typeof SaleChannel)[keyof typeof SaleChannel]
export type SaleCoupon = {
  __typename?: 'SaleCoupon'
  /** code */
  code: Scalars['String']['output']
  /** discount type */
  discountType: DiscountType
  /** coupon id */
  id: Scalars['ID']['output']
  /** coupon value */
  value: Scalars['Int']['output']
}

export type SaleLineItem = {
  __typename?: 'SaleLineItem'
  comboComponents?: Maybe<Array<LineItemComboComponent>>
  container: Scalars['String']['output']
  discount?: Maybe<Scalars['Int']['output']>
  itemID: Scalars['ID']['output']
  name: Scalars['String']['output']
  netContent: Scalars['Int']['output']
  quantity: Scalars['Int']['output']
  total: Scalars['Int']['output']
  unitPrice: Scalars['Int']['output']
  units: Scalars['String']['output']
}

export type SalePayment = {
  __typename?: 'SalePayment'
  amount: Scalars['Int']['output']
  last4?: Maybe<Scalars['String']['output']>
  method: Scalars['String']['output']
}

export type SalePlace = {
  __typename?: 'SalePlace'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type SaleSeat = {
  __typename?: 'SaleSeat'
  id: Scalars['ID']['output']
  label: Scalars['String']['output']
}

export type SaleSegment = {
  __typename?: 'SaleSegment'
  destination: SalePlace
  id: Scalars['ID']['output']
  origin: SalePlace
}

export const SaleStatus = {
  Cancelled: 'cancelled',
  Confirmed: 'confirmed'
} as const

export type SaleStatus = (typeof SaleStatus)[keyof typeof SaleStatus]
export type SaleTrip = {
  __typename?: 'SaleTrip'
  destination: SalePlace
  id: Scalars['ID']['output']
  origin: SalePlace
  segment: SaleSegment
}

export type SaleUser = {
  __typename?: 'SaleUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

/** sales channel */
export const SalesChannel = {
  KolorsMx: 'KOLORS_MX',
  KolorsUs: 'KOLORS_US',
  Pos: 'POS',
  All: 'all',
  Offline: 'offline',
  Online: 'online'
} as const

export type SalesChannel = (typeof SalesChannel)[keyof typeof SalesChannel]
export type SalesChannelCountry = {
  __typename?: 'SalesChannelCountry'
  code: Scalars['String']['output']
  currency: SalesChannelCurrency
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type SalesChannelCurrency = {
  __typename?: 'SalesChannelCurrency'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  symbol: Scalars['String']['output']
}

export type SalesChannelInput = {
  id: Scalars['ID']['input']
}

/** sales channel type */
export const SalesChannelType = {
  Offline: 'OFFLINE',
  Online: 'ONLINE'
} as const

export type SalesChannelType = (typeof SalesChannelType)[keyof typeof SalesChannelType]
export const SalesChannelTypeV2 = {
  Offline: 'OFFLINE',
  Online: 'ONLINE'
} as const

export type SalesChannelTypeV2 = (typeof SalesChannelTypeV2)[keyof typeof SalesChannelTypeV2]
export type SalesChannelV2 = {
  __typename?: 'SalesChannelV2'
  country: SalesChannelCountry
  createdAt: Scalars['Time']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  type: SalesChannelTypeV2
  updatedAt: Scalars['Time']['output']
}

export type SalesChannelsInput = {
  countryID?: InputMaybe<Scalars['ID']['input']>
}

export type SalesChannelsOutput = {
  __typename?: 'SalesChannelsOutput'
  items: Array<SalesChannelV2>
  total: Scalars['Int']['output']
}

export type SalesDashboardDataInfo = {
  __typename?: 'SalesDashboardDataInfo'
  amount: Scalars['Int']['output']
  count: Scalars['Int']['output']
}

/** paginated sales response */
export type SalesResponse = {
  __typename?: 'SalesResponse'
  /** sales */
  items: Array<Sale>
  /** total of sales */
  total: Scalars['Int']['output']
}

export type ScheduleRouteServiceTripsInput = {
  /** force scheduling */
  force?: Scalars['Boolean']['input']
  /** route service id */
  id: Scalars['ID']['input']
  /** end at */
  scheduleEndAt?: InputMaybe<Scalars['Date']['input']>
  /** start at */
  scheduleStartAt?: InputMaybe<Scalars['Date']['input']>
}

export type SeasonEvent = {
  __typename?: 'SeasonEvent'
  activePeriods: Array<ActivePeriod>
  company: SeasonEventCompany
  id: Scalars['ID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  routeServices: Array<SeasonEventRouteService>
  segments: Array<SeasonEventSegment>
  type: SeasonEventType
}

export type SeasonEventCompany = {
  __typename?: 'SeasonEventCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type SeasonEventRouteService = {
  __typename?: 'SeasonEventRouteService'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type SeasonEventSegment = {
  __typename?: 'SeasonEventSegment'
  destination: SeasonEventSegmentPlace
  id: Scalars['ID']['output']
  origin: SeasonEventSegmentPlace
}

export type SeasonEventSegmentPlace = {
  __typename?: 'SeasonEventSegmentPlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export const SeasonEventType = {
  /** exception event */
  E: 'E',
  /** high season */
  H: 'H',
  /** low season */
  L: 'L',
  /** special event */
  S: 'S'
} as const

export type SeasonEventType = (typeof SeasonEventType)[keyof typeof SeasonEventType]
/** season type */
export const SeasonType = {
  /** exception event */
  E: 'E',
  /** high season */
  H: 'H',
  /** low season */
  L: 'L',
  /** N/A */
  N: 'N',
  /** special event */
  S: 'S'
} as const

export type SeasonType = (typeof SeasonType)[keyof typeof SeasonType]
/** seat */
export type Seat = {
  __typename?: 'Seat'
  /** seat id */
  id: Scalars['ID']['output']
  /** seat label */
  label: Scalars['String']['output']
  /** seat status */
  status: SeatStatus
}

/** seat status */
export const SeatStatus = {
  Available: 'available',
  Occupied: 'occupied'
} as const

export type SeatStatus = (typeof SeatStatus)[keyof typeof SeatStatus]
export type SeatsTemplateResponse = {
  __typename?: 'SeatsTemplateResponse'
  /** seats */
  seats: Array<Seat>
  /** vehicle template */
  vehicleTemplate: VehicleTemplate
}

/** segment */
export type Segment = {
  __typename?: 'Segment'
  /** company */
  company: SegmentCompany
  /** company line specs */
  companyLineSpecs: Array<SegmentCompanyLineSpec>
  /** destination place */
  destination: SegmentPlace
  /** segment id */
  id: Scalars['ID']['output']
  /** origin place */
  origin: SegmentPlace
}

export type SegmentCity = {
  __typename?: 'SegmentCity'
  /** code */
  code: Scalars['String']['output']
  /** city id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** company */
export type SegmentCompany = {
  __typename?: 'SegmentCompany'
  /** company lines */
  companyLines: Array<SegmentCompanyCompanyLine>
  /** company id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** company line */
export type SegmentCompanyCompanyLine = {
  __typename?: 'SegmentCompanyCompanyLine'
  /** company line id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** company line spec */
export type SegmentCompanyLineSpec = {
  __typename?: 'SegmentCompanyLineSpec'
  /** company line */
  companyLine: SegmentCompanyLineSpecCompanyLine
  /** distance in meters */
  distance?: Maybe<Scalars['Int']['output']>
  /** duration in minutes */
  duration?: Maybe<Scalars['Int']['output']>
  /** fares */
  fares: Array<SegmentCompanyLineSpecFare>
  /** maximum fare in cents */
  maxFare?: Maybe<Scalars['Int']['output']>
  /** minimum fare in cents */
  minFare?: Maybe<Scalars['Int']['output']>
  /** real distance in meters */
  realDistance?: Maybe<Scalars['Int']['output']>
  /** vat rate */
  vatRate?: Maybe<Scalars['Float']['output']>
}

/** company line */
export type SegmentCompanyLineSpecCompanyLine = {
  __typename?: 'SegmentCompanyLineSpecCompanyLine'
  /** company line id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** fare */
export type SegmentCompanyLineSpecFare = {
  __typename?: 'SegmentCompanyLineSpecFare'
  /** discount rate */
  discountRate: Scalars['Float']['output']
  /** fare id */
  id: Scalars['ID']['output']
  /** passenger type this fare applies to */
  passengerType: PassengerType
  /** subtotal in cents */
  subtotal: Scalars['Int']['output']
  /** vat in cents */
  vat: Scalars['Int']['output']
}

/** place */
export type SegmentPlace = {
  __typename?: 'SegmentPlace'
  /** city */
  city: SegmentCity
  /** code */
  code: Scalars['String']['output']
  /** place id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

export type SegmentSuggestion = {
  __typename?: 'SegmentSuggestion'
  destination: SegmentSuggestionPlace
  /** @deprecated Use destination.name instead */
  destinationName?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  origin: SegmentSuggestionPlace
  /** @deprecated Use origin.name instead */
  originName?: Maybe<Scalars['String']['output']>
}

export type SegmentSuggestionPlace = {
  __typename?: 'SegmentSuggestionPlace'
  cityID: Scalars['UUID']['output']
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type SegmentSuggestionsInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  destinationCityIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  destinationIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  includeReverse?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  onlyNoFareFamily?: InputMaybe<Scalars['Boolean']['input']>
  originCityIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  originIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type SegmentSuggestionsResponse = {
  __typename?: 'SegmentSuggestionsResponse'
  items: Array<SegmentSuggestion>
  total: Scalars['Long']['output']
}

export type SegmentsDifference = {
  __typename?: 'SegmentsDifference'
  new: Array<ChangeSegment>
  old: Array<ChangeSegment>
}

export type SegmentsResponse = {
  __typename?: 'SegmentsResponse'
  /** segments */
  items: Array<Segment>
  /** total number of segments */
  total: Scalars['Int']['output']
}

/** sell status */
export const SellStatus = {
  Activated: 'activated',
  Deactivated: 'deactivated'
} as const

export type SellStatus = (typeof SellStatus)[keyof typeof SellStatus]
export type SendEmailCouponInput = {
  campaignID: Scalars['ID']['input']
  couponID: Scalars['ID']['input']
  email?: InputMaybe<Scalars['String']['input']>
  subcampaignID: Scalars['ID']['input']
}

export type SendEmailIncidenceCouponInput = {
  campaignID: Scalars['ID']['input']
  couponID: Scalars['ID']['input']
  email?: InputMaybe<Scalars['String']['input']>
  subcampaignID: Scalars['ID']['input']
}

export type SendPartnersPaymentSummaryEmailsInput = {
  /** ID of the summary */
  id: Scalars['UUID']['input']
}

export type SendSmsCouponInput = {
  campaignID: Scalars['ID']['input']
  couponID: Scalars['ID']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  subcampaignID: Scalars['ID']['input']
}

export type SendSmsIncidenceCouponInput = {
  campaignID: Scalars['ID']['input']
  couponID: Scalars['ID']['input']
  phone?: InputMaybe<Scalars['String']['input']>
  subcampaignID: Scalars['ID']['input']
}

/** route service */
export type Service = {
  __typename?: 'Service'
  /** active period */
  activePeriod?: Maybe<Scalars['Int']['output']>
  /** business clients */
  businessClients?: Maybe<Array<RouteServiceBusinessClient>>
  /** code */
  code?: Maybe<Scalars['String']['output']>
  /** company line */
  companyLine: RouteServiceCompanyLine
  /**
   * confirmation modalities
   * @deprecated use confirmationModalitiesV2 instead
   */
  confirmationModalities: ConfirmationModalities
  /** confirmation modalities v2 */
  confirmationModalitiesV2: Array<RouteServiceConfirmationModalityV2>
  /** created at */
  createdAt: Scalars['Time']['output']
  /** created by */
  createdBy: RouteServiceUser
  /** crew users */
  crewUsers: Array<RouteServiceUser>
  /**
   * days of week the service is active
   * @deprecated use itinerariesSchedule.dow instead
   */
  dow?: Maybe<Array<DayOfWeek>>
  /** endAt */
  endAt?: Maybe<Scalars['String']['output']>
  /** idicates whether the route service has selectable seats or not */
  hasSelectableSeats: Scalars['Boolean']['output']
  /** has tolls */
  hasTolls: Scalars['Boolean']['output']
  /** route service id */
  id: Scalars['ID']['output']
  /** indicates whether the route service is active or not */
  isActive: Scalars['Boolean']['output']
  /** determines if the route service can be deleted */
  isDeletable: Scalars['Boolean']['output']
  /** is on guard */
  isOnGuard: Scalars['Boolean']['output']
  /** is pet friendly */
  isPetFriendly: Scalars['Boolean']['output']
  /** is private */
  isPrivate: Scalars['Boolean']['output']
  /** itineraries schedule */
  itinerariesSchedule: Array<RouteServiceItinerarySchedule>
  /**
   * itinerary
   * @deprecated use itinerariesSchedule.itinerary instead
   */
  itinerary?: Maybe<Array<RouteServiceItineraryStop>>
  /** limits */
  limits: Array<Limit>
  /** peaks */
  peaks?: Maybe<Array<RouteServicePeak>>
  /** price checked at */
  priceCheckedAt: Scalars['Time']['output']
  /** price per trip */
  pricePerTrip?: Maybe<Scalars['Int']['output']>
  /**
   * route
   * @deprecated use itinerariesSchedule.route instead
   */
  route?: Maybe<RouteServiceRoute>
  /**
   * sales channels
   * @deprecated use salesChannelsV2 instead
   */
  salesChannels?: Maybe<Array<SalesChannel>>
  /** sales channels v2 */
  salesChannelsV2?: Maybe<Array<RouteServiceSalesChannelV2>>
  /** startAt */
  startAt: Scalars['String']['output']
  /** updated at */
  updatedAt: Scalars['Time']['output']
  /** vehicles schedule */
  vehiclesSchedule: Array<RouteServiceVehicleSchedule>
}

export type ServiceFee = {
  __typename?: 'ServiceFee'
  id: Scalars['ID']['output']
  price: Scalars['Int']['output']
}

export type ServiceFeeAddonRule = {
  __typename?: 'ServiceFeeAddonRule'
  company: ServiceFeeAddonRuleCompany
  companyLine: ServiceFeeAddonRuleCompanyLine
  confirmationModalities: Array<ConfirmationModality>
  id: Scalars['ID']['output']
  isEnabled: Scalars['Boolean']['output']
  salesChannels: Array<SalesChannel>
  salesChannelsV2: Array<ServiceFeeAddonRuleSalesChannel>
  segments: Array<ServiceFeeAddonRuleSegment>
  ticketFees: Array<ServiceFeeAddonRuleTicketFee>
}

export type ServiceFeeAddonRuleCompany = {
  __typename?: 'ServiceFeeAddonRuleCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ServiceFeeAddonRuleCompanyLine = {
  __typename?: 'ServiceFeeAddonRuleCompanyLine'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ServiceFeeAddonRuleFee = {
  __typename?: 'ServiceFeeAddonRuleFee'
  amount: Scalars['Int']['output']
  currencyCode: Scalars['String']['output']
}

export type ServiceFeeAddonRulePlace = {
  __typename?: 'ServiceFeeAddonRulePlace'
  code: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  stateCode: Scalars['String']['output']
}

export type ServiceFeeAddonRuleSalesChannel = {
  __typename?: 'ServiceFeeAddonRuleSalesChannel'
  country: ServiceFeeAddonRuleSalesChannelCountry
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ServiceFeeAddonRuleSalesChannelCountry = {
  __typename?: 'ServiceFeeAddonRuleSalesChannelCountry'
  code: Scalars['String']['output']
  currency: ServiceFeeAddonRuleSalesChannelCountryCurrency
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type ServiceFeeAddonRuleSalesChannelCountryCurrency = {
  __typename?: 'ServiceFeeAddonRuleSalesChannelCountryCurrency'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  symbol: Scalars['String']['output']
}

export type ServiceFeeAddonRuleSegment = {
  __typename?: 'ServiceFeeAddonRuleSegment'
  destination: ServiceFeeAddonRulePlace
  id: Scalars['ID']['output']
  origin: ServiceFeeAddonRulePlace
}

export type ServiceFeeAddonRuleTicketFee = {
  __typename?: 'ServiceFeeAddonRuleTicketFee'
  fees: Array<ServiceFeeAddonRuleFee>
  quantity: Scalars['Int']['output']
}

/** service fee addon rules input */
export type ServiceFeeAddonRulesInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
}

export type ServiceFeeAddonRulesOutput = {
  __typename?: 'ServiceFeeAddonRulesOutput'
  items: Array<ServiceFeeAddonRule>
  total: Scalars['Int']['output']
}

export type ServiceQueryInput = {
  id: Scalars['ID']['input']
}

/** service type */
export const ServiceType = {
  /** Economic */
  E: 'E',
  /** Luxury */
  L: 'L',
  /** Primera */
  P: 'P'
} as const

export type ServiceType = (typeof ServiceType)[keyof typeof ServiceType]
export type ServicesResponse = {
  __typename?: 'ServicesResponse'
  /** route services */
  items: Array<Service>
  /** total number of route services */
  total: Scalars['Int']['output']
}

export type SetCampaignTemplateInput = {
  confirmationModalities?: InputMaybe<ConfirmationMoldalitiesInput>
  expirationTime: DurationInput
  id: Scalars['ID']['input']
  prefix?: InputMaybe<Scalars['String']['input']>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  value: Scalars['Int']['input']
}

export type ShipOrderInput = {
  id: Scalars['ID']['input']
}

/** site */
export type Site = {
  __typename?: 'Site'
  /** address */
  address?: Maybe<Address>
  /** company this site belongs to */
  company: SiteCompany
  /** site id */
  id: Scalars['ID']['output']
  /** indicates wether the site is active or not */
  isActive: Scalars['Boolean']['output']
  /** site name */
  name: Scalars['String']['output']
  /** site's settings */
  settings: SiteSettings
  /** site type */
  type: SiteType
  /** users assigned to this site */
  users: Array<SiteUser>
}

/** site autocomplete */
export type SiteAutocomplete = {
  __typename?: 'SiteAutocomplete'
  /** company ID */
  companyID: Scalars['ID']['output']
  /** site ID */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** site company */
export type SiteCompany = {
  __typename?: 'SiteCompany'
  /** company id */
  id: Scalars['ID']['output']
  /** company name */
  name: Scalars['String']['output']
}

/** companyu line */
export type SiteCompanyLine = {
  __typename?: 'SiteCompanyLine'
  /** company line id */
  id: Scalars['ID']['output']
  /** company line name */
  name: Scalars['String']['output']
}

export type SiteKreditsSettings = {
  __typename?: 'SiteKreditsSettings'
  canTopUp: Scalars['Boolean']['output']
}

/** a site's settings. */
export type SiteSettings = {
  __typename?: 'SiteSettings'
  /** defines if the ticket price can be modified by the user */
  canChangePrice: Scalars['Boolean']['output']
  /** defines if tickets can be reserved */
  canReserveTickets: Scalars['Boolean']['output']
  /** default origin place for this site. */
  defaultOrigin?: Maybe<DefaultOrigin>
  /** defines if a site can recive mixed payments */
  enableMixedPayments: Scalars['Boolean']['output']
  /** enabled company lines */
  enabledCompanyLines: Array<SiteCompanyLine>
  /** physical printer present in site. */
  hasPrinter: Scalars['Boolean']['output']
  /** defines if the site can see the transactions report */
  hideTransactionsReport: Scalars['Boolean']['output']
  /** defines if a site can top up kredits */
  kredits: SiteKreditsSettings
  /** passenger name required */
  passengerNameRequired: Scalars['Boolean']['output']
  /** payment methods allowed at shis site. */
  payment: Array<SiteSettingsPaymentMethod>
  /** minutes before departure to close sales. */
  saleClosingThreshold: Scalars['Int']['output']
  /** snacks settings */
  snacks: SiteSnacksSettings
}

export const SiteSettingsPaymentMethod = {
  Card: 'CARD',
  Cash: 'CASH'
} as const

export type SiteSettingsPaymentMethod = (typeof SiteSettingsPaymentMethod)[keyof typeof SiteSettingsPaymentMethod]
export type SiteSnacksSettings = {
  __typename?: 'SiteSnacksSettings'
  canSell: Scalars['Boolean']['output']
  showMinPrice: Scalars['Boolean']['output']
  tripRequired: Scalars['Boolean']['output']
}

export const SiteType = {
  Fixed: 'fixed',
  Mobile: 'mobile'
} as const

export type SiteType = (typeof SiteType)[keyof typeof SiteType]
/** site user */
export type SiteUser = {
  __typename?: 'SiteUser'
  /** user's first name */
  firstName: Scalars['String']['output']
  /** user id */
  id: Scalars['ID']['output']
  /** user's last name */
  lastName: Scalars['String']['output']
  /** user's username */
  username: Scalars['String']['output']
}

export type SitesAutocompleteInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type SitesDashboard = {
  __typename?: 'SitesDashboard'
  topAgents: Array<TopAgentDashboardData>
  topCompanies: Array<TopCompanyDashboardData>
  topServices: Array<TopServiceDasboardData>
  topSites: Array<TopSiteDashboardData>
  totalSales: TotalSalesDashboardData
}

export type SitesResponse = {
  __typename?: 'SitesResponse'
  items: Array<Site>
  total: Scalars['Int']['output']
}

export type SnackConstraintsInput = {
  limit: Scalars['Int']['input']
  minSale?: InputMaybe<Scalars['Int']['input']>
}

export type SortingV2 = {
  field: Scalars['String']['input']
  order: Scalars['Int']['input']
}

export const Source = {
  Android: 'android',
  Ios: 'ios',
  Mobileweb: 'mobileweb',
  Web: 'web'
} as const

export type Source = (typeof Source)[keyof typeof Source]
export type StartBookingTripChangeResponse = {
  __typename?: 'StartBookingTripChangeResponse'
  tripChangeID: Scalars['ID']['output']
}

export type StartMoveBookingTripChangeResponse = {
  __typename?: 'StartMoveBookingTripChangeResponse'
  tripChangeID: Scalars['ID']['output']
}

export type StatusChange = {
  __typename?: 'StatusChange'
  changedAt: Scalars['Time']['output']
  status: ChangeStatus
}

export type SubCampaign = {
  __typename?: 'SubCampaign'
  authorizer?: Maybe<Scalars['String']['output']>
  campaign: SubCampaignCampaign
  coupons: Array<Coupon>
  endsAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  name?: Maybe<Scalars['String']['output']>
  reason?: Maybe<Scalars['String']['output']>
  startsAt: Scalars['String']['output']
  trip?: Maybe<SubCampaignTrip>
}

export type SubCampaignCampaign = {
  __typename?: 'SubCampaignCampaign'
  area: CampaignArea
  company: SubCampaignCompany
  endsAt: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  startsAt: Scalars['String']['output']
  timezone: Scalars['String']['output']
  type: CampaignType
}

export type SubCampaignCompany = {
  __typename?: 'SubCampaignCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type SubCampaignTrip = {
  __typename?: 'SubCampaignTrip'
  destination: CampaignPlace
  id: Scalars['ID']['output']
  legSegments: Array<CampaignSegment>
  origin: CampaignPlace
}

export type Subcampaign = {
  __typename?: 'Subcampaign'
  campaignID: Scalars['ID']['output']
  coupons: Array<SubcampaignCoupon>
  id: Scalars['ID']['output']
  trip: SubcampaignTrip
}

export type SubcampaignBooking = {
  __typename?: 'SubcampaignBooking'
  buyer?: Maybe<Buyer>
  coupon?: Maybe<SubcampaignBookingCoupon>
  destination: SubcampaignPlace
  id: Scalars['ID']['output']
  origin: SubcampaignPlace
  passengersCount: Scalars['Int']['output']
  ticketsCount: Scalars['Int']['output']
}

export type SubcampaignBookingCoupon = {
  __typename?: 'SubcampaignBookingCoupon'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type SubcampaignCoupon = {
  __typename?: 'SubcampaignCoupon'
  emails: Array<Email>
  id: Scalars['ID']['output']
  originalBooking: SubcampaignBooking
  redeemedBooking?: Maybe<SubcampaignBooking>
  status: CouponStatus
  supportInteractions: Array<SubcampaignSupportInteraction>
}

export const SubcampaignCouponEmailStatus = {
  Blocked: 'BLOCKED',
  Bounce: 'BOUNCE',
  Deferred: 'DEFERRED',
  Delivered: 'DELIVERED',
  Dropped: 'DROPPED',
  Processed: 'PROCESSED',
  Sent: 'SENT'
} as const

export type SubcampaignCouponEmailStatus =
  (typeof SubcampaignCouponEmailStatus)[keyof typeof SubcampaignCouponEmailStatus]
export type SubcampaignInput = {
  id: Scalars['ID']['input']
}

export type SubcampaignPlace = {
  __typename?: 'SubcampaignPlace'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type SubcampaignRouteService = {
  __typename?: 'SubcampaignRouteService'
  code: Scalars['String']['output']
  id: Scalars['ID']['output']
}

export type SubcampaignSegment = {
  __typename?: 'SubcampaignSegment'
  destination: SubcampaignPlace
  id: Scalars['ID']['output']
  origin: SubcampaignPlace
}

export type SubcampaignSupportInteraction = {
  __typename?: 'SubcampaignSupportInteraction'
  bookingID: Scalars['ID']['output']
  callStatus?: Maybe<CallStatus>
  createdAt: Scalars['Time']['output']
  notes?: Maybe<Scalars['String']['output']>
  notificationChannel?: Maybe<NotificationChannel>
  user: InteractionUser
}

export type SubcampaignTrip = {
  __typename?: 'SubcampaignTrip'
  affectedLegSegments: Array<SubcampaignSegment>
  departureAt: Scalars['Time']['output']
  destination: SubcampaignPlace
  id: Scalars['ID']['output']
  origin: SubcampaignPlace
  routeService: SubcampaignRouteService
}

export type SubmitB2BContactFormInput = {
  company?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  name: Scalars['String']['input']
  passengersNumber: Scalars['Int']['input']
  phone: Scalars['String']['input']
}

export type SummaryEmail = {
  __typename?: 'SummaryEmail'
  /** the email address */
  address: Scalars['String']['output']
  /** the email id */
  id: Scalars['UUID']['output']
  /** partner */
  partner: SummaryEmailPartner
  /** reason */
  reason?: Maybe<Scalars['String']['output']>
  /** the email status */
  status: Scalars['String']['output']
  /** updated at */
  updatedAt: Scalars['Time']['output']
}

export type SummaryEmailPartner = {
  __typename?: 'SummaryEmailPartner'
  /** the partner id */
  id: Scalars['UUID']['output']
  /** the partner name */
  name: Scalars['String']['output']
}

/** supplier autocomplete */
export type SupplierAutocomplete = {
  __typename?: 'SupplierAutocomplete'
  /** name */
  name: Scalars['String']['output']
}

export type SuppliersAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
}

export type SupportInteraction = {
  __typename?: 'SupportInteraction'
  callStatus?: Maybe<CallStatus>
  createdAt: Scalars['Time']['output']
  notes?: Maybe<Scalars['String']['output']>
  notificationChannel?: Maybe<NotificationChannel>
  user: InteractionUser
}

export type TCitiesAutocompleteInput = {
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type TCitiesAutocompleteResponse = {
  __typename?: 'TCitiesAutocompleteResponse'
  items: Array<TCityAutocomplete>
  total: Scalars['Int']['output']
}

export type TCitiesInput = {
  code?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
}

export type TCitiesResponse = {
  __typename?: 'TCitiesResponse'
  items: Array<TCity>
  total: Scalars['Int']['output']
}

export type TCity = {
  __typename?: 'TCity'
  code: Scalars['String']['output']
  countryCode?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Time']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  param: Scalars['String']['output']
  places: Array<TPlace>
  stateCode?: Maybe<Scalars['String']['output']>
  tags: Array<Scalars['String']['output']>
  timezone: Scalars['String']['output']
  updatedAt: Scalars['Time']['output']
}

export type TCityAutocomplete = {
  __typename?: 'TCityAutocomplete'
  countryCode?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  stateCode: Scalars['String']['output']
}

export type TCityInput = {
  code?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  param?: InputMaybe<Scalars['String']['input']>
}

export type TDriver = {
  __typename?: 'TDriver'
  createdAt: Scalars['Time']['output']
  documents: Array<TDriverDocument>
  id: Scalars['UUID']['output']
  isAssigned: Scalars['Boolean']['output']
  isEnabled: Scalars['Boolean']['output']
  partner: TDriverPartner
  rating: Scalars['Float']['output']
  stateCode?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['Time']['output']
  userAccount: TDriverUserAccount
  vehicles: Array<TDriverVehicle>
}

export type TDriverAutocomplete = {
  __typename?: 'TDriverAutocomplete'
  id: Scalars['UUID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type TDriverDocument = {
  __typename?: 'TDriverDocument'
  category: TDriverDocumentCategory
  document: Asset
}

export const TDriverDocumentCategory = {
  Application: 'APPLICATION',
  BirthCertificate: 'BIRTH_CERTIFICATE',
  Curp: 'CURP',
  Id: 'ID',
  Licence: 'LICENCE',
  Photo: 'PHOTO',
  ProofOfAddress: 'PROOF_OF_ADDRESS',
  ProofOfLastStudy: 'PROOF_OF_LAST_STUDY'
} as const

export type TDriverDocumentCategory = (typeof TDriverDocumentCategory)[keyof typeof TDriverDocumentCategory]
export type TDriverInput = {
  email?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
}

export type TDriverPartner = {
  __typename?: 'TDriverPartner'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TDriverUserAccount = {
  __typename?: 'TDriverUserAccount'
  devices?: Maybe<Array<Maybe<DriverDevice>>>
  email?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  gender?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  lastName?: Maybe<Scalars['String']['output']>
  /** @deprecated Use firstName and lastName instead */
  name?: Maybe<Scalars['String']['output']>
  /** @deprecated Use phoneNumber instead */
  phone?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<PhoneNumber>
}

export type TDriverVehicle = {
  __typename?: 'TDriverVehicle'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TDriversAutocompleteInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  partnerID?: InputMaybe<Scalars['UUID']['input']>
}

export type TDriversAutocompleteResponse = {
  __typename?: 'TDriversAutocompleteResponse'
  items: Array<TDriverAutocomplete>
  total: Scalars['Int']['output']
}

export type TDriversInput = {
  email?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  partnerID?: InputMaybe<Scalars['UUID']['input']>
}

export type TDriversResponse = {
  __typename?: 'TDriversResponse'
  items: Array<TDriver>
  total: Scalars['Int']['output']
}

export type TPagination = {
  page: Scalars['Int']['input']
  size: Scalars['Int']['input']
}

export type TPlace = {
  __typename?: 'TPlace'
  address?: Maybe<TPlaceAddress>
  amenities: Array<TPlaceAmenity>
  area?: Maybe<Scalars['String']['output']>
  businessClient?: Maybe<TPlaceBusinessClient>
  businessCustomer?: Maybe<TPlaceBusinessCustomer>
  businessSite?: Maybe<TPlaceBusinessSite>
  code: Scalars['String']['output']
  company?: Maybe<TPlaceCompany>
  coordinates: TPlaceCoordinates
  countryCode?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['Time']['output']
  directions?: Maybe<Scalars['String']['output']>
  geofenceRadius?: Maybe<Scalars['Int']['output']>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  param: Scalars['String']['output']
  parent: TCity
  photo?: Maybe<Asset>
  stateCode?: Maybe<Scalars['String']['output']>
  tags: Array<Scalars['String']['output']>
  timezone: Scalars['String']['output']
  type: TPlaceType
  updatedAt: Scalars['Time']['output']
}

export type TPlaceAddress = {
  __typename?: 'TPlaceAddress'
  cityName: Scalars['String']['output']
  countryCode: Scalars['String']['output']
  line1: Scalars['String']['output']
  line2?: Maybe<Scalars['String']['output']>
  stateCode: Scalars['String']['output']
  zipCode: Scalars['String']['output']
}

export const TPlaceAmenity = {
  KolorsMobile: 'KOLORS_MOBILE',
  KolorsTicket: 'KOLORS_TICKET'
} as const

export type TPlaceAmenity = (typeof TPlaceAmenity)[keyof typeof TPlaceAmenity]
export type TPlaceAutocomplete = {
  __typename?: 'TPlaceAutocomplete'
  coordinates: TPlaceCoordinates
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  stateCode: Scalars['String']['output']
}

export type TPlaceBusinessClient = {
  __typename?: 'TPlaceBusinessClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TPlaceBusinessCustomer = {
  __typename?: 'TPlaceBusinessCustomer'
  id: Scalars['UUID']['output']
}

export type TPlaceBusinessSite = {
  __typename?: 'TPlaceBusinessSite'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TPlaceCompany = {
  __typename?: 'TPlaceCompany'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  vertical: TPlaceVertical
}

export type TPlaceCoordinates = {
  __typename?: 'TPlaceCoordinates'
  latitude: Scalars['String']['output']
  longitude: Scalars['String']['output']
}

export type TPlaceInput = {
  code?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  param?: InputMaybe<Scalars['String']['input']>
}

export type TPlaceSuggestionsInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  includeWithNoSites?: InputMaybe<Scalars['Boolean']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
  vertical?: InputMaybe<Scalars['String']['input']>
}

export type TPlaceSuggestionsResponse = {
  __typename?: 'TPlaceSuggestionsResponse'
  items: Array<PlaceSuggestion>
  total: Scalars['Long']['output']
}

export const TPlaceType = {
  Attraction: 'ATTRACTION',
  ConvenienceStore: 'CONVENIENCE_STORE',
  Hotel: 'HOTEL',
  Mall: 'MALL',
  Office: 'OFFICE',
  ParkingLot: 'PARKING_LOT',
  PointOfInterest: 'POINT_OF_INTEREST',
  ResidentialArea: 'RESIDENTIAL_AREA',
  Restaurant: 'RESTAURANT',
  School: 'SCHOOL',
  Sidewalk: 'SIDEWALK',
  Station: 'STATION',
  Supermarket: 'SUPERMARKET',
  Venue: 'VENUE'
} as const

export type TPlaceType = (typeof TPlaceType)[keyof typeof TPlaceType]
export const TPlaceVertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type TPlaceVertical = (typeof TPlaceVertical)[keyof typeof TPlaceVertical]
export type TPlacesAutocompleteInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  companyID?: InputMaybe<Scalars['UUID']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
  vertical?: InputMaybe<TPlaceVertical>
}

export type TPlacesAutocompleteResponse = {
  __typename?: 'TPlacesAutocompleteResponse'
  items: Array<TPlaceAutocomplete>
  total: Scalars['Int']['output']
}

export type TPlacesInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  cityID?: InputMaybe<Scalars['UUID']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  vertical?: InputMaybe<TPlaceVertical>
}

export type TPlacesResponse = {
  __typename?: 'TPlacesResponse'
  items: Array<TPlace>
  total: Scalars['Int']['output']
}

export type TRoute = {
  __typename?: 'TRoute'
  businessClient?: Maybe<TRouteBusinessClient>
  businessSite?: Maybe<TRouteBusinessSite>
  company: TRouteCompany
  companyLines: Array<TRouteCompanyLine>
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  name?: Maybe<Scalars['String']['output']>
  polyline?: Maybe<TRoutePolyline>
  segments: Array<TRouteSegment>
  services: Array<TRouteRouteService>
  stops: Array<TRouteStop>
}

export type TRouteAutocomplete = {
  __typename?: 'TRouteAutocomplete'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TRouteBusinessClient = {
  __typename?: 'TRouteBusinessClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TRouteBusinessSite = {
  __typename?: 'TRouteBusinessSite'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TRouteCompany = {
  __typename?: 'TRouteCompany'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  vertical: TRouteVertical
}

export type TRouteCompanyLine = {
  __typename?: 'TRouteCompanyLine'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TRouteCompanyLineSpec = {
  __typename?: 'TRouteCompanyLineSpec'
  distance?: Maybe<Scalars['Int']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  id: Scalars['UUID']['output']
}

export type TRouteInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  stopIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
}

export type TRoutePlace = {
  __typename?: 'TRoutePlace'
  id: Scalars['UUID']['output']
  timezone: Scalars['String']['output']
}

export type TRoutePolyline = {
  __typename?: 'TRoutePolyline'
  distance: Scalars['Int']['output']
  encoded: Scalars['String']['output']
}

export type TRouteRouteService = {
  __typename?: 'TRouteRouteService'
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
}

export type TRouteSegment = {
  __typename?: 'TRouteSegment'
  companyLineSpecs: Array<TRouteCompanyLineSpec>
  destination: TRoutePlace
  id: Scalars['UUID']['output']
  origin: TRoutePlace
}

export type TRouteStop = {
  __typename?: 'TRouteStop'
  address?: Maybe<RouteStopAddress>
  code: Scalars['String']['output']
  coordinates?: Maybe<RouteStopCoordinates>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  timezone: Scalars['String']['output']
}

export const TRouteVertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type TRouteVertical = (typeof TRouteVertical)[keyof typeof TRouteVertical]
export type TRoutesAutocompleteInput = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type TRoutesAutocompleteResponse = {
  __typename?: 'TRoutesAutocompleteResponse'
  items: Array<TRouteAutocomplete>
  total: Scalars['Int']['output']
}

export type TRoutesInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  companyID?: InputMaybe<Scalars['UUID']['input']>
  destinationID?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  offerDateRange?: InputMaybe<DateRangeInput>
  originID?: InputMaybe<Scalars['UUID']['input']>
  routeServiceCode?: InputMaybe<Scalars['String']['input']>
}

export type TRoutesResponse = {
  __typename?: 'TRoutesResponse'
  items: Array<TRoute>
  total: Scalars['Int']['output']
}

export type TSorting = {
  field: Scalars['String']['input']
  order: Scalars['Int']['input']
}

export type TVehicle = {
  __typename?: 'TVehicle'
  cards: TVehicleCards
  cityName?: Maybe<Scalars['String']['output']>
  clients: Array<TVehicleClient>
  companies: Array<TVehicleCompany>
  createdAt: Scalars['Time']['output']
  documents: Array<TVehicleDocument>
  drivers: Array<TVehicleDriver>
  externalID?: Maybe<Scalars['String']['output']>
  features?: Maybe<TVehicleFeatures>
  id: Scalars['UUID']['output']
  inactiveReason?: Maybe<Scalars['String']['output']>
  insurancePolicy?: Maybe<TVehicleInsurancePolicy>
  /** @deprecated Use status instead */
  isActive?: Maybe<Scalars['Boolean']['output']>
  isAssigned: Scalars['Boolean']['output']
  /** @deprecated Use isActive instead */
  isEnabled?: Maybe<Scalars['Boolean']['output']>
  licensePlates?: Maybe<Array<TVehicleLicensePlate>>
  name: Scalars['String']['output']
  odometerReading?: Maybe<Scalars['Int']['output']>
  partner: TVehiclePartner
  registrationDetails?: Maybe<TVehicleRegistrationDetails>
  routeServices: Array<TVehicleRouteService>
  stateCode?: Maybe<Scalars['String']['output']>
  status: VehicleStatus
  template: TVehicleTemplate
  updatedAt: Scalars['Time']['output']
  vin: Scalars['String']['output']
}

export type TVehicleAutocomplete = {
  __typename?: 'TVehicleAutocomplete'
  capacity: Scalars['Int']['output']
  externalID?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TVehicleCards = {
  __typename?: 'TVehicleCards'
  /** @deprecated Use fuelCards instead */
  fuel?: Maybe<Scalars['String']['output']>
  fuelCards?: Maybe<Array<Scalars['String']['output']>>
  /** @deprecated Use tagCards instead */
  tag?: Maybe<Scalars['String']['output']>
  tagCards?: Maybe<Array<Scalars['String']['output']>>
}

export type TVehicleClient = {
  __typename?: 'TVehicleClient'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TVehicleCompany = {
  __typename?: 'TVehicleCompany'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TVehicleDocument = {
  __typename?: 'TVehicleDocument'
  category: TVehicleDocumentCategory
  document: Asset
}

export const TVehicleDocumentCategory = {
  Bills: 'BILLS',
  ExternalInspection: 'EXTERNAL_INSPECTION',
  InternalInspection: 'INTERNAL_INSPECTION',
  Photo: 'PHOTO',
  TuningService: 'TUNING_SERVICE',
  VerificationCertificate: 'VERIFICATION_CERTIFICATE'
} as const

export type TVehicleDocumentCategory = (typeof TVehicleDocumentCategory)[keyof typeof TVehicleDocumentCategory]
export type TVehicleDriver = {
  __typename?: 'TVehicleDriver'
  id: Scalars['UUID']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type TVehicleFeatures = {
  __typename?: 'TVehicleFeatures'
  amenities: Array<Scalars['String']['output']>
  brandCoverage?: Maybe<Scalars['String']['output']>
  make?: Maybe<Scalars['String']['output']>
  model?: Maybe<Scalars['String']['output']>
  year?: Maybe<Scalars['Int']['output']>
}

export type TVehicleInput = {
  id?: InputMaybe<Scalars['UUID']['input']>
  vin?: InputMaybe<Scalars['String']['input']>
}

export type TVehicleInsurancePolicy = {
  __typename?: 'TVehicleInsurancePolicy'
  document: Asset
  expirationDate: Scalars['Date']['output']
}

export type TVehicleLicensePlate = {
  __typename?: 'TVehicleLicensePlate'
  number: Scalars['String']['output']
  stateCode?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type TVehiclePartner = {
  __typename?: 'TVehiclePartner'
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
}

export const TVehicleRegistrationCategory = {
  Federal: 'FEDERAL',
  Local: 'LOCAL'
} as const

export type TVehicleRegistrationCategory =
  (typeof TVehicleRegistrationCategory)[keyof typeof TVehicleRegistrationCategory]
export type TVehicleRegistrationDetails = {
  __typename?: 'TVehicleRegistrationDetails'
  category: TVehicleRegistrationCategory
  document?: Maybe<Asset>
  expirationDate?: Maybe<Scalars['Date']['output']>
  isPermanent: Scalars['Boolean']['output']
  stateCode?: Maybe<Scalars['String']['output']>
  /** @deprecated type would be removed in the future */
  type?: Maybe<TVehicleRegistrationType>
}

export const TVehicleRegistrationType = {
  A: 'A',
  A1: 'A1',
  A2: 'A2',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  E1: 'E1'
} as const

export type TVehicleRegistrationType = (typeof TVehicleRegistrationType)[keyof typeof TVehicleRegistrationType]
export const TVehicleRegistrationTypeInput = {
  A: 'A',
  A1: 'A1',
  A2: 'A2',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  E1: 'E1'
} as const

export type TVehicleRegistrationTypeInput =
  (typeof TVehicleRegistrationTypeInput)[keyof typeof TVehicleRegistrationTypeInput]
export type TVehicleRouteService = {
  __typename?: 'TVehicleRouteService'
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
}

export type TVehicleTemplate = {
  __typename?: 'TVehicleTemplate'
  capacity: Scalars['Int']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  type: TVehicleTemplateType
}

export const TVehicleTemplateType = {
  Bus: 'BUS',
  Car: 'CAR',
  Sedan: 'SEDAN',
  Suv: 'SUV',
  Van: 'VAN'
} as const

export type TVehicleTemplateType = (typeof TVehicleTemplateType)[keyof typeof TVehicleTemplateType]
export const TVehicleTemplateTypeInput = {
  Bus: 'BUS',
  Car: 'CAR',
  Sedan: 'SEDAN',
  Suv: 'SUV',
  Van: 'VAN'
} as const

export type TVehicleTemplateTypeInput = (typeof TVehicleTemplateTypeInput)[keyof typeof TVehicleTemplateTypeInput]
export type TVehiclesAutocompleteInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  partnerID?: InputMaybe<Scalars['UUID']['input']>
}

export type TVehiclesAutocompleteResponse = {
  __typename?: 'TVehiclesAutocompleteResponse'
  items: Array<TVehicleAutocomplete>
  total: Scalars['Int']['output']
}

export type TVehiclesInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  driverID?: InputMaybe<Scalars['UUID']['input']>
  externalID?: InputMaybe<Scalars['String']['input']>
  hasDriver?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>
  make?: InputMaybe<Scalars['String']['input']>
  partnerID?: InputMaybe<Scalars['UUID']['input']>
  plateType?: InputMaybe<Scalars['String']['input']>
  plates?: InputMaybe<Scalars['String']['input']>
  registrationType?: InputMaybe<TVehicleRegistrationTypeInput>
  stateCode?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<TVehicleTemplateTypeInput>
  vin?: InputMaybe<Scalars['String']['input']>
}

export type TVehiclesResponse = {
  __typename?: 'TVehiclesResponse'
  items: Array<TVehicle>
  total: Scalars['Int']['output']
}

export const TemplateName = {
  MobilePlan: 'mobilePlan',
  Sim: 'sim'
} as const

export type TemplateName = (typeof TemplateName)[keyof typeof TemplateName]
export type TicketInsurance = {
  __typename?: 'TicketInsurance'
  bookingID: Scalars['ID']['output']
  hasConflict?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['ID']['output']
  insurance: Insurance
  passenger: BookingPassenger
  trip: TicketInsuranceTrip
}

export type TicketInsuranceResponse = {
  __typename?: 'TicketInsuranceResponse'
  items: Array<TicketInsurance>
  total: Scalars['Int']['output']
}

export type TicketInsuranceTrip = {
  __typename?: 'TicketInsuranceTrip'
  id: Scalars['ID']['output']
  segment: TicketInsuranceTripSegment
}

export type TicketInsuranceTripSegment = {
  __typename?: 'TicketInsuranceTripSegment'
  departureAt: Scalars['Time']['output']
  destination: BookingTripPlace
  id: Scalars['ID']['output']
  origin: BookingTripPlace
}

/** ticket payment */
export type TicketPayment = {
  __typename?: 'TicketPayment'
  /** discount */
  discount: Scalars['Int']['output']
  /** status */
  status: Scalars['String']['output']
  /** subtotal */
  subtotal: Scalars['Int']['output']
  /** VAT */
  vat: Scalars['Int']['output']
}

/** ticket status */
export const TicketStatus = {
  Cancelled: 'cancelled',
  Confirmed: 'confirmed',
  Pending: 'pending',
  Reserved: 'reserved'
} as const

export type TicketStatus = (typeof TicketStatus)[keyof typeof TicketStatus]
export type TicketsByStatus = {
  __typename?: 'TicketsByStatus'
  cancelled: Scalars['Int']['output']
  confirmed: Scalars['Int']['output']
}

export type TimelineEventUser = {
  __typename?: 'TimelineEventUser'
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type TimesRangeInput = {
  from?: InputMaybe<Scalars['Time']['input']>
  to?: InputMaybe<Scalars['Time']['input']>
}

/** toggle item response */
export type ToggleItemResponse = {
  __typename?: 'ToggleItemResponse'
  /** item id */
  id: Scalars['ID']['output']
  /** indicates whether the item is active or not */
  isActive: Scalars['Boolean']['output']
}

/** toggle route service response */
export type ToggleServiceResponse = {
  __typename?: 'ToggleServiceResponse'
  /** route service id */
  id: Scalars['ID']['output']
  /** indicates whether the route service is active or not */
  isActive: Scalars['Boolean']['output']
}

/** toggle site response */
export type ToggleSiteResponse = {
  __typename?: 'ToggleSiteResponse'
  /** site id */
  id: Scalars['ID']['output']
  /** indicates wether the site is active or not */
  isActive: Scalars['Boolean']['output']
}

/** toggle user response */
export type ToggleUserResponse = {
  __typename?: 'ToggleUserResponse'
  /** user id */
  id: Scalars['ID']['output']
  /** indicates whether the user is active or not */
  isActive: Scalars['Boolean']['output']
}

export type TopAgentDashboardData = {
  __typename?: 'TopAgentDashboardData'
  amount: Scalars['Int']['output']
  company: Scalars['String']['output']
  count: Scalars['Int']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
}

export type TopCompanyDashboardData = {
  __typename?: 'TopCompanyDashboardData'
  amount: Scalars['Int']['output']
  count: Scalars['Int']['output']
  name: Scalars['String']['output']
}

export type TopServiceDasboardData = {
  __typename?: 'TopServiceDasboardData'
  amount: Scalars['Int']['output']
  code: Scalars['String']['output']
  company: Scalars['String']['output']
  count: Scalars['Int']['output']
  destination: Scalars['String']['output']
  origin: Scalars['String']['output']
}

export type TopSiteDashboardData = {
  __typename?: 'TopSiteDashboardData'
  amount: Scalars['Int']['output']
  company: Scalars['String']['output']
  count: Scalars['Int']['output']
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type TotalSalesDashboardData = {
  __typename?: 'TotalSalesDashboardData'
  card: SalesDashboardDataInfo
  cash: SalesDashboardDataInfo
  total: SalesDashboardDataInfo
}

/**
 * The TransactionSource type represents the source and it's specific details.
 * it could only be one of the following: booking, sale (topUp), MobileLine
 */
export type TransactionSource =
  | TransactionSourceAdmin
  | TransactionSourceBooking
  | TransactionSourceCorporate
  | TransactionSourceMobileLine
  | TransactionSourceRefund
  | TransactionSourceSale

export type TransactionSourceAdmin = {
  __typename?: 'TransactionSourceAdmin'
  userID?: Maybe<Scalars['UUID']['output']>
}

export type TransactionSourceBooking = {
  __typename?: 'TransactionSourceBooking'
  bookingID: Scalars['ID']['output']
}

export type TransactionSourceCorporate = {
  __typename?: 'TransactionSourceCorporate'
  dispersionID?: Maybe<Scalars['UUID']['output']>
  userID?: Maybe<Scalars['UUID']['output']>
}

export type TransactionSourceMobileLine = {
  __typename?: 'TransactionSourceMobileLine'
  number: Scalars['String']['output']
}

export type TransactionSourceRefund = {
  __typename?: 'TransactionSourceRefund'
  refundedTransactionID: Scalars['ID']['output']
}

export type TransactionSourceSale = {
  __typename?: 'TransactionSourceSale'
  salesChannelID: Scalars['ID']['output']
}

/** trip */
export type Trip = {
  __typename?: 'Trip'
  /** arrival time */
  arrivalAt: Scalars['Time']['output']
  /** company line */
  companyLine: TripCompanyLine
  /** number of confirmed seats */
  confirmedSeats: Scalars['Int']['output']
  /** crew users */
  crewUsers: Array<TripUser>
  /** departure time */
  departureAt: Scalars['Time']['output']
  /** vehicle driver, outside of vehicle object to avoid caching issues */
  driver?: Maybe<TripVehicleDriver>
  /** trip id */
  id: Scalars['ID']['output']
  /** itinerary */
  itinerary: Array<TripItineraryStop>
  /** leg segments */
  legSegments: Array<TripLegSegment>
  /** notes */
  notes?: Maybe<Array<TripNote>>
  /** route */
  route: TripRoute
  /** route service */
  routeService: TripRouteService
  /** sale status */
  saleStatus: TripSaleStatus
  /** number of seats */
  seats: Scalars['Int']['output']
  /** service score */
  serviceScore?: Maybe<Scalars['Int']['output']>
  /** status */
  status: TripStatus
  /** timeline events */
  timeline: Array<TripTimelineEvent>
  /** vehicle */
  vehicle?: Maybe<TripVehicle>
}

export type TripBookings = {
  __typename?: 'TripBookings'
  arrivalAt: Scalars['Time']['output']
  departureAt: Scalars['Time']['output']
  destination: TripBookingsPlace
  id: Scalars['UUID']['output']
  itinerary: Array<TripBookingsStop>
  origin: TripBookingsPlace
  routeServiceCode: Scalars['String']['output']
}

export type TripBookingsPlace = {
  __typename?: 'TripBookingsPlace'
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  timezone: Scalars['String']['output']
}

export type TripBookingsQueryInput = {
  id: Scalars['UUID']['input']
}

export type TripBookingsStop = {
  __typename?: 'TripBookingsStop'
  bookings: Array<TripStopBooking>
  departureAt?: Maybe<Scalars['Time']['output']>
  destination: TripBookingsPlace
  origin: TripBookingsPlace
  passengers: TripStopPassengers
}

/** company line */
export type TripCompanyLine = {
  __typename?: 'TripCompanyLine'
  /** company */
  company: TripCompanyLineCompany
  /** company line id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** company */
export type TripCompanyLineCompany = {
  __typename?: 'TripCompanyLineCompany'
  id: Scalars['ID']['output']
}

export const TripDriverRsvpNoteStatus = {
  Confirmed: 'CONFIRMED',
  Declined: 'DECLINED'
} as const

export type TripDriverRsvpNoteStatus = (typeof TripDriverRsvpNoteStatus)[keyof typeof TripDriverRsvpNoteStatus]
/** itinerary stop */
export type TripItineraryStop = {
  __typename?: 'TripItineraryStop'
  /** arrival time */
  arrival?: Maybe<TripItineraryStopTime>
  /** departure time */
  departure?: Maybe<TripItineraryStopTime>
  /** place */
  place: TripItineraryStopPlace
  /** real departure time */
  realDepartureTime?: Maybe<Scalars['Time']['output']>
}

/** place */
export type TripItineraryStopPlace = {
  __typename?: 'TripItineraryStopPlace'
  /** place id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** timezone */
  timezone: Scalars['String']['output']
}

/** change trip itinerary departure time itinerary time */
export type TripItineraryStopTime = {
  __typename?: 'TripItineraryStopTime'
  /** an integer representing how many days after departure the stop takes place. ex. 0 = same day, 1 = next day */
  day: Scalars['Int']['output']
  /** time in hh:mm format, in the timezone of the place */
  time: Scalars['String']['output']
}

export type TripLegSegment = {
  __typename?: 'TripLegSegment'
  destination: TripLegSegmentPlace
  id: Scalars['ID']['output']
  origin: TripLegSegmentPlace
}

export type TripLegSegmentPlace = {
  __typename?: 'TripLegSegmentPlace'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

/** trip note */
export type TripNote = {
  __typename?: 'TripNote'
  /** cash flow */
  cashFlow?: Maybe<CashFlow>
  /** note category */
  category: Scalars['String']['output']
  /** created at */
  createdAt: Scalars['Time']['output']
  /** attached files */
  files?: Maybe<Array<NoteFile>>
  /** message */
  message: Scalars['String']['output']
}

export const TripNoteCategoryInput = {
  Ambassador: 'AMBASSADOR',
  Cash: 'CASH',
  Driver: 'DRIVER',
  Events: 'EVENTS',
  Odometer: 'ODOMETER',
  Passengers: 'PASSENGERS',
  Service: 'SERVICE',
  Tolls: 'TOLLS',
  Vehicle: 'VEHICLE'
} as const

export type TripNoteCategoryInput = (typeof TripNoteCategoryInput)[keyof typeof TripNoteCategoryInput]
export type TripNoteDriver = {
  __typename?: 'TripNoteDriver'
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
  rsvpStatus: TripNoteDriverRsvpStatus
}

export const TripNoteDriverRsvpStatus = {
  Confirmed: 'CONFIRMED',
  Declined: 'DECLINED'
} as const

export type TripNoteDriverRsvpStatus = (typeof TripNoteDriverRsvpStatus)[keyof typeof TripNoteDriverRsvpStatus]
/** route */
export type TripRoute = {
  __typename?: 'TripRoute'
  /** route id */
  id: Scalars['ID']['output']
  /** route name */
  name?: Maybe<Scalars['String']['output']>
}

export type TripRoutePolyline = {
  __typename?: 'TripRoutePolyline'
  distance: Scalars['Int']['output']
  encoded: Scalars['String']['output']
}

/** route service */
export type TripRouteService = {
  __typename?: 'TripRouteService'
  /** business clients */
  businessClients: Array<TripRouteServiceBusinessClient>
  /** route service code */
  code: Scalars['String']['output']
  /** route service id */
  id: Scalars['ID']['output']
}

export type TripRouteServiceBusinessClient = {
  __typename?: 'TripRouteServiceBusinessClient'
  /** business sites */
  businessSites: Array<TripRouteServiceBusinessSite>
  /** business client id */
  id: Scalars['ID']['output']
  /** business client name */
  name: Scalars['String']['output']
}

export type TripRouteServiceBusinessSite = {
  __typename?: 'TripRouteServiceBusinessSite'
  /** business site id */
  id: Scalars['ID']['output']
  /** business site name */
  name: Scalars['String']['output']
}

/** sale status */
export const TripSaleStatus = {
  Activated: 'activated',
  Deactivated: 'deactivated'
} as const

export type TripSaleStatus = (typeof TripSaleStatus)[keyof typeof TripSaleStatus]
export type TripSegment = {
  __typename?: 'TripSegment'
  availableSeatsNumber: Scalars['Int']['output']
  basePrice: Scalars['Int']['output']
  duration: Scalars['Int']['output']
  hasSelectableSeats: Scalars['Boolean']['output']
  id: Scalars['ID']['output']
  itinerary: Array<TripSegmentItineraryStop>
  segment: TripSegmentSegment
  tripID: Scalars['ID']['output']
}

export type TripSegmentFare = {
  __typename?: 'TripSegmentFare'
  discountRate: Scalars['Float']['output']
  passengerType: PassengerType
  subtotal: Scalars['Int']['output']
  vat: Scalars['Int']['output']
}

export type TripSegmentItineraryStop = {
  __typename?: 'TripSegmentItineraryStop'
  arrivalTime?: Maybe<Scalars['String']['output']>
  day: Scalars['Int']['output']
  departureTime?: Maybe<Scalars['String']['output']>
  place: TripItineraryStopPlace
}

export type TripSegmentSegment = {
  __typename?: 'TripSegmentSegment'
  destination: TripSegmentSegmentPlace
  id: Scalars['ID']['output']
  origin: TripSegmentSegmentPlace
}

export type TripSegmentSegmentPlace = {
  __typename?: 'TripSegmentSegmentPlace'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export const TripSegmentVerticalInput = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type TripSegmentVerticalInput = (typeof TripSegmentVerticalInput)[keyof typeof TripSegmentVerticalInput]
export type TripSegmentsPassengerTypeInput = {
  id: Scalars['ID']['input']
  quantity: Scalars['Int']['input']
}

/** trip status */
export const TripStatus = {
  Cancelled: 'cancelled',
  Completed: 'completed',
  Deactivated: 'deactivated',
  Delayed: 'delayed',
  InTransit: 'inTransit',
  OnTime: 'onTime'
} as const

export type TripStatus = (typeof TripStatus)[keyof typeof TripStatus]
export type TripStopBooking = {
  __typename?: 'TripStopBooking'
  buyer?: Maybe<TripStopBookingBuyer>
  checkInScore?: Maybe<Scalars['Float']['output']>
  destinationName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  status: Scalars['String']['output']
  supportInteractions: Array<TripStopBookingSupportInteraction>
  tickets: Array<TripStopBookingTicket>
  vertical: Scalars['String']['output']
}

export type TripStopBookingBuyer = {
  __typename?: 'TripStopBookingBuyer'
  email: Scalars['String']['output']
  firstName: Scalars['String']['output']
  lastName: Scalars['String']['output']
  phone: Scalars['String']['output']
}

export type TripStopBookingSupportInteraction = {
  __typename?: 'TripStopBookingSupportInteraction'
  callStatus?: Maybe<CallStatus>
  createdAt: Scalars['Time']['output']
  notes?: Maybe<Scalars['String']['output']>
  notificationChannel?: Maybe<NotificationChannel>
}

export type TripStopBookingTicket = {
  __typename?: 'TripStopBookingTicket'
  checkedIn: Scalars['Boolean']['output']
  couponCode: Scalars['String']['output']
  id: Scalars['UUID']['output']
  passenger: TripStopBookingTicketPassenger
  payment?: Maybe<TripStopBookingTicketPayment>
  seat: TripStopBookingTicketSeat
  status: Scalars['String']['output']
}

export type TripStopBookingTicketPassenger = {
  __typename?: 'TripStopBookingTicketPassenger'
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  lastName?: Maybe<Scalars['String']['output']>
}

export type TripStopBookingTicketPayment = {
  __typename?: 'TripStopBookingTicketPayment'
  discount: Scalars['Int']['output']
  status: PaymentStatus
  subtotal: Scalars['Int']['output']
  vat: Scalars['Int']['output']
}

export type TripStopBookingTicketSeat = {
  __typename?: 'TripStopBookingTicketSeat'
  label: Scalars['String']['output']
}

export type TripStopPassengers = {
  __typename?: 'TripStopPassengers'
  /** passengers that descend at this stop. */
  down: Scalars['Int']['output']
  /** total passengers at this stop after boarding and descending */
  total: Scalars['Int']['output']
  /** passengers that board at this stop. */
  up: Scalars['Int']['output']
}

/** trip timeline event */
export type TripTimelineEvent = {
  __typename?: 'TripTimelineEvent'
  /** correlation id */
  correlationID: Scalars['String']['output']
  /** timestamp */
  createdAt: Scalars['Time']['output']
  /** placeID (could be null) */
  placeID?: Maybe<Scalars['ID']['output']>
  /** type */
  type: Scalars['String']['output']
  /** user */
  user: TripUser
}

export type TripTrackingQueryInput = {
  id: Scalars['UUID']['input']
}

export type TripTrackingRecord = {
  __typename?: 'TripTrackingRecord'
  fixTime: Scalars['Time']['output']
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  speed: Scalars['Float']['output']
}

export type TripTrackingResponse = {
  __typename?: 'TripTrackingResponse'
  records: Array<TripTrackingRecord>
  total: Scalars['Int']['output']
}

/** Crew User */
export type TripUser = {
  __typename?: 'TripUser'
  firstName: Scalars['String']['output']
  id: Scalars['ID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type TripV2 = {
  __typename?: 'TripV2'
  arrivalAt: Scalars['Time']['output']
  availableSeatsNumber: Scalars['Int']['output']
  company: TripV2Company
  companyLine: TripV2CompanyLine
  confirmationModalities: Array<TripV2ConfirmationModality>
  confirmedSeatsNumber: Scalars['Int']['output']
  createdAt: Scalars['Time']['output']
  crewUsers: Array<TripV2User>
  departureAt: Scalars['Time']['output']
  driver?: Maybe<TripV2Driver>
  id: Scalars['UUID']['output']
  isOnGuard: Scalars['Boolean']['output']
  isPeak: Scalars['Boolean']['output']
  itinerary: Array<TripV2ItineraryStop>
  legSegments: Array<TripV2LegSegment>
  notes?: Maybe<Array<TripV2Note>>
  route: TripV2Route
  routeService: TripV2RouteService
  saleStatus: TripV2SaleStatus
  serviceScore?: Maybe<Scalars['Int']['output']>
  status: TripV2Status
  timeline: Array<TripV2TimelineEvent>
  updatedAt: Scalars['Time']['output']
  vehicle?: Maybe<TripV2Vehicle>
  vertical: TripV2Vertical
}

export const TripV2CancellationReasonCategory = {
  BusinessClient: 'BUSINESS_CLIENT',
  Driver: 'DRIVER',
  ExternalConditions: 'EXTERNAL_CONDITIONS',
  Other: 'OTHER',
  Partner: 'PARTNER',
  Planning: 'PLANNING',
  Vehicle: 'VEHICLE'
} as const

export type TripV2CancellationReasonCategory =
  (typeof TripV2CancellationReasonCategory)[keyof typeof TripV2CancellationReasonCategory]
export const TripV2CancellationReasonSubcategory = {
  Absence: 'ABSENCE',
  Accident: 'ACCIDENT',
  Disability: 'DISABILITY',
  MechanicalFailure: 'MECHANICAL_FAILURE',
  Other: 'OTHER',
  Protest: 'PROTEST',
  Roadblock: 'ROADBLOCK',
  ScheduledMaintenance: 'SCHEDULED_MAINTENANCE',
  Security: 'SECURITY',
  Traffic: 'TRAFFIC',
  UnitStoppage: 'UNIT_STOPPAGE',
  Weather: 'WEATHER'
} as const

export type TripV2CancellationReasonSubcategory =
  (typeof TripV2CancellationReasonSubcategory)[keyof typeof TripV2CancellationReasonSubcategory]
export type TripV2Company = {
  __typename?: 'TripV2Company'
  id: Scalars['UUID']['output']
}

export type TripV2CompanyLine = {
  __typename?: 'TripV2CompanyLine'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TripV2ConfirmationModality = {
  __typename?: 'TripV2ConfirmationModality'
  exceptions: TripV2ConfirmationModalityExceptions
  name: TripV2ConfirmationModalityName
  salesChannels: Array<TripV2ConfirmationModalitySalesChannel>
}

export type TripV2ConfirmationModalityExceptions = {
  __typename?: 'TripV2ConfirmationModalityExceptions'
  places: Array<TripV2ConfirmationModalityExceptionsPlace>
}

export type TripV2ConfirmationModalityExceptionsPlace = {
  __typename?: 'TripV2ConfirmationModalityExceptionsPlace'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export const TripV2ConfirmationModalityName = {
  Paid: 'PAID',
  Reserved: 'RESERVED'
} as const

export type TripV2ConfirmationModalityName =
  (typeof TripV2ConfirmationModalityName)[keyof typeof TripV2ConfirmationModalityName]
export const TripV2ConfirmationModalityNameInput = {
  Paid: 'PAID',
  Reserved: 'RESERVED'
} as const

export type TripV2ConfirmationModalityNameInput =
  (typeof TripV2ConfirmationModalityNameInput)[keyof typeof TripV2ConfirmationModalityNameInput]
export type TripV2ConfirmationModalitySalesChannel = {
  __typename?: 'TripV2ConfirmationModalitySalesChannel'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TripV2Driver = {
  __typename?: 'TripV2Driver'
  RSVP?: Maybe<TripV2DriverRsvp>
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
}

export type TripV2DriverRsvp = {
  __typename?: 'TripV2DriverRSVP'
  attempt: Scalars['Int']['output']
  status: TripV2DriverRsvpStatus
}

export const TripV2DriverRsvpStatus = {
  Confirmed: 'CONFIRMED',
  Declined: 'DECLINED',
  Failed: 'FAILED',
  Missed: 'MISSED',
  Sent: 'SENT'
} as const

export type TripV2DriverRsvpStatus = (typeof TripV2DriverRsvpStatus)[keyof typeof TripV2DriverRsvpStatus]
export type TripV2Input = {
  id: Scalars['UUID']['input']
}

export type TripV2ItineraryStop = {
  __typename?: 'TripV2ItineraryStop'
  arrival?: Maybe<TripV2ItineraryStopTime>
  checkIns?: Maybe<Array<TripV2ItineraryStopCheck>>
  checkOuts?: Maybe<Array<TripV2ItineraryStopCheck>>
  /** @deprecated Use checkIns instead */
  checkedIn?: Maybe<TripV2ItineraryStopCheck>
  /** @deprecated Use checkOuts instead */
  checkedOut?: Maybe<TripV2ItineraryStopCheck>
  departure?: Maybe<TripV2ItineraryStopTime>
  place: TripV2ItineraryStopPlace
  realDepartureTime?: Maybe<Scalars['Time']['output']>
}

export type TripV2ItineraryStopCheck = {
  __typename?: 'TripV2ItineraryStopCheck'
  at: Scalars['Time']['output']
  method: TripV2ItineraryStopCheckMethod
}

export const TripV2ItineraryStopCheckMethod = {
  Automatic: 'AUTOMATIC',
  Manual: 'MANUAL'
} as const

export type TripV2ItineraryStopCheckMethod =
  (typeof TripV2ItineraryStopCheckMethod)[keyof typeof TripV2ItineraryStopCheckMethod]
export const TripV2ItineraryStopCheckType = {
  CheckIn: 'CHECK_IN',
  CheckOut: 'CHECK_OUT'
} as const

export type TripV2ItineraryStopCheckType =
  (typeof TripV2ItineraryStopCheckType)[keyof typeof TripV2ItineraryStopCheckType]
export type TripV2ItineraryStopPlace = {
  __typename?: 'TripV2ItineraryStopPlace'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  timezone: Scalars['Timezone']['output']
}

export type TripV2ItineraryStopTime = {
  __typename?: 'TripV2ItineraryStopTime'
  day: Scalars['Int']['output']
  time: Scalars['String']['output']
}

export type TripV2LegSegment = {
  __typename?: 'TripV2LegSegment'
  destination: TripV2LegSegmentPlace
  id: Scalars['UUID']['output']
  origin: TripV2LegSegmentPlace
}

export type TripV2LegSegmentPlace = {
  __typename?: 'TripV2LegSegmentPlace'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TripV2Note = {
  __typename?: 'TripV2Note'
  cashFlow?: Maybe<TripV2NoteCashFlow>
  category?: Maybe<TripV2NoteCategory>
  changeType?: Maybe<TripV2NoteChangeType>
  createdAt: Scalars['Time']['output']
  distance?: Maybe<Scalars['Int']['output']>
  driver?: Maybe<TripNoteDriver>
  files?: Maybe<Array<TripV2NoteFile>>
  message?: Maybe<Scalars['String']['output']>
  subcategory?: Maybe<TripV2NoteSubcategory>
  user?: Maybe<TripV2User>
}

export type TripV2NoteCashFlow = {
  __typename?: 'TripV2NoteCashFlow'
  amount: Scalars['Int']['output']
  type: Scalars['String']['output']
}

export const TripV2NoteCategory = {
  Ambassador: 'AMBASSADOR',
  BusinessClient: 'BUSINESS_CLIENT',
  Cash: 'CASH',
  Driver: 'DRIVER',
  DriverRsvp: 'DRIVER_RSVP',
  Events: 'EVENTS',
  ExternalConditions: 'EXTERNAL_CONDITIONS',
  Odometer: 'ODOMETER',
  Other: 'OTHER',
  Partner: 'PARTNER',
  Passengers: 'PASSENGERS',
  Planning: 'PLANNING',
  Service: 'SERVICE',
  Tolls: 'TOLLS',
  Vehicle: 'VEHICLE'
} as const

export type TripV2NoteCategory = (typeof TripV2NoteCategory)[keyof typeof TripV2NoteCategory]
export const TripV2NoteChangeType = {
  AddDriverRsvpNote: 'ADD_DRIVER_RSVP_NOTE',
  AddNote: 'ADD_NOTE',
  AssignDriver: 'ASSIGN_DRIVER',
  CancelTrip: 'CANCEL_TRIP',
  ChangeVehicle: 'CHANGE_VEHICLE',
  TripOdometerDistanceRegistered: 'TRIP_ODOMETER_DISTANCE_REGISTERED'
} as const

export type TripV2NoteChangeType = (typeof TripV2NoteChangeType)[keyof typeof TripV2NoteChangeType]
export type TripV2NoteFile = {
  __typename?: 'TripV2NoteFile'
  name: Scalars['String']['output']
  path: Scalars['String']['output']
}

export const TripV2NoteSubcategory = {
  Absence: 'ABSENCE',
  Accident: 'ACCIDENT',
  Disability: 'DISABILITY',
  MechanicalFailure: 'MECHANICAL_FAILURE',
  Other: 'OTHER',
  Protest: 'PROTEST',
  Replacement: 'REPLACEMENT',
  Roadblock: 'ROADBLOCK',
  ScheduledMaintenance: 'SCHEDULED_MAINTENANCE',
  Security: 'SECURITY',
  Traffic: 'TRAFFIC',
  UnitStoppage: 'UNIT_STOPPAGE',
  Weather: 'WEATHER'
} as const

export type TripV2NoteSubcategory = (typeof TripV2NoteSubcategory)[keyof typeof TripV2NoteSubcategory]
export type TripV2Route = {
  __typename?: 'TripV2Route'
  id: Scalars['UUID']['output']
  name?: Maybe<Scalars['String']['output']>
  polyline?: Maybe<TripRoutePolyline>
}

export type TripV2RouteService = {
  __typename?: 'TripV2RouteService'
  businessClients: Array<TripV2RouteServiceBusinessClient>
  code: Scalars['String']['output']
  id: Scalars['UUID']['output']
}

export type TripV2RouteServiceBusinessClient = {
  __typename?: 'TripV2RouteServiceBusinessClient'
  businessSites: Array<TripV2RouteServiceBusinessSite>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TripV2RouteServiceBusinessSite = {
  __typename?: 'TripV2RouteServiceBusinessSite'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export const TripV2SaleStatus = {
  Activated: 'ACTIVATED',
  Deactivated: 'DEACTIVATED'
} as const

export type TripV2SaleStatus = (typeof TripV2SaleStatus)[keyof typeof TripV2SaleStatus]
export const TripV2Status = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  InTransit: 'IN_TRANSIT',
  OnTime: 'ON_TIME'
} as const

export type TripV2Status = (typeof TripV2Status)[keyof typeof TripV2Status]
export type TripV2TimelineEvent = {
  __typename?: 'TripV2TimelineEvent'
  correlationID: Scalars['UUID']['output']
  createdAt: Scalars['Time']['output']
  placeID?: Maybe<Scalars['UUID']['output']>
  tripCancellationReason?: Maybe<TripV2TimelineEventTripCancellationReason>
  type: Scalars['String']['output']
  user: TripV2User
}

export type TripV2TimelineEventTripCancellationReason = {
  __typename?: 'TripV2TimelineEventTripCancellationReason'
  category?: Maybe<TripV2CancellationReasonCategory>
  subcategory?: Maybe<TripV2CancellationReasonSubcategory>
}

export type TripV2User = {
  __typename?: 'TripV2User'
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type TripV2Vehicle = {
  __typename?: 'TripV2Vehicle'
  externalID?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  isActive: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  partner?: Maybe<TripV2VehiclePartner>
  schedule?: Maybe<TripV2VehicleSchedule>
  template?: Maybe<TripV2VehicleTemplate>
}

export type TripV2VehiclePartner = {
  __typename?: 'TripV2VehiclePartner'
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type TripV2VehicleSchedule = {
  __typename?: 'TripV2VehicleSchedule'
  id: Scalars['UUID']['output']
  type: TripV2VehicleScheduleType
}

export const TripV2VehicleScheduleType = {
  Dow: 'DOW',
  Frequency: 'FREQUENCY'
} as const

export type TripV2VehicleScheduleType = (typeof TripV2VehicleScheduleType)[keyof typeof TripV2VehicleScheduleType]
export type TripV2VehicleTemplate = {
  __typename?: 'TripV2VehicleTemplate'
  id: Scalars['UUID']['output']
}

export const TripV2Vertical = {
  City: 'CITY',
  Rental: 'RENTAL',
  Team: 'TEAM',
  Travel: 'TRAVEL'
} as const

export type TripV2Vertical = (typeof TripV2Vertical)[keyof typeof TripV2Vertical]
/** vehicle */
export type TripVehicle = {
  __typename?: 'TripVehicle'
  /** external ID */
  externalID?: Maybe<Scalars['String']['output']>
  /** vehicle id */
  id: Scalars['ID']['output']
  /** vehicle name */
  name: Scalars['String']['output']
  /** partner */
  partner?: Maybe<TripVehiclePartner>
  /** schedule */
  schedule?: Maybe<TripVehicleSchedule>
  /**
   * vehicle template
   * @deprecated Use seats on Trip
   */
  template?: Maybe<TripVehicleVehicleTemplate>
}

export type TripVehicleDriver = {
  __typename?: 'TripVehicleDriver'
  email?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
  partner: TripVehiclePartner
  phoneNumber?: Maybe<PhoneNumber>
}

/** partner */
export type TripVehiclePartner = {
  __typename?: 'TripVehiclePartner'
  /** partner id */
  id: Scalars['ID']['output']
  /** partner name */
  name: Scalars['String']['output']
}

export type TripVehicleSchedule = {
  __typename?: 'TripVehicleSchedule'
  id: Scalars['ID']['output']
  type: TripVehicleScheduleType
}

export const TripVehicleScheduleType = {
  Dow: 'DOW',
  Frequency: 'FREQUENCY'
} as const

export type TripVehicleScheduleType = (typeof TripVehicleScheduleType)[keyof typeof TripVehicleScheduleType]
export type TripVehicleVehicleTemplate = {
  __typename?: 'TripVehicleVehicleTemplate'
  capacity: Scalars['Int']['output']
  id: Scalars['ID']['output']
}

export type TripsDriverConflictInput = {
  driverID: Scalars['UUID']['input']
  tripID: Scalars['UUID']['input']
}

export type TripsDriverConflictResponse = {
  __typename?: 'TripsDriverConflictResponse'
  items: Array<TripV2>
  total: Scalars['Int']['output']
}

/** paginated trips response */
export type TripsResponse = {
  __typename?: 'TripsResponse'
  /** trips. id is correlationID */
  items: Array<Trip>
  /** total of trips */
  total: Scalars['Int']['output']
}

export const TripsV2DayOfWeek = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const

export type TripsV2DayOfWeek = (typeof TripsV2DayOfWeek)[keyof typeof TripsV2DayOfWeek]
export type TripsV2HourRangeInput = {
  endHour?: InputMaybe<Scalars['String']['input']>
  startHour?: InputMaybe<Scalars['String']['input']>
}

export type TripsV2Input = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  companyID?: InputMaybe<Scalars['UUID']['input']>
  companyLineID?: InputMaybe<Scalars['UUID']['input']>
  confirmationModalityName?: InputMaybe<TripV2ConfirmationModalityNameInput>
  departureAtRange?: InputMaybe<TripsV2TimeRangeInput>
  departureDaysOfWeek?: InputMaybe<Array<TripsV2DayOfWeek>>
  departureHourRange?: InputMaybe<TripsV2HourRangeInput>
  destinationCityID?: InputMaybe<Scalars['UUID']['input']>
  destinationID?: InputMaybe<Scalars['UUID']['input']>
  driverID?: InputMaybe<Scalars['UUID']['input']>
  driverRSVPStatus?: InputMaybe<TripV2DriverRsvpStatus>
  hasDriver?: InputMaybe<Scalars['Boolean']['input']>
  hasIncidents?: InputMaybe<Scalars['Boolean']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  notConfirmationModalityName?: InputMaybe<TripV2ConfirmationModalityNameInput>
  originCityID?: InputMaybe<Scalars['UUID']['input']>
  originID?: InputMaybe<Scalars['UUID']['input']>
  partnerIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  routeIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  routeServiceIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  saleStatus?: InputMaybe<TripsV2SaleStatusInput>
  shortIDs?: InputMaybe<Array<Scalars['String']['input']>>
  status?: InputMaybe<TripsV2StatusInput>
  vehicleID?: InputMaybe<Scalars['UUID']['input']>
  vehicleIsActive?: InputMaybe<Scalars['Boolean']['input']>
}

export type TripsV2Response = {
  __typename?: 'TripsV2Response'
  items: Array<TripV2>
  total: Scalars['Int']['output']
}

export const TripsV2SaleStatusInput = {
  Activated: 'ACTIVATED',
  Deactivated: 'DEACTIVATED'
} as const

export type TripsV2SaleStatusInput = (typeof TripsV2SaleStatusInput)[keyof typeof TripsV2SaleStatusInput]
export const TripsV2StatusInput = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  InTransit: 'IN_TRANSIT',
  OnTime: 'ON_TIME'
} as const

export type TripsV2StatusInput = (typeof TripsV2StatusInput)[keyof typeof TripsV2StatusInput]
export type TripsV2TimeRangeInput = {
  endAt?: InputMaybe<Scalars['Time']['input']>
  startAt?: InputMaybe<Scalars['Time']['input']>
}

export type TripsVehicleConflictInput = {
  tripID: Scalars['UUID']['input']
  vehicleID: Scalars['UUID']['input']
}

export type TripsVehicleConflictResponse = {
  __typename?: 'TripsVehicleConflictResponse'
  items: Array<TripV2>
  total: Scalars['Int']['output']
}

export type UnassignBusinessCustomerKreditCategoryInput = {
  id: Scalars['UUID']['input']
}

export type UnassignBusinessCustomersKreditCategoryInput = {
  ids: Array<Scalars['UUID']['input']>
}

export type UpdateCampaignDatesInput = {
  endsAt?: InputMaybe<Scalars['String']['input']>
  startsAt?: InputMaybe<Scalars['String']['input']>
  timezone: Scalars['String']['input']
}

export type UpdateCampaignInput = {
  dates?: InputMaybe<UpdateCampaignDatesInput>
  description?: InputMaybe<Scalars['String']['input']>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCouponConstraintsInput = {
  bookingTypes?: InputMaybe<Array<BookingType>>
  citySegments?: InputMaybe<Array<CouponConstraintsCitySegmentInput>>
  confirmationModalities?: InputMaybe<ConfirmationMoldalitiesInput>
  departureDateRanges?: InputMaybe<Array<DepartureDateRangeInput>>
  limit?: InputMaybe<Scalars['Int']['input']>
  minSale?: InputMaybe<Scalars['Int']['input']>
  minTicketsCount?: InputMaybe<Scalars['Int']['input']>
  onlyRegisteredUsers?: InputMaybe<Scalars['Boolean']['input']>
  onlyRoundTrips?: InputMaybe<Scalars['Boolean']['input']>
  passengerTypes?: InputMaybe<Array<CouponConstraintsPassengerTypeInput>>
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  userLimit?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateCouponCouponDatesInput = {
  endsAt?: InputMaybe<Scalars['String']['input']>
  startsAt?: InputMaybe<Scalars['String']['input']>
  timezone: Scalars['String']['input']
}

export type UpdateCouponCouponDiscountInput = {
  discountType?: InputMaybe<DiscountType>
  value?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateCouponCouponInput = {
  channels?: InputMaybe<Array<CouponChannel>>
  constraints?: InputMaybe<UpdateCouponConstraintsInput>
  dates?: InputMaybe<UpdateCouponCouponDatesInput>
  discount?: InputMaybe<UpdateCouponCouponDiscountInput>
  id: Scalars['ID']['input']
}

export type UpdateCouponInput = {
  campaignID: Scalars['ID']['input']
  coupon: UpdateCouponCouponInput
}

export type UpdateRouteServicePeakInput = {
  endAt: Scalars['Date']['input']
  id: Scalars['ID']['input']
  startAt: Scalars['Date']['input']
}

export type UpdateServiceInput = {
  activePeriod?: InputMaybe<Scalars['Int']['input']>
  businessClients?: InputMaybe<Array<ChangeRouteServiceBusinessClientInput>>
  confirmationModalitiesV2?: InputMaybe<Array<RouteServiceConfirmationModalitiesV2Input>>
  executeAt?: InputMaybe<Scalars['Time']['input']>
  hasSelectableSeats?: InputMaybe<Scalars['Boolean']['input']>
  hasTolls?: InputMaybe<Scalars['Boolean']['input']>
  id: Scalars['ID']['input']
  isPetFriendly?: InputMaybe<Scalars['Boolean']['input']>
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>
  itinerary?: InputMaybe<Array<ItineraryInput>>
  limits?: InputMaybe<Array<RouteServiceLimitInput>>
  peaks?: InputMaybe<Array<UpdateRouteServicePeakInput>>
  pricePerTrip?: InputMaybe<Scalars['Int']['input']>
  /** sales channels ids */
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  vehicleID?: InputMaybe<Scalars['ID']['input']>
}

export type UpdateSnacksCouponCouponConstraintsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>
  minSale?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateSnacksCouponCouponInput = {
  constraints?: InputMaybe<UpdateSnacksCouponCouponConstraintsInput>
  dates?: InputMaybe<UpdateCouponCouponDatesInput>
  discount?: InputMaybe<UpdateCouponCouponDiscountInput>
  id: Scalars['ID']['input']
}

export type UpdateSnacksCouponInput = {
  campaignID: Scalars['ID']['input']
  coupon: UpdateSnacksCouponCouponInput
}

export type UpdateUserInput = {
  companyIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  id: Scalars['UUID']['input']
  lastName?: InputMaybe<Scalars['String']['input']>
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>
  passwordExpirationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  policyIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  position?: InputMaybe<Scalars['String']['input']>
}

/** update vehicle input */
export type UpdateVehicleInput = {
  /** documents */
  documents?: InputMaybe<DocumentsUpdateInput>
  /** driver IDs */
  driverIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** vehicle id */
  id: Scalars['ID']['input']
  /** make e.g. Ford */
  make?: InputMaybe<Scalars['String']['input']>
  /** model e.g. Focus */
  model?: InputMaybe<Scalars['String']['input']>
  /** vehicle name */
  name?: InputMaybe<Scalars['String']['input']>
  /** odometer reading */
  odometerReading?: InputMaybe<Scalars['Int']['input']>
  /** partner */
  partner?: InputMaybe<PartnerInput>
  photoPath?: InputMaybe<Scalars['String']['input']>
  /** registration plate */
  registrationPlate?: InputMaybe<Scalars['String']['input']>
  /** registration state code */
  registrationStateCode?: InputMaybe<Scalars['String']['input']>
  /** vehicle type */
  type?: InputMaybe<VehicleType>
  /** vehicle identification number */
  vin?: InputMaybe<Scalars['String']['input']>
  /** year e.g. 2015 */
  year?: InputMaybe<Scalars['Int']['input']>
}

export type UploadOperationalCostSettingsInput = {
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  sheetUrl: Scalars['String']['input']
}

export type UpsertPartnerCostScheduleInput = {
  cost: Scalars['Int']['input']
  dow: Array<PartnerCostScheduleDow>
  endAt?: InputMaybe<Scalars['Date']['input']>
  note: Scalars['String']['input']
  startAt: Scalars['Date']['input']
  type?: InputMaybe<CostType>
}

export type UpsertPartnerCostsInput = {
  routeServiceIDs: Array<Scalars['UUID']['input']>
  schedule: UpsertPartnerCostScheduleInput
  vehicleIDs: Array<Scalars['UUID']['input']>
}

/** user */
export type User = {
  __typename?: 'User'
  /** companies */
  companies: Array<UserCompany>
  /**
   * company
   * @deprecated Use companies instead
   */
  company?: Maybe<UserCompany>
  /** email */
  email?: Maybe<Scalars['String']['output']>
  /** first name */
  firstName: Scalars['String']['output']
  /** user id */
  id: Scalars['ID']['output']
  /** indicates whether the user is active or not */
  isActive: Scalars['Boolean']['output']
  /** indicates whether the user is blocked or not */
  isBlocked: Scalars['Boolean']['output']
  /** last name */
  lastName: Scalars['String']['output']
  /** MFA enabled */
  mfaEnabled: Scalars['Boolean']['output']
  /** password expiration enabled */
  passwordExpirationEnabled: Scalars['Boolean']['output']
  /** permissions assigned to this user */
  permissions: Array<Permission>
  /** position */
  position?: Maybe<Scalars['String']['output']>
  /** roles assigned to this user */
  roles: Array<Role>
  /** site ID */
  siteID?: Maybe<Scalars['ID']['output']>
  /** username */
  username: Scalars['String']['output']
}

export const UserAccountGenderInput = {
  Female: 'female',
  Male: 'male',
  NotSharing: 'notSharing',
  Other: 'other'
} as const

export type UserAccountGenderInput = (typeof UserAccountGenderInput)[keyof typeof UserAccountGenderInput]
/** user autocomplete */
export type UserAutocomplete = {
  __typename?: 'UserAutocomplete'
  /** first name */
  firstName: Scalars['String']['output']
  /** user ID */
  id: Scalars['ID']['output']
  /** last name */
  lastName: Scalars['String']['output']
  /** site ID */
  siteID?: Maybe<Scalars['String']['output']>
  /** username */
  username: Scalars['String']['output']
}

export const UserAutocompleteType = {
  Base: 'base',
  Cashier: 'cashier',
  Crew: 'crew',
  Warehouse: 'warehouse'
} as const

export type UserAutocompleteType = (typeof UserAutocompleteType)[keyof typeof UserAutocompleteType]
/** company */
export type UserCompany = {
  __typename?: 'UserCompany'
  /** company id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
  /** policy role */
  policyRole?: Maybe<UserCompanyPolicyRole>
  /** vertical */
  vertical?: Maybe<CompanyV2Vertical>
}

export type UserCompanyPolicyRole = {
  __typename?: 'UserCompanyPolicyRole'
  /** policy role id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

export type UserSuggestion = {
  __typename?: 'UserSuggestion'
  firstName: Scalars['String']['output']
  id: Scalars['UUID']['output']
  lastName: Scalars['String']['output']
  name: Scalars['String']['output']
  username: Scalars['String']['output']
}

export type UserSuggestionsInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
  siteIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  type?: InputMaybe<Scalars['String']['input']>
}

export type UserSuggestionsResponse = {
  __typename?: 'UserSuggestionsResponse'
  items: Array<UserSuggestion>
  total: Scalars['Long']['output']
}

export type UsersAutocompleteInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  type?: InputMaybe<UserAutocompleteType>
}

/** paginated users response */
export type UsersResponse = {
  __typename?: 'UsersResponse'
  /** users */
  items: Array<User>
  /** total of users */
  total: Scalars['Int']['output']
}

export type ValidateBusinessCustomersCsvInput = {
  /** The path of the CSV file */
  path: Scalars['String']['input']
}

export type ValidateCouponsCsvInput = {
  path: Scalars['String']['input']
}

/** vehicle */
export type Vehicle = {
  __typename?: 'Vehicle'
  /** company */
  company?: Maybe<VehicleCompany>
  /** documents */
  documents: Array<VehicleDocument>
  /** drivers */
  drivers: Array<VehicleDriver>
  /** vehicle id */
  id: Scalars['ID']['output']
  /** make e.g. Ford */
  make?: Maybe<Scalars['String']['output']>
  /** model e.g. Focus */
  model?: Maybe<Scalars['String']['output']>
  /** vehicle name */
  name: Scalars['String']['output']
  /** last odometer reading */
  odometerReading?: Maybe<VehicleOdometerReading>
  /** partner */
  partner: Partner
  /** photo path */
  photoPath?: Maybe<Scalars['String']['output']>
  /** registration plate */
  registrationPlate: Scalars['String']['output']
  /** registration state code */
  registrationStateCode: Scalars['String']['output']
  /** status */
  status: VehicleStatus
  /** vehicle template */
  template: VehicleVehicleTemplate
  /** vehicle type */
  type: VehicleType
  /** vehicle identification number */
  vin: Scalars['String']['output']
  /** year e.g. 2015 */
  year?: Maybe<Scalars['Int']['output']>
}

/** vehicle company */
export type VehicleCompany = {
  __typename?: 'VehicleCompany'
  /** company id */
  id: Scalars['ID']['output']
  /** company name */
  name: Scalars['String']['output']
}

export type VehicleDifference = {
  __typename?: 'VehicleDifference'
  new: ChangeVehicle
  old: ChangeVehicle
}

/** documents */
export type VehicleDocument = {
  __typename?: 'VehicleDocument'
  /** document category */
  category: DocumentCategory
  /** filename */
  filename: Scalars['String']['output']
  /** document id */
  id: Scalars['ID']['output']
  /** path */
  path: Scalars['String']['output']
}

export const VehicleDocumentCategoryInput = {
  Bills: 'BILLS',
  ExternalInspection: 'EXTERNAL_INSPECTION',
  InternalInspection: 'INTERNAL_INSPECTION',
  Photo: 'PHOTO',
  TuningService: 'TUNING_SERVICE',
  VerificationCertificate: 'VERIFICATION_CERTIFICATE'
} as const

export type VehicleDocumentCategoryInput =
  (typeof VehicleDocumentCategoryInput)[keyof typeof VehicleDocumentCategoryInput]
/** vehicle driver */
export type VehicleDriver = {
  __typename?: 'VehicleDriver'
  /** driver first name */
  firstName: Scalars['String']['output']
  /** driver id */
  id: Scalars['String']['output']
  /** driver last name */
  lastName: Scalars['String']['output']
  username: Scalars['String']['output']
}

/** odometer reading */
export type VehicleOdometerReading = {
  __typename?: 'VehicleOdometerReading'
  /** date of reading */
  readAt: Scalars['Time']['output']
  /** odometer reading */
  value: Scalars['Int']['output']
}

export const VehicleRegistrationCategoryInput = {
  DrivingPermit: 'DRIVING_PERMIT',
  Federal: 'FEDERAL',
  Local: 'LOCAL'
} as const

export type VehicleRegistrationCategoryInput =
  (typeof VehicleRegistrationCategoryInput)[keyof typeof VehicleRegistrationCategoryInput]
export const VehicleRegistrationTypeInput = {
  A: 'A',
  A1: 'A1',
  A2: 'A2',
  B: 'B',
  C: 'C',
  D: 'D',
  E: 'E',
  E1: 'E1'
} as const

export type VehicleRegistrationTypeInput =
  (typeof VehicleRegistrationTypeInput)[keyof typeof VehicleRegistrationTypeInput]
/** vehicle status */
export const VehicleStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  OutOfService: 'OUT_OF_SERVICE',
  Assigned: 'assigned',
  Unassigned: 'unassigned'
} as const

export type VehicleStatus = (typeof VehicleStatus)[keyof typeof VehicleStatus]
export type VehicleSuggestion = {
  __typename?: 'VehicleSuggestion'
  capacity: Scalars['Int']['output']
  externalID?: Maybe<Scalars['String']['output']>
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
}

export type VehicleSuggestionsInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>
  partnerID?: InputMaybe<Scalars['UUID']['input']>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type VehicleSuggestionsResponse = {
  __typename?: 'VehicleSuggestionsResponse'
  items: Array<VehicleSuggestion>
  total: Scalars['Long']['output']
}

/** vehicle template */
export type VehicleTemplate = {
  __typename?: 'VehicleTemplate'
  /** capacity */
  capacity: Scalars['Int']['output']
  /** companies that use this template */
  companies: Array<VehicleTemplateCompany>
  /** template id */
  id: Scalars['ID']['output']
  /** template layout [floor][row][column] */
  layout: Array<Array<Array<VehicleTemplateCell>>>
  /** template name */
  name: Scalars['String']['output']
  /** vehicle type */
  type: VehicleType
  /** vehicles that use this template */
  vehicleIDs: Array<Scalars['ID']['output']>
}

export type VehicleTemplateAutocomplete = {
  __typename?: 'VehicleTemplateAutocomplete'
  /** vehicle template id */
  id: Scalars['ID']['output']
  /** name */
  name: Scalars['String']['output']
}

/** layout cell */
export type VehicleTemplateCell = {
  __typename?: 'VehicleTemplateCell'
  /** component */
  component: CellComponent
  /** label, used for seat number */
  label?: Maybe<Scalars['String']['output']>
  /** component properties */
  properties: Array<CellComponentProperty>
}

/** layout cell */
export type VehicleTemplateCellInput = {
  /** component */
  component: CellComponent
  /** label, used for seat number */
  label?: InputMaybe<Scalars['String']['input']>
  /** component properties */
  properties: Array<CellComponentProperty>
}

/** company */
export type VehicleTemplateCompany = {
  __typename?: 'VehicleTemplateCompany'
  id: Scalars['ID']['output']
  name: Scalars['String']['output']
}

export type VehicleTemplateSuggestion = {
  __typename?: 'VehicleTemplateSuggestion'
  capacity: Scalars['Int']['output']
  id: Scalars['UUID']['output']
  name: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type VehicleTemplateSuggestionsInput = {
  companyID?: InputMaybe<Scalars['UUID']['input']>
  id?: InputMaybe<Scalars['UUID']['input']>
  ids?: InputMaybe<Array<Scalars['UUID']['input']>>
  pattern?: InputMaybe<Scalars['String']['input']>
}

export type VehicleTemplateSuggestionsResponse = {
  __typename?: 'VehicleTemplateSuggestionsResponse'
  items: Array<VehicleTemplateSuggestion>
  total: Scalars['Long']['output']
}

export type VehicleTemplatesAutocompleteInput = {
  capacity: Scalars['Int']['input']
  type: VehicleType
}

/** vehicle type */
export const VehicleType = {
  Bus: 'bus',
  Car: 'car',
  Sedan: 'sedan',
  Suv: 'suv',
  Van: 'van'
} as const

export type VehicleType = (typeof VehicleType)[keyof typeof VehicleType]
/** vehicle template */
export type VehicleVehicleTemplate = {
  __typename?: 'VehicleVehicleTemplate'
  /** capacity */
  capacity: Scalars['Int']['output']
  /** template id */
  id: Scalars['String']['output']
  /** template name */
  name: Scalars['String']['output']
}

export type VerifyMfaCodeInput = {
  code: Scalars['String']['input']
}

export type VerifyMfaCodeResponse = {
  __typename?: 'VerifyMfaCodeResponse'
  accessToken: Scalars['String']['output']
  passwordExpired: Scalars['Boolean']['output']
  refreshToken: Scalars['String']['output']
}

export type VerifyTripsInventoryRuleInput = {
  /** inventory rule id */
  id: Scalars['ID']['input']
}

/**
 * The Wallet type represents a single user's wallet,
 * including its balance and transactions.
 */
export type Wallet = {
  __typename?: 'Wallet'
  /** The balance of the wallet, represented in cents. */
  balance: Scalars['Int']['output']
  /** The timestamp of when the wallet was created. */
  createdAt: Scalars['Time']['output']
  /** The unique ID of the wallet. */
  id: Scalars['ID']['output']
  /** The list of transactions associated with the wallet. */
  transactions: Array<WalletTransaction>
  /** The timestamp of when the wallet was last updated. */
  updatedAt: Scalars['Time']['output']
  /** The user related to this wallet. */
  user: WalletUser
}

/** Input for querying a specific wallet by ID. */
export type WalletInput = {
  /** The ID of the wallet to query. */
  id: Scalars['ID']['input']
}

/** The WalletTransaction type represents a single transaction made on a Wallet. */
export type WalletTransaction = {
  __typename?: 'WalletTransaction'
  /** The amount of the transaction, represented in cents. */
  amount: Scalars['Int']['output']
  /** The potential booking ID associated with the transaction. */
  bookingID?: Maybe<Scalars['ID']['output']>
  /** The timestamp of when the transaction was created. */
  createdAt: Scalars['Time']['output']
  /** The unique ID of the transaction. */
  id: Scalars['ID']['output']
  /** The potential payment ID associated with the transaction. */
  paymentID?: Maybe<Scalars['ID']['output']>
  /** The type of transaction made (deposit, withdrawal, transfer, etc.). */
  type: WalletTransactionType
}

export const WalletTransactionType = {
  Deposit: 'DEPOSIT',
  Unknown: 'UNKNOWN',
  Withdrawal: 'WITHDRAWAL'
} as const

export type WalletTransactionType = (typeof WalletTransactionType)[keyof typeof WalletTransactionType]
/** The WalletUser type represents a single user in the system. */
export type WalletUser = {
  __typename?: 'WalletUser'
  /** The email of the user. */
  email: Scalars['String']['output']
  /** The unique ID of the user. */
  id: Scalars['ID']['output']
  /** The phone number of the user. */
  phone: Scalars['String']['output']
  /** The full name of the user. */
  userFullName: Scalars['String']['output']
}

/** Input for querying wallets by associated user details. */
export type WalletsInput = {
  /** The email of the user to find associated wallets. */
  email?: InputMaybe<Scalars['String']['input']>
  /** The phone number of the user to find associated wallets. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** The full name of the user to find associated wallets. */
  userFullName?: InputMaybe<Scalars['String']['input']>
}

/**
 * The response from querying for a list of wallets. Includes the list of wallets
 * and the total count of wallets.
 */
export type WalletsResponse = {
  __typename?: 'WalletsResponse'
  /** The specific wallets that match the query. */
  items: Array<Wallet>
  /** The total number of wallets that match the query. */
  total: Scalars['Int']['output']
}

export const Weekday = {
  Friday: 'FRIDAY',
  Monday: 'MONDAY',
  Saturday: 'SATURDAY',
  Sunday: 'SUNDAY',
  Thursday: 'THURSDAY',
  Tuesday: 'TUESDAY',
  Wednesday: 'WEDNESDAY'
} as const

export type Weekday = (typeof Weekday)[keyof typeof Weekday]
export type ActivateBookingClassInput = {
  id: Scalars['ID']['input']
}

/** activate item input */
export type ActivateItemInput = {
  /** item id */
  ID: Scalars['ID']['input']
}

export type ActivateSeasonEventInput = {
  id: Scalars['ID']['input']
}

/** activate route service input */
export type ActivateServiceInput = {
  /** route service id */
  ID: Scalars['ID']['input']
}

/** activate site input */
export type ActivateSiteInput = {
  /** site id */
  id: Scalars['ID']['input']
}

/** activate trip sale input */
export type ActivateTripSaleInput = {
  /** trip id */
  id: Scalars['ID']['input']
}

/** activate user input */
export type ActivateUserInput = {
  /** user id */
  ID: Scalars['ID']['input']
}

export type AddCampaignCouponSupportInteractionInput = {
  campaignID: Scalars['ID']['input']
  couponID: Scalars['ID']['input']
  interaction: CampaignCouponSupportInteractionInput
  subcampaignID?: InputMaybe<Scalars['ID']['input']>
}

/** company line specs input */
export type AddCompanyLineSpecInput = {
  /** company line id */
  companyLineID: Scalars['ID']['input']
  /** distance in meters */
  distance?: InputMaybe<Scalars['Int']['input']>
  /** duration in minutes */
  duration?: InputMaybe<Scalars['Int']['input']>
}

export type AddFareFamilyFaresResponse = {
  __typename?: 'addFareFamilyFaresResponse'
  fareIDs: Array<Scalars['ID']['output']>
}

export type AddSegmentCompanyLineSpecInput = {
  companyLineSpec: AddCompanyLineSpecInput
  id: Scalars['ID']['input']
}

/** address input. */
export type AddressInput = {
  /** city */
  city: Scalars['String']['input']
  /** country code in ISO_3166-1_alpha-2 format. */
  countryCode: Scalars['String']['input']
  /** line 1. */
  line1: Scalars['String']['input']
  /** line 2. optional. */
  line2?: InputMaybe<Scalars['String']['input']>
  /** state code in ISO_3166-2:MX format. */
  stateCode: Scalars['String']['input']
  /** zip code. */
  zipCode: Scalars['String']['input']
}

/** address update input. only the fields to change should be included. */
export type AddressUpdateInput = {
  /** city */
  city?: InputMaybe<Scalars['String']['input']>
  /** country code in ISO_3166-1_alpha-2 format. */
  countryCode?: InputMaybe<Scalars['String']['input']>
  /** line 1 */
  line1?: InputMaybe<Scalars['String']['input']>
  /** line 2 */
  line2?: InputMaybe<Scalars['String']['input']>
  /** state code in ISO_3166-2:MX format. */
  stateCode?: InputMaybe<Scalars['String']['input']>
  /** zipcode */
  zipCode?: InputMaybe<Scalars['String']['input']>
}

/** archive vehicle template input */
export type ArchiveVehicleTemplateInput = {
  /** vehicle template id */
  id: Scalars['ID']['input']
}

export type BookingClassesInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
}

/** bookings dashboard input */
export type BookingsDashboardInput = {
  /** date in dd/mm/yyyy format */
  date?: InputMaybe<Scalars['String']['input']>
  /** timezone of the client (browser) */
  timezone?: InputMaybe<Scalars['String']['input']>
}

/** bookings query input */
export type BookingsQueryInput = {
  /** buyer phone */
  buyerPhone?: InputMaybe<Scalars['String']['input']>
  /** company Line ID */
  companyLineID?: InputMaybe<Scalars['ID']['input']>
  /** destination id */
  destination?: InputMaybe<Scalars['ID']['input']>
  /** buuyer's email */
  email?: InputMaybe<Scalars['String']['input']>
  /** email status */
  emailStatus?: InputMaybe<BookingEmailStatus>
  /** origin id */
  origin?: InputMaybe<Scalars['ID']['input']>
  /** purchase date range */
  purchaseDateRange?: InputMaybe<DateRangeInput>
  /** reservation number */
  reservation?: InputMaybe<Array<Scalars['String']['input']>>
  /** sales channel id */
  salesChannelID?: InputMaybe<Scalars['ID']['input']>
  /** sales channel type */
  salesChannelType?: InputMaybe<SalesChannelType>
  /** service codes */
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>
  /** service id */
  serviceID?: InputMaybe<Scalars['ID']['input']>
  /** pos id */
  siteID?: InputMaybe<Scalars['ID']['input']>
  /** sorting date defaults to last 4 months if not provided */
  sortingDate?: InputMaybe<DateRangeInput>
  /** status */
  status?: InputMaybe<Array<Scalars['String']['input']>>
  /** timezone of the client (browser) */
  timezone?: InputMaybe<Scalars['String']['input']>
  /** travel date range */
  travelDateRange?: InputMaybe<DateRangeInput>
}

/** buyer input */
export type BuyerInput = {
  /** email */
  email?: InputMaybe<Scalars['String']['input']>
  /** first name */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** last name */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** phone number */
  phone?: InputMaybe<Scalars['String']['input']>
}

export const CallStatus = {
  AttendanceConfirmed: 'attendanceConfirmed',
  BusyNumber: 'busyNumber',
  Cancellation: 'cancellation',
  HungUp: 'hungUp',
  NonExistentNumber: 'nonExistentNumber',
  ServiceChange: 'serviceChange',
  UnavailableNumber: 'unavailableNumber',
  Voicemail: 'voicemail',
  WrongNumber: 'wrongNumber'
} as const

export type CallStatus = (typeof CallStatus)[keyof typeof CallStatus]
/** cancel booking change input */
export type CancelBookingTripChangeInput = {
  /** booking id */
  id: Scalars['ID']['input']
  /** trip change id */
  tripChangeID: Scalars['ID']['input']
}

export type CancelChangeInput = {
  id: Scalars['ID']['input']
}

/** cancel tickets input */
export type CancelTicketsInput = {
  /** booking id */
  bookingID: Scalars['ID']['input']
  /** comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** payments */
  payments?: InputMaybe<Array<PaymentRefundInput>>
  /** cancelation reason */
  reason?: InputMaybe<BookingTicketCancelationReason>
  /** ticket IDs */
  ticketIDs: Array<Scalars['ID']['input']>
}

/** cancel trip input */
export type CancelTripInput = {
  /** trip cancellation category */
  category?: InputMaybe<CancellationCategory>
  /** trip cancellation comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** trip id */
  id: Scalars['ID']['input']
  /** trip cancellation subcategory */
  subcategory?: InputMaybe<CancellationSubcategory>
}

/** cancel multiple trips input */
export type CancelTripsInput = {
  /** trip cancellation category */
  category?: InputMaybe<CancellationCategory>
  /** trip cancellation comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** trip cancellation subcategory */
  subcategory?: InputMaybe<CancellationSubcategory>
  /** trip ids */
  tripIDs: Array<Scalars['ID']['input']>
}

export type CartActivityInput = {
  cartID: Scalars['ID']['input']
}

/** cashiers input */
export type CashiersQueryInput = {
  /** company id */
  companyID?: InputMaybe<Scalars['ID']['input']>
  /** if true, returns users assigned to a site. */
  isAssigned?: InputMaybe<Scalars['Boolean']['input']>
}

/** change booking payment input */
export type ChangeBookingPaymentInput = {
  /** booking id */
  bookingID: Scalars['ID']['input']
  /** payment */
  payment: ChangePaymentInput
}

export type ChangeBookingTripChangeTicketSeatInput = {
  /** booking ID */
  id: Scalars['ID']['input']
  /** seat ID */
  seatID: Scalars['ID']['input']
  /** ticket ID */
  ticketID: Scalars['ID']['input']
  /** tripChange ID */
  tripChangeID: Scalars['ID']['input']
}

/** change buyer input */
export type ChangeBuyerInput = {
  /** booking id */
  bookingID: Scalars['ID']['input']
  /** buyer */
  buyer: BuyerInput
}

export type ChangeFareFamilyFaresFareInput = {
  basePrice?: InputMaybe<Scalars['Int']['input']>
  id: Scalars['ID']['input']
  isActive: Scalars['Boolean']['input']
  /** deprecated in favor of basePrice */
  total?: InputMaybe<Scalars['Int']['input']>
}

export type ChangeFareFamilyFaresInput = {
  fares: Array<ChangeFareFamilyFaresFareInput>
  /** fare family id */
  id: Scalars['ID']['input']
}

/** change payment input */
export type ChangePaymentInput = {
  /** id */
  id: Scalars['ID']['input']
  /** last 4 */
  last4?: InputMaybe<Scalars['String']['input']>
  /** payment method */
  method: PaymentMethod
  /** payment processor */
  processor?: InputMaybe<PaymentProcessor>
}

/** change site input */
export type ChangeSiteInput = {
  /** the address of the site. */
  address?: InputMaybe<AddressUpdateInput>
  /** site id. */
  id: Scalars['ID']['input']
  /** the name of the site. */
  name?: InputMaybe<Scalars['String']['input']>
  /** settings for this site. */
  settings?: InputMaybe<ChangeSiteSettingsInput>
  /** the type of the site. */
  type?: InputMaybe<SiteType>
  /** users assigned to this site. */
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type ChangeSiteKreditsSettingsInput = {
  canTopUp?: InputMaybe<Scalars['Boolean']['input']>
}

/** change site's settings input */
export type ChangeSiteSettingsInput = {
  /** defines if the ticket price can be modified by the user */
  canChangePrice?: InputMaybe<Scalars['Boolean']['input']>
  /** defines if the site can reserve tickets */
  canReserveTickets?: InputMaybe<Scalars['Boolean']['input']>
  /** default origin place for this site. */
  defaultOriginID?: InputMaybe<Scalars['ID']['input']>
  /** defines if a site can recive mixed payments */
  enableMixedPayments?: InputMaybe<Scalars['Boolean']['input']>
  /** enabled company line IDs */
  enabledCompanyLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** physical printer present in site. */
  hasPrinter?: InputMaybe<Scalars['Boolean']['input']>
  /** defines if the site can see the transactions report */
  hideTransactionsReport?: InputMaybe<Scalars['Boolean']['input']>
  /** kredits settings */
  kredits?: InputMaybe<ChangeSiteKreditsSettingsInput>
  /** defines if the passenger name is required */
  passengerNameRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** payment methods allowed at shis site. */
  payment?: InputMaybe<Array<SiteSettingsPaymentMethod>>
  /** minutes before departure to close sales. */
  saleClosingThreshold?: InputMaybe<Scalars['Int']['input']>
  /** snacks settings */
  snacks?: InputMaybe<ChangeSiteSnacksSettingsInput>
}

export type ChangeSiteSnacksSettingsInput = {
  canSell?: InputMaybe<Scalars['Boolean']['input']>
  showMinPrice?: InputMaybe<Scalars['Boolean']['input']>
  tripRequired?: InputMaybe<Scalars['Boolean']['input']>
}

/** change ticket passenger input */
export type ChangeTicketsPassengerInput = {
  /** booking id */
  bookingID: Scalars['ID']['input']
  /** ticket id */
  tickets: Array<ChangeTicketsPassengerTicketsInput>
}

export type ChangeTicketsPassengerTicketsInput = {
  /** ticket id */
  id: Scalars['ID']['input']
  /** passenger */
  passenger: PassengerInput
}

export type ChangeTripBookingSeatBookingInput = {
  /** booking id */
  id: Scalars['ID']['input']
  /** id of the seat to be added */
  newSeatID: Scalars['ID']['input']
  /** id of the seat to be removed */
  oldSeatID: Scalars['ID']['input']
  /** segment id */
  segmentID: Scalars['ID']['input']
}

export type ChangeTripBookingSeatInput = {
  /** booking */
  booking: ChangeTripBookingSeatBookingInput
  /** trip id */
  id: Scalars['ID']['input']
}

export type ChangesQueryInput = {
  category: ChangeCategory
  companyID?: InputMaybe<Scalars['ID']['input']>
  dateRange?: InputMaybe<DateRangeInput>
  id?: InputMaybe<Scalars['ID']['input']>
  serviceCode?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  types?: InputMaybe<Array<ChangeType>>
  userID?: InputMaybe<Scalars['UUID']['input']>
}

/** city created payload */
export type CityCreatedPayload = {
  __typename?: 'cityCreatedPayload'
  /** place */
  place?: Maybe<Place>
}

/** companies query input */
export type CompaniesQueryInput = {
  /** limit the number of results. defaults to 10. */
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** company line query input */
export type CompanyLineQueryInput = {
  /** company line id */
  ID: Scalars['ID']['input']
}

/** company line specs input */
export type CompanyLineSpecInput = {
  /** company line id */
  companyLineID?: InputMaybe<Scalars['ID']['input']>
  /** distance in meters */
  distance?: InputMaybe<Scalars['Int']['input']>
  /** duration in minutes */
  duration?: InputMaybe<Scalars['Int']['input']>
  /** real distance in meters */
  realDistance?: InputMaybe<Scalars['Int']['input']>
}

/** company lines query input */
export type CompanyLinesQueryInput = {
  /** company id */
  companyID?: InputMaybe<Scalars['ID']['input']>
  /** limit the number of results. defaults to 10. */
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** company query input */
export type CompanyQueryInput = {
  /** company id */
  id: Scalars['ID']['input']
}

/** paginated company roles response */
export type CompanyRolesResponse = {
  __typename?: 'companyRolesResponse'
  /** company roles */
  items: Array<CompanyRole>
  /** total of company roles */
  total: Scalars['Int']['output']
}

/** confirm booking payment on site input */
export type ConfirmBookingPaymentOnSiteInput = {
  /** booking id */
  bookingID: Scalars['ID']['input']
  /** charge id to assign to the payment confirmation */
  chargeID?: InputMaybe<Scalars['String']['input']>
  /** last 4 digits of the card */
  last4?: InputMaybe<Scalars['String']['input']>
  /** payment method */
  method: PaymentMethod
  /** payment processor */
  processor?: InputMaybe<PaymentProcessor>
  /** ticket ids */
  ticketIDs: Array<Scalars['ID']['input']>
}

export type ConfirmBookingTripChangesInput = {
  /** booking id */
  id: Scalars['ID']['input']
  /** tripChange IDs */
  tripChangeIDs: Array<Scalars['ID']['input']>
}

export type ConfirmBookingTripChangesResponse = {
  __typename?: 'confirmBookingTripChangesResponse'
  fail: Array<Scalars['ID']['output']>
  success: Array<Scalars['ID']['output']>
}

export type CreateBookingClassInput = {
  companyID: Scalars['ID']['input']
  name: Scalars['String']['input']
  priority: Scalars['Int']['input']
  promo: Scalars['Boolean']['input']
}

/** create city input */
export type CreateCityInput = {
  /** city code */
  code: Scalars['String']['input']
  /** country code */
  countryCode?: InputMaybe<Scalars['String']['input']>
  /** name */
  name: Scalars['String']['input']
  /** unique human readable identifier for the place */
  param: Scalars['String']['input']
  /** state code in ISO_3166-2:MX format. */
  stateCode: Scalars['String']['input']
  /** tags */
  tags: Array<Scalars['String']['input']>
  /** timezone */
  timezone: Scalars['String']['input']
}

/** create company input */
export type CreateCompanyInput = {
  /** address */
  address: AddressInput
  /** comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** domains */
  domains: Array<Scalars['String']['input']>
  /** name */
  name: Scalars['String']['input']
  /** phone number */
  phone?: InputMaybe<Scalars['String']['input']>
  /** company policy role ID. optional. */
  policyRoleID?: InputMaybe<Scalars['String']['input']>
}

/** create company line inpue */
export type CreateCompanyLineInput = {
  /** amenities */
  amenities: Array<Amenity>
  /** class */
  class: Class
  /** id of the company this line belongs to */
  companyID: Scalars['ID']['input']
  /** logoPath */
  logoPath: Scalars['String']['input']
  /** name */
  name: Scalars['String']['input']
  /** refund rules */
  refundRules: Scalars['String']['input']
  /** type */
  type: CompanyLineType
}

export type CreateFareFamiliesInput = {
  fareFamilies: Array<FareFamilyInput>
}

/** create place input */
export type CreatePlaceInput = {
  /** address, optional */
  address?: InputMaybe<AddressInput>
  /** amenities */
  amenities?: InputMaybe<Array<PlaceAmenity>>
  /** area */
  area?: InputMaybe<Scalars['String']['input']>
  /** place code */
  code: Scalars['String']['input']
  /** directions */
  directions?: InputMaybe<Scalars['String']['input']>
  /** geolocation, opptional */
  location: LocationInput
  /** name */
  name: Scalars['String']['input']
  /** unique human readable identifier for the place */
  param: Scalars['String']['input']
  /** id of the city this place is in */
  parentID: Scalars['String']['input']
  /** tags */
  tags: Array<Scalars['String']['input']>
  /** place type */
  type: PlaceType
}

/** create policy compay role input */
export type CreatePolicyCompanyRoleInput = {
  /** conditions */
  conditions: Array<Scalars['String']['input']>
  /** company role name */
  name: Scalars['String']['input']
  /** policies to assign to the company role */
  policyIDs: Array<Scalars['ID']['input']>
}

/** create policy permission input */
export type CreatePolicyPermissionInput = {
  /** permission actions */
  actions: Array<Scalars['String']['input']>
  /** permission name */
  name: Scalars['String']['input']
}

/** create policy private role input */
export type CreatePolicyPrivateRoleInput = {
  /** company this private role belongs to */
  companyID: Scalars['ID']['input']
  /** provate role name */
  name: Scalars['String']['input']
  /** policies to assign to the private role */
  policyIDs: Array<Scalars['ID']['input']>
}

/** create policy role input */
export type CreatePolicyRoleInput = {
  /** role name */
  name: Scalars['String']['input']
  /** role's policies */
  policyIDs: Array<Scalars['ID']['input']>
}

export type CreateSeasonEventInput = {
  activePeriods: Array<ActivePeriodInput>
  companyID: Scalars['ID']['input']
  name: Scalars['String']['input']
  routeServiceIDs: Array<Scalars['ID']['input']>
  segmentIDs: Array<Scalars['ID']['input']>
  type: SeasonEventType
}

/** create route service input */
export type CreateServiceInput = {
  /** active period */
  activePeriod?: InputMaybe<Scalars['Int']['input']>
  /** business clients */
  businessClients?: InputMaybe<Array<CreateRouteServiceBusinessClientInput>>
  /** code */
  code?: InputMaybe<Scalars['String']['input']>
  /** company line id */
  companyLineID: Scalars['ID']['input']
  /** confirmation modalitites v2 */
  confirmationModalitiesV2?: InputMaybe<Array<RouteServiceConfirmationModalitiesV2Input>>
  /** if present, when the trips scheduling ends. Otherwise, trips will be continuously scheduled. */
  endAt?: InputMaybe<Scalars['String']['input']>
  /** idicates whether the route service has selectable seats or not */
  hasSelectableSeats?: InputMaybe<Scalars['Boolean']['input']>
  /** has tolls */
  hasTolls?: Scalars['Boolean']['input']
  /** is on guard */
  isOnGuard?: Scalars['Boolean']['input']
  /** is pet friendly */
  isPetFriendly?: Scalars['Boolean']['input']
  /** is private */
  isPrivate?: Scalars['Boolean']['input']
  /** itineraries schedule */
  itinerariesSchedule?: InputMaybe<Array<CreateRouteServiceItineraryScheduleInput>>
  /** limits per passenger type */
  limits: Array<RouteServiceLimitInput>
  /** peaks */
  peaks?: InputMaybe<Array<RouteServicePeakInput>>
  /** price per trip */
  pricePerTrip?: InputMaybe<Scalars['Int']['input']>
  /** sales channels ids */
  salesChannelIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** when the trips scheduling begins */
  startAt: Scalars['String']['input']
  /** crew user ids */
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** vehicles schedule */
  vehiclesSchedule?: InputMaybe<Array<CreateRouteServiceVehicleScheduleInput>>
}

/** create site input */
export type CreateSiteInput = {
  /** the address of the site. optional. */
  address?: InputMaybe<AddressInput>
  /** company that this site belongs to. */
  companyID: Scalars['ID']['input']
  /** the name of the site. */
  name: Scalars['String']['input']
  /**
   * settings for this site.
   * defaults to {
   * 	hasPrinter: false,
   * 	payment: [card, cash],
   * 	saleClosingThreshold: 5,
   * 	canChangePrice: false,
   * 	enabledCompanyLineIDs: [],
   * 	passengerNameRequired: true,
   * 	snacks: {
   * 		canSell: false,
   * 		showMinPrice: false,
   * 		tripRequired: false
   * 	}
   * 	canTopUpKredits: false,
   * }
   */
  settings?: InputMaybe<SiteSettingsInput>
  /** the type of the site. */
  type: SiteType
  /** users assigned to this site. */
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** create user input */
export type CreateUserInput = {
  /** companies the user belongs to */
  companyIDs?: InputMaybe<Array<Scalars['UUID']['input']>>
  /** email */
  email?: InputMaybe<Scalars['String']['input']>
  /** first name */
  firstName: Scalars['String']['input']
  /** last name */
  lastName: Scalars['String']['input']
  /** MFA enabled */
  mfaEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** password (confirmation must be done by the client) */
  password: Scalars['String']['input']
  /** password expiration enabled */
  passwordExpirationEnabled?: InputMaybe<Scalars['Boolean']['input']>
  /** policies to assign to this user */
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** position */
  position: Scalars['String']['input']
  /** username */
  username: Scalars['String']['input']
}

/** create vehicle template input */
export type CreateVehicleTemplateInput = {
  /** company id */
  companyID?: InputMaybe<Scalars['ID']['input']>
  /** template layout [floor][row][column] */
  layout: Array<Array<Array<VehicleTemplateCellInput>>>
  /** template name */
  name: Scalars['String']['input']
  /** vehicle type */
  type: VehicleType
}

export type DeactivateBookingClassInput = {
  id: Scalars['ID']['input']
}

/** deactivate item input */
export type DeactivateItemInput = {
  /** item id */
  ID: Scalars['ID']['input']
}

export type DeactivateSeasonEventInput = {
  id: Scalars['ID']['input']
}

/** deactivate route service input */
export type DeactivateServiceInput = {
  /** route service id */
  ID: Scalars['ID']['input']
}

/** deactivate site input */
export type DeactivateSiteInput = {
  /** site id */
  id: Scalars['ID']['input']
}

/** deactivate trip input */
export type DeactivateTripInput = {
  /** trip id */
  id: Scalars['ID']['input']
  /** trip deactivation reason */
  reason?: InputMaybe<DeactivationReason>
}

/** deactivate trip sale input */
export type DeactivateTripSaleInput = {
  /** trip id */
  id: Scalars['ID']['input']
}

/** deactivate user input */
export type DeactivateUserInput = {
  /** user id */
  ID: Scalars['ID']['input']
}

/** change documents input */
export type DocumentsUpdateInput = {
  /** documents to be added */
  add?: InputMaybe<Array<VehicleDocumentInput>>
  /** id of documents to be removed */
  remove?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type DrawersInput = {
  /** company IDs */
  companyIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** start date in dd/mm/yyyy format */
  from?: InputMaybe<Scalars['String']['input']>
  /** site IDs */
  siteIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** status */
  status?: InputMaybe<DrawerStatus>
  /** client timezone */
  timezone?: InputMaybe<Scalars['String']['input']>
  /** end date in dd/mm/yyyy format */
  to?: InputMaybe<Scalars['String']['input']>
  /** user IDs */
  userIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** drivers input */
export type DriversInput = {
  /** company id */
  companyID?: InputMaybe<Scalars['ID']['input']>
}

export type FareFamiliesInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  destinationCityID?: InputMaybe<Scalars['ID']['input']>
  originCityID?: InputMaybe<Scalars['ID']['input']>
  segmentID?: InputMaybe<Scalars['ID']['input']>
}

export type FareFamilyInput = {
  companyID: Scalars['ID']['input']
  familyName: Scalars['String']['input']
  fares: Array<FareFamilyFareInput>
  segmentID: Scalars['ID']['input']
}

/** itinerary input */
export type ItineraryInput = {
  /** arrival time */
  arrival?: InputMaybe<ItineraryTimeInput>
  /** departure time */
  departure?: InputMaybe<ItineraryTimeInput>
  /** place id */
  placeID: Scalars['ID']['input']
}

/** itinerary time input */
export type ItineraryTimeInput = {
  /** an integer representing how many days after departure the stop takes place. ex. 0 = same day, 1 = next day */
  day: Scalars['Int']['input']
  /** time in hh:mm format, in the timezone of the place */
  time: Scalars['String']['input']
}

/** login input */
export type LoginInput = {
  /** password */
  password: Scalars['String']['input']
  /** username */
  username: Scalars['String']['input']
}

/** login response */
export type LoginResponse = {
  __typename?: 'loginResponse'
  /** access token */
  accessToken: Scalars['String']['output']
  /** MFARequired */
  mfaRequired: Scalars['Boolean']['output']
  /** passwordExpired */
  passwordExpired: Scalars['Boolean']['output']
  /** refresh token */
  refreshToken: Scalars['String']['output']
}

/** new fare input */
export type NewFareInput = {
  /** passenger type this fare applies to */
  passengerType: PassengerType
  /** subtotal in cents */
  subtotal: Scalars['Int']['input']
  /** VAT in cents */
  vat: Scalars['Int']['input']
}

export const NotificationChannel = {
  Email: 'EMAIL',
  Phone: 'PHONE',
  SocialMedia: 'SOCIAL_MEDIA',
  Whatsapp: 'WHATSAPP'
} as const

export type NotificationChannel = (typeof NotificationChannel)[keyof typeof NotificationChannel]
/** passenger input */
export type PassengerInput = {
  /** first name */
  firstName: Scalars['String']['input']
  /** last name */
  lastName: Scalars['String']['input']
  /** type id */
  typeID?: InputMaybe<Scalars['ID']['input']>
}

/** permissions query input */
export type PermissionsQueryInput = {
  /** filter by company */
  companyID?: InputMaybe<Scalars['ID']['input']>
}

/** place created payload */
export type PlaceCreatedPayload = {
  __typename?: 'placeCreatedPayload'
  /** place */
  place?: Maybe<Place>
}

/** place query input */
export type PlaceQueryInput = {
  /** place id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** unique human readable identifier for the place */
  param?: InputMaybe<Scalars['String']['input']>
}

/** places query input */
export type PlacesQueryInput = {
  /** limit the number of results. defaults to 10. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** a string to filter the places against. */
  pattern?: InputMaybe<Scalars['String']['input']>
}

/** prices query input */
export type PricesQueryInput = {
  /** limit the number of results. defaults to 10. */
  limit?: InputMaybe<Scalars['Int']['input']>
}

/** refresh session input */
export type RefreshSessionInput = {
  /** refresh token */
  refreshToken: Scalars['String']['input']
}

/** register vehicle input */
export type RegisterVehicleInput = {
  /** company id */
  companyID?: InputMaybe<Scalars['String']['input']>
  /** documents */
  documents?: InputMaybe<Array<VehicleDocumentInput>>
  /** driver IDs */
  driverIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** make e.g. Ford */
  make?: InputMaybe<Scalars['String']['input']>
  /** model e.g. Focus */
  model?: InputMaybe<Scalars['String']['input']>
  /** vehicle name */
  name: Scalars['String']['input']
  /** odometer reading */
  odometerReading?: InputMaybe<Scalars['Int']['input']>
  /** partner */
  partner?: InputMaybe<PartnerInput>
  photoPath?: InputMaybe<Scalars['String']['input']>
  /** registration plate */
  registrationPlate: Scalars['String']['input']
  /** registration state code */
  registrationStateCode: Scalars['String']['input']
  /** template id */
  templateID: Scalars['ID']['input']
  /** vehicle type */
  type: VehicleType
  /** vehicle identification number */
  vin: Scalars['String']['input']
  /** year e.g. 2015 */
  year?: InputMaybe<Scalars['Int']['input']>
}

/** role query input */
export type RoleQueryInput = {
  /** role id */
  id: Scalars['ID']['input']
}

/** roles query input */
export type RolesQueryInput = {
  /** filter by company */
  companyID?: InputMaybe<Scalars['ID']['input']>
}

/** paginated roles response */
export type RolesResponse = {
  __typename?: 'rolesResponse'
  /** roles */
  items: Array<Role>
  /** total of roles */
  total: Scalars['Int']['output']
}

/** route query input */
export type RouteQueryInput = {
  /** route id */
  ID?: InputMaybe<Scalars['ID']['input']>
  /** company id */
  companyID?: InputMaybe<Scalars['ID']['input']>
  /** route stops */
  stopIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type RouteServiceLimitInput = {
  /** limit key */
  key: Scalars['String']['input']
  /** limit type */
  type: LimitType
  /** limit value */
  value?: InputMaybe<Scalars['Int']['input']>
}

export type RoutesQueryInput = {
  destinationID?: InputMaybe<Scalars['ID']['input']>
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>
  originID?: InputMaybe<Scalars['ID']['input']>
  routeServiceCode?: InputMaybe<Scalars['String']['input']>
}

export type SalesQueryInput = {
  cartID?: InputMaybe<Scalars['ID']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  purchaseDateRange?: InputMaybe<DateRangeInput>
  sellerID?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type SeasonEventInput = {
  id: Scalars['ID']['input']
}

export type SeatsTemplateInput = {
  segmentID: Scalars['ID']['input']
  tripID: Scalars['ID']['input']
}

/** segment query input */
export type SegmentQueryInput = {
  /** segment id */
  ID: Scalars['ID']['input']
}

/** segments between cities input */
export type SegmentsBetweenCitiesInput = {
  /** company id */
  companyID?: InputMaybe<Scalars['ID']['input']>
  /** destination city id */
  destinationID: Scalars['ID']['input']
  /** origin city id */
  originID: Scalars['ID']['input']
}

/** segmemts query input */
export type SegmentsQueryInput = {
  /** company id */
  companyID?: InputMaybe<Scalars['UUID']['input']>
  /** company line ids */
  companyLineIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** destination id */
  destinationID?: InputMaybe<Scalars['ID']['input']>
  /** show only segments that have duration set for all its company line specs */
  hasDuration?: InputMaybe<Scalars['Boolean']['input']>
  /** show only segments that have fares set for all its company line specs */
  hasPricing?: InputMaybe<Scalars['Boolean']['input']>
  /** limit the number of results. defaults to 10. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** origin id */
  originID?: InputMaybe<Scalars['ID']['input']>
  /** filter by route id */
  routeID?: InputMaybe<Scalars['ID']['input']>
}

/** send tickets input */
export type SendTicketsInput = {
  /** booking id */
  bookingID: Scalars['ID']['input']
  /** emails to which the tickets will be sent */
  emails: Array<Scalars['String']['input']>
}

/** route services query input */
export type ServicesQueryInput = {
  /** confirmation modalities */
  confirmationModalities?: InputMaybe<Array<Scalars['String']['input']>>
  /** filter by destination */
  destinationID?: InputMaybe<Scalars['ID']['input']>
  /** dow */
  dow?: InputMaybe<Array<DayOfWeek>>
  /** include all route services by route even if they are not in that route any more */
  includeAllByRoute?: InputMaybe<Scalars['Boolean']['input']>
  /** filter by status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** filter by origin */
  originID?: InputMaybe<Scalars['ID']['input']>
  /** filter by route */
  routeID?: InputMaybe<Scalars['ID']['input']>
  /** filter by segments ids */
  segmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** vehicle id */
  vehicleID?: InputMaybe<Scalars['ID']['input']>
}

export type SiteKreditsSettingsInput = {
  canTopUp: Scalars['Boolean']['input']
}

/** site input */
export type SiteQueryInput = {
  /** site id */
  id: Scalars['ID']['input']
}

/** site's settings input */
export type SiteSettingsInput = {
  /** defines if the ticket price can be modified by the user */
  canChangePrice: Scalars['Boolean']['input']
  /** defines if the site can reserve tickets */
  canReserveTickets: Scalars['Boolean']['input']
  /** default origin place for this site. */
  defaultOriginID?: InputMaybe<Scalars['ID']['input']>
  /** defines if a site can recive mixed payments */
  enableMixedPayments: Scalars['Boolean']['input']
  /** enabled company line IDs */
  enabledCompanyLineIDs: Array<Scalars['ID']['input']>
  /** physical printer present in site. */
  hasPrinter: Scalars['Boolean']['input']
  /** defines if the site can see the transactions report */
  hideTransactionsReport: Scalars['Boolean']['input']
  /** kredits settings */
  kredits: SiteKreditsSettingsInput
  /** defines if the passenger name is required */
  passengerNameRequired?: InputMaybe<Scalars['Boolean']['input']>
  /** payment methods allowed at shis site. */
  payment?: InputMaybe<Array<SiteSettingsPaymentMethod>>
  /** minutes before departure to close sales. */
  saleClosingThreshold: Scalars['Int']['input']
  /** snacks settings */
  snacks: SiteSnacksSettingsInput
}

export type SiteSnacksSettingsInput = {
  canSell: Scalars['Boolean']['input']
  showMinPrice: Scalars['Boolean']['input']
  tripRequired: Scalars['Boolean']['input']
}

export type SitesDashboardInput = {
  /** company IDs */
  companyIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** start date in dd/mm/yyyy format */
  from?: InputMaybe<Scalars['String']['input']>
  /** site IDs */
  siteIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** client timezone */
  timezone?: InputMaybe<Scalars['String']['input']>
  /** end date in dd/mm/yyyy format */
  to?: InputMaybe<Scalars['String']['input']>
}

/** sites query input */
export type SitesQueryInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<SiteType>
  userID?: InputMaybe<Scalars['ID']['input']>
  withoutUser?: InputMaybe<Scalars['Boolean']['input']>
}

/** start booking change input */
export type StartBookingTripChangeInput = {
  /** booking id */
  id: Scalars['ID']['input']
  /** trip change */
  tripChange: TripChangeInput
}

/** start move booking change input */
export type StartMoveBookingTripChangeInput = {
  /** booking id */
  id: Scalars['ID']['input']
  /** trip change */
  tripChange: TripChangeMoveInput
}

export const SubcampaignStatus = {
  Created: 'CREATED',
  Sent: 'SENT'
} as const

export type SubcampaignStatus = (typeof SubcampaignStatus)[keyof typeof SubcampaignStatus]
/** template query input */
export type TemplateQueryInput = {
  /** vehicle template id */
  id: Scalars['ID']['input']
}

/** templates query input */
export type TemplatesQueryInput = {
  /** capacity */
  capacity?: InputMaybe<Scalars['Int']['input']>
  /** vehicle type */
  type?: InputMaybe<VehicleType>
}

export type TicketsInsuranceInput = {
  bookingID?: InputMaybe<Scalars['ID']['input']>
  certificateIDs?: InputMaybe<Array<Scalars['String']['input']>>
  hasConflict?: InputMaybe<Scalars['Boolean']['input']>
  statusV2?: InputMaybe<Array<AncillaryStatusInput>>
  timezone?: InputMaybe<Scalars['String']['input']>
  travelDateRange?: InputMaybe<DateRangeInput>
}

/** trip change input */
export type TripChangeInput = {
  /** new trip id */
  newTripID: Scalars['ID']['input']
  /** old trip id */
  oldTripID: Scalars['ID']['input']
}

/** trip change move input */
export type TripChangeMoveInput = {
  /** new trip */
  newTrip: TripChangeMoveTripInput
  /** old trip id */
  oldTripID: Scalars['ID']['input']
}

/** trip change move trip input */
export type TripChangeMoveTripInput = {
  /** trip id */
  id: Scalars['ID']['input']
  /** segment id */
  segmentID: Scalars['ID']['input']
}

/** trip passengers input */
export type TripPassengersInput = {
  /** trip id */
  id: Scalars['ID']['input']
}

/** trip query input */
export type TripQueryInput = {
  id: Scalars['ID']['input']
}

export type TripSegmentsQueryInput = {
  departureDate: Scalars['String']['input']
  destinationID: Scalars['ID']['input']
  originID: Scalars['ID']['input']
  passengerTypes: Array<TripSegmentsPassengerTypeInput>
  salesChannelID: Scalars['ID']['input']
  vertical?: TripSegmentVerticalInput
}

/** trips query input */
export type TripsQueryInput = {
  /** route service business client ID */
  businessClientID?: InputMaybe<Scalars['UUID']['input']>
  /** route service business client business site ID */
  businessSiteID?: InputMaybe<Scalars['UUID']['input']>
  /** company ID */
  companyID?: InputMaybe<Scalars['ID']['input']>
  /** company line ID */
  companyLineID?: InputMaybe<Scalars['ID']['input']>
  /** minimum range of departure date, in dd/mm/yyyy format */
  departureDateFrom: Scalars['String']['input']
  /** maximum range of departure date, in dd/mm/yyyy format */
  departureDateTo: Scalars['String']['input']
  /** destinationCityID */
  destinationCityID?: InputMaybe<Scalars['ID']['input']>
  /** destination ID */
  destinationID?: InputMaybe<Scalars['ID']['input']>
  /** driver ID */
  driverID?: InputMaybe<Scalars['ID']['input']>
  /** has subcampaigns */
  hasSubcampaigns?: InputMaybe<Scalars['Boolean']['input']>
  /** array of trip IDs (could be the fisrt 8 characters or the full ID) */
  ids?: InputMaybe<Array<Scalars['String']['input']>>
  /** originCityID */
  originCityID?: InputMaybe<Scalars['ID']['input']>
  /** origin ID */
  originID?: InputMaybe<Scalars['ID']['input']>
  /** array of partner ids */
  partnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  /** route ID */
  routeID?: InputMaybe<Scalars['UUID']['input']>
  /** route name */
  routeName?: InputMaybe<Scalars['String']['input']>
  /** sale status */
  saleStatus?: InputMaybe<TripSaleStatus>
  /** service codes */
  serviceCodes?: InputMaybe<Array<Scalars['String']['input']>>
  /** status */
  status?: InputMaybe<TripStatus>
  /** timezone of the client (browser) */
  timezone: Scalars['String']['input']
  /** vehicle ID */
  vehicleID?: InputMaybe<Scalars['ID']['input']>
}

/** update city input */
export type UpdateCityInput = {
  /** city id */
  id: Scalars['ID']['input']
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
  /** unique human readable identifier for the place */
  param?: InputMaybe<Scalars['String']['input']>
  /** state code in ISO_3166-2:MX format. */
  stateCode?: InputMaybe<Scalars['String']['input']>
  /** tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  /** timezone */
  timezone?: InputMaybe<Scalars['String']['input']>
}

/** update company input. only the fields to change should be included. */
export type UpdateCompanyInput = {
  /** company id */
  ID: Scalars['ID']['input']
  /** address */
  address?: InputMaybe<AddressUpdateInput>
  /** comments */
  comments?: InputMaybe<Scalars['String']['input']>
  /** domains */
  domains?: InputMaybe<Array<Scalars['String']['input']>>
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
  /** phone */
  phone?: InputMaybe<Scalars['String']['input']>
  /** company policy role id */
  policyRoleID?: InputMaybe<Scalars['String']['input']>
}

/** update company line input. only the fields to change should be included. */
export type UpdateCompanyLineInput = {
  /** amenities */
  amenities?: InputMaybe<Array<Amenity>>
  /** class */
  class?: InputMaybe<Class>
  /** company line id */
  id: Scalars['ID']['input']
  /** logoPath */
  logoPath?: InputMaybe<Scalars['String']['input']>
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
  /** refund rules */
  refundRules?: InputMaybe<Scalars['String']['input']>
}

/** update fare input */
export type UpdateFareInput = {
  /** fare id */
  id: Scalars['ID']['input']
  /** subtotal in cents */
  subtotal?: InputMaybe<Scalars['Int']['input']>
  /** VAT in cents */
  vat?: InputMaybe<Scalars['Int']['input']>
}

/** update place input */
export type UpdatePlaceInput = {
  /** address */
  address?: InputMaybe<AddressUpdateInput>
  /** amenities */
  amenities?: InputMaybe<Array<PlaceAmenity>>
  /** area */
  area?: InputMaybe<Scalars['String']['input']>
  /** directions */
  directions?: InputMaybe<Scalars['String']['input']>
  /** place id */
  id: Scalars['ID']['input']
  /** geolocation */
  location?: InputMaybe<LocationInput>
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
  /** unique human readable identifier for the place */
  param?: InputMaybe<Scalars['String']['input']>
  /** tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>
  /** place type */
  type?: InputMaybe<PlaceType>
}

/** update policy company role input */
export type UpdatePolicyCompanyRoleInput = {
  /** company role id */
  id: Scalars['ID']['input']
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
  /** policies to assign to the company role */
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

/** update policy private role input */
export type UpdatePolicyPrivateRoleInput = {
  /** private role id */
  id: Scalars['ID']['input']
  /** name */
  name?: InputMaybe<Scalars['String']['input']>
  /** policies to assign to the private role */
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>
}

export type UpdateSeasonEventInput = {
  activePeriods?: InputMaybe<Array<ActivePeriodInput>>
  id: Scalars['ID']['input']
  name?: InputMaybe<Scalars['String']['input']>
  routeServiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>
  segments?: InputMaybe<Array<Scalars['ID']['input']>>
  type?: InputMaybe<SeasonEventType>
}

/** update segment input */
export type UpdateSegmentInput = {
  /** company line specs */
  companyLineSpecs: Array<CompanyLineSpecInput>
  /** segment id */
  id: Scalars['ID']['input']
}

/** update template input */
export type UpdateVehicleTemplateInput = {
  id: Scalars['ID']['input']
  name: Scalars['String']['input']
}

/** user query input */
export type UserQueryInput = {
  /** user id */
  id: Scalars['ID']['input']
}

/** users query input */
export type UsersQueryInmput = {
  /** user id */
  id?: InputMaybe<Scalars['ID']['input']>
  /** filter by isActive */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
}

export type VehicleDocumentInput = {
  /** document category */
  category: DocumentCategory
  filePath: Scalars['String']['input']
}

/** vehicle query input */
export type VehicleQueryInput = {
  id: Scalars['ID']['input']
}

/** vehicles query input */
export type VehiclesQueryInput = {
  companyID?: InputMaybe<Scalars['ID']['input']>
}

export type BookingTicketFragmentFragment = {
  __typename?: 'BookingV2Ticket'
  id: any
  subtotal: number
  vat: number
  discount: number
  status: BookingV2TicketStatus
  isCheckedIn: boolean
  isRewardApplied: boolean
  cancellationSource?: BookingV2TicketCancellationSource | null
  seat?: { __typename?: 'BookingV2TicketSeat'; id: any; label: string } | null
  passenger?: {
    __typename?: 'BookingV2Passenger'
    id: any
    firstName: string
    lastName: string
    type: { __typename?: 'BookingV2PassengerType'; id: any; name: string }
    properties: Array<{ __typename?: 'BookingV2PassengerProperty'; id: any; name: string }>
  } | null
  trip?: {
    __typename?: 'BookingV2Trip'
    id: any
    segment: { __typename?: 'BookingV2TripSegment'; id: any; departureAt: any }
  } | null
  serviceFee?: { __typename?: 'BookingV2TicketServiceFee'; price: number } | null
  ancillaries?: Array<{
    __typename?: 'BookingV2TicketAncillary'
    id: any
    type: BookingV2TicketAncillaryType
    total: number
    status: BookingV2TicketAncillaryStatus
    unitPrice: number
    quantity: number
  }> | null
} & { ' $fragmentName'?: 'BookingTicketFragmentFragment' }

export type BookingTripFragmentFragment = {
  __typename?: 'BookingV2Trip'
  id: any
  checkInScore?: number | null
  companyLine: { __typename?: 'BookingV2TripCompanyLine'; id: any; name: string }
  segment: {
    __typename?: 'BookingV2TripSegment'
    id: any
    departureAt: any
    fare?: { __typename?: 'BookingV2TripSegmentFare'; id: any; basePrice: number } | null
    origin: {
      __typename?: 'BookingV2TripSegmentPlace'
      id: any
      name: string
      city: { __typename?: 'BookingV2TripSegmentPlaceCity'; id: any; name: string; timezone: any }
    }
    destination: {
      __typename?: 'BookingV2TripSegmentPlace'
      id: any
      name: string
      city: { __typename?: 'BookingV2TripSegmentPlaceCity'; id: any; name: string; timezone: any }
    }
  }
} & { ' $fragmentName'?: 'BookingTripFragmentFragment' }

export type GetBookingQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['UUID']['input']> | Scalars['UUID']['input']>
}>

export type GetBookingQuery = {
  __typename?: 'Query'
  bookingsV2: {
    __typename?: 'BookingsV2Response'
    items: Array<{
      __typename?: 'BookingV2'
      id: any
      vertical: BookingV2Vertical
      salesChannel: { __typename?: 'BookingV2SalesChannel'; id: any; name: string }
      currency: { __typename?: 'BookingV2Currency'; id: any; code: string }
      buyer?: {
        __typename?: 'BookingV2Buyer'
        firstName: string
        lastName: string
        email: string
        phone: string
      } | null
      coupon?: {
        __typename?: 'BookingV2Coupon'
        id: any
        value: number
        discountType: BookingV2CouponDiscountType
        code: string
      } | null
      payments: Array<{
        __typename?: 'BookingV2Payment'
        id: any
        method: BookingV2PaymentMethod
        processor?: BookingV2PaymentProcessor | null
        status: BookingV2PaymentStatus
        chargeID?: string | null
        authCode?: string | null
        last4?: string | null
        amount: number
        tickets: Array<{
          __typename?: 'BookingV2PaymentTicket'
          id: any
          subtotal: number
          vat: number
          discount: number
        }>
      }>
      departureTrips: Array<
        { __typename?: 'BookingV2Trip' } & {
          ' $fragmentRefs'?: { BookingTripFragmentFragment: BookingTripFragmentFragment }
        }
      >
      returnTrips: Array<
        { __typename?: 'BookingV2Trip' } & {
          ' $fragmentRefs'?: { BookingTripFragmentFragment: BookingTripFragmentFragment }
        }
      >
      tickets: Array<
        { __typename?: 'BookingV2Ticket' } & {
          ' $fragmentRefs'?: { BookingTicketFragmentFragment: BookingTicketFragmentFragment }
        }
      >
      refunds: Array<{ __typename?: 'BookingV2Refund'; amount: number }>
    }>
  }
}

export type GetBookingsQueryVariables = Exact<{
  pagination: PaginationV2
  input: BookingsV2Input
}>

export type GetBookingsQuery = {
  __typename?: 'Query'
  bookingsV2: {
    __typename?: 'BookingsV2Response'
    total: number
    items: Array<{
      __typename?: 'BookingV2'
      id: any
      createdAt: any
      confirmedAt?: any | null
      vertical: BookingV2Vertical
      isHomePickup: boolean
      status: BookingV2Status
      isTaxInvoiced: boolean
      invoicedBy?: BookingInvoicedBy | null
      isTaxInvoiceable: boolean
      userAccount?: {
        __typename?: 'BookingV2UserAccount'
        email?: string | null
        id: any
        firstName?: string | null
        lastName?: string | null
        phoneNumber?: { __typename?: 'PhoneNumber'; countryCode: string; number: string } | null
      } | null
      client?: { __typename?: 'BookingV2Client'; source: BookingV2ClientSource } | null
      country: { __typename?: 'BookingV2Country'; id: any; code: string }
      currency: { __typename?: 'BookingV2Currency'; id: any; code: string }
      salesChannel: { __typename?: 'BookingV2SalesChannel'; id: any; name: string; type: BookingV2SalesChannelType }
      businessClient?: { __typename?: 'BookingV2BusinessClient'; id: any; name: string } | null
      buyer?: {
        __typename?: 'BookingV2Buyer'
        firstName: string
        lastName: string
        email: string
        phone: string
      } | null
      coupon?: {
        __typename?: 'BookingV2Coupon'
        value: number
        discountType: BookingV2CouponDiscountType
        code: string
      } | null
      payments: Array<{
        __typename?: 'BookingV2Payment'
        id: any
        method: BookingV2PaymentMethod
        processor?: BookingV2PaymentProcessor | null
        status: BookingV2PaymentStatus
        chargeID?: string | null
        authCode?: string | null
        last4?: string | null
        amount: number
        paymentListID?: any | null
        user?: { __typename?: 'BookingV2PaymentUser'; firstName: string; lastName: string } | null
        tickets: Array<{
          __typename?: 'BookingV2PaymentTicket'
          id: any
          subtotal: number
          vat: number
          discount: number
        }>
      }>
      refunds: Array<{ __typename?: 'BookingV2Refund'; paymentID: any; amount: number }>
      departureTrips: Array<
        { __typename?: 'BookingV2Trip' } & {
          ' $fragmentRefs'?: { BookingTripFragmentFragment: BookingTripFragmentFragment }
        }
      >
      returnTrips: Array<
        { __typename?: 'BookingV2Trip' } & {
          ' $fragmentRefs'?: { BookingTripFragmentFragment: BookingTripFragmentFragment }
        }
      >
      tickets: Array<
        { __typename?: 'BookingV2Ticket' } & {
          ' $fragmentRefs'?: { BookingTicketFragmentFragment: BookingTicketFragmentFragment }
        }
      >
      emailsSent: Array<{
        __typename?: 'BookingV2EmailSent'
        id: any
        address: string
        status: string
        reason?: string | null
        updatedAt: any
      }>
      supportInteractions: Array<{
        __typename?: 'BookingV2SupportInteraction'
        createdAt: any
        notificationChannel?: BookingV2SupportInteractionNotificationChannel | null
        callStatus?: BookingV2SupportInteractionCallStatus | null
        notes?: string | null
        user: { __typename?: 'BookingV2SupportInteractionUser'; username: string }
      }>
    }>
  }
}

export type CreateBusinessClientsRouteServicesSchedulePriceMutationVariables = Exact<{
  input: CreateBusinessClientsRouteServicesSchedulePriceInput
}>

export type CreateBusinessClientsRouteServicesSchedulePriceMutation = {
  __typename?: 'Mutation'
  createBusinessClientsRouteServicesSchedulePrice: boolean
}

export type GetBusinessClientUsersQueryVariables = Exact<{
  input: BusinessClientUsersInput
  pagination?: InputMaybe<PaginationV2>
}>

export type GetBusinessClientUsersQuery = {
  __typename?: 'Query'
  businessClientUsers: {
    __typename?: 'BusinessClientUsersResponse'
    total: number
    items: Array<{
      __typename?: 'BusinessClientUser'
      id: any
      isActive: boolean
      title: string
      hasAdminRole: boolean
      createdAt: any
      updatedAt: any
      userAccount: {
        __typename?: 'BusinessClientUserUserAccount'
        id: any
        firstName?: string | null
        lastName?: string | null
        email?: string | null
        phoneNumber?: {
          __typename?: 'BusinessClientUserUserAccountPhoneNumber'
          countryCode: string
          number: string
        } | null
      }
      businessClient: { __typename?: 'BusinessClientUserBusinessClient'; id: any; name: string }
      businessSite?: { __typename?: 'BusinessClientUserBusinessSite'; id: any; name: string } | null
    }>
  }
}

export type GetBusinessClientUserQueryVariables = Exact<{
  id: Scalars['UUID']['input']
}>

export type GetBusinessClientUserQuery = {
  __typename?: 'Query'
  businessClientUser: {
    __typename?: 'BusinessClientUser'
    id: any
    isActive: boolean
    hasAdminRole: boolean
    title: string
    createdAt: any
    updatedAt: any
    userAccount: {
      __typename?: 'BusinessClientUserUserAccount'
      id: any
      firstName?: string | null
      lastName?: string | null
      email?: string | null
      phoneNumber?: {
        __typename?: 'BusinessClientUserUserAccountPhoneNumber'
        countryCode: string
        number: string
      } | null
    }
    businessClient: { __typename?: 'BusinessClientUserBusinessClient'; id: any; name: string }
    businessSite?: { __typename?: 'BusinessClientUserBusinessSite'; id: any; name: string } | null
  }
}

export type CreateBusinessClientUserMutationVariables = Exact<{
  input: CreateBusinessClientUserInput
}>

export type CreateBusinessClientUserMutation = { __typename?: 'Mutation'; createBusinessClientUser: boolean }

export type ChangeBusinessClientUserMutationVariables = Exact<{
  input: ChangeBusinessClientUserInput
}>

export type ChangeBusinessClientUserMutation = { __typename?: 'Mutation'; changeBusinessClientUser: boolean }

export type ActivateBusinessClientMutationVariables = Exact<{
  id: Scalars['UUID']['input']
}>

export type ActivateBusinessClientMutation = { __typename?: 'Mutation'; activateBusinessClient: boolean }

export type DeactivateBusinessClientMutationVariables = Exact<{
  id: Scalars['UUID']['input']
}>

export type DeactivateBusinessClientMutation = { __typename?: 'Mutation'; deactivateBusinessClient: boolean }

export type ActivateBusinessClientUserMutationVariables = Exact<{
  input: ActivateBusinessClientUserInput
}>

export type ActivateBusinessClientUserMutation = { __typename?: 'Mutation'; activateBusinessClientUser: boolean }

export type DeactivateBusinessClientUserMutationVariables = Exact<{
  input: DeactivateBusinessClientUserInput
}>

export type DeactivateBusinessClientUserMutation = { __typename?: 'Mutation'; deactivateBusinessClientUser: boolean }

export type AssignBusinessClientSimsMutationVariables = Exact<{
  input: AssignBusinessClientSimsInput
}>

export type AssignBusinessClientSimsMutation = { __typename?: 'Mutation'; assignBusinessClientSims: boolean }

export type RequestBusinessClientKreditDepositMutationVariables = Exact<{
  input: RequestBusinessClientKreditDepositInput
}>

export type RequestBusinessClientKreditDepositMutation = {
  __typename?: 'Mutation'
  requestBusinessClientKreditDeposit: boolean
}

export type CancelBusinessClientKreditDepositMutationVariables = Exact<{
  input: CancelBusinessClientKreditDepositInput
}>

export type CancelBusinessClientKreditDepositMutation = {
  __typename?: 'Mutation'
  cancelBusinessClientKreditDeposit: boolean
}

export type ChangeBusinessClientUserBusinessClientMutationVariables = Exact<{
  input: ChangeBusinessClientUserBusinessClientInput
}>

export type ChangeBusinessClientUserBusinessClientMutation = {
  __typename?: 'Mutation'
  changeBusinessClientUserBusinessClient: boolean
}

export type ChangeBusinessCustomerBusinessClientMutationVariables = Exact<{
  input: ChangeBusinessCustomerBusinessClientInput
}>

export type ChangeBusinessCustomerBusinessClientMutation = {
  __typename?: 'Mutation'
  changeBusinessCustomerBusinessClient: boolean
}

export type ChangeFragmentFragment = {
  __typename?: 'Change'
  id: string
  status?: ChangeStatus | null
  type: ChangeType
  statusChanges: Array<{ __typename?: 'StatusChange'; status: ChangeStatus; changedAt: any }>
  user: { __typename?: 'ChangeUser'; id: string; username: string; firstName: string; lastName: string }
  bookings: Array<{ __typename?: 'ChangeBooking'; id: string }>
  trips: Array<{ __typename?: 'ChangeTrip'; id: string; departureAt: any }>
  difference: Array<{
    __typename?: 'ChangeDifference'
    routeService: { __typename?: 'ChangeRouteService'; id: string; code: string }
    vehicle?: {
      __typename?: 'VehicleDifference'
      old: {
        __typename?: 'ChangeVehicle'
        id: string
        name: string
        capacity: number
        partner: { __typename?: 'Partner'; name: string; externalID: string }
      }
      new: {
        __typename?: 'ChangeVehicle'
        id: string
        name: string
        capacity: number
        partner: { __typename?: 'Partner'; name: string; externalID: string }
      }
    } | null
    segments?: {
      __typename?: 'SegmentsDifference'
      old: Array<{
        __typename?: 'ChangeSegment'
        id: string
        origin: { __typename?: 'ChangePlace'; id: string; name: string; code: string; timezone: string }
        destination: { __typename?: 'ChangePlace'; id: string; name: string; code: string; timezone: string }
      }>
      new: Array<{
        __typename?: 'ChangeSegment'
        id: string
        origin: { __typename?: 'ChangePlace'; id: string; name: string; code: string; timezone: string }
        destination: { __typename?: 'ChangePlace'; id: string; name: string; code: string; timezone: string }
      }>
    } | null
    itinerary?: {
      __typename?: 'ItineraryDifference'
      old: Array<{
        __typename?: 'ChangeStop'
        departureAt?: any | null
        arrivalAt?: any | null
        origin: { __typename?: 'ChangePlace'; id: string; name: string; code: string; timezone: string }
      }>
      new: Array<{
        __typename?: 'ChangeStop'
        departureAt?: any | null
        arrivalAt?: any | null
        origin: { __typename?: 'ChangePlace'; id: string; name: string; code: string; timezone: string }
      }>
    } | null
  }>
} & { ' $fragmentName'?: 'ChangeFragmentFragment' }

export type GetExecutedChangesQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>
  input?: InputMaybe<ChangesQueryInput>
}>

export type GetExecutedChangesQuery = {
  __typename?: 'Query'
  changes: {
    __typename?: 'ChangesResponse'
    total: number
    items: Array<
      { __typename?: 'Change'; movedBookings: Array<{ __typename?: 'ChangeBooking'; id: string }> } & {
        ' $fragmentRefs'?: { ChangeFragmentFragment: ChangeFragmentFragment }
      }
    >
  }
}

export type GetScheduledChangesQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>
  input?: InputMaybe<ChangesQueryInput>
}>

export type GetScheduledChangesQuery = {
  __typename?: 'Query'
  changes: {
    __typename?: 'ChangesResponse'
    total: number
    items: Array<
      { __typename?: 'Change'; executeAt?: any | null } & {
        ' $fragmentRefs'?: { ChangeFragmentFragment: ChangeFragmentFragment }
      }
    >
  }
}

export type GetCitiesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationV2>
  input?: InputMaybe<TCitiesInput>
}>

export type GetCitiesQuery = {
  __typename?: 'Query'
  tcities: {
    __typename?: 'TCitiesResponse'
    total: number
    items: Array<{
      __typename?: 'TCity'
      id: any
      name: string
      stateCode?: string | null
      countryCode?: string | null
      tags: Array<string>
      code: string
      places: Array<{ __typename?: 'TPlace'; id: any; name: string }>
    }>
  }
}

export type CreateCompanyV2MutationVariables = Exact<{
  input: CreateCompanyV2Input
}>

export type CreateCompanyV2Mutation = { __typename?: 'Mutation'; createCompanyV2: boolean }

export type GetBusinessSiteKreditsSettingsQueryVariables = Exact<{
  id: Scalars['UUID']['input']
}>

export type GetBusinessSiteKreditsSettingsQuery = {
  __typename?: 'Query'
  businessSite: {
    __typename?: 'BusinessSite'
    id: any
    kreditsSettings?: Array<{
      __typename?: 'KreditCategory'
      amount: number
      name: number
      frequency: { __typename?: 'Frequency'; unit: FrequencyUnit; value: number }
    }> | null
  }
}

export type CreateOperationalCostMutationVariables = Exact<{
  input: CreateOperationalCostInput
}>

export type CreateOperationalCostMutation = {
  __typename?: 'Mutation'
  createOperationalCost: { __typename?: 'CreateOperationalCostResponse'; id: any; isNew: boolean }
}

export type ChangeOperationalCostSettingsMutationVariables = Exact<{
  input: ChangeOperationalCostSettingsInput
}>

export type ChangeOperationalCostSettingsMutation = { __typename?: 'Mutation'; changeOperationalCostSettings: boolean }

export type UploadOperationalCostSettingsMutationVariables = Exact<{
  input: UploadOperationalCostSettingsInput
}>

export type UploadOperationalCostSettingsMutation = { __typename?: 'Mutation'; uploadOperationalCostSettings: boolean }

export type GetOperationalCostsQueryVariables = Exact<{
  input?: InputMaybe<OperationalCostsInput>
  pagination?: InputMaybe<PaginationV2>
}>

export type GetOperationalCostsQuery = {
  __typename?: 'Query'
  operationalCosts: {
    __typename?: 'OperationalCostsResponse'
    total: number
    items: Array<{
      __typename?: 'OperationalCost'
      id: any
      stateCode: string
      vehicleCapacity: number
      vehicleType: OperationalCostVehicleType
      settings: {
        __typename?: 'OperationalCostSettings'
        costs: {
          __typename?: 'OperationalCostSettingsCosts'
          fixedCost: number
          durationCost: number
          costPerKm: number
          costPerDriver: number
        }
        factors: {
          __typename?: 'OperationalCostSettingsFactors'
          airConditioning: number
          baseDistance: number
          perKm: number
          redZone: number
          duration: Array<{
            __typename?: 'OperationalCostSettingsFactorsDuration'
            start: number
            end: number
            value: number
          }>
        }
      }
    }>
  }
}

export type UpsertPartnerCostsMutationVariables = Exact<{
  input: UpsertPartnerCostsInput
}>

export type UpsertPartnerCostsMutation = { __typename?: 'Mutation'; upsertPartnerCosts: boolean }

export type CreatePaymentSummaryMutationVariables = Exact<{
  input: CreatePartnersPaymentSummaryInput
}>

export type CreatePaymentSummaryMutation = {
  __typename?: 'Mutation'
  createPartnersPaymentSummary: { __typename?: 'CreatePartnersPaymentSummaryResponse'; id: any }
}

export type AddPaymentSummaryFilesMutationVariables = Exact<{
  input: AddPartnersPaymentSummaryFilesInput
}>

export type AddPaymentSummaryFilesMutation = { __typename?: 'Mutation'; addPartnersPaymentSummaryFiles: boolean }

export type SendPartnersPaymentSummaryEmailsMutationVariables = Exact<{
  input: SendPartnersPaymentSummaryEmailsInput
}>

export type SendPartnersPaymentSummaryEmailsMutation = {
  __typename?: 'Mutation'
  sendPartnersPaymentSummaryEmails: boolean
}

export type GetPartnersPaymentsSummaryQueryVariables = Exact<{
  input?: InputMaybe<PartnersPaymentSummariesInput>
  pagination?: InputMaybe<PaginationV2>
}>

export type GetPartnersPaymentsSummaryQuery = {
  __typename?: 'Query'
  partnersPaymentSummaries: {
    __typename?: 'PartnersPaymentSummariesResponse'
    total: number
    items: Array<{
      __typename?: 'PartnersPaymentSummary'
      id: any
      name: string
      status: PartnersPaymentSummaryStatus
      startDate: string
      endDate: string
      files: Array<{
        __typename?: 'PartnersPaymentSummaryFile'
        id: any
        category: PartnersPaymentSummaryFileCategory
        errorsFilePath?: string | null
      }>
      timeline: Array<{
        __typename?: 'PartnersPaymentSummaryTimelineEvent'
        id: any
        correlationID: any
        type: string
        createdAt: any
        user: { __typename?: 'TimelineEventUser'; id: any; firstName: string; lastName: string; username: string }
        action?: {
          __typename?: 'PartnersPaymentSummaryTimelineEventActionFilesUploaded'
          files: Array<{
            __typename?: 'PartnersPaymentSummaryFile'
            id: any
            category: PartnersPaymentSummaryFileCategory
            path: string
          }>
        } | null
      }>
      emails: Array<{
        __typename?: 'SummaryEmail'
        id: any
        address: string
        status: string
        reason?: string | null
        updatedAt: any
        partner: { __typename?: 'SummaryEmailPartner'; id: any; name: string }
      }>
    }>
  }
}

export type GetPartnersPaymentSummaryQueryVariables = Exact<{
  input: PartnersPaymentSummaryInput
}>

export type GetPartnersPaymentSummaryQuery = {
  __typename?: 'Query'
  partnersPaymentSummary: {
    __typename?: 'PartnersPaymentSummary'
    id: any
    name: string
    status: PartnersPaymentSummaryStatus
    startDate: string
    endDate: string
    files: Array<{
      __typename?: 'PartnersPaymentSummaryFile'
      id: any
      category: PartnersPaymentSummaryFileCategory
      errorsFilePath?: string | null
    }>
    emails: Array<{
      __typename?: 'SummaryEmail'
      id: any
      address: string
      status: string
      reason?: string | null
      updatedAt: any
      partner: { __typename?: 'SummaryEmailPartner'; id: any; name: string }
    }>
  }
}

export type GetRoutesPlanningQueryVariables = Exact<{
  pagination?: InputMaybe<TPagination>
  input?: InputMaybe<TRoutesInput>
}>

export type GetRoutesPlanningQuery = {
  __typename?: 'Query'
  troutes: {
    __typename?: 'TRoutesResponse'
    total: number
    items: Array<{
      __typename?: 'TRoute'
      id: any
      name?: string | null
      polyline?: { __typename?: 'TRoutePolyline'; encoded: string; distance: number } | null
      stops: Array<{
        __typename?: 'TRouteStop'
        id: any
        name: string
        code: string
        address?: {
          __typename?: 'RouteStopAddress'
          line1: string
          line2?: string | null
          city: string
          stateCode: string
          countryCode: string
          zipCode: string
        } | null
        coordinates?: { __typename?: 'RouteStopCoordinates'; latitude: string; longitude: string } | null
      }>
      services: Array<{ __typename?: 'TRouteRouteService'; id: any; isActive: boolean; code: string }>
    }>
  }
}

export type CreateRoutingProjectMutationVariables = Exact<{
  input: CreateRoutingProjectInput
}>

export type CreateRoutingProjectMutation = {
  __typename?: 'Mutation'
  createRoutingProject: { __typename?: 'CreateRoutingProjectResponse'; id: any }
}

export type ChangeRoutingProjectMutationVariables = Exact<{
  input: ChangeRoutingProjectInput
}>

export type ChangeRoutingProjectMutation = { __typename?: 'Mutation'; changeRoutingProject: boolean }

export type CreateRoutingProjectDatasetMutationVariables = Exact<{
  input: CreateRoutingProjectDatasetInput
}>

export type CreateRoutingProjectDatasetMutation = {
  __typename?: 'Mutation'
  createRoutingProjectDataset: { __typename?: 'CreateRoutingProjectDatasetResponse'; id: any }
}

export type CreateRoutingProjectPlanMutationVariables = Exact<{
  input: CreateRoutingProjectPlanInput
}>

export type CreateRoutingProjectPlanMutation = {
  __typename?: 'Mutation'
  createRoutingProjectPlan: { __typename?: 'CreateRoutingProjectPlanResponse'; id: any }
}

export type ChangeRoutingProjectPlanConstraintsMutationVariables = Exact<{
  input: ChangeRoutingProjectPlanConstraintsInput
}>

export type ChangeRoutingProjectPlanConstraintsMutation = {
  __typename?: 'Mutation'
  changeRoutingProjectPlanConstraints: boolean
}

export type CreateRoutingProjectPlanOptimizationMutationVariables = Exact<{
  input: CreateRoutingProjectPlanOptimizationInput
}>

export type CreateRoutingProjectPlanOptimizationMutation = {
  __typename?: 'Mutation'
  createRoutingProjectPlanOptimization: boolean
}

export type ChangeRoutingProjectPlanDatasetLocationsMutationVariables = Exact<{
  input: ChangeRoutingProjectPlanDatasetLocationsInput
}>

export type ChangeRoutingProjectPlanDatasetLocationsMutation = {
  __typename?: 'Mutation'
  changeRoutingProjectPlanDatasetLocations: boolean
}

export type ChangeRoutingProjectPlanOptimizationRouteStopsMutationVariables = Exact<{
  input: ChangeRoutingProjectPlanOptimizationRouteStopsInput
}>

export type ChangeRoutingProjectPlanOptimizationRouteStopsMutation = {
  __typename?: 'Mutation'
  changeRoutingProjectPlanOptimizationRouteStops: boolean
}

export type RemoveRoutingProjectPlanDatasetLocationsMutationVariables = Exact<{
  input: RemoveRoutingProjectPlanDatasetLocationsInput
}>

export type RemoveRoutingProjectPlanDatasetLocationsMutation = {
  __typename?: 'Mutation'
  removeRoutingProjectPlanDatasetLocations: boolean
}

export type AddRoutingProjectPlanDatasetLocationsMutationVariables = Exact<{
  input: AddRoutingProjectPlanDatasetLocationsInput
}>

export type AddRoutingProjectPlanDatasetLocationsMutation = {
  __typename?: 'Mutation'
  addRoutingProjectPlanDatasetLocations: {
    __typename?: 'AddRoutingProjectPlanDatasetLocationsResponse'
    locations: Array<{ __typename?: 'AddRoutingProjectPlanDatasetLocationsLocationResponse'; id: any }>
  }
}

export type RoutingProjectPlanFragment = {
  __typename?: 'RoutingProjectPlan'
  id: any
  name: string
  status: RoutingProjectPlanStatus
  dataset: {
    __typename?: 'RoutingProjectDataset'
    name: string
    locations: Array<{
      __typename?: 'RoutingProjectDatasetLocation'
      id: any
      label: string
      coordinates: { __typename?: 'RoutingProjectDatasetLocationCoordinates'; latitude: string; longitude: string }
    }>
  }
  constraints?: {
    __typename?: 'RoutingProjectPlanConstraints'
    maxStops?: number | null
    maxDuration?: number | null
    maxDistance?: number | null
    stopDuration?: number | null
    startTime?: string | null
    endTime?: string | null
    origin?: { __typename?: 'RoutingProjectPlanConstraintsLocation'; id: any; label: string } | null
    destination?: { __typename?: 'RoutingProjectPlanConstraintsLocation'; id: any; label: string } | null
    vehicles?: Array<{ __typename?: 'RoutingProjectPlanConstraintsVehicle'; number: number; capacity: number }> | null
  } | null
  optimization?: {
    __typename?: 'RoutingProjectPlanOptimization'
    routes: Array<{
      __typename?: 'RoutingProjectPlanOptimizationRoute'
      id: any
      polyline: string
      distance: number
      duration: number
      stops: Array<{
        __typename?: 'RoutingProjectPlanOptimizationRouteStop'
        arrival?: { __typename?: 'RoutingProjectPlanOptimizationRouteStopTime'; day: number; time: string } | null
        departure?: { __typename?: 'RoutingProjectPlanOptimizationRouteStopTime'; day: number; time: string } | null
        location: {
          __typename?: 'RoutingProjectDatasetLocation'
          id: any
          label: string
          coordinates: { __typename?: 'RoutingProjectDatasetLocationCoordinates'; latitude: string; longitude: string }
        }
      }>
    }>
    skippedLocations: Array<{
      __typename?: 'RoutingProjectPlanOptimizationSkippedLocation'
      reasons: Array<RoutingProjectPlanOptimizationSkippedLocationReason>
      location: {
        __typename?: 'RoutingProjectDatasetLocation'
        id: any
        label: string
        coordinates: { __typename?: 'RoutingProjectDatasetLocationCoordinates'; latitude: string; longitude: string }
      }
    }>
  } | null
} & { ' $fragmentName'?: 'RoutingProjectPlanFragment' }

export type RoutingProjectDatasetFragment = {
  __typename?: 'RoutingProjectDataset'
  id: any
  name: string
  locations: Array<{
    __typename?: 'RoutingProjectDatasetLocation'
    id: any
    label: string
    coordinates: { __typename?: 'RoutingProjectDatasetLocationCoordinates'; latitude: string; longitude: string }
  }>
} & { ' $fragmentName'?: 'RoutingProjectDatasetFragment' }

export type RoutingProjectFragment = {
  __typename?: 'RoutingProject'
  id: any
  name: string
  tags?: Array<string> | null
  plans: Array<
    { __typename?: 'RoutingProjectPlan' } & {
      ' $fragmentRefs'?: { RoutingProjectPlanFragment: RoutingProjectPlanFragment }
    }
  >
  datasets: Array<
    { __typename?: 'RoutingProjectDataset' } & {
      ' $fragmentRefs'?: { RoutingProjectDatasetFragment: RoutingProjectDatasetFragment }
    }
  >
} & { ' $fragmentName'?: 'RoutingProjectFragment' }

export type RoutingProjectsQueryVariables = Exact<{
  input: RoutingProjectsInput
  pagination?: InputMaybe<PaginationV2>
}>

export type RoutingProjectsQuery = {
  __typename?: 'Query'
  routingProjects: {
    __typename?: 'RoutingProjectsResponse'
    total: number
    items: Array<
      { __typename?: 'RoutingProject' } & { ' $fragmentRefs'?: { RoutingProjectFragment: RoutingProjectFragment } }
    >
  }
}

export type GetRoutingProjectQueryVariables = Exact<{
  input: RoutingProjectInput
}>

export type GetRoutingProjectQuery = {
  __typename?: 'Query'
  routingProject: {
    __typename?: 'RoutingProjectResponse'
    routingProject: { __typename?: 'RoutingProject' } & {
      ' $fragmentRefs'?: { RoutingProjectFragment: RoutingProjectFragment }
    }
  }
}

export type GetRoutingProjectsTagsQueryVariables = Exact<{ [key: string]: never }>

export type GetRoutingProjectsTagsQuery = {
  __typename?: 'Query'
  routingProjectsTags: { __typename?: 'RoutingProjectsTagsResponse'; tags: Array<string> }
}

export type GetRoutingProjectPlanQueryVariables = Exact<{
  input: RoutingProjectPlanInput
}>

export type GetRoutingProjectPlanQuery = {
  __typename?: 'Query'
  routingProjectPlan: {
    __typename?: 'RoutingProjectPlanResponse'
    plan: { __typename?: 'RoutingProjectPlan' } & {
      ' $fragmentRefs'?: { RoutingProjectPlanFragment: RoutingProjectPlanFragment }
    }
  }
}

export type CreateServiceVehicleOverrideMutationVariables = Exact<{
  input: CreateRouteServiceVehicleOverrideInput
}>

export type CreateServiceVehicleOverrideMutation = {
  __typename?: 'Mutation'
  createRouteServiceVehicleOverride: boolean
}

export type CreateServicePastVehicleOverrideMutationVariables = Exact<{
  input: CreateRouteServicePastVehicleOverrideInput
}>

export type CreateServicePastVehicleOverrideMutation = {
  __typename?: 'Mutation'
  createRouteServicePastVehicleOverride: boolean
}

export type CreateServiceDriverOverrideMutationVariables = Exact<{
  input: CreateRouteServiceDriverOverrideInput
}>

export type CreateServiceDriverOverrideMutation = { __typename?: 'Mutation'; createRouteServiceDriverOverride: boolean }

export type CreateServiceItineraryOverrideMutationVariables = Exact<{
  input: CreateRouteServiceItineraryOverrideInput
}>

export type CreateServiceItineraryOverrideMutation = {
  __typename?: 'Mutation'
  createRouteServiceItineraryOverride: boolean
}

export type CreateServiceRouteOverrideMutationVariables = Exact<{
  input: CreateRouteServiceRouteOverrideInput
}>

export type CreateServiceRouteOverrideMutation = { __typename?: 'Mutation'; createRouteServiceRouteOverride: boolean }

export type GetServicesQueryVariables = Exact<{
  pagination?: InputMaybe<Pagination>
  input?: InputMaybe<ServicesQueryInput>
}>

export type GetServicesQuery = {
  __typename?: 'Query'
  servicesWithPagination: {
    __typename?: 'ServicesResponse'
    total: number
    items: Array<{
      __typename?: 'Service'
      id: string
      code?: string | null
      isActive: boolean
      isDeletable: boolean
      dow?: Array<DayOfWeek> | null
      startAt: string
      endAt?: string | null
      businessClients?: Array<{
        __typename?: 'RouteServiceBusinessClient'
        id: string
        name: string
        businessSites?: Array<{ __typename?: 'RouteServiceBusinessSite'; id: string; name: string }> | null
      }> | null
      confirmationModalities: {
        __typename?: 'ConfirmationModalities'
        paid: boolean
        reserved: boolean
        facebook: boolean
      }
      companyLine: {
        __typename?: 'RouteServiceCompanyLine'
        id: string
        name: string
        company: { __typename?: 'RouteServiceCompany'; id: string }
      }
      itinerariesSchedule: Array<{
        __typename?: 'RouteServiceItinerarySchedule'
        id: string
        startAt: any
        endAt?: any | null
        dow: Array<Weekday>
        route: {
          __typename?: 'RouteServiceRoute'
          id: string
          stops: Array<{ __typename?: 'RouteServiceRouteStop'; id: string }>
        }
        itinerary: Array<{
          __typename?: 'RouteServiceItineraryStop'
          placeID: string
          departure?: { __typename?: 'RouteServiceItineraryTime'; time: string; day: number } | null
          arrival?: { __typename?: 'RouteServiceItineraryTime'; time: string; day: number } | null
        }>
      }>
      vehiclesSchedule: Array<{
        __typename?: 'RouteServiceVehicleSchedule'
        id: string
        vehicle: {
          __typename?: 'RouteServiceVehicle'
          id?: string | null
          name?: string | null
          externalID?: string | null
        }
        driver?: {
          __typename?: 'RouteServiceVehicleScheduleDriver'
          id: string
          userAccount: {
            __typename?: 'RouteServiceVehicleScheduleDriverUserAccount'
            id: string
            firstName: string
            lastName: string
          }
        } | null
      }>
    }>
  }
}

export type AddTripDriverRsvpNoteMutationVariables = Exact<{
  input: AddTripDriverRsvpNoteInput
}>

export type AddTripDriverRsvpNoteMutation = { __typename?: 'Mutation'; addTripDriverRSVPNote: boolean }

export type AddTripDriverRealDistanceNoteMutationVariables = Exact<{
  input: RegisterTripOdometerDistanceInput
}>

export type AddTripDriverRealDistanceNoteMutation = { __typename?: 'Mutation'; registerTripOdometerDistance: boolean }

export type GetTripDriverQueryVariables = Exact<{
  input: TDriverInput
}>

export type GetTripDriverQuery = {
  __typename?: 'Query'
  tdriver: {
    __typename?: 'TDriver'
    id: any
    partner: { __typename?: 'TDriverPartner'; id: any; name: string }
    userAccount: {
      __typename?: 'TDriverUserAccount'
      id: any
      firstName?: string | null
      lastName?: string | null
      email?: string | null
      gender?: string | null
      phoneNumber?: { __typename?: 'PhoneNumber'; number: string; countryCode: string } | null
    }
    documents: Array<{
      __typename?: 'TDriverDocument'
      category: TDriverDocumentCategory
      document: { __typename?: 'Asset'; name: string; path: string }
    }>
  }
}

export type TripNotesFragment = {
  __typename?: 'TripV2'
  notes?: Array<{
    __typename?: 'TripV2Note'
    category?: TripV2NoteCategory | null
    subcategory?: TripV2NoteSubcategory | null
    message?: string | null
    changeType?: TripV2NoteChangeType | null
    createdAt: any
    distance?: number | null
    user?: { __typename?: 'TripV2User'; id: any; firstName: string; lastName: string; username: string } | null
    files?: Array<{ __typename?: 'TripV2NoteFile'; name: string; path: string }> | null
    cashFlow?: { __typename?: 'TripV2NoteCashFlow'; type: string; amount: number } | null
    driver?: {
      __typename?: 'TripNoteDriver'
      id: any
      firstName: string
      lastName: string
      rsvpStatus: TripNoteDriverRsvpStatus
    } | null
  }> | null
} & { ' $fragmentName'?: 'TripNotesFragment' }

export type GetTripV2QueryVariables = Exact<{
  input: TripV2Input
}>

export type GetTripV2Query = {
  __typename?: 'Query'
  tripV2: {
    __typename?: 'TripV2'
    id: any
    status: TripV2Status
    saleStatus: TripV2SaleStatus
    departureAt: any
    arrivalAt: any
    confirmedSeatsNumber: number
    serviceScore?: number | null
    availableSeatsNumber: number
    vertical: TripV2Vertical
    route: {
      __typename?: 'TripV2Route'
      id: any
      name?: string | null
      polyline?: { __typename?: 'TripRoutePolyline'; encoded: string } | null
    }
    routeService: {
      __typename?: 'TripV2RouteService'
      id: any
      code: string
      businessClients: Array<{
        __typename?: 'TripV2RouteServiceBusinessClient'
        id: any
        name: string
        businessSites: Array<{ __typename?: 'TripV2RouteServiceBusinessSite'; id: any; name: string }>
      }>
    }
    legSegments: Array<{
      __typename?: 'TripV2LegSegment'
      id: any
      destination: { __typename?: 'TripV2LegSegmentPlace'; id: any; name: string }
      origin: { __typename?: 'TripV2LegSegmentPlace'; id: any; name: string }
    }>
    company: { __typename?: 'TripV2Company'; id: any }
    companyLine: { __typename?: 'TripV2CompanyLine'; id: any; name: string }
    driver?: {
      __typename?: 'TripV2Driver'
      id: any
      firstName: string
      lastName: string
      RSVP?: { __typename?: 'TripV2DriverRSVP'; status: TripV2DriverRsvpStatus; attempt: number } | null
    } | null
    itinerary: Array<{
      __typename?: 'TripV2ItineraryStop'
      realDepartureTime?: any | null
      place: { __typename?: 'TripV2ItineraryStopPlace'; id: any; name: string; timezone: any }
      departure?: { __typename?: 'TripV2ItineraryStopTime'; day: number; time: string } | null
      arrival?: { __typename?: 'TripV2ItineraryStopTime'; day: number; time: string } | null
      checkIns?: Array<{
        __typename?: 'TripV2ItineraryStopCheck'
        at: any
        method: TripV2ItineraryStopCheckMethod
      }> | null
      checkOuts?: Array<{
        __typename?: 'TripV2ItineraryStopCheck'
        at: any
        method: TripV2ItineraryStopCheckMethod
      }> | null
    }>
    timeline: Array<{
      __typename?: 'TripV2TimelineEvent'
      correlationID: any
      placeID?: any | null
      type: string
      createdAt: any
      user: { __typename?: 'TripV2User'; id: any; firstName: string; lastName: string; username: string }
      tripCancellationReason?: {
        __typename?: 'TripV2TimelineEventTripCancellationReason'
        category?: TripV2CancellationReasonCategory | null
        subcategory?: TripV2CancellationReasonSubcategory | null
      } | null
    }>
    crewUsers: Array<{ __typename?: 'TripV2User'; id: any; firstName: string; lastName: string; username: string }>
    confirmationModalities: Array<{
      __typename?: 'TripV2ConfirmationModality'
      name: TripV2ConfirmationModalityName
      salesChannels: Array<{ __typename?: 'TripV2ConfirmationModalitySalesChannel'; id: any; name: string }>
      exceptions: {
        __typename?: 'TripV2ConfirmationModalityExceptions'
        places: Array<{ __typename?: 'TripV2ConfirmationModalityExceptionsPlace'; id: any; name: string }>
      }
    }>
    vehicle?: {
      __typename?: 'TripV2Vehicle'
      id: any
      externalID?: string | null
      name: string
      schedule?: { __typename?: 'TripV2VehicleSchedule'; id: any; type: TripV2VehicleScheduleType } | null
    } | null
  } & { ' $fragmentRefs'?: { TripNotesFragment: TripNotesFragment } }
}

export type GetTripsQueryVariables = Exact<{
  pagination: PaginationV2
  input: TripsV2Input
}>

export type GetTripsQuery = {
  __typename?: 'Query'
  tripsV2: {
    __typename?: 'TripsV2Response'
    total: number
    items: Array<
      {
        __typename?: 'TripV2'
        id: any
        status: TripV2Status
        saleStatus: TripV2SaleStatus
        departureAt: any
        arrivalAt: any
        confirmedSeatsNumber: number
        serviceScore?: number | null
        availableSeatsNumber: number
        vertical: TripV2Vertical
        route: { __typename?: 'TripV2Route'; id: any; name?: string | null }
        routeService: {
          __typename?: 'TripV2RouteService'
          id: any
          code: string
          businessClients: Array<{
            __typename?: 'TripV2RouteServiceBusinessClient'
            id: any
            name: string
            businessSites: Array<{ __typename?: 'TripV2RouteServiceBusinessSite'; id: any; name: string }>
          }>
        }
        legSegments: Array<{
          __typename?: 'TripV2LegSegment'
          id: any
          destination: { __typename?: 'TripV2LegSegmentPlace'; id: any; name: string }
          origin: { __typename?: 'TripV2LegSegmentPlace'; id: any; name: string }
        }>
        company: { __typename?: 'TripV2Company'; id: any }
        companyLine: { __typename?: 'TripV2CompanyLine'; id: any; name: string }
        vehicle?: {
          __typename?: 'TripV2Vehicle'
          id: any
          name: string
          externalID?: string | null
          schedule?: { __typename?: 'TripV2VehicleSchedule'; type: TripV2VehicleScheduleType } | null
        } | null
        driver?: {
          __typename?: 'TripV2Driver'
          id: any
          firstName: string
          lastName: string
          RSVP?: { __typename?: 'TripV2DriverRSVP'; status: TripV2DriverRsvpStatus; attempt: number } | null
        } | null
        itinerary: Array<{
          __typename?: 'TripV2ItineraryStop'
          realDepartureTime?: any | null
          place: { __typename?: 'TripV2ItineraryStopPlace'; id: any; name: string; timezone: any }
          arrival?: { __typename?: 'TripV2ItineraryStopTime'; time: string; day: number } | null
          departure?: { __typename?: 'TripV2ItineraryStopTime'; time: string; day: number } | null
        }>
        timeline: Array<{
          __typename?: 'TripV2TimelineEvent'
          type: string
          correlationID: any
          createdAt: any
          placeID?: any | null
          user: { __typename?: 'TripV2User'; id: any; firstName: string; lastName: string; username: string }
        }>
        crewUsers: Array<{ __typename?: 'TripV2User'; id: any; firstName: string; lastName: string; username: string }>
        confirmationModalities: Array<{
          __typename?: 'TripV2ConfirmationModality'
          name: TripV2ConfirmationModalityName
          salesChannels: Array<{ __typename?: 'TripV2ConfirmationModalitySalesChannel'; id: any; name: string }>
          exceptions: {
            __typename?: 'TripV2ConfirmationModalityExceptions'
            places: Array<{ __typename?: 'TripV2ConfirmationModalityExceptionsPlace'; id: any; name: string }>
          }
        }>
      } & { ' $fragmentRefs'?: { TripNotesFragment: TripNotesFragment } }
    >
  }
}

export type GetVehicleTemplatesAutocompleteQueryVariables = Exact<{
  input: VehicleTemplateSuggestionsInput
}>

export type GetVehicleTemplatesAutocompleteQuery = {
  __typename?: 'Query'
  vehicleTemplateSuggestions: {
    __typename?: 'VehicleTemplateSuggestionsResponse'
    total: any
    items: Array<{ __typename?: 'VehicleTemplateSuggestion'; id: any; name: string; capacity: number; type: string }>
  }
}

export type MarkVehicleOutOfServiceMutationVariables = Exact<{
  input: MarkVehicleOutOfServiceInput
}>

export type MarkVehicleOutOfServiceMutation = { __typename?: 'Mutation'; markVehicleOutOfService: boolean }

export const BookingTicketFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingTicketFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BookingV2Ticket' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCheckedIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRewardApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancellationSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seat' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passenger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'properties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trip' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'segment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceFee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'price' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ancillaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unitPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<BookingTicketFragmentFragment, unknown>
export const BookingTripFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingTripFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BookingV2Trip' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyLine' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'segment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fare' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'city' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'city' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<BookingTripFragmentFragment, unknown>
export const ChangeFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChangeFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Change' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookings' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trips' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'difference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeService' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalID' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalID' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'segments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itinerary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ChangeFragmentFragment, unknown>
export const RoutingProjectPlanFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectPlan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dataset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'maxStops' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDistance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optimization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'polyline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stops' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'arrival' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'departure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'coordinates' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skippedLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reasons' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoutingProjectPlanFragment, unknown>
export const RoutingProjectDatasetFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectDataset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectDataset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoutingProjectDatasetFragment, unknown>
export const RoutingProjectFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'plans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProjectPlan' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'datasets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProjectDataset' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectPlan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dataset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'maxStops' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDistance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optimization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'polyline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stops' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'arrival' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'departure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'coordinates' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skippedLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reasons' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectDataset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectDataset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoutingProjectFragment, unknown>
export const TripNotesFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TripNotes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripV2' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subcategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rsvpStatus' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'distance' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<TripNotesFragment, unknown>
export const GetBookingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBooking' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookingsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ids' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vertical' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buyer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coupon' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'discountType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'chargeID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'authCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tickets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'vat' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'discount' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'departureTrips' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BookingTripFragment' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'returnTrips' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BookingTripFragment' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tickets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BookingTicketFragment' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refunds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingTripFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BookingV2Trip' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyLine' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'segment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fare' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'city' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'city' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingTicketFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BookingV2Ticket' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCheckedIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRewardApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancellationSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seat' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passenger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'properties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trip' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'segment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceFee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'price' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ancillaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unitPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetBookingQuery, GetBookingQueryVariables>
export const GetBookingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBookings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationV2' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BookingsV2Input' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookingsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sorting' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'StringValue', value: 'createdAt', block: false }
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'order' },
                      value: { kind: 'IntValue', value: '-1' }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vertical' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isHomePickup' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTaxInvoiced' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'invoicedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isTaxInvoiceable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userAccount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phoneNumber' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'number' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'client' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'source' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'country' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesChannel' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessClient' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'buyer' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coupon' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'discountType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'payments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'method' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'processor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'chargeID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'authCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'last4' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'tickets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'vat' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'discount' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentListID' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'refunds' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'paymentID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'departureTrips' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BookingTripFragment' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'returnTrips' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BookingTripFragment' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tickets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'BookingTicketFragment' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'emailsSent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supportInteractions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'notificationChannel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'callStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'username' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingTripFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BookingV2Trip' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'checkInScore' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyLine' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'segment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fare' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'basePrice' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'city' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'city' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BookingTicketFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BookingV2Ticket' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'subtotal' } },
          { kind: 'Field', name: { kind: 'Name', value: 'vat' } },
          { kind: 'Field', name: { kind: 'Name', value: 'discount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCheckedIn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isRewardApplied' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cancellationSource' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'seat' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passenger' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'type' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'properties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trip' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'segment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'serviceFee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'price' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'ancillaries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unitPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetBookingsQuery, GetBookingsQueryVariables>
export const CreateBusinessClientsRouteServicesSchedulePriceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBusinessClientsRouteServicesSchedulePrice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateBusinessClientsRouteServicesSchedulePriceInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBusinessClientsRouteServicesSchedulePrice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateBusinessClientsRouteServicesSchedulePriceMutation,
  CreateBusinessClientsRouteServicesSchedulePriceMutationVariables
>
export const GetBusinessClientUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBusinessClientUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'BusinessClientUsersInput' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationV2' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessClientUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasAdminRole' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userAccount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phoneNumber' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'number' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessClient' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessSite' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetBusinessClientUsersQuery, GetBusinessClientUsersQueryVariables>
export const GetBusinessClientUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBusinessClientUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessClientUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasAdminRole' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessClient' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'businessSite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetBusinessClientUserQuery, GetBusinessClientUserQueryVariables>
export const CreateBusinessClientUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateBusinessClientUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateBusinessClientUserInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBusinessClientUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateBusinessClientUserMutation, CreateBusinessClientUserMutationVariables>
export const ChangeBusinessClientUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeBusinessClientUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeBusinessClientUserInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeBusinessClientUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ChangeBusinessClientUserMutation, ChangeBusinessClientUserMutationVariables>
export const ActivateBusinessClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateBusinessClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateBusinessClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ActivateBusinessClientMutation, ActivateBusinessClientMutationVariables>
export const DeactivateBusinessClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateBusinessClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateBusinessClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<DeactivateBusinessClientMutation, DeactivateBusinessClientMutationVariables>
export const ActivateBusinessClientUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ActivateBusinessClientUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ActivateBusinessClientUserInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activateBusinessClientUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ActivateBusinessClientUserMutation, ActivateBusinessClientUserMutationVariables>
export const DeactivateBusinessClientUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeactivateBusinessClientUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeactivateBusinessClientUserInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deactivateBusinessClientUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<DeactivateBusinessClientUserMutation, DeactivateBusinessClientUserMutationVariables>
export const AssignBusinessClientSimsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignBusinessClientSims' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignBusinessClientSimsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignBusinessClientSims' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<AssignBusinessClientSimsMutation, AssignBusinessClientSimsMutationVariables>
export const RequestBusinessClientKreditDepositDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RequestBusinessClientKreditDeposit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RequestBusinessClientKreditDepositInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestBusinessClientKreditDeposit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RequestBusinessClientKreditDepositMutation,
  RequestBusinessClientKreditDepositMutationVariables
>
export const CancelBusinessClientKreditDepositDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CancelBusinessClientKreditDeposit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CancelBusinessClientKreditDepositInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cancelBusinessClientKreditDeposit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CancelBusinessClientKreditDepositMutation,
  CancelBusinessClientKreditDepositMutationVariables
>
export const ChangeBusinessClientUserBusinessClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeBusinessClientUserBusinessClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeBusinessClientUserBusinessClientInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeBusinessClientUserBusinessClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ChangeBusinessClientUserBusinessClientMutation,
  ChangeBusinessClientUserBusinessClientMutationVariables
>
export const ChangeBusinessCustomerBusinessClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeBusinessCustomerBusinessClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeBusinessCustomerBusinessClientInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeBusinessCustomerBusinessClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ChangeBusinessCustomerBusinessClientMutation,
  ChangeBusinessCustomerBusinessClientMutationVariables
>
export const GetExecutedChangesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetExecutedChanges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Pagination' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'changesQueryInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChangeFragment' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'movedBookings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChangeFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Change' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookings' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trips' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'difference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeService' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalID' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalID' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'segments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itinerary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetExecutedChangesQuery, GetExecutedChangesQueryVariables>
export const GetScheduledChangesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetScheduledChanges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Pagination' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'changesQueryInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChangeFragment' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'executeAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChangeFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Change' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bookings' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trips' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'difference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeService' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalID' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalID' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'segments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itinerary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'old' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'new' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetScheduledChangesQuery, GetScheduledChangesQueryVariables>
export const GetCitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetCities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationV2' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TCitiesInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tcities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'places' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetCitiesQuery, GetCitiesQueryVariables>
export const CreateCompanyV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateCompanyV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateCompanyV2Input' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanyV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateCompanyV2Mutation, CreateCompanyV2MutationVariables>
export const GetBusinessSiteKreditsSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetBusinessSiteKreditsSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'businessSite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'kreditsSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'frequency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetBusinessSiteKreditsSettingsQuery, GetBusinessSiteKreditsSettingsQueryVariables>
export const CreateOperationalCostDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateOperationalCost' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateOperationalCostInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createOperationalCost' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNew' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateOperationalCostMutation, CreateOperationalCostMutationVariables>
export const ChangeOperationalCostSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeOperationalCostSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeOperationalCostSettingsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeOperationalCostSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ChangeOperationalCostSettingsMutation, ChangeOperationalCostSettingsMutationVariables>
export const UploadOperationalCostSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UploadOperationalCostSettings' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UploadOperationalCostSettingsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadOperationalCostSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UploadOperationalCostSettingsMutation, UploadOperationalCostSettingsMutationVariables>
export const GetOperationalCostsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetOperationalCosts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'OperationalCostsInput' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationV2' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'operationalCosts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleCapacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'settings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'costs' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'fixedCost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'durationCost' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'costPerKm' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'costPerDriver' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'factors' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'airConditioning' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'baseDistance' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'perKm' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'redZone' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'duration' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetOperationalCostsQuery, GetOperationalCostsQueryVariables>
export const UpsertPartnerCostsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertPartnerCosts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpsertPartnerCostsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertPartnerCosts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<UpsertPartnerCostsMutation, UpsertPartnerCostsMutationVariables>
export const CreatePaymentSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePaymentSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePartnersPaymentSummaryInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPartnersPaymentSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreatePaymentSummaryMutation, CreatePaymentSummaryMutationVariables>
export const AddPaymentSummaryFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddPaymentSummaryFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddPartnersPaymentSummaryFilesInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addPartnersPaymentSummaryFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<AddPaymentSummaryFilesMutation, AddPaymentSummaryFilesMutationVariables>
export const SendPartnersPaymentSummaryEmailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendPartnersPaymentSummaryEmails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendPartnersPaymentSummaryEmailsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendPartnersPaymentSummaryEmails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SendPartnersPaymentSummaryEmailsMutation,
  SendPartnersPaymentSummaryEmailsMutationVariables
>
export const GetPartnersPaymentsSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPartnersPaymentsSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PartnersPaymentSummariesInput' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationV2' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnersPaymentSummaries' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'files' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'errorsFilePath' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'correlationID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'action' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'PartnersPaymentSummaryTimelineEventActionFilesUploaded'
                                      }
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'files' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'path' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'emails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'partner' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetPartnersPaymentsSummaryQuery, GetPartnersPaymentsSummaryQueryVariables>
export const GetPartnersPaymentSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPartnersPaymentSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PartnersPaymentSummaryInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'partnersPaymentSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorsFilePath' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'emails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'partner' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetPartnersPaymentSummaryQuery, GetPartnersPaymentSummaryQueryVariables>
export const GetRoutesPlanningDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRoutesPlanning' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TPagination' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TRoutesInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'troutes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'polyline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'encoded' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'distance' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stops' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'line1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'line2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'services' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetRoutesPlanningQuery, GetRoutesPlanningQueryVariables>
export const CreateRoutingProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRoutingProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRoutingProjectInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRoutingProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateRoutingProjectMutation, CreateRoutingProjectMutationVariables>
export const ChangeRoutingProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeRoutingProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeRoutingProjectInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeRoutingProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ChangeRoutingProjectMutation, ChangeRoutingProjectMutationVariables>
export const CreateRoutingProjectDatasetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRoutingProjectDataset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRoutingProjectDatasetInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRoutingProjectDataset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateRoutingProjectDatasetMutation, CreateRoutingProjectDatasetMutationVariables>
export const CreateRoutingProjectPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRoutingProjectPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRoutingProjectPlanInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRoutingProjectPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateRoutingProjectPlanMutation, CreateRoutingProjectPlanMutationVariables>
export const ChangeRoutingProjectPlanConstraintsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeRoutingProjectPlanConstraints' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeRoutingProjectPlanConstraintsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeRoutingProjectPlanConstraints' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ChangeRoutingProjectPlanConstraintsMutation,
  ChangeRoutingProjectPlanConstraintsMutationVariables
>
export const CreateRoutingProjectPlanOptimizationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRoutingProjectPlanOptimization' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRoutingProjectPlanOptimizationInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRoutingProjectPlanOptimization' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateRoutingProjectPlanOptimizationMutation,
  CreateRoutingProjectPlanOptimizationMutationVariables
>
export const ChangeRoutingProjectPlanDatasetLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeRoutingProjectPlanDatasetLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ChangeRoutingProjectPlanDatasetLocationsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeRoutingProjectPlanDatasetLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ChangeRoutingProjectPlanDatasetLocationsMutation,
  ChangeRoutingProjectPlanDatasetLocationsMutationVariables
>
export const ChangeRoutingProjectPlanOptimizationRouteStopsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ChangeRoutingProjectPlanOptimizationRouteStops' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ChangeRoutingProjectPlanOptimizationRouteStopsInput' }
            }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeRoutingProjectPlanOptimizationRouteStops' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  ChangeRoutingProjectPlanOptimizationRouteStopsMutation,
  ChangeRoutingProjectPlanOptimizationRouteStopsMutationVariables
>
export const RemoveRoutingProjectPlanDatasetLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveRoutingProjectPlanDatasetLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RemoveRoutingProjectPlanDatasetLocationsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeRoutingProjectPlanDatasetLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  RemoveRoutingProjectPlanDatasetLocationsMutation,
  RemoveRoutingProjectPlanDatasetLocationsMutationVariables
>
export const AddRoutingProjectPlanDatasetLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddRoutingProjectPlanDatasetLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddRoutingProjectPlanDatasetLocationsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addRoutingProjectPlanDatasetLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  AddRoutingProjectPlanDatasetLocationsMutation,
  AddRoutingProjectPlanDatasetLocationsMutationVariables
>
export const RoutingProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'routingProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectsInput' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationV2' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routingProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProject' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'total' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectPlan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dataset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'maxStops' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDistance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optimization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'polyline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stops' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'arrival' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'departure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'coordinates' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skippedLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reasons' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectDataset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectDataset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'plans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProjectPlan' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'datasets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProjectDataset' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoutingProjectsQuery, RoutingProjectsQueryVariables>
export const GetRoutingProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRoutingProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routingProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routingProject' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProject' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectPlan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dataset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'maxStops' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDistance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optimization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'polyline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stops' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'arrival' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'departure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'coordinates' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skippedLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reasons' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectDataset' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectDataset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProject' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProject' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'plans' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProjectPlan' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'datasets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProjectDataset' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetRoutingProjectQuery, GetRoutingProjectQueryVariables>
export const GetRoutingProjectsTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRoutingProjectsTags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routingProjectsTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'tags' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetRoutingProjectsTagsQuery, GetRoutingProjectsTagsQueryVariables>
export const GetRoutingProjectPlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRoutingProjectPlan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectPlanInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'routingProjectPlan' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'plan' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoutingProjectPlan' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoutingProjectPlan' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RoutingProjectPlan' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dataset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'coordinates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'constraints' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'origin' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'destination' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'maxStops' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDistance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stopDuration' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'optimization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'polyline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'distance' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'stops' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'arrival' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'departure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'location' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'coordinates' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'skippedLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'reasons' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'coordinates' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'longitude' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetRoutingProjectPlanQuery, GetRoutingProjectPlanQueryVariables>
export const CreateServiceVehicleOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateServiceVehicleOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRouteServiceVehicleOverrideInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRouteServiceVehicleOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateServiceVehicleOverrideMutation, CreateServiceVehicleOverrideMutationVariables>
export const CreateServicePastVehicleOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateServicePastVehicleOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRouteServicePastVehicleOverrideInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRouteServicePastVehicleOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CreateServicePastVehicleOverrideMutation,
  CreateServicePastVehicleOverrideMutationVariables
>
export const CreateServiceDriverOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateServiceDriverOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRouteServiceDriverOverrideInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRouteServiceDriverOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateServiceDriverOverrideMutation, CreateServiceDriverOverrideMutationVariables>
export const CreateServiceItineraryOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateServiceItineraryOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRouteServiceItineraryOverrideInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRouteServiceItineraryOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateServiceItineraryOverrideMutation, CreateServiceItineraryOverrideMutationVariables>
export const CreateServiceRouteOverrideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateServiceRouteOverride' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRouteServiceRouteOverrideInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRouteServiceRouteOverride' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CreateServiceRouteOverrideMutation, CreateServiceRouteOverrideMutationVariables>
export const GetServicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetServices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Pagination' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'servicesQueryInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'servicesWithPagination' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeletable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dow' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessClients' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'businessSites' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'confirmationModalities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'paid' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reserved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'facebook' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyLine' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'company' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itinerariesSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dow' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'route' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'stops' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                                    }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'itinerary' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'placeID' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'departure' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'day' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'arrival' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'day' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehiclesSchedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'vehicle' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalID' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'driver' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'userAccount' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetServicesQuery, GetServicesQueryVariables>
export const AddTripDriverRsvpNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTripDriverRSVPNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddTripDriverRSVPNoteInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addTripDriverRSVPNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<AddTripDriverRsvpNoteMutation, AddTripDriverRsvpNoteMutationVariables>
export const AddTripDriverRealDistanceNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddTripDriverRealDistanceNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegisterTripOdometerDistanceInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registerTripOdometerDistance' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<AddTripDriverRealDistanceNoteMutation, AddTripDriverRealDistanceNoteMutationVariables>
export const GetTripDriverDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTripDriver' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TDriverInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tdriver' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'partner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userAccount' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'phoneNumber' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'documents' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'document' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'path' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetTripDriverQuery, GetTripDriverQueryVariables>
export const GetTripV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTripV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TripV2Input' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'saleStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'confirmedSeatsNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'serviceScore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'availableSeatsNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vertical' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'route' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'polyline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'encoded' } }]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'routeService' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessClients' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'businessSites' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'legSegments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'origin' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'company' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyLine' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'RSVP' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'attempt' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itinerary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'realDepartureTime' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'place' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'departure' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'arrival' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'day' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'time' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkIns' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'at' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'method' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkOuts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'at' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'method' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripNotes' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'timeline' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'correlationID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'placeID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tripCancellationReason' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'subcategory' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'crewUsers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'confirmationModalities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'salesChannels' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exceptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'places' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalID' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schedule' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TripNotes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripV2' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subcategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rsvpStatus' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'distance' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetTripV2Query, GetTripV2QueryVariables>
export const GetTripsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetTrips' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationV2' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TripsV2Input' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tripsV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'saleStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'departureAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'arrivalAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'confirmedSeatsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serviceScore' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableSeatsNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vertical' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'route' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'routeService' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'businessClients' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'businessSites' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'legSegments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'origin' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'company' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyLine' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'vehicle' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalID' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'schedule' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'driver' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'RSVP' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attempt' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itinerary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'realDepartureTime' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'place' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timezone' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'arrival' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'departure' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'day' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'timeline' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'correlationID' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'placeID' } }
                          ]
                        }
                      },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'TripNotes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'routeService' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'crewUsers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'confirmationModalities' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'salesChannels' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'exceptions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'places' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TripNotes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'TripV2' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subcategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'changeType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'username' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'path' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cashFlow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rsvpStatus' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'distance' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetTripsQuery, GetTripsQueryVariables>
export const GetVehicleTemplatesAutocompleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetVehicleTemplatesAutocomplete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleTemplateSuggestionsInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicleTemplateSuggestions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GetVehicleTemplatesAutocompleteQuery, GetVehicleTemplatesAutocompleteQueryVariables>
export const MarkVehicleOutOfServiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkVehicleOutOfService' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MarkVehicleOutOfServiceInput' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markVehicleOutOfService' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
              }
            ]
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<MarkVehicleOutOfServiceMutation, MarkVehicleOutOfServiceMutationVariables>
